/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class Utils {
    /**
     * Reviver for JSON.parse
     * - Converts dates & timestamps in API response to Date type
     * - Converts true/false to boolean
     * Usage: shipment = JSON.parse(apiResponse, Utils.reviver);
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    static reviver(key, value) {
        if (typeof key === "string") {
            if ((/** @type {?} */ (key)).match(".*Timestamp|.*Date")) {
                return new Date(parseInt(value.toString()));
            }
        }
        if (typeof value === "string") {
            if ((/** @type {?} */ (value)).toLowerCase().match("true")) {
                return true;
            }
            else if ((/** @type {?} */ (value)).toLowerCase().match("false")) {
                return false;
            }
        }
        return value;
    }
}
class FileContents {
    constructor() {
        this.contentType = undefined;
        this.fileName = undefined;
        this.contents = undefined;
    }
}
/**
 * @template T
 */
class Envelope {
    constructor() {
        /**
         * The HTTP code for this response. E.g. 200 for Ok, 500 for Internal server error.
         */
        this.code = undefined;
        /**
         * Contains the date and time of when this transaction occured. Pass this in the header of PUT and DELETE requests to enable concurrent update checks.
         */
        this.transactionTimestamp = undefined;
        /**
         * Contains the data in this response.
         */
        this.data = undefined;
        /**
         * Contains file attachments.
         */
        this.attachment = undefined;
        /**
         * Contains the error details if there was any failure
         */
        this.error = undefined;
        /**
         * Contains links to resources
         */
        this.link = undefined;
    }
}
/**
 * Master list of partner carriers.  Added 04/01/2021 LISG-11106
 */
class CarrierMaster {
    constructor() {
        /**
         * Unique identifier
         */
        this.carrierId = undefined;
        /**
         * Standard Carrier Alpha Code is a unique two-to-four-letter code useed to identify transporation companies.  They are maintained by the National Motor Freight Traffic Association (NMFTA)
         */
        this.scacCd = undefined;
        /**
         * Name of carrier
         */
        this.carrierName = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Record of the individual shipments that are part of a tender.   Added 06/24/2021  LISG-13075
 */
class TenderDetail {
    constructor() {
        /**
         * Identifier for the carrier tendered to
         */
        this.carrierId = undefined;
        /**
         * Part of Primary key: system generated
         */
        this.tenderId = undefined;
        /**
         * Makes this tender detail unique
         */
        this.tenderDetailSequenceNbr = undefined;
        /**
         * If an individual shipment was tendered for delivery, this is the shipment id
         */
        this.shipmentInstId = undefined;
        /**
         * PRO number/business key of the shipment tendered for delivery
         */
        this.proNbr = undefined;
        /**
         * If an individual pickup request was tendered, this the id of that request
         */
        this.pkrPickupRequestId = undefined;
        /**
         * If an individual pickup request was tendered, this identifies the individual shipment on the request
         */
        this.pkrShipmentId = undefined;
        /**
         * Call number/business key of the tendered pickup request
         */
        this.callNbr = undefined;
        /**
         * Status of the tender detail:
         *
         * Valid Values:
         * TENDERED
         * ACKOWLEDGED
         * ACCEPTED
         * REJECTED
         * WITHDRAWN
         */
        this.statusCd = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multiple rows across various tables for a
         *
         * single business transaction.
         */
        this.correlationId = undefined;
        /**
         * Provides detailed information about why a shipment tender failed (in XPO systems) or was rejected (by partner carrier).  Added 07/13/2021  LISG-13654
         */
        this.statusMessage = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Contains identifying information for a customer account
 */
class AcctId {
    constructor() {
        this.acctInstId = undefined;
        this.acctMadCd = undefined;
        /**
         * The name of the customer at the detail account level
         */
        this.acctName = undefined;
        /**
         * roles for this account. p2D, billTo, corp, supplier, pay agent
         */
        this.acctPartyRole = undefined;
        /**
         * Indicates the current state of the customer's credit. It may include bad debt, credit, non-credit, PCO control, voluntary, cash only or non-rated
         */
        this.creditStatCd = undefined;
        /**
         * Indicates if the Account is a national account. True or false
         */
        this.nationalAccountInd = undefined;
        /**
         * unique id of the parent customer account
         */
        this.parentAcctInstId = undefined;
    }
}
/**
 * Contains identifying information for a customer account
 */
class AcctIdBasic {
    constructor() {
        this.acctInstId = undefined;
        this.acctMadCd = undefined;
        /**
         * The name of the customer at the detail account level
         */
        this.acctName = undefined;
    }
}
class Address {
    constructor() {
        /**
         * When there is a list of addresses, the type will be used to communicate what type of address it is - for example: home, work, headquarters, admin offices, etc., billing. If there is just one, then this field may be empty
         */
        this.addressTypeCd = undefined;
        /**
         * Primary name
         */
        this.name = undefined;
        /**
         * Applies to mailing address of a person, where the address is actually in another entity's name.
         */
        this.careOfName = undefined;
        /**
         * Address line that includes Street name, direction and optionally building number, unit# etc.
         * e.g. 1000 SW Broadway st
         */
        this.addressLine1 = undefined;
        /**
         * Address line that includes Street name, direction and optionally building number, unit# etc.
         * e.g. 1000 SW Broadway st
         */
        this.addressLine2 = undefined;
        /**
         * PO Box typically applies to a mailing address. This is the standard PO Box# of an address.
         */
        this.postOfficeBox = undefined;
        /**
         * City Name part of the address.
         */
        this.cityName = undefined;
        /**
         * Standard Postal abbreviation for state name. Example: OR for Oregon.
         */
        this.stateCd = undefined;
        /**
         * standard Postal abbreviation for a country. Example: CA for Canada.
         */
        this.countryCd = undefined;
        /**
         * Postal Code are aka Zip code in USA. US and Mexico use 5 digit postal codes. Canada uses 6 char postal codes.
         */
        this.postalCd = undefined;
        /**
         * This is a 4 digit extension to US 5 digit zip code.
         */
        this.usZip4 = undefined;
    }
}
class Area {
    constructor() {
        this.area = undefined;
        this.areaUom = undefined;
    }
}
/**
 * To be used as type for attaching files.
 */
class Attachment {
    constructor() {
        /**
         * Name of the file.
         */
        this.fileName = undefined;
        /**
         * Mime type representing the contents of the file.
         */
        this.contentType = undefined;
        /**
         * Base 64 Formatted data.
         */
        this.base64Data = undefined;
    }
}
class AuditInfo {
    constructor() {
        this.createdById = undefined;
        this.createdTimestamp = undefined;
        this.updateById = undefined;
        this.updatedTimestamp = undefined;
        this.createByPgmId = undefined;
        this.updateByPgmId = undefined;
        this.correlationId = undefined;
        this.createdApplicationId = undefined;
        this.lastUpdateApplicationId = undefined;
    }
}
class Charge {
    constructor() {
        /**
         * linehaul, accessorial, tax, discount, cod, cash ppd, cash coll, part ppd, part coll
         */
        this.chargeTypeCd = undefined;
        /**
         * sequence of charge. This is used for accessorials and miscellaneous line items
         */
        this.seq = undefined;
        /**
         * a descriptive code identifying the accessorial, tax type, discount, etc. For chargeType codes that have sub codes, this will be used and include the description for them. For example - NotifyOnArrival.
         */
        this.chargeCd = undefined;
        /**
         * Expanded Name :  Charge Amount
         *
         * Desc : The dollar amount of the charge for the
         * commodity.
         */
        this.chargeAmt = undefined;
        /**
         * Expanded Name : Minimum charge indicator
         *
         * Desc : Indicates if the charges associated with the
         * line are the minimum charges for the commodity.
         */
        this.minChargeInd = undefined;
        /**
         * True if the charge associated with the accessorial line is the maximum charge
         */
        this.maxChargeInd = undefined;
        /**
         * The method to calculate the charges including exchangeRate, percentage, flat rate, flat fees, etc.
         */
        this.calcMethod = undefined;
        /**
         * A code indicating which party or parties get the revenue from the accessorial - PayToAdvance, PayToPrimary, SplitBetweenAll, SplitAdvancePrimaryOnly, SplitPrimaryBeyondOnly
         */
        this.responsibleParty = undefined;
        /**
         * Textual description of charge other than a standard description represented by the description in ChargeTypeCd
         */
        this.desc = undefined;
        this.reference = undefined;
    }
}
/**
 * The pair of business identifiers of the current and new child shipments.
 */
class ChildProNbrReplacement {
    constructor() {
        /**
         * The business identifier of the current child shipment.
         */
        this.currentChildProNbr = undefined;
        /**
         * The business identifier of the new child shipment.
         */
        this.newChildProNbr = undefined;
    }
}
/**
 * The identifying information for a child shipment.
 */
class ChildShipmentId {
    constructor() {
        /**
         * The unique identifier of the shipment.
         */
        this.shipmentInstId = undefined;
        /**
         * The system assigned number which is used to uniquely identify each child PRO of a shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * The business identifier for the child shipment.
         */
        this.childProNbr = undefined;
        /**
         * The identifying information for the parent shipment.
         */
        this.parentShipmentId = undefined;
    }
}
/**
 * Use this type to represent the delta list of fields that have been changed either as a before list or after list.
 */
class Code {
    constructor() {
        /**
         * unique DB identifier of the Pricing Code
         */
        this.pricingCodeId = undefined;
        /**
         * highest grouping qualifier
         */
        this.category = undefined;
        /**
         * grouping wthin category
         */
        this.subCategory = undefined;
        /**
         * The string used to identify a code
         */
        this.code = undefined;
        /**
         * The description of the code
         */
        this.name = undefined;
        /**
         * Optionally a value for this code.
         */
        this.value = undefined;
        /**
         * An ordinal for displaying this code on a drop down list.
         */
        this.displayOrder = undefined;
        /**
         * effective date of the record
         */
        this.effDate = undefined;
        /**
         * expiry date of the record
         */
        this.expDate = undefined;
    }
}
class Comment {
    constructor() {
        /**
         * Operational Alert, Special Handling Alert, Do not contact
         */
        this.commentTypeCd = undefined;
        /**
         * sub-category of comment
         */
        this.commentSubTypeCd = undefined;
        /**
         * The text of the comment.
         */
        this.note = undefined;
        /**
         * The identity of the entity that entered the comment. This could be an employee id, customer id or a name.
         */
        this.enteredBy = undefined;
        /**
         * The timestamp when the comment was created
         */
        this.dateTime = undefined;
    }
}
class CompanyLocation {
    constructor() {
        this.locFullName = undefined;
        this.locAbbrName = undefined;
        /**
         * Standard 3 character timezone - PST PDT, etc.
         */
        this.locTimezone = undefined;
        this.locOpenTime = undefined;
        this.locCloseTime = undefined;
        /**
         * Hours, minutes, days
         */
        this.locationInfo = undefined;
        this.locContactInfo = undefined;
        this.locPhone = undefined;
    }
}
/**
 * *** Needs Review The contact information including email, phone and preferences
 */
class ContactInfo {
    constructor() {
        /**
         * In many cases, the ContactInfoType seems to be all that is needed within transactions. For customer contacts, however, it seems that the ContactType is needed which has more person information. This field will be populated when the ContactInfo type is used as the contact reference instead of the ContactType which has full person information. If the full ContactType is present, then this field need not be populated.
         */
        this.contactFirstName = undefined;
        this.contactLastName = undefined;
        /**
         * The title of the contact
         */
        this.contactTitle = undefined;
        /**
         * Email Address to communicate with the contact
         */
        this.emailAddress = undefined;
        /**
         * Full telephone number with country code, extension etc. Used to communicate with the contact.
         */
        this.telephone = undefined;
        /**
         * IM addresses - Google chat, Microsoft, Chatter, etc.
         */
        this.chatIMAddress = undefined;
        /**
         * ***Needs review - Does the preference need to have a way of saying - contact me this way for this purpose and this other way for another purpose...? ***The preferred contact method to use - for example email vs. phone. The name in the name value pair should hold the mode and the value, the specific instance within that mode. For example - email/work or phone/mobile or chat/Google
         */
        this.contactModePreference = undefined;
        /**
         * Web URL. Typically applies to where a contact is a non-person entity such as business.
         */
        this.contactWebSiteURL = undefined;
    }
}
/**
 * Basic Contact Information including name , email and phone
 */
class ContactInfoBasic {
    constructor() {
        /**
         * Company Name of the Contact Person
         */
        this.companyName = undefined;
        /**
         * Contact email address
         */
        this.email = undefined;
        /**
         * Full Name
         */
        this.fullName = undefined;
        /**
         * Contact Phone Number
         */
        this.phone = undefined;
    }
}
/**
 * Information for reporting record counts
 */
class CountInfo {
    constructor() {
        /**
         * name for data to be counted
         */
        this.name = undefined;
        /**
         * description of the data
         */
        this.description = undefined;
        /**
         * count for the data
         */
        this.count = undefined;
    }
}
class DataValidationError {
    constructor() {
        /**
         * Data validation error code
         */
        this.errorCd = undefined;
        /**
         * The message describing the validation error
         */
        this.message = undefined;
        /**
         * The name of the parameter or body field that is in error
         */
        this.fieldName = undefined;
        /**
         * The value of the parameter or body field that is in error
         */
        this.fieldValue = undefined;
        /**
         * Any additional information that will help in troubleshooting this fault. E.g. include any context information such as requesting application, user details, any identifying details from the API request such as customer number, PRO number etc.
         */
        this.moreInfo = undefined;
    }
}
class Density {
    constructor() {
        this.density = undefined;
        this.densityUom = undefined;
    }
}
/**
 * Information about the Transit time between origin and destination postal codes
 */
class TransitTime {
    constructor() {
        /**
         * Destination State Code
         */
        this.destStateCd = undefined;
        /**
         * Destination Postal Code
         */
        this.destPostalCd = undefined;
        /**
         * Destination service center that is delivering the freight
         */
        this.destSicCd = undefined;
        /**
         * Delivery date derived from requested pickup date and transit days
         */
        this.estdDlvrDate = undefined;
        /**
         * If true then guaranteed service is available in this lane
         */
        this.garntInd = undefined;
        /**
         * Latest date by which the freight should be picked up in order to meet the requested delivery date
         */
        this.latestPkupDate = undefined;
        /**
         * Origin Postal Cd
         */
        this.origPostalCd = undefined;
        /**
         * Origin state code
         */
        this.origStateCd = undefined;
        /**
         * Origin service center that is picking up the freight
         */
        this.origSicCd = undefined;
        /**
         * Delivery Date as requested by customer
         */
        this.requestedDlvrDate = undefined;
        /**
         * Customer requested pickup date. If not provided then defaults to todays date
         */
        this.requestedPkupDate = undefined;
        /**
         * standard service transit (business) days(excluding weekend and holidays) to move from origin to destination.
         */
        this.transitDays = undefined;
        /**
         * Earliest date by which the freight should be picked up in order to meet the requested delivery date
         */
        this.earliestPkupDate = undefined;
        /**
         * Notes about the transit time
         */
        this.note = undefined;
        /**
         * Set to True if the Requested pickup date is holiday or non-working day
         */
        this.isPkupDateHoliday = undefined;
        /**
         * Set to True if the Requested Delivery date is holiday or non-working day
         */
        this.isrqstdDeliveryDateHoliday = undefined;
    }
}
/**
 * The replacement for Dimensions.
 */
class DimensionMeasurement {
    constructor() {
        this.length = undefined;
        this.width = undefined;
        this.height = undefined;
        this.dimensionUomCd = undefined;
    }
}
/**
 * This has been deprecated.  Please use DimensionMeasurement instead.
 */
class Dimensions {
    constructor() {
        this.length = undefined;
        this.width = undefined;
        this.height = undefined;
        this.dimensionsUom = undefined;
    }
}
class Distance {
    constructor() {
        this.distance = undefined;
        /**
         * miles or kilometers
         */
        this.distanceUOM = undefined;
        /**
         * The description of the distance.
         */
        this.description = undefined;
    }
}
/**
 * Information about the supporting documents
 */
class Document {
    constructor() {
        /**
         * Indicates if the document is restricted or not
         */
        this.restrictedInd = undefined;
        /**
         * Type of Document
         */
        this.docTypeCd = undefined;
        /**
         * File Name of the document
         */
        this.docFile = undefined;
        /**
         * URL Of the document in the DMS
         */
        this.docUrl = undefined;
        /**
         * Document folder name in DMS
         */
        this.docFolder = undefined;
        /**
         * Name of the document
         */
        this.docName = undefined;
        /**
         * content type of the document - pdf, or text or csv, etc
         */
        this.contentType = undefined;
        /**
         * size of document stored in DMS
         */
        this.docLength = undefined;
        /**
         * create date of document in DMS
         */
        this.createdDate = undefined;
        /**
         * update date of document in DMS
         */
        this.modifiedDate = undefined;
        /**
         * name of the author of the document.
         */
        this.docAuthor = undefined;
    }
}
/**
 * Information about sending email messages
 */
class ElectronicMessage {
    constructor() {
        /**
         * bcc'd list of recipients email addresses separated by ;
         */
        this.bcc = undefined;
        /**
         * cc'd list of recipients email addresses separated by ;
         */
        this.cc = undefined;
        /**
         * sender email address
         */
        this.from = undefined;
        /**
         * Name of the sender of the message
         */
        this.fromName = undefined;
        /**
         * Email message body
         */
        this.messageBody = undefined;
        /**
         * priority of the message
         * Low, Medium, High
         */
        this.priority = undefined;
        /**
         * Timestamp when the message was sent.
         */
        this.sentDateTime = undefined;
        /**
         * subject of email message
         */
        this.subject = undefined;
        /**
         * recipients email address separated by ;
         */
        this.to = undefined;
    }
}
class Email {
    constructor() {
        this.emailAddr = undefined;
        this.emailTypeCd = undefined;
    }
}
/**
 * Identification info for equipment
 */
class EquipmentId {
    constructor() {
        /**
         * The unique identifier assigned to equipment. The ID is assigned in the EQP component.
         */
        this.equipmentInstId = undefined;
        /**
         * The type of equipment - Tractor, Trailer, Dolly, Straight Truck, etc.
         */
        this.equipmentTypeCd = undefined;
        /**
         * The prefix for the equipment number.
         */
        this.equipmentPrefix = undefined;
        /**
         * The sequencing or serial part of an equipment unit's identifying number.
         */
        this.equipmentSuffix = undefined;
        /**
         * The equipment suffix number which is stored to identify foreign trailers that may have been deleted from the system.
         */
        this.equipmentIdSuffixNbr = undefined;
    }
}
/**
 * Event Hdr Info
 */
class EventHdr {
    constructor() {
        /**
         * Internal identifier for the event
         */
        this.eventInstId = undefined;
        /**
         * Sequence number of the event for a Pro
         */
        this.seq = undefined;
        /**
         * Identifies type of event that happened for a shipment
         */
        this.eventTypeCd = undefined;
        /**
         * Description  of the event that can be used for display or more information
         */
        this.eventDesc = undefined;
        /**
         * Time that the event occurred
         */
        this.eventTmst = undefined;
        /**
         * This event has exception information
         */
        this.isException = undefined;
    }
}
class ExchangeRateInfo {
    constructor() {
        /**
         * Currency Code in standard format e.g. USD. The exchange rate is to convert from this currentcy.
         */
        this.fromCrncyCd = undefined;
        /**
         * Currency Code in standard format e.g. USD. The exchange rate is to convert to this currentcy.
         */
        this.toCrncyCd = undefined;
        /**
         * Currency code that is the  basis for both the from and to conversions. For example - from SEK to USD and from USD to EUR
         */
        this.baseCrncyCd = undefined;
        /**
         * The exchange rate to convert amount given in fromCrncyCd to toCrncyCd.
         */
        this.exchRate = undefined;
        /**
         * The dates on which this exchange rate is effective.
         */
        this.exchDate = undefined;
        /**
         * source of exchange rate
         */
        this.src = undefined;
    }
}
class Fault {
    constructor() {
        /**
         * The HTTP error code for this fault. E.g. 404 for a Not Found condition
         */
        this.code = undefined;
        /**
         * Internal error code
         */
        this.errorCd = undefined;
        /**
         * The message describing the fault
         */
        this.message = undefined;
        /**
         * Program trace information to help troubleshoot this fault E.g. The Java Stack trace from the exception.
         */
        this.trace = undefined;
        /**
         * Any additional information that will help in troubleshooting this fault. E.g. include any context information such as requesting application, user details, any identifying details from the API request suchs customer number, PRO number etc.
         */
        this.moreInfo = undefined;
    }
}
/**
 * Information about a field for mapping records from file to DB columns
 */
class FieldInfo {
    constructor() {
        /**
         * name of the field
         */
        this.name = undefined;
        /**
         * description of the field
         */
        this.description = undefined;
        /**
         * column number of the field
         */
        this.columnNbr = undefined;
    }
}
/**
 * Includes details about a field that was modified.
 */
class FieldValueChange {
    constructor() {
        /**
         * The name of the field that was changed.
         */
        this.fieldName = undefined;
        /**
         * The previous value of the field.
         */
        this.previousValue = undefined;
        /**
         * The new value of the field.
         */
        this.newValue = undefined;
        /**
         * The timestamp for when the change occurred.
         */
        this.modificationDateTime = undefined;
        /**
         * The username of the user who made the change.
         */
        this.modifiedBy = undefined;
    }
}
/**
 * To be used as type for uploading/downloading files.
 */
class File {
    constructor() {
        /**
         * Name of the file.
         */
        this.fileName = undefined;
        /**
         * Mime type representing the contents of the file.
         */
        this.contentType = undefined;
    }
}
/**
 * The filter criteria. The different elements on the list represent AND conditions. Different values on the same element represent OR conditions.
 */
class FilterCriteria {
    constructor() {
        this.stringFilters = undefined;
        this.dateFilters = undefined;
        this.numberFilters = undefined;
    }
}
class FilterString {
    constructor() {
        this.field = undefined;
        this.fields = undefined;
        this.values = undefined;
        this.between = undefined;
    }
}
class FilterStringBetween {
    constructor() {
        this.from = undefined;
        this.to = undefined;
    }
}
class FilterDate {
    constructor() {
        this.field = undefined;
        this.fields = undefined;
        this.values = undefined;
        this.between = undefined;
    }
}
class FilterDateBetween {
    constructor() {
        this.from = undefined;
        this.to = undefined;
    }
}
class FilterNumber {
    constructor() {
        this.field = undefined;
        this.fields = undefined;
        this.values = undefined;
        this.between = undefined;
    }
}
class FilterNumberBetween {
    constructor() {
        this.from = undefined;
        this.to = undefined;
    }
}
/**
 * Deprecated. Use GeoCoordinates so that elastic search geo is enabled.
 */
class LatLong {
    constructor() {
        /**
         * positive or negative number representing geopoint
         */
        this.latitude = undefined;
        /**
         * positive or negative number representing geopoint
         */
        this.longitude = undefined;
    }
}
/**
 * The geo coordinates for a location.
 */
class GeoCoordinates {
    constructor() {
        /**
         * The positive or negative number representing geopoint.
         */
        this.lat = undefined;
        /**
         * The positive or negative number representing geopoint.
         */
        this.lon = undefined;
    }
}
class HyperMedia {
    constructor() {
        /**
         * A relative link to the URI
         */
        this.rel = undefined;
        /**
         * The URI to the resource
         */
        this.uri = undefined;
        /**
         * Http method: GET, PUT, POST, etc
         */
        this.method = undefined;
    }
}
/**
 * The list type to be included as parameters in all list APIs. Response types will need to include a field for the totalRowCount
 */
class ListInfo {
    constructor() {
        this.levelOfDetail = undefined;
        /**
         * page size - number of rows
         */
        this.numberOfRows = undefined;
        /**
         * start at row number
         */
        this.startAt = undefined;
        /**
         * List of fields for sorting
         */
        this.sortFields = undefined;
        /**
         * List of fields to include in response - if not populated, this will return all fields specified in the response type
         */
        this.fields = undefined;
        /**
         * The first response will populate this with the total query row count
         */
        this.totalRowCount = undefined;
        /**
         * start at row number for ID
         */
        this.startAtId = undefined;
    }
}
class Location {
    constructor() {
        /**
         * Consignee, Receiver, Sender, Shipper, Warehouse, DC, Hub, Transit Point,Spot, Drop, Yard, Dock, Port
         */
        this.locationTypeCd = undefined;
        /**
         * Primary and alias names and addresses
         */
        this.address = undefined;
        this.coordinate = undefined;
        this.note = undefined;
        this.reference = undefined;
    }
}
/**
 * Basic GeoLocation information
 */
class GeoLocation {
    constructor() {
        /**
         * City Name part of the address.
         */
        this.cityName = undefined;
        /**
         * Standard Postal abbreviation for state name. Example: OR for Oregon.
         */
        this.stateCd = undefined;
        /**
         * standard Postal abbreviation for a country. Example: CA for Canada.
         */
        this.countryCd = undefined;
        /**
         * Postal Code are aka Zip code in USA. US and Mexico use 5 digit postal codes. Canada uses 6 char postal codes.
         */
        this.postalCd = undefined;
        /**
         * Preferred City Name
         */
        this.preferredCityName = undefined;
    }
}
class MappingInfo {
    constructor() {
        this.columnIdx = undefined;
        this.columnName = undefined;
    }
}
class MonetaryAmount {
    constructor() {
        this.amt = undefined;
        /**
         * ISO 3 Letter Currency codes
         */
        this.currencyCd = undefined;
    }
}
class MoreInfo {
    constructor() {
        /**
         * Internal error code
         */
        this.errorCode = undefined;
        /**
         * A message describing the fault in more detail.
         */
        this.message = undefined;
        /**
         * Describes the location at which this fault occurred.
         */
        this.location = undefined;
        /**
         * The index of the element being described if it is part of an array.
         */
        this.itemNbr = undefined;
        /**
         * Has a value related to the error code. E.g. the PRO number on which the error/warning occurred.
         */
        this.value = undefined;
    }
}
class NameValue {
    constructor() {
        this.name = undefined;
        this.value = undefined;
    }
}
class PaymentCalcMethod {
    constructor() {
        /**
         * spot quote, rate-based
         */
        this.calcMethodTypeCd = undefined;
        /**
         * whatever if being multiplied by unit rate - hours, weight, miles
         */
        this.quantity = undefined;
        this.quantityUOM = undefined;
        this.perUnitRate = undefined;
        this.perUnitRateEffDate = undefined;
        this.exchRateInfo = undefined;
        this.percentageFactor = undefined;
    }
}
/**
 * The business identifiers for the child shipment and its new parent shipment.
 */
class ParentProNbrReplacement {
    constructor() {
        /**
         * The business identifier of the child shipment.
         */
        this.childProNbr = undefined;
        /**
         * The business identifier of the new parent for the child shipment.
         */
        this.newParentProNbr = undefined;
        /**
         * Indicates whether the shipment has been split for the new parent PRO.
         */
        this.splitInd = undefined;
    }
}
class Person {
    constructor() {
        /**
         * Full name is concatenation of  title, first, middle and last name. This is a denorm attribute.
         */
        this.fullName = undefined;
        /**
         * First name of the person.
         */
        this.firstName = undefined;
        /**
         * Either middle name of middle initials
         */
        this.middleName = undefined;
        /**
         * Last name or the Sir name of the person.
         */
        this.lastName = undefined;
        /**
         * Prefix used with the name such as Dr. Mr. Ms. etc.
         */
        this.salutation = undefined;
        /**
         * Title as appropriate including job title, professional title etc.
         */
        this.title = undefined;
        /**
         * Various addresses for the person including business, home etc.
         */
        this.address = undefined;
        /**
         * email addresses, chat handles, phone numbers and preferences.
         */
        this.contactInfo = undefined;
        /**
         * Preferered language that should be used to communicate with the person.
         */
        this.preferredLanguage = undefined;
        /**
         * Follows a person's full name and provides additional information about the person such as a position, educational degree, accreditation, office, or honor.
         */
        this.suffix = undefined;
    }
}
class Phone {
    constructor() {
        /**
         * Daytime, Evening, Mobile, Home, Emergency
         */
        this.phoneTypeCd = undefined;
        /**
         * Country code of the full phone#. Example US country code is 1.
         */
        this.countryCd = undefined;
        /**
         * When a phone is on an internal company network, these are additional digits to reach a party after dialing the standard phone#.
         */
        this.extension = undefined;
        /**
         * This is phone number that might optionally include components such as country code, city code, area in addition to the standard within city phone#. Example: 450-6019 or 503-450-6019 or 1-503-450-6019. The phone# might include various delimiters such as - ( )
         */
        this.phoneNbr = undefined;
    }
}
/**
 * Contains identifying information for a pickup request.
 */
class PickupRequestId {
    constructor() {
        /**
         * The unique identifier for the pickup request.
         */
        this.pkupInstId = undefined;
        /**
         * The sequence number associated with the pickup request item.
         */
        this.pkupItemSeq = undefined;
    }
}
/**
 * This type will be used for the management of postal code assignments to sic, network node or sales territory.
 */
class PostalAssignment {
    constructor() {
        /**
         * US or Canadian postal code
         */
        this.postalCode = undefined;
        /**
         * Date assignment was or will be active
         */
        this.effectiveDate = undefined;
        /**
         * Date assignment was or will be expired
         */
        this.expirationDate = undefined;
    }
}
/**
 * The ReferenceType type is the type of all reference elements within
 * 								Conway schemas. This type provides a reference attribute, to reference an object
 * 								defined elsewhere.  It does not contain metadata,
 * 								as it does not itself establish the existence of an object; it relies on a definition
 * 								located elsewhere.
 * Data that is commonly understood, but often rendered with different edit masks will be preserved in original format as well as the Conway canonical format. This will be done by repeating the reference number type instance for both the canonical. This is only done for type where there is an industry standard and different ways of representing it, like phone number, etc...For anything where it is specific to domain/client, then the format/value will be preserved.
 *
 */
class ReferenceNumber {
    constructor() {
        this.reference = undefined;
        this.referenceDescr = undefined;
        /**
         * PO, Lading number, etc
         */
        this.referenceTypeCd = undefined;
    }
}
/**
 * This type will be used to return basic location information for service centers
 */
class ServiceCenterLocation {
    constructor() {
        /**
         * company sic code
         */
        this.sic = undefined;
        /**
         * component that the sic is part of
         */
        this.component = undefined;
        /**
         * city for the sic
         */
        this.cityName = undefined;
        /**
         * 2 character state code
         */
        this.stateCd = undefined;
        /**
         * 2 character country code
         */
        this.countryCd = undefined;
        /**
         * A generated link that will display the service center location information on the XPO website.
         */
        this.locationLink = undefined;
        /**
         * The phone number of the service center
         */
        this.phoneNbr = undefined;
        /**
         * The postal code of the service center.
         */
        this.postalCd = undefined;
        /**
         * The name of the SIC.
         */
        this.sicName = undefined;
    }
}
/**
 * The identifying information for a shipment.
 */
class ShipmentId {
    constructor() {
        /**
         * The uunique identifier of the shipment
         */
        this.shipmentInstId = undefined;
        /**
         * The business identifier for the shipment.
         */
        this.proNumber = undefined;
        /**
         * The pickup date for the shipment.
         */
        this.pickupDate = undefined;
    }
}
/**
 * Information about Imaged Documents for a Pro Number
 */
class ShipmentImagedDocument {
    constructor() {
        /**
         * unique business identifier of the shipment
         */
        this.proNumber = undefined;
        /**
         * type of image: BL (Bill of lading, DR(Delivery Receipt),CUST(Customs document),DRRR(Delivery Return Receipt), IR(Inspection Report), LOA(Letter of Authority),NCIC(NMFC Certificate),WI(Weight and Correction Certificate), WRFO(Weight and Research Photos)
         */
        this.imageType = undefined;
        /**
         * image format - pdf, jpg,png, tiff
         */
        this.imageFormat = undefined;
        /**
         * image files
         */
        this.imageFiles = undefined;
        /**
         * Date when the document was scanned and imaged
         */
        this.scanDate = undefined;
    }
}
class ShipmentImagedDocument_File {
    constructor() {
        /**
         * Base 64 Formatted image data.
         */
        this.base64Data = undefined;
    }
}
class SortField {
    constructor() {
        /**
         * Name of the column for sort
         */
        this.sortByFieldName = undefined;
        /**
         * asc - ascending, desc - descending
         */
        this.sortOrder = undefined;
    }
}
class Status {
    constructor() {
        /**
         * Examples: missed pickup, attempted delivery, damaged, disputed, paid short.
         */
        this.statusCd = undefined;
        /**
         * Examples: No answer, Office closed, Invalid address, Traffic Jam, Cow crossing, etc.
         */
        this.statusReasonCd = undefined;
        this.reason = undefined;
        this.dateTime = undefined;
        this.description = undefined;
        this.comment = undefined;
    }
}
class StatusException {
    constructor() {
        /**
         * Examples: missed pickup, attempted delivery, damaged.
         */
        this.exceptionTypeCd = undefined;
        /**
         * Examples: No answer, Office closed, Invalid address, Traffic Jam, Cow crossing, etc.
         */
        this.exceptionReasonCd = undefined;
        this.reason = undefined;
        /**
         * Resolution - New, Acknowledged, Resolved, Unresolved, Superseded, In-progress, Assigned, etc.
         */
        this.rsltnCd = undefined;
        this.dateTime = undefined;
        this.description = undefined;
        this.comment = undefined;
    }
}
/**
 * The ReferenceType type is the type of all reference elements within
 * 								Conway schemas. This type provides a reference attribute, to reference an object
 * 								defined elsewhere.  It does not contain metadata,
 * 								as it does not itself establish the existence of an object; it relies on a definition
 * 								located elsewhere.
 * Data that is commonly understood, but often rendered with different edit masks will be preserved in original format as well as the Conway canonical format. This will be done by repeating the reference number type instance for both the canonical. This is only done for type where there is an industry standard and different ways of representing it, like phone number, etc...For anything where it is specific to domain/client, then the format/value will be preserved.
 *
 */
class SupplementalReference {
    constructor() {
        /**
         * PO, Lading number, etc
         */
        this.suppRefTypeCd = undefined;
        /**
         * sequence of supplemental reference on shipment
         */
        this.seq = undefined;
        this.refValue = undefined;
        this.refDesc = undefined;
        this.sourceCd = undefined;
        this.printIncludeInd = undefined;
        this.mask = undefined;
        this.mandatoryInd = undefined;
    }
}
/**
 * Basic information about the employee
 */
class EmployeeId {
    constructor() {
        /**
         * User Employee Id
         */
        this.employeeId = undefined;
        /**
         * The given name of the Employee
         */
        this.employeeName = undefined;
    }
}
class User {
    constructor() {
        /**
         * The ID of the user making this request
         */
        this.userId = undefined;
        /**
         * User Employee Id
         */
        this.employeeId = undefined;
        /**
         * RACF ID of the user
         */
        this.racfId = undefined;
        /**
         * Contain the instance id of the user prifile. Will be populated if user is an external registered user.
         */
        this.profileInstId = undefined;
        /**
         * The name to be displayed
         */
        this.displayName = undefined;
        /**
         * The given name of the user
         */
        this.givenName = undefined;
        /**
         * The last name of the user
         */
        this.lastName = undefined;
        /**
         * The job title of the user
         */
        this.title = undefined;
        /**
         * The email address of the user
         */
        this.emailAddress = undefined;
        /**
         * The mobile phone number of the user
         */
        this.mobile = undefined;
        /**
         * The telephone number of the user
         */
        this.telephone = undefined;
        /**
         * The address of the user
         */
        this.streetAddress = undefined;
        /**
         * Standard Postal abbreviation for state name. Example: OR for Oregon.
         */
        this.stateCd = undefined;
        /**
         * standard Postal abbreviation for a country. Example: CA for Canada.
         */
        this.countryCd = undefined;
        /**
         * The postal code for the street address
         */
        this.postalCode = undefined;
        /**
         * Department of the user
         */
        this.department = undefined;
        /**
         * Business unit of employee as defined in the HR system
         */
        this.businessUnit = undefined;
        /**
         * A description of the region. E.g. IT LTL Dev
         */
        this.regionDescription = undefined;
        /**
         * Employee Manager
         */
        this.manager = undefined;
        /**
         * Primary job role code
         */
        this.jobRoleCode = undefined;
        /**
         * A list of roles associated with this user
         */
        this.roles = undefined;
        /**
         * user location sic code
         */
        this.sicCode = undefined;
    }
}
class Volume {
    constructor() {
        this.volume = undefined;
        this.volumeUOM = undefined;
    }
}
class Weight {
    constructor() {
        this.weight = undefined;
        this.weightUom = undefined;
    }
}
class GetHealthCheckResp {
    constructor() {
        this.service = undefined;
        this.status = undefined;
        this.build = undefined;
    }
}
class Instruction {
    constructor() {
        this.instructionTypeCd = undefined;
        this.value = undefined;
        this.role = undefined;
        this.notes = undefined;
        this.schedule = undefined;
        this.suppRef = undefined;
        this.documentRequirement = undefined;
        this.ruleParameter = undefined;
    }
}
/**
 * Object to map the t_cust_hrchy_table, this will be used for GET_CUST_HRCHY_CHILDREN and GET_CUST_HRCHY_PARENTS DB Functions.
 */
class CustomerHrchy {
    constructor() {
        /**
         * Mad code
         */
        this.madCd = undefined;
        /**
         * Party name 1
         */
        this.partyName = undefined;
        /**
         * Party Name 2
         */
        this.name2 = undefined;
        /**
         * Legacy CIS Customer Number
         */
        this.legacyCisCustNbr = undefined;
        /**
         * Function code
         */
        this.functionCd = undefined;
        /**
         * Customer Status Cd: ACTIVE, INACTIVE
         */
        this.statusCd = undefined;
        /**
         * Address
         */
        this.addressTxt = undefined;
        /**
         * City Name
         */
        this.cityNm = undefined;
        /**
         * State code
         */
        this.stateCd = undefined;
        /**
         * Zip code
         */
        this.zipCd = undefined;
        /**
         * Zip4 Code
         */
        this.zip4Cd = undefined;
        /**
         * Country code
         */
        this.cntryCd = undefined;
        /**
         * Customer location function ID
         */
        this.custLocationFuncId = undefined;
        /**
         * Parent corporate customer location function ID
         */
        this.parentCorpCustLocFuncId = undefined;
        /**
         * Address ID
         */
        this.addresId = undefined;
        /**
         * Party 1 ID
         */
        this.party1Id = undefined;
        /**
         * Party 2 ID
         */
        this.party2Id = undefined;
        /**
         * Display order serquence
         */
        this.displayOrderSeq = undefined;
        /**
         * Hierarchy level number
         */
        this.levelNbr = undefined;
        /**
         * Specifies number of days after which an invoice is due.  The due date is generally calculated by adding days associated with the payment term to Pickup Date. E.g. NET30 means 30 days after the pickup date.
         */
        this.paymentTermCd = undefined;
    }
}
class CustomerSchedule {
    constructor() {
        /**
         * number of unit
         */
        this.frequencyInterval = undefined;
        /**
         * Hours, minutes, days
         */
        this.frequencyUnit = undefined;
        this.scheduledTime = undefined;
    }
}
class ConfigParm {
    constructor() {
        this.ruleTypeCd = undefined;
        /**
         * A grouping identifier for parms config parm sets that should be executed today
         */
        this.groupID = undefined;
        this.parms = undefined;
        this.desc = undefined;
        this.priority = undefined;
        this.seq = undefined;
        this.processContext = undefined;
        this.ruleFunctionName = undefined;
    }
}
/**
 * Account IDs and address
 */
class PartyBasic {
    constructor() {
        /**
         * Database key for customer
         */
        this.acctInstId = undefined;
        /**
         * Business key for customer
         */
        this.acctMadCd = undefined;
        /**
         * Address
         */
        this.address = undefined;
    }
}
/**
 * Account IDs and address
 */
class PartyAccountBasic {
    constructor() {
        /**
         * Database key for customer
         */
        this.acctInstId = undefined;
        /**
         * Business key for customer
         */
        this.acctMadCd = undefined;
        /**
         * Business key for customer
         */
        this.acctName = undefined;
        /**
         * Address
         */
        this.address = undefined;
    }
}
/**
 * Account IDs and address
 */
class PartyContactBasic {
    constructor() {
        /**
         * Database key for customer
         */
        this.acctInstId = undefined;
        /**
         * Business key for customer
         */
        this.acctMadCd = undefined;
        /**
         * Address
         */
        this.address = undefined;
        this.contactInfo = undefined;
    }
}
class InvoicingInstruction {
    constructor() {
        /**
         * This is to distinguish groups of instructions used for generating invoices for a customer. e.g. Prepaid invoices, Past Due invoices etc.
         */
        this.invInstrTypeCd = undefined;
        /**
         * Reference by customerAccount ID to the bill to location
         */
        this.bil2Account = undefined;
        /**
         * These are the instruction used by the invoicing process to generate invoices. The instructions include the schedule (when to generate invoice e.g. daily for this customer), additional documents that need to be attached, additional data such as Supplimentary references that must be available for the PRO before an invoice can be generated etc.
         */
        this.instruction = undefined;
        /**
         * The method of transmission of invoices to the customer. Example electronic, EDI, email attachment, pape etc.
         */
        this.transmissionMode = undefined;
        /**
         * The format in which the invoice is generated. Example plain text, comma delimited, PDF, html etc. Most commonly used when the transmission mode is electronic. For paper invoices, this can store the name of the template.
         */
        this.invoiceFormat = undefined;
        /**
         * This may be Statement or Manifest. If not populated then the invoices are being rendered individually with no summary.
         */
        this.consolidatedInvoiceFormat = undefined;
        /**
         * ***What type? For this invoicing mode, use this contact. It will have the name, address or email address or phone. FTP addresses will be in address with an address type of FTP and the ID will be in reference in the AdressType
         */
        this.sendTo = undefined;
    }
}
/**
 * Account Information in the CRM System
 */
class CrmAccount {
    constructor() {
        /**
         * Database key for customer
         */
        this.acctInstId = undefined;
        /**
         * Unique Identifier of the Account in the CRM System
         */
        this.accountId = undefined;
        /**
         * Account Name in the CRM System
         */
        this.accountName = undefined;
        /**
         * Account Address in the CRM System
         */
        this.accountAddress = undefined;
    }
}
/**
 * Account Owner Information in the CRM System
 */
class CrmAccountOwner {
    constructor() {
        /**
         * Unique Identifier for the employee
         */
        this.employeeId = undefined;
        /**
         * First name of the employee
         */
        this.firstName = undefined;
        /**
         * Last name of the employee
         */
        this.lastName = undefined;
        /**
         * Full name of the employee
         */
        this.fullName = undefined;
        /**
         * Job title of the employee
         */
        this.title = undefined;
        /**
         * Job profile of the employee
         */
        this.profile = undefined;
        /**
         * Name of the role
         */
        this.roleName = undefined;
    }
}
/**
 *
 */
class AccountDetail {
    constructor() {
        /**
         *
         */
        this.acctInstId = undefined;
        /**
         *
         */
        this.acctMadCd = undefined;
        /**
         *
         */
        this.parentAcctInstId = undefined;
        /**
         *
         */
        this.nationalAcctInd = undefined;
        /**
         *
         */
        this.name1 = undefined;
        /**
         *
         */
        this.name2 = undefined;
        /**
         *
         */
        this.creditStatusCode = undefined;
        /**
         *
         */
        this.locationTypeCode = undefined;
        /**
         *
         */
        this.addressLine1 = undefined;
        /**
         *
         */
        this.addressLine2 = undefined;
        /**
         *
         */
        this.cityName = undefined;
        /**
         *
         */
        this.stateCd = undefined;
        /**
         *
         */
        this.postalCd = undefined;
        /**
         *
         */
        this.countryCd = undefined;
        /**
         *
         */
        this.deletedInd = undefined;
        /**
         *
         */
        this.latitudeNbr = undefined;
        /**
         *
         */
        this.longitudeNbr = undefined;
        /**
         *
         */
        this.lastCreatedBy = undefined;
        /**
         *
         */
        this.lastCreatedDateTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         *
         */
        this.geoCoordinates = undefined;
        /**
         * Geo coordinations
         */
        this.geoCoordinatesGeo = undefined;
        /**
         *
         */
        this.zip4RestUs = undefined;
    }
}
class Equipment {
    constructor() {
        this.equipmentBase = undefined;
        /**
         * replaced, intact, broken, missing
         */
        this.sealInfo = undefined;
        /**
         * The stackability factor indicates how many items of packaging material, such as pallets, can be stacked on top of one another. It is not a control and is therefore for information purposes only.
         */
        this.stackabilityFactor = undefined;
        /**
         * The filling level is the percentage to which a handling unit should be filled. It is not a control and is therefore for information purposes only.
         */
        this.fillingLevel = undefined;
        /**
         * In this field, you can enter a percentage tolerance limit, up to which the allowed packing weight of a handling unit can be exceeded.
         */
        this.excessWeightTolerance = undefined;
        /**
         * In this field, you can enter a percentage tolerance limit, up to which the allowed packing volume of a handling unit can be exceeded.
         */
        this.excessVolumeTolerance = undefined;
        this.maxSpeed = undefined;
        /**
         * Used for optimization
         */
        this.averageSpeed = undefined;
        /**
         * Serial or VIN number of the equipment
         */
        this.equipmentSerialNbr = undefined;
        /**
         * Transponder Number of the tractor
         */
        this.equipmentTransponderNbr = undefined;
        /**
         * The DOT number of the tractor For XPO LTL tractors it is 241829.  For XPO LTL Canada
         * tractors, that is 838885.
         */
        this.equipmentDOTNbr = undefined;
    }
}
class EquipmentBase {
    constructor() {
        this.equipmentInstID = undefined;
        this.equipmentPrefix = undefined;
        /**
         * Sequencing or serial part of an equipment unit's identifying number (pure numeric form for equipment number is preferred)
         */
        this.equipmentSuffix = undefined;
        /**
         * Prefix or alphabetic part of an equipment unit's identifying number
         */
        this.ownerPfx = undefined;
        /**
         * Name of equipment owner if not ltl.xpo
         */
        this.ownerName = undefined;
        /**
         * Company, Subservice, rental company,
         */
        this.supplierTypeCd = undefined;
        /**
         * Trip Leased,Seller owned(Returnable),Railroad Leased,Not customer owned or leased,Customer owned or leased
         */
        this.leaseTypeCd = undefined;
        /**
         * Container, Forklift, Dolly, Tractor, Skid, TrailerType -
         */
        this.equipmentTypeCd = undefined;
        /**
         * LiftGate, PackingMaterials, StackingAppliance
         */
        this.equipmentCharacteristics = undefined;
        this.tareWeight = undefined;
        this.allowedGrossWeight = undefined;
        this.allowedGrossVolume = undefined;
        this.dimensions = undefined;
        this.dateOfManufacture = undefined;
        /**
         * License or Registration number of the Equipment
         */
        this.equipmentLicNbr = undefined;
        /**
         * State or Province Code where the license waas issued.
         */
        this.equipmentLicLoc = undefined;
        /**
         * Country where the license was issued
         */
        this.equipmentLicCountryCd = undefined;
    }
}
/**
 * Identification info for equipment
 */
class EquipmentInfo {
    constructor() {
        this.equipmentInstID = undefined;
        /**
         * Type of the equipment - Tractor, Trailer, Dolly, Straight Truck
         */
        this.equipmentTypeCd = undefined;
        /**
         * Prefix for the quipment number.
         */
        this.equipmentPrefix = undefined;
        /**
         * Sequencing or serial part of an equipment unit's identifying number (pure numeric form for equipment number is preferred)
         */
        this.equipmentSuffix = undefined;
    }
}
class EquipmentProperty {
    constructor() {
        this.eqpPropTypeCd = undefined;
        this.eqpPropDesc = undefined;
    }
}
class EquipmentSeal {
    constructor() {
        /**
         * for now it will be hardcoded value not a code lookup
         */
        this.sealOwner = undefined;
        /**
         * Unique number on seal used to close a shipment
         */
        this.sealNbr = undefined;
        /**
         * replaced, intact, broken, missing
         */
        this.sealStatusCd = undefined;
    }
}
class Speed {
    constructor() {
        this.speed = undefined;
        this.speedUOM = undefined;
    }
}
/**
 * Captures transaction events. API writes one record per transaction.  Added to EVT seed model  06/26/2020
 */
class TransactionEvent {
    constructor() {
        /**
         * PK. Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         */
        this.transactionId = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         */
        this.transactionType = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey5 = undefined;
        /**
         * Number of seconds to hold event before publishing.  Added 09/21/2020  LISG-7498
         */
        this.eventReleaseDelaySeconds = undefined;
        /**
         *
         */
        this.transactionDetails = undefined;
        /**
         *
         */
        this.transactionBusinessEvents = undefined;
    }
}
/**
 *
 */
class TransactionEventBusiness {
    constructor() {
        /**
         * Unique identifier for the record.  This will be populate by a trigger before insert to get the ID from _EVT_TRANSACTION_BUS_SEQ
         */
        this.instId = undefined;
        /**
         * The transaction id from the session.  This will be populate by a trigger before insert.
         */
        this.transactionId = undefined;
        /**
         * Short description of the business transaction type.
         */
        this.transactionType = undefined;
        /**
         * Code identifying the type of business event.
         */
        this.typeCd = undefined;
        /**
         * Code identifying the type of business event.
         */
        this.subTypeCd = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions. In other words, this groups multiple rows across various tables for a single business transaction.
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Stores the snapshot of all the tables that were updated as part of the transaction. The snapshot is a json representation of all columns that were changed. The snapshot will be created by insert/update/delete triggers on the source table.   Added to EVT seed model  06/26/2020
 */
class TransactionEventDetail {
    constructor() {
        /**
         * PK. Unique id for the snapshot record. Generated by Sequence.
         */
        this.detailId = undefined;
        /**
         * Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         */
        this.transactionId = undefined;
        /**
         * Name of the table for which the snapshot is stored
         */
        this.tableName = undefined;
        /**
         * Json string containing the before and after values for all the columns that were changed by the transaction.
         */
        this.snapshot = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         */
        this.businessKey5 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         */
        this.transactionType = undefined;
    }
}
class FaultResponse {
    constructor() {
        /**
         * Internal error code
         */
        this.errorCode = undefined;
        /**
         * The message describing the fault
         */
        this.message = undefined;
        /**
         * A JSON message describing the fault
         */
        this.jsonMessage = undefined;
        /**
         * Program trace information to help troubleshoot this fault E.g. The Java Stack trace from the exception.
         */
        this.trace = undefined;
        /**
         * The ID of the application using this API
         */
        this.srcApplicationId = undefined;
        /**
         * Contains the date and time of when this transaction occurred.
         */
        this.transactionTimestamp = undefined;
        /**
         * A unique ID for this transaction.
         */
        this.correlationId = undefined;
        /**
         * Any additional information that will help in troubleshooting this fault. E.g. include any context information such as requesting application, user details, any identifying details from the API request such as customer number, PRO number etc.
         */
        this.moreInfo = undefined;
        /**
         * Fault Response from the root cause.
         */
        this.rootCause = undefined;
    }
}
class JobStatus {
    constructor() {
        this.code = undefined;
        this.message = undefined;
        this.details = undefined;
    }
}
class JobRetryConfig {
    constructor() {
        this.retryCount = undefined;
        this.maxRetryDuration = undefined;
        this.maxBackoffDuration = undefined;
        this.maxDoublings = undefined;
    }
}
class Attribute {
    constructor() {
        this.name = undefined;
        this.value = undefined;
    }
}
class PubsubTarget {
    constructor() {
        this.topicName = undefined;
        this.data = undefined;
        this.attributes = undefined;
    }
}
class AppEngineRouting {
    constructor() {
        this.service = undefined;
        this.version = undefined;
        this.instance = undefined;
        this.host = undefined;
    }
}
class AppEngineHttpTarget {
    constructor() {
        this.httpMethod = undefined;
        this.appEngineRouting = undefined;
        this.maxBackoffDuration = undefined;
        this.relativeUri = undefined;
        this.headers = undefined;
        this.body = undefined;
    }
}
class HttpTarget {
    constructor() {
        this.uri = undefined;
        this.httpMethod = undefined;
        this.headers = undefined;
        this.body = undefined;
    }
}
class Job {
    constructor() {
        this.name = undefined;
        this.description = undefined;
        this.schedule = undefined;
        this.timeZone = undefined;
        this.userUpdateTime = undefined;
        this.state = undefined;
        this.status = undefined;
        this.scheduleTime = undefined;
        this.lastAttemptTime = undefined;
        this.retryConfig = undefined;
        this.attemptDeadline = undefined;
        this.target = undefined;
    }
}
/**
 *
 */
class Locations {
    constructor() {
        this.locationId = undefined;
        this.name = undefined;
        this.typeCd = undefined;
        this.sic = undefined;
        this.geoAreaId = undefined;
        this.shape = undefined;
        this.geoCodingPrecision = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocationAddress {
    constructor() {
        /**
         *
         */
        this.refSicCd = undefined;
        /**
         *
         */
        this.addressId = undefined;
        /**
         *
         */
        this.locationAddressEffDate = undefined;
        /**
         *
         */
        this.altAddressType = undefined;
        /**
         *
         */
        this.addr1 = undefined;
        /**
         *
         */
        this.addr2 = undefined;
        /**
         *
         */
        this.addr3 = undefined;
        /**
         *
         */
        this.boxNbr = undefined;
        /**
         *
         */
        this.cityName = undefined;
        /**
         *
         */
        this.countryCd = undefined;
        /**
         *
         */
        this.countryName = undefined;
        /**
         *
         */
        this.countrySubdivisionCd = undefined;
        /**
         *
         */
        this.countrySubdivisionName = undefined;
        /**
         *
         */
        this.companyName = undefined;
        /**
         *
         */
        this.deliveryInstructionDescription = undefined;
        /**
         *
         */
        this.expiryDate = undefined;
        /**
         *
         */
        this.nm1Name = undefined;
        /**
         *
         */
        this.nm2Name = undefined;
        /**
         *
         */
        this.prmyAddressFlag = undefined;
        /**
         *
         */
        this.postalCd = undefined;
        /**
         *
         */
        this.postalExtCd = undefined;
        /**
         *
         */
        this.expiryReasonCd = undefined;
        /**
         *
         */
        this.pyrlCntr = undefined;
        /**
         *
         */
        this.pyrlCorpCd = undefined;
        /**
         *
         */
        this.pyrlEnvs = undefined;
        /**
         *
         */
        this.geoCodedFlag = undefined;
        /**
         *
         */
        this.postalCertifiedFlag = undefined;
        /**
         *
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         */
        this.dmlDateTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Added for compatibility
 */
class KafkaMessageHeader {
    constructor() {
        /**
         * Name of the target elastic search index
         */
        this.index = undefined;
        /**
         * This is the envrionment within that division  e.g. CTSI, CTS2, CTSS, PROD
         */
        this.env = undefined;
        /**
         * Id of the document
         */
        this.id = undefined;
        /**
         * Type of document
         */
        this.docType = undefined;
        /**
         * Correlation id of the transaction
         */
        this.correlationId = undefined;
        /**
         * Id of the application generating this message
         */
        this.srcApplicationId = undefined;
    }
}
/**
 * Envelope for messages bound for a Elastic Search
 */
class SearchRecordMessageHeader {
    constructor() {
        /**
         * Name of the target elastic search index
         */
        this.index = undefined;
        /**
         * This is the environment within that division  e.g. CTSI, CTS2, CTSS, PROD
         */
        this.env = undefined;
        /**
         * Id of the document
         */
        this.id = undefined;
        /**
         * Type of document
         */
        this.docType = undefined;
        /**
         * Correlation id of the transaction
         */
        this.correlationId = undefined;
        /**
         * Id of the application generating this message
         */
        this.srcApplicationId = undefined;
        /**
         * Type of document
         */
        this.action = undefined;
    }
}
/**
 * This is the root element for the LTL Canonical Msg
 */
class LTLMessageHdr {
    constructor() {
        this.hdr = undefined;
        this.body = undefined;
    }
}
class Body {
    constructor() {
        this.payload = undefined;
    }
}
class PayloadType {
}
/**
 * TransactionContext format. transaction type, action
 *
 */
class TranCntxt {
    constructor() {
        /**
         * Transaction event
         */
        this.tranType = undefined;
        /**
         * The action to be taken on this message --- is a business body of work.
         */
        this.action = undefined;
        this.correlationId = undefined;
        this.contextId = undefined;
    }
}
class LTLEvent {
    constructor() {
        /**
         * The type of event.
         */
        this.eventType = undefined;
        /**
         * Contains a list of additional event types that are included in this event.
         */
        this.auxEventTypes = undefined;
        /**
         * The event occurrence timestamp.
         */
        this.eventTmst = undefined;
        /**
         * The name of component from which this event originated.
         */
        this.srcComponent = undefined;
        /**
         * The correlation ID of the originating transaction
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         */
        this.businessKey5 = undefined;
        /**
         * A unique id for the event. If this is chunked, the eventId will help in combining chunks of the same message
         */
        this.eventId = undefined;
        /**
         * If there are a large number of payloads, the events can be chunked and published as smaller payloads. Set chunkInd to true if this is a chunk of a larger event message
         */
        this.chunkedInd = undefined;
        /**
         * If this is a chunked event message, specifies the sequence number of this instance
         */
        this.chunkSeqNbr = undefined;
        /**
         * If this is a chunked event message, specifies the total number of chunks
         */
        this.totalChunks = undefined;
        /**
         * The event data.
         */
        this.eventData = undefined;
    }
}
class CBOHeaderType {
    constructor() {
        /**
         * The name of the message.
         */
        this.cboName = undefined;
        /**
         * The version of the message.
         */
        this.cboVersion = undefined;
        /**
         * The correlation ID maps back the original ID. This may be the JMS Message ID, ADB Sequence number, etc.
         */
        this.correlationID = undefined;
        /**
         * The original subject name on which this message was published.
         */
        this.originSubjectName = undefined;
        /**
         * The common name of the origin publisher. Examples are DB2ADB, RPT1ADB, CAXFileAdapter. In subsequent publishes of this type this should not be changed.
         */
        this.originPublisher = undefined;
        /**
         * The timestamp from the origin message.
         */
        this.originTimestamp = undefined;
        /**
         * The name of the application that published this message.
         */
        this.currentPublisher = undefined;
        /**
         * The date and time the message was sent.
         */
        this.currentTimestamp = undefined;
        /**
         * The priority of the message.
         */
        this.priority = undefined;
        /**
         * The type of the message.
         */
        this.type = undefined;
        /**
         * This indicated whether the message has been republished.
         */
        this.redelivered = undefined;
        /**
         * The version of the message.
         */
        this.version = undefined;
    }
}
class TrackingInfoType {
    constructor() {
        /**
         * The identifier of the message.
         */
        this.id = undefined;
        /**
         * The application information of the requestor.
         */
        this.appInfo = undefined;
    }
}
class AppInfoType {
    constructor() {
        /**
         * The type of application information.
         */
        this.info = undefined;
    }
}
class InfoType {
    constructor() {
        /**
         * The item that holds the information about the application.
         */
        this.item = undefined;
    }
}
class CBOType {
}
/**
 * The schedule details which are published as an event.
 */
class LinehaulSchedule {
    constructor() {
        /**
         * The unique identifier assigned to the schedule.
         */
        this.lnhScheduleId = undefined;
        /**
         * The list of employee identifiers for the drivers.
         */
        this.dsrEmployeeIds = undefined;
        /**
         * The service center identification code for the location where the schedule originated.
         */
        this.originSicCd = undefined;
        /**
         * The cut date and time as derived from the calculation after the model is released.
         */
        this.originCutDateTime = undefined;
        /**
         * The equipment identifier, which includes the prefix and suffix, for the tractor.
         */
        this.tractorEquipmentId = undefined;
        /**
         * The list of equipment identifiers, which include the prefix and suffix, for the trailers.
         */
        this.trailerEquipmentIds = undefined;
        /**
         * The code associated with the linehaul schedule event status.
         */
        this.statusCd = undefined;
        /**
         * The estimated date and time when the schedule will start at the origin SIC.
         */
        this.estimatedDepartDateTime = undefined;
        /**
         * The actual date and time when the schedule was dispatched from the origin SIC.
         */
        this.actualDepartDateTime = undefined;
        /**
         * The legs of this schedule.
         */
        this.linehaulScheduleLegs = undefined;
        /**
         * The date for which the Linehaul schedule is active.
         */
        this.scheduleDate = undefined;
        /**
         * The shift code at the origin SIC where the schedule was planned.
         */
        this.shiftCd = undefined;
    }
}
/**
 * The details for a leg of a linehaul schedule.
 */
class LinehaulScheduleLeg {
    constructor() {
        /**
         * The actual date and time when the schedule was dispatched from the SIC.
         */
        this.actualDepartDateTime = undefined;
        /**
         * The estimated date and time when the schedule leg will start at the SIC.
         */
        this.estimatedDepartDateTime = undefined;
        /**
         * The actual arrival date and time for this schedule leg.
         */
        this.actualArrivalDateTime = undefined;
        /**
         * The estimated arrival date and time for this schedule leg.
         */
        this.estimatedArrivalDateTime = undefined;
        /**
         * The service center identification code for this leg.
         */
        this.sicCd = undefined;
        /**
         * The type of leg. E.g. VIA, FINAL-DESTINATION, etc.
         */
        this.type = undefined;
    }
}
/**
 * Details about a stop window including its type, start/end dates and times, and the list of associated notes.
 * The beginning local date of the service window.
 * The ending local date of the service window.
 */
class StopWindow {
    constructor() {
        /**
         * Indicates if the window is profile based or for a specific date/date range.
         */
        this.stopWindowType = undefined;
        this.beginDate = undefined;
        /**
         * The beginning local time of the service window.
         */
        this.beginTime = undefined;
        this.endDate = undefined;
        /**
         * The ending local time of the service window.
         */
        this.endTime = undefined;
        /**
         * The list of notes associated with the stop window.
         */
        this.notes = undefined;
    }
}
/**
 * The note contents and type associated with a stop window.
 */
class StopWindowNote {
    constructor() {
        /**
         * The type of stop window note.
         */
        this.type = undefined;
        /**
         * The content of the appointment note.
         */
        this.note = undefined;
    }
}
/**
 * Details which are used to confirm the cancellation of a pickup request.
 */
class CancelledPickupRequest {
    constructor() {
        /**
         * The unique identifier of the pickup request.
         */
        this.pkrPickupRequestId = undefined;
        /**
         * The business key which is used to uniquely identify a pickup request.
         */
        this.callNbr = undefined;
        /**
         * The business key (format: ddnnn) which is used to uniquely identify a pickup request from the SCO application.
         */
        this.callNbrLegacy = undefined;
        /**
         * The identification code for the service center that is responsible for processing the pickup request.
         */
        this.pickupTerminalSicCd = undefined;
        /**
         * The status of the pickup request after cancellation.
         */
        this.statusCd = undefined;
        /**
         * The exception message that may occur when cancelling the pickup request.
         */
        this.exceptionMessage = undefined;
        /**
         * The pickup request shipment ID and status code for each pickup request shipment after cancellation.
         */
        this.cancelledPickupRequestShipments = undefined;
    }
}
/**
 * Details which are used to confirm the cancellation of a pickup request shipment.
 */
class CancelledPickupRequestShipment {
    constructor() {
        /**
         * The unique identifier of the pickup request shipment.
         */
        this.pkrShipmentId = undefined;
        /**
         * The status of the pickup request shipment after cancellation.
         */
        this.statusCd = undefined;
    }
}
/**
 * The complete pickup request.
 */
class CompletePickupRequest {
    constructor() {
        /**
         * The pickup request that will be created.
         */
        this.pkrPickupRequest = undefined;
        /**
         * List of shipments that are part of the pickup request that will be created.
         */
        this.pickupRequestShipments = undefined;
    }
}
/**
 *
 */
class PickupRequest {
    constructor() {
        /**
         *
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         */
        this.sourceCd = undefined;
        /**
         *
         */
        this.statusCd = undefined;
        /**
         *
         */
        this.pickupDate = undefined;
        /**
         *
         */
        this.readyTime = undefined;
        /**
         *
         */
        this.closeTime = undefined;
        /**
         *
         */
        this.ttlPalletsCount = undefined;
        /**
         *
         */
        this.ttlLoosePiecesCount = undefined;
        /**
         *
         */
        this.ttlWeightLbs = undefined;
        /**
         *
         */
        this.pickupTerminalSicCd = undefined;
        /**
         *
         */
        this.cadCallNbr = undefined;
        /**
         *
         */
        this.shipperName1 = undefined;
        /**
         *
         */
        this.shipperName2 = undefined;
        /**
         *
         */
        this.shipperAddress = undefined;
        /**
         *
         */
        this.shipperCity = undefined;
        /**
         *
         */
        this.shipperState = undefined;
        /**
         *
         */
        this.shipperCountryCd = undefined;
        /**
         *
         */
        this.shipperZip6 = undefined;
        /**
         *
         */
        this.shipperZip4RestUs = undefined;
        /**
         *
         */
        this.rqstrName = undefined;
        /**
         *
         */
        this.rqstrCompanyName = undefined;
        /**
         *
         */
        this.rqstrPhoneCountryCdNbr = undefined;
        /**
         *
         */
        this.rqstrPhoneAreaCdNbr = undefined;
        /**
         *
         */
        this.rqstrPhoneNbr = undefined;
        /**
         *
         */
        this.rqstrPhoneExtensionNbr = undefined;
        /**
         *
         */
        this.rqstrEMailId = undefined;
        /**
         *
         */
        this.customerProfitabilityInstId = undefined;
        /**
         *
         */
        this.contactName = undefined;
        /**
         *
         */
        this.contactCompanyName = undefined;
        /**
         *
         */
        this.contactPhoneCountryCdNbr = undefined;
        /**
         *
         */
        this.contactPhoneAreaCdNbr = undefined;
        /**
         *
         */
        this.contactPhoneNbr = undefined;
        /**
         *
         */
        this.contactPhoneExtensionNbr = undefined;
        /**
         *
         */
        this.createdTimestamp = undefined;
        /**
         *
         */
        this.createdUserId = undefined;
        /**
         *
         */
        this.remarks = undefined;
        /**
         *
         */
        this.shipperPhoneCountryCd = undefined;
        /**
         *
         */
        this.shipperPhoneExtension = undefined;
        /**
         *
         */
        this.shipperPhoneAreaCd = undefined;
        /**
         *
         */
        this.shipperPhone = undefined;
        /**
         *
         */
        this.equipmentNbr = undefined;
        /**
         *
         */
        this.strandInd = undefined;
        /**
         *
         */
        this.callDate = undefined;
        /**
         *
         */
        this.rqstrRoleCd = undefined;
        /**
         *
         */
        this.callSequenceNbr = undefined;
        /**
         *
         */
        this.cashDueInd = undefined;
        /**
         *
         */
        this.specialEquipmentCd = undefined;
        /**
         *
         */
        this.earlyCutoffInd = undefined;
        /**
         *
         */
        this.shipperAddr2 = undefined;
        /**
         *
         */
        this.shipperCreditedStatusCd = undefined;
        /**
         *
         */
        this.insidePickupInd = undefined;
        /**
         *
         */
        this.pickupTypeCd = undefined;
        /**
         *
         */
        this.volumeInd = undefined;
        /**
         *
         */
        this.areaInstId = undefined;
        /**
         *
         */
        this.dsrNote = undefined;
        /**
         *
         */
        this.rschCnclReasonCd = undefined;
        /**
         *
         */
        this.rschCnclReason = undefined;
        /**
         *
         */
        this.originTerminalSicCd = undefined;
        /**
         *
         */
        this.archiveInd = undefined;
        /**
         *
         */
        this.shipperSicCd = undefined;
        /**
         *
         */
        this.csrOmsInd = undefined;
        /**
         *
         */
        this.omsEmployeeUserid = undefined;
        /**
         *
         */
        this.strandReasonCd = undefined;
        /**
         *
         */
        this.arrivalShiftDate = undefined;
        /**
         *
         */
        this.arrivalShiftCd = undefined;
        /**
         *
         */
        this.loadId = undefined;
        /**
         *
         */
        this.rschCnclContactName = undefined;
        /**
         *
         */
        this.rschCnclContactPhoneNbr = undefined;
        /**
         *
         */
        this.lastUsedSequenceNbr = undefined;
        /**
         *
         */
        this.possibleDuplicateOrderInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * The business identifier of a pickup activity.
         */
        this.callNbr = undefined;
        /**
         * Each service center is divided into multiple geographic areas for delivery. This identifies the delivery area of destination service center in which this shipment's consignee is located.
         */
        this.areaName = undefined;
    }
}
/**
 * Contains details about the shipments included in the pickup request.
 */
class PickupRequestShipment {
    constructor() {
        /**
         * The shipment that is part of the pickup request.
         */
        this.shipment = undefined;
        /**
         * The list of hazardous materials for a shipment that is part of the pickup request.
         */
        this.shipmentHazMats = undefined;
        /**
         * The list of dimensions for a shipment that is part of the pickup request.
         */
        this.shipmentDimensions = undefined;
        /**
         * The list of handling units for a shipment that is part of the pickup request.
         */
        this.shipmentHandlingUnits = undefined;
        /**
         * The unique identifier of the pickup request.
         */
        this.pkrPickupRequestId = undefined;
        /**
         * The unique index to identify a particular shipment in a list.
         */
        this.shipmentIndex = undefined;
        /**
         * The business key which is used to uniquely identify a pickup request.  The format is NN-NNNN.
         */
        this.handheldCallNbr = undefined;
        /**
         * Indicates whether this is initiated by a handheld device.
         */
        this.invokeFromHandheldInd = undefined;
    }
}
/**
 * Details which are used to confirm the status update of one or more pickup requests and shipments.
 */
class PickupRequestStatus {
    constructor() {
        /**
         * The pickup request ID, call number, status code, and error message for each pickup request after the status is updated to cancelled.
         */
        this.cancelledPickupRequests = undefined;
        /**
         * The pickup request ID, call number, and error message for each pickup request after the status is updated to rescheduled.
         */
        this.rescheduledPickupRequests = undefined;
    }
}
/**
 * The customer might request multiple shipments to be picked up from a shipper, typically going to different destinations. This entity records various shipments to be picked up as part of a given pickup request.
 */
class PickupShipment {
    constructor() {
        /**
         * The system generated ID which uniquely identifies a record.
         */
        this.pickupShipmentId = undefined;
        /**
         * The zip code of the consignee.
         */
        this.destinationZip6 = undefined;
        /**
         * The code associated with the service center that is responsible for the delivery of the shipment.
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * The status of the shipment.
         */
        this.statusCd = undefined;
        /**
         * The business identifier for the shipment.
         */
        this.proNbr = undefined;
        /**
         * When a shipment has been confirmed as picked up, a shipment record (SHM_SHIPMENT) is created and this attribute is set with the identifier of that shipment record.
         */
        this.shipmentInstId = undefined;
        /**
         * The internal identifier of the eBol (BOL_DOC).
         */
        this.bolInstId = undefined;
        /**
         * The number of pallets in the shipment.
         */
        this.palletsCount = undefined;
        /**
         * The total number of loose pieces from all commodities in the shipment.
         */
        this.loosePiecesCount = undefined;
        /**
         * The total weight of the shipment in pounds.
         */
        this.weightLbs = undefined;
        /**
         * The amount of trailer area that the shipment will occupy.
         */
        this.cubeNbr = undefined;
        /**
         * The method used to calculate the volume of the freight (TOT_VOL_CFT).
         */
        this.cubicFeetProfileMethodCd = undefined;
        /**
         * If a default or destination shipper profile was used to calculate the volume of the freight, then this field describes the type of shipper profile used.
         */
        this.cubicFeetProfileTypeCd = undefined;
        /**
         * The cubic feet of the shipment.
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * Indicates whether the shipment is under the Guaranteed Service Program.
         */
        this.guaranteedInd = undefined;
        /**
         * Indicates whether a hazardous material commodity is being carried on a shipment.
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether a shipment requires special handling to prevent freezing during harsh weather.
         */
        this.freezableInd = undefined;
        /**
         * Indicates whether foodstuffs, feed or other edible material intended for consumption by humans or animals is included in this shipment.
         */
        this.foodInd = undefined;
        /**
         * Indicates whether the shipment has been placed in the nose of a trailer and will not need to be removed from the trailer for outbound.
         */
        this.headloadInd = undefined;
        /**
         * Indicates whether the consignee requests that the shipment be delivered on a Weekend (Saturday) or a Holiday.
         */
        this.holidayDeliveryInd = undefined;
        /**
         * Indicates whether a shipment contains a bulk liquid. If volume is known, then this applies to shipments >119 gallons.
         */
        this.bulkLiquidInd = undefined;
        /**
         * Indicates whether the cube entered for the pickup line might be invalid.
         */
        this.suspectCubeInd = undefined;
        /**
         * Indicates whether the pickup line item needs to be reviewed for accuracy.
         */
        this.reviewRequiredInd = undefined;
        /**
         * The code associated with the specific type of service provided for a shipment.
         */
        this.serviceTypeCd = undefined;
        /**
         * Designates something about the origin/destination SIC that will require getting this shipment back to the service center earlier than the standard cut-off time for outbound freight.
         */
        this.earlyCutoffCd = undefined;
        /**
         * The number of forklift moves (motor moves) that are required to move the shipment.
         */
        this.motorMovesNbr = undefined;
        /**
         * The sender-id of the EDI customer.
         */
        this.ediSenderId = undefined;
        /**
         * The shipment identifier of the EDI Pkup Req supplied by the EDI customer.
         */
        this.ediSenderShipmentId = undefined;
        /**
         * The user ID of the DSR who explicitly opted out of taking measurements at pickup time.
         */
        this.optOutByEmployeeId = undefined;
        /**
         * The freeform text which contains any additional information relevant to a shipment on a pickup request.
         */
        this.shipmentRemark = undefined;
        /**
         * The same value is assigned to the correlation ID of various rows from different tables that form a single business transaction.
         */
        this.correlationId = undefined;
        /**
         * The same value for event ID is assigned to various rows from different tables that form a single database transaction.
         */
        this.pickupEventId = undefined;
        /**
         * Indicates the source or origination of the shipment that is part of a pickup request.
         */
        this.overrideSourceCd = undefined;
        /**
         * Indicates whether the PRO is exempted to be tracked via piece level.
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         * An explanation of why a PRO is exempted from piece level tracking.
         */
        this.handlingUnitExemptionReason = undefined;
        /**
         * Indicates whether an appointment should be created for delivering the shipment.
         */
        this.appointmentRequiredInd = undefined;
        /**
         * Indicates whether a destination SIC override has already occurred, in which case the update of the line item should NOT change the destination SIC.
         */
        this.destinationSicOverrideInd = undefined;
        /**
         * Indicates the source or origination of the pickup request.
         */
        this.sourceCd = undefined;
        /**
         * The consignee address line 1 for the corresponding consignee zip.
         */
        this.consigneeAddress1 = undefined;
        /**
         * The consignee address line 2 for the corresponding consignee zip.
         */
        this.consigneeAddress2 = undefined;
        /**
         *
         */
        this.consigneeAreaInstId = undefined;
        /**
         * The internal customer number that belongs to Consignee from CIS.
         */
        this.consigneeCisCustomerNbr = undefined;
        /**
         * The country code of the consignee.
         */
        this.consigneeCountryCd = undefined;
        /**
         * The consignee credit status code.
         */
        this.consigneeCreditStatusCd = undefined;
        /**
         * The city of the consignee.
         */
        this.consigneeCity = undefined;
        /**
         * The consignee name 1.
         */
        this.consigneeName1 = undefined;
        /**
         * The consignee name 2.
         */
        this.consigneeName2 = undefined;
        /**
         * The area code for the phone number of the consignee.
         */
        this.consigneePhoneAreaCd = undefined;
        /**
         * The country code for the phone number of the consignee.
         */
        this.consigneePhoneCountryCd = undefined;
        /**
         * The phone extension of the consignee for a pickup request.
         */
        this.consigneePhoneExtension = undefined;
        /**
         * The phone number of the consignee for a pickup request.
         */
        this.consigneePhoneNbr = undefined;
        /**
         * A unique, randomly-generated number that identifies a registered customer in the XPO Customer Profile Component.
         */
        this.consigneeProfitabilityInstId = undefined;
        /**
         * The service center identification code where the consignee is located.
         */
        this.consigneeSicCd = undefined;
        /**
         * The state for the delivery location.
         */
        this.consigneeStateCd = undefined;
        /**
         * The last four characters of the zip code for a US address for the delivery location.
         */
        this.consigneeZip4RestUs = undefined;
        /**
         * The zip code for the delivery location.
         */
        this.consigneeZip6 = undefined;
        /**
         * This is the length of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment to which the dimensions apply.
         */
        this.lengthNbr = undefined;
        /**
         * This is the width of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment to which the dimensions apply.
         */
        this.widthNbr = undefined;
        /**
         * This is the height of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment to which the dimensions apply.
         */
        this.heightNbr = undefined;
        /**
         * The unit of measure used for the shipment dimensions.
         */
        this.unitOfMeasure = undefined;
        /**
         * Indicates whether it is an excessive length shipment.
         */
        this.excessiveLengthInd = undefined;
        /**
         * Indicates whether the shipment is under the Rapid Remote Service Program.
         */
        this.rrsInd = undefined;
        /**
         * Indicates whether this shipment is time date critical.
         */
        this.tdcInd = undefined;
        /**
         * Indicates whether there should be notification prior to delivery.
         */
        this.notifyPriorToDeliveryInd = undefined;
        /**
         * Indicates whether delivery should be made after business hours.
         */
        this.deliveryAfterBusinessHrsInd = undefined;
        /**
         * Indicates whether the delivery should be sorted.
         */
        this.deliverySortInd = undefined;
        /**
         *
         */
        this.deliveryInboundFreightInd = undefined;
        /**
         * Indicates whether the driver needs to collect money at delivery.
         */
        this.deliveryCollectInd = undefined;
        /**
         * The pickup request line level sequence Number from PUR_DELIVERY_LOC in SCO.
         */
        this.pickupRequestSequenceNbrLegacy = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction.
         */
        this.auditInfo = undefined;
        /**
         * This shipment line is merged with another shipment line as identified by this attribute.
         */
        this.parentMergeToPickupShipmentId = undefined;
        /**
         * Manually added. This is the old delivery location seqNbr that is required to support old processes using the PKR DTOs.
         */
        this.sequenceNbr = undefined;
    }
}
/**
 *
 */
class PickupRequestor {
    constructor() {
        /**
         *
         */
        this.rqstrInstId = undefined;
        /**
         *
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         */
        this.statusCd = undefined;
        /**
         *
         */
        this.archiveInd = undefined;
        /**
         *
         */
        this.readyTime = undefined;
        /**
         *
         */
        this.closeTime = undefined;
        /**
         *
         */
        this.name = undefined;
        /**
         *
         */
        this.companyName = undefined;
        /**
         *
         */
        this.phoneCountryCdNbr = undefined;
        /**
         *
         */
        this.phoneAreaCdNbr = undefined;
        /**
         *
         */
        this.phoneNbr = undefined;
        /**
         *
         */
        this.phoneExtensionNbr = undefined;
        /**
         *
         */
        this.eMailId = undefined;
        /**
         *
         */
        this.roleCd = undefined;
        /**
         *
         */
        this.customerProfitabilityInstId = undefined;
        /**
         *
         */
        this.contactName = undefined;
        /**
         *
         */
        this.contactCompanyName = undefined;
        /**
         *
         */
        this.contactPhoneCountryCdNbr = undefined;
        /**
         *
         */
        this.contactPhoneAreaCdNbr = undefined;
        /**
         *
         */
        this.contactPhoneNbr = undefined;
        /**
         *
         */
        this.contactPhoneExtensionNbr = undefined;
        /**
         *
         */
        this.createdUserId = undefined;
        /**
         *
         */
        this.updateById = undefined;
        /**
         *
         */
        this.ediSenderId = undefined;
        /**
         *
         */
        this.pickupDate = undefined;
        /**
         *
         */
        this.shipperName1 = undefined;
        /**
         *
         */
        this.shipperName2 = undefined;
        /**
         *
         */
        this.shipperAddress = undefined;
        /**
         *
         */
        this.shipperCity = undefined;
        /**
         *
         */
        this.shipperStateCd = undefined;
        /**
         *
         */
        this.shipperCountryCd = undefined;
        /**
         *
         */
        this.shipperZip6 = undefined;
        /**
         *
         */
        this.shipperZip4RestUs = undefined;
        /**
         *
         */
        this.shipperPhoneCountryCd = undefined;
        /**
         *
         */
        this.shipperPhoneAreaCd = undefined;
        /**
         *
         */
        this.shipperPhone = undefined;
        /**
         *
         */
        this.shipperPhoneExtension = undefined;
        /**
         *
         */
        this.equipmentNbr = undefined;
        /**
         *
         */
        this.specialEquipmentCd = undefined;
        /**
         *
         */
        this.insidePickupInd = undefined;
        /**
         *
         */
        this.remarks = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
class PickupLineItemSearchFilter {
    constructor() {
        this.q = undefined;
        this.hostOriginTerminalSicCd = undefined;
        this.header_pickupTerminalSicCd = undefined;
        this.header_pickupDate = undefined;
        this.header_pickupTypeCd = undefined;
        this.header_readyTime = undefined;
        this.header_closeTime = undefined;
        this.header_cadCallNbr = undefined;
        this.header_callNbr = undefined;
        this.guaranteedInd = undefined;
        this.hazardousMtInd = undefined;
        this.freezableInd = undefined;
        this.proNbr = undefined;
        this.shipper_geoCoordinatesGeo = undefined;
        this.header_statusCd = undefined;
        this.suppRef_suppRefTypeCd = undefined;
        this.suppRef_refValue = undefined;
        this.header_shipperName1 = undefined;
        this.header_shipperAddress = undefined;
        this.header_shipperCity = undefined;
        this.header_shipperState = undefined;
        this.header_shipperZip6 = undefined;
        this.header_shipperCountryCd = undefined;
        this.header_shipperZip4RestUs = undefined;
        this.header_shipperPhoneCountryCd = undefined;
        this.header_shipperPhoneAreaCd = undefined;
        this.header_shipperPhone = undefined;
        this.header_shipperPhoneExtension = undefined;
        this.header_specialEquipmentCd = undefined;
        this.header_sourceCd = undefined;
        this.specialServiceSummary_specialService = undefined;
        this.header_callDate = undefined;
        this.header_originTerminalSicCd = undefined;
        this.header_pickupRequestInstId = undefined;
        this.destinationTerminalSicCd = undefined;
        this.header_rqstrRoleCd = undefined;
        this.header_rqstrCompanyName = undefined;
        this.header_rqstrName = undefined;
        this.header_rqstrPhoneCountryCdNbr = undefined;
        this.header_rqstrPhoneAreaCdNbr = undefined;
        this.header_rqstrPhoneNbr = undefined;
        this.header_rqstrPhoneExtensionNbr = undefined;
        this.header_rqstrEMailId = undefined;
        this.shipper_acctMadCd = undefined;
        this.pickupRequestInstId = undefined;
        this.pickupRequestSequenceNbr = undefined;
        this.pickupCreateDateTime = undefined;
        this.rescheduledCount = undefined;
        this.zip6 = undefined;
        this.ediSenderId = undefined;
        this.statusCd = undefined;
        this.dispatchGroupId = undefined;
        this.tripInstId = undefined;
        this.carrierId = undefined;
        this.tenderId = undefined;
        this.tenderDetailSequenceNbr = undefined;
        this.tenderDetailStatusCd = undefined;
        this.tenderDetailStatusMessage = undefined;
        this.appointmentRequiredInd = undefined;
        /**
         * The unique, randomly-generated number that identifies a registered customer.  'Profitability' should have been generated as 'Profile', but the wrong abbreviation was used for the associated column name.
         */
        this.customerProfitabilityInstId = undefined;
        this.toJSON = function () {
            return {
                "q": this.q,
                "hostOriginTerminalSicCd": this.hostOriginTerminalSicCd,
                "header.pickupTerminalSicCd": this.header_pickupTerminalSicCd,
                "header.pickupDate": this.header_pickupDate,
                "header.pickupTypeCd": this.header_pickupTypeCd,
                "header.readyTime": this.header_readyTime,
                "header.closeTime": this.header_closeTime,
                "header.cadCallNbr": this.header_cadCallNbr,
                "header.callNbr": this.header_callNbr,
                "guaranteedInd": this.guaranteedInd,
                "hazardousMtInd": this.hazardousMtInd,
                "freezableInd": this.freezableInd,
                "proNbr": this.proNbr,
                "shipper.geoCoordinatesGeo": this.shipper_geoCoordinatesGeo,
                "header.statusCd": this.header_statusCd,
                "suppRef.suppRefTypeCd": this.suppRef_suppRefTypeCd,
                "suppRef.refValue": this.suppRef_refValue,
                "header.shipperName1": this.header_shipperName1,
                "header.shipperAddress": this.header_shipperAddress,
                "header.shipperCity": this.header_shipperCity,
                "header.shipperState": this.header_shipperState,
                "header.shipperZip6": this.header_shipperZip6,
                "header.shipperCountryCd": this.header_shipperCountryCd,
                "header.shipperZip4RestUs": this.header_shipperZip4RestUs,
                "header.shipperPhoneCountryCd": this.header_shipperPhoneCountryCd,
                "header.shipperPhoneAreaCd": this.header_shipperPhoneAreaCd,
                "header.shipperPhone": this.header_shipperPhone,
                "header.shipperPhoneExtension": this.header_shipperPhoneExtension,
                "header.specialEquipmentCd": this.header_specialEquipmentCd,
                "header.sourceCd": this.header_sourceCd,
                "specialServiceSummary.specialService": this.specialServiceSummary_specialService,
                "header.callDate": this.header_callDate,
                "header.originTerminalSicCd": this.header_originTerminalSicCd,
                "header.pickupRequestInstId": this.header_pickupRequestInstId,
                "destinationTerminalSicCd": this.destinationTerminalSicCd,
                "header.rqstrRoleCd": this.header_rqstrRoleCd,
                "header.rqstrCompanyName": this.header_rqstrCompanyName,
                "header.rqstrName": this.header_rqstrName,
                "header.rqstrPhoneCountryCdNbr": this.header_rqstrPhoneCountryCdNbr,
                "header.rqstrPhoneAreaCdNbr": this.header_rqstrPhoneAreaCdNbr,
                "header.rqstrPhoneNbr": this.header_rqstrPhoneNbr,
                "header.rqstrPhoneExtensionNbr": this.header_rqstrPhoneExtensionNbr,
                "header.rqstrEMailId": this.header_rqstrEMailId,
                "shipper.acctMadCd": this.shipper_acctMadCd,
                "pickupRequestInstId": this.pickupRequestInstId,
                "pickupRequestSequenceNbr": this.pickupRequestSequenceNbr,
                "pickupCreateDateTime": this.pickupCreateDateTime,
                "rescheduledCount": this.rescheduledCount,
                "zip6": this.zip6,
                "ediSenderId": this.ediSenderId,
                "statusCd": this.statusCd,
                "dispatchGroupId": this.dispatchGroupId,
                "tripInstId": this.tripInstId,
                "carrierId": this.carrierId,
                "tenderId": this.tenderId,
                "tenderDetailSequenceNbr": this.tenderDetailSequenceNbr,
                "tenderDetailStatusCd": this.tenderDetailStatusCd,
                "tenderDetailStatusMessage": this.tenderDetailStatusMessage,
                "appointmentRequiredInd": this.appointmentRequiredInd,
                "customerProfitabilityInstId": this.customerProfitabilityInstId
            };
        };
    }
}
/**
 * Elastic Search document for Pickup line item
 */
class PickupLineItemSearchRecord {
    constructor() {
        this.pickupRequestInstId = undefined;
        this.hostOriginTerminalSicCd = undefined;
        this.zip6 = undefined;
        this.pickupRequestSequenceNbr = undefined;
        this.palletsCount = undefined;
        this.loosePiecesCount = undefined;
        this.weightLbs = undefined;
        this.guaranteedInd = undefined;
        this.hazardousMtInd = undefined;
        this.freezableInd = undefined;
        this.statusCd = undefined;
        this.destinationTerminalSicCd = undefined;
        this.createdUserId = undefined;
        this.remarks = undefined;
        this.updateById = undefined;
        this.serviceTypeCd = undefined;
        this.holDeliveryInd = undefined;
        this.proNbr = undefined;
        this.headloadInd = undefined;
        this.cubeNbr = undefined;
        this.earlyCutoffCd = undefined;
        this.motorMovesNbr = undefined;
        this.archiveInd = undefined;
        this.shipmentInstanceId = undefined;
        this.omsCd = undefined;
        this.omsEmployeeUserId = undefined;
        this.omsAuthUserId = undefined;
        this.foodInd = undefined;
        this.bolInstId = undefined;
        this.ediSenderId = undefined;
        this.ediSenderShipmentId = undefined;
        this.optOutBy = undefined;
        this.totalVolumeCubicFeet = undefined;
        this.bulkLiquidInd = undefined;
        this.suspectCubeInd = undefined;
        this.reviewReqdInd = undefined;
        this.moveShiftDate = undefined;
        this.moveShiftCd = undefined;
        this.expectedDeliveryDate = undefined;
        this.cubicFeetProfileMthdCd = undefined;
        this.cubicFeetProfileTypeCd = undefined;
        this.sourceCd = undefined;
        this.originalPickupRequestInstId = undefined;
        this.originalPickupRequestSequenceNbr = undefined;
        this.lstUpdtTmst = undefined;
        this.eventTmst = undefined;
        this.eventActionCd = undefined;
        this.pickupTypeCd = undefined;
        this.shipper = undefined;
        this.requestor = undefined;
        this.header = undefined;
        this.specialServiceSummary = undefined;
        this.suppRef = undefined;
        this.preassignedDriver = undefined;
        this.remarksAvailableInd = undefined;
        this.operationalRemarks = undefined;
        this.pickupInstructions = undefined;
        this.locationType = undefined;
        this.minimumAllowableTrailerAge = undefined;
        this.pickupDwellTime = undefined;
        this.equipmentDwellTime = undefined;
        this.lineItemCount = undefined;
        this.srnCount = undefined;
        this.headerDerivedStatusCd = undefined;
        this.pickupCreateDateTime = undefined;
        this.rescheduledCount = undefined;
        this.specialEquipmentCd = undefined;
        this.eventTmstMicro = undefined;
        this.destinationZipCount = undefined;
        this.ediSenderIdCount = undefined;
        this.destinationSicCount = undefined;
        this.dispatchGroupId = undefined;
        this.tripInstId = undefined;
        this.carrierId = undefined;
        this.tenderId = undefined;
        this.tenderDetailSequenceNbr = undefined;
        this.tenderDetailStatusCd = undefined;
        this.tenderDetailStatusMessage = undefined;
        this.appointmentRequiredInd = undefined;
        /**
         * The unique, randomly-generated number that identifies a registered customer.  'Profitability' should have been generated as 'Profile', but the wrong abbreviation was used for the associated column name.
         */
        this.customerProfitabilityInstId = undefined;
    }
}
/**
 * Details which are used to confirm the rescheduling of a pickup request.
 */
class RescheduledPickupRequest {
    constructor() {
        /**
         * The unique identifier of the pickup request.
         */
        this.pkrPickupRequestId = undefined;
        /**
         * The business key which is used to uniquely identify a pickup request.
         */
        this.callNbr = undefined;
        /**
         * The business key (format: ddnnn) which is used to uniquely identify a pickup request from the SCO application.
         */
        this.callNbrLegacy = undefined;
        /**
         * The identification code for the service center that is responsible for processing the pickup request.
         */
        this.pickupTerminalSicCd = undefined;
        /**
         * The exception message that may occur when rescheduling the pickup request.
         */
        this.exceptionMessage = undefined;
    }
}
/**
 * This records the pickup request information as received.
 * The pickup request can be received from 3 different channels/sources:
 * 1. Electronic BOL entered by customer on XPO.com
 * 2. Customer calls CSR
 * 3. EDI
 *
 * It is possible that the same request to pickup could be received via multiple channels. System can automatically merge duplicates or identify potential duplicates for CSR to review.
 * Upon review, CSR could merge a pickup request with another existing pickup request.
 */
class PkrPickupRequest {
    constructor() {
        /**
         * System Generated ID to uniquely identify a record.
         */
        this.pkrPickupRequestId = undefined;
        /**
         * Expanded Name : Source Code
         *
         * Desc : Indicates the source or origination of the Pickup Request.
         *
         * Valid Values:
         * 1 - Pickup Request web page for customers
         * 2   - set 204 or set 211
         * 3  - Mixed (changed from FTP 11/13/17)
         * 4  - Auto-genned (SMART4 batch)
         * 5 - Internal (SMART 4)
         * 6 - Operational (added 11/13/17)
         */
        this.sourceCd = undefined;
        /**
         * Business key to uniquely identify a pickup request.
         * Format: SIC-yyyymmdd-nnn  where SIC is the SIC code that received this request, yyyymmdd is the date when the pickup request was received (Date portion of CRTE_TMST). nnn is running seq for SIC/yyyymmdd
         */
        this.callNbr = undefined;
        /**
         * Expanded Name:  Call Sequence Number
         *
         * Desc:  A number sequentially generated by the system starting from 1 for a given SIC plus date when pickup req was received (Date portion of CRTE_TMST)
         * E.G. UPO for requests created on 2/27/2019 will have sequence from 1 through 55
         */
        this.callSequenceNbr = undefined;
        /**
         * Expanded Name : Status Code
         *
         * Desc : Current status of the Pickup Request.
         *
         * Valid Values:
         * 1 - Entered
         * 2 - Scheduled (for CAD dispatch only, not used by SMART4)
         * 3 - Cancelled
         * 4 - Pre-assigned/Routed [SMART 4]
         * 5 - Dispatched (SMART 4)
         * 6 - Freight is ON BOARD (pickup completed) [SMART 4]
         */
        this.statusCd = undefined;
        /**
         * Desc: Possible Duplicate with this pickup request. E.g. this is for the same shipper and same pickup date. Presence of this prompts the CSR to review and merge if this pickup req is indeed duplicate of pickup req identified by POSSIBLE_DUP_PKUP_REQ_ID
         */
        this.possibleDuplicatePickupRequestId = undefined;
        /**
         * Expanded Name : Pickup Date
         *
         * Desc : Date that the freight is to be picked up at a  Pickup Location.
         */
        this.pickupDate = undefined;
        /**
         * Expanded Name : Total Pallets count
         *
         * Desc : Total Pallets from all Shipments on the
         * Pickup Request.
         */
        this.totalPalletsCount = undefined;
        /**
         * Expanded Name : Total Loose Pieces count
         *
         * Desc : Total loose pieces from all Shipments on the
         * Pickup Request.
         */
        this.totalLoosePiecesCount = undefined;
        /**
         * Expanded Name : Total weight (in pounds)
         *
         * Desc : Total weight of all the freight being moved as
         * part of a Pickup Request.
         */
        this.totalWeightLbs = undefined;
        /**
         * Expanded Name : Pickup terminal SIC
         *
         * Desc : SIC where the Pickup Request is sent.
         * This is the SIC that is responsible for processing the pickup request.  If we were dealing with a zone situation, this would be the zone office.
         *
         * Example:  The shipper address is in Tillamook, Oregon (UTY), the western zone office is UZO.  When this pickup request is created, the responsible SIC is UZO.
         */
        this.pickupTerminalSicCd = undefined;
        /**
         * Expanded Name: Shipper SIC Code
         *
         * Desc: This is the SIC code for  the service center that encompasses the shipper location, based on shippers address. This service cneter may or may not always provide the pick up and delivery service to this customer location.
         *
         * Example:  The shipper address is in Tillamook, Oregon (UTY) and the western zone office is UZO.  When this pickup request is created, the customer SIC is UTY.  If a different SIC performs the actual pickup,for example,  Bend, Oregon (UBD), the Origin Terminal SIC is changed to UBD but the Customer SIC remains as UTY.
         */
        this.shipperSicCd = undefined;
        /**
         * Expanded Name : Origin terminal SIC
         *
         * Desc : This is typically the SIC where the Pickup Request orginated based on shippers address.
         *
         * This is the SIC that will perform the actual pickup.  If we were dealing with a zone situation, this would be the zone SIC.
         *
         * Example:  The shipper address is in Tillamook, Oregon (UTY) and the western zone office is UZO.  When this pickup request is created, the origin SIC is UTY.
         */
        this.originTerminalSicCd = undefined;
        /**
         * Expanded Name : Shipper CIS Customer Number
         *
         * Desc : LEGACY CUSTOMER NUMBER -Identifier of the appropriate customer in CIS,
         * determined by the matching sub-routine (97 percent shippers are coded in customer system)
         */
        this.shipperCisCustomerNbr = undefined;
        /**
         * Expanded Name : Shipper Name Line 1
         *
         * Desc : Name Line 1 of the Company that is the Pickup Location.
         *
         * Valid Values :
         */
        this.shipperName1 = undefined;
        /**
         * Expanded Name : Shipper Name Line 2
         *
         * Desc : Name Line 2 of the Company that is the Pickup Location.
         *
         * Valid Values :
         */
        this.shipperName2 = undefined;
        /**
         * Address Line 1 of the shipper
         */
        this.shipperAddress1 = undefined;
        /**
         * Address Line 2 of the shipper
         */
        this.shipperAddress2 = undefined;
        /**
         * Expanded Name : Shipper City
         *
         * Desc : City where the Pickup Location is located.
         *
         * Valid Values :
         */
        this.shipperCity = undefined;
        /**
         * Expanded Name : Shipper State
         *
         * Desc : State where the Pickup Location is located.
         *
         * Valid Values :
         */
        this.shipperStateCd = undefined;
        /**
         * Expanded Name : Shipper Zip (code) first 5 (characters) (6
         * characters for Canadian zips)
         *
         * Desc : Zip Code where the Pickup Location is located.
         * First 5 characters of the zip code for a US
         * address or first 6 characters of the Canadian zip code
         * of the address where the customer is located.
         *
         * Valid Values :
         */
        this.shipperZip6 = undefined;
        /**
         * Expanded Name : Shipper Zip (Code) last 4 (characters)
         *
         * Desc : Last 4 characters of the zip code for a US
         * address for the Pickup Location.
         */
        this.shipperZip4RestUs = undefined;
        /**
         * Expanded Name : Shipper Country
         *
         * Desc : Country where the Pickup Location is located.
         *
         * Valid Values :
         */
        this.shipperCountryCd = undefined;
        /**
         * Expanded Name: Phone Country Code
         *
         * Desc: Country code for the phone number of the Requestor for a Pickup Request.
         */
        this.shipperPhoneCountryCd = undefined;
        /**
         * Expanded Name:  Phone Extension Number
         *
         * Desc: Phone Extension of the Shipper for a Pickup Request.
         */
        this.shipperPhoneExtension = undefined;
        /**
         * Expanded Name:  Phone Area Code
         *
         * Desc:  Area code for the phone number of the Shipper for a Pickup Request
         */
        this.shipperPhoneAreaCd = undefined;
        /**
         * Expanded Name: Phone Number
         *
         * Desc:  Phone number of the Shipper for a Pickup Request.
         */
        this.shipperPhoneNbr = undefined;
        /**
         * Expanded Name:  Shipper Credit Status Code
         *
         * Desc: Credit status code of the shipper
         * Values:
         * CASH
         * BANKRUPT
         * CREDIT
         * NO_CREDIT
         * VOLUNTARY
         */
        this.shipperCreditedStatusCd = undefined;
        /**
         * Expanded Name : Customer Profile Instance Id
         *
         * Desc : A unique, randomly-generated number that
         * identifies a registered customer in the Con-Way
         * Customer Profile Component.
         */
        this.shipperProfitabilityInstId = undefined;
        /**
         * Unique Instance ID assigned to area by the GEO Area component on the middle tier
         */
        this.shipperAreaInstId = undefined;
        /**
         * Expanded Name : Requestor Name
         *
         * Desc : Name of the Requestor.
         *
         * Valid Values :
         */
        this.requesterName = undefined;
        /**
         * Expanded Name : Requestor Company Name.
         *
         * Desc : Company Name of the Requestor.
         *
         * Valid Values :
         */
        this.requesterCompanyName = undefined;
        /**
         * Expanded Name : Requestor Phone Country Code
         *
         * Desc : Country code for the phone number of the
         * Requestor for a Pickup Request.
         */
        this.requesterPhoneCountryCd = undefined;
        /**
         * Expanded Name : Requestor Phone Area Code
         *
         * Desc : Area code for the phone number of the Requestor
         * for a Pickup Request.
         */
        this.requesterPhoneAreaCd = undefined;
        /**
         * Expanded Name : Requestor Phone Number
         *
         * Desc : Phone number of the Requestor for a Pickup Request.  In many cases, this may turn out to be the
         * same as the shipper.
         */
        this.requesterPhoneNbr = undefined;
        /**
         * Expanded Name : Requestor Phone Extension Number
         *
         * Desc : Phone Extension of the Requestor for a Pickup Request .  This may often turn out to be the shipper in
         * many cases.
         */
        this.requesterPhoneExtension = undefined;
        /**
         * Expanded Name : Requestor E-mail Id
         *
         * Desc : E-mail address of the requestor, used to return
         * any confirmation e-mail when the pickup request has
         * been accepted.
         */
        this.requesterEmail = undefined;
        /**
         * Expanded Name : Requestor Role Code
         *
         * Desc : The role of the entity making the request for the pickup.
         *
         * Valid Values :
         * SHIPPER
         * CONSIGNEE
         * THIRD_PARTY
         */
        this.requesterRoleCd = undefined;
        /**
         * Expanded Name : Contact Name
         *
         * Desc : Name of the Contact.
         *
         * Valid Values :
         */
        this.contactName = undefined;
        /**
         * Expanded Name : Contact Company Name.
         *
         * Desc : Company Name of the Contact.
         *
         * Valid Values :
         */
        this.contactCompanyName = undefined;
        /**
         * Expanded Name : Contact Phone Country Code
         *
         * Desc : Country code for the phone number of the
         * Contact for a Pickup Request.
         */
        this.contactPhoneCountryCd = undefined;
        /**
         * Expanded Name : Contact Phone Area Code
         *
         * Desc : Area code for the phone number of the Contact
         * for a Pickup Request.
         */
        this.contactPhoneAreaCd = undefined;
        /**
         * Expanded Name : Contact Phone Number
         *
         * Desc : Phone number of the Contact for a Pickup Request.  In many cases, this may turn out to be the same as the shipper.
         */
        this.contactPhoneNbr = undefined;
        /**
         * Expanded Name : Contact Phone Extension Number
         *
         * Desc : Phone Extension of the Contact for a Pickup Request   This may often turn out to be the shipper in
         * many cases.
         */
        this.contactPhoneExtension = undefined;
        /**
         * Indicates the type of pickup.
         *
         * Values:
         * NORMAL
         * SPOT_EMPTY
         * HOOK_LOADED
         * HOOK_EMPTY
         */
        this.pickupTypeCd = undefined;
        /**
         * Desc: ID of the Equipment related to this Pickup.  Examples: Trailer that is expected to be hooked;  Customer-managed Truckload ID.
         */
        this.equipmentNbr = undefined;
        /**
         * Expanded Name:  Special Equipment Requirement Code
         *
         * Desc:  Indicates whether any special equipment is required to make the pickup.
         *
         * Valid valies:
         * L - Liftgate
         * F - Forklift
         * P - Pallet Jack
         */
        this.specialEquipmentCd = undefined;
        /**
         * The purpose of the strand indicator is to signal that the freight contained on this pickup request is going to be handled differently by O/B Planning.  Typically, freight that is stranded does not move out the evening that it is picked up.
         *
         * Is set to Y if freight on the pickup request needs to be stranded. Otherwise is set to N
         */
        this.strandInd = undefined;
        /**
         * The purpose of the Strand Reason Code is to specify the reason that the freight contained on this pickup request is going to be handled differently by O/B Planning.  Freight that is stranded does not move out the evening that it is picked up.
         *
         * Valid Values:
         * space - Not Stranded
         * L - Late Tender (customer caused)
         * C - Con-way (Con-way caused)
         */
        this.strandReasonCd = undefined;
        /**
         * Expanded Name:  Cash Due Indicator
         *
         * Desc:  Indicates whether cash needs to be collected by the driver at the time of pickup.
         *
         * Values :
         * 	Y - Cash is Due
         * 	N - No
         */
        this.cashDueInd = undefined;
        /**
         * Expanded Name:  Early Cut-off Time Indicator
         *
         * Desc:  Used in conjunction with EARLY_CUTOFF_CD in PKR_DELIVERY_LOCATION.  Used to indicate that the pickup request has one or more shipments on it that will require getting back to the service center earlier than the standard cut-off time for outbound freight.
         *
         * Values:
         * Y - Has an early cut-off shipment
         * N -- No
         */
        this.earlyCutoffInd = undefined;
        /**
         * Extended Name:  Inside Pickup Indicator
         *
         * Desc:  Indicates whether this will be an inside pickup.
         * Values:
         * 	N - No
         * 	Y - Is an inside delivery
         */
        this.insidePickupInd = undefined;
        /**
         * Expanded Name: Volume Indicator
         *
         * Desc:  Indicates a pickup request that consists of weight greater than 5000 lbs
         * Values:
         * 	N - Not a volume pickup
         * 	Y - Is a volume pickup
         */
        this.volumeInd = undefined;
        /**
         * Description:  Indicates the reason why a pickup request was rescheduled.   Note this is longer than normal length 20.
         *
         * Valid values are in table PKR_REASON_CODE
         */
        this.rescheduleReasonCd = undefined;
        /**
         * Desc: Reschedule  Contact Name
         * Contact name of the person authorizing or requesting the  reschedule of the Shipment. To help Track EDI/EBOL cancellation.
         *
         * 07/17/2018 Cathy Doucet Added as per Asha Kava for EBOL Accountability R2
         */
        this.rescheduleContactName = undefined;
        /**
         * Desc: Reschedule Contact Phone Number
         * Full Contact Phone Number (incudes Area code) of the person authorizing or requesting the reschedule of the Shipment.  To help Track EDI/EBOL cancellation.
         *
         *
         * 07/17/2018 Cathy Doucet Added as per Asha Kava for EBOL Accountability R2
         */
        this.rescheduleContactPhoneNbr = undefined;
        /**
         * Desc: For trailers containing Deconsolidation shipments, the expected arrival shift date
         */
        this.arrivalShiftDate = undefined;
        /**
         * Desc: For trailers containing Deconsolidation shipments, the expected arrival shift.
         *
         * Non Null Values:
         * I - Inbound
         * D - Day FAC
         * O - Outbound
         * N - Night FAC
         */
        this.arrivalShiftCd = undefined;
        /**
         * Desc: For trailers containing Deconsolidation shipments, a unique Identifier of the Trailer Load, example: Seal Number.
         */
        this.loadId = undefined;
        /**
         *
         */
        this.pickupPriorityNbr = undefined;
        /**
         * Cancel Reason Codes.  Note this is longer than normal length 20.
         *
         * Valid values are in table PKR_REASON_CODE
         */
        this.cancelReasonCd = undefined;
        /**
         * The date in which Pickup request is cancelled
         */
        this.cancelDate = undefined;
        /**
         * Pickup Request Cancel Description.  Used to record detailed free format  information about pickup request cancellations.
         */
        this.cancelRemark = undefined;
        /**
         *
         */
        this.callCustomerBeforePickupInd = undefined;
        /**
         *
         */
        this.carrierName = undefined;
        /**
         * Special instructions for the DSR for handling of the Pickup request.  11/01/2021 Increased length from 120.  LISG-15458
         */
        this.dsrNote = undefined;
        /**
         * Expanded Name : Remarks
         *
         * Desc : Freeform textual comments used to relate information pertinent to the Pickup Request or Pickup Location.  07/28/2021  LISG-14052 Increased length from 1000
         */
        this.pickupRemark = undefined;
        /**
         * A same value is assigned to CORRELATION id of various rows from different tables that form a single business transactions. In other words, this groups multipple rows across various tables for a single business transaction..
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tion.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id.
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         */
        this.pkrEventId = undefined;
        /**
         * Expanded Name : Ready Time
         *
         * Desc : Earliest available time that freight can be
         * picked up from a Pickup Location.
         * Recorded in the following format:  HH24:MI
         * EXAMPLE: 16:30 for 4:30pm
         *
         * Note:  This time is stored as LOCAL time (not Pacific time).
         */
        this.readyTime = undefined;
        /**
         * Expanded Name : Close Time
         *
         * Desc : Latest available time that freight can be
         * picked up from a Pickup Location.
         *
         * Note:  This time is stored as LOCAL time (not Pacific time).
         *
         * Recorded in the following format:  HH24:MI
         * EXAMPLE: 16:30 for 4:30pm
         */
        this.closeTime = undefined;
        /**
         * When a Pickup Request is re-scheduled, capture detailed re schedue notes
         */
        this.rescheduleReasonRemark = undefined;
        /**
         * When a Pickup Request is Re-Scheduled, capture the Email address of the contact person who has requedted a re-schedule either from a shipper -or- consignee -o- 3PL.  07/28/2021  Increased length from 100  LISG-14052
         */
        this.rescheduleContactEmail = undefined;
        /**
         * Desc: Cancel Contact Phone Number
         *
         * Full Contact Phone Number (incudes Area code) of the person authorizing or requesting the cancel of the Shipment.  To help Track EDI/EBOL cancellation.
         */
        this.cancelContactPhoneNbr = undefined;
        /**
         * When a Pickup request is cancelled, capture email addres of the contact person requesting cancellation either from shipper -or- consignee -or- 3PL
         */
        this.cancelContactEmail = undefined;
        /**
         * Capture Appoint Required Indicator at the time of Pickup.  For the time being this is captured in Pickup Request and will be revisited during Appointment Management development work holistically.
         * 'Y' - Appointment Required
         * 'N' - Appointment not Required
         */
        this.appointmentRequiredInd = undefined;
        /**
         * Appointment Time Window   Start Date and Time.
         *
         * 1) In the application capture the date and time separately and concatenate to store here.
         * 2) If only Date portion is captured then Appointment window is a all day window.
         * 3) If the time portion is available then this is the start time and cannot be > APPT_TO_DATE
         *
         * 09/10/2021  LISG-14952 Changed suffix from _DT to _DTTM to allow change to mthods in the transformers in Java
         */
        this.appointmentConfirmFromDateTime = undefined;
        /**
         * Appointment Time Window   End Date and Time.
         *
         * 1) In the application capture the date and time separately and concatenate to store here.
         * 2) If only Date portion is captured then Appointment window is a all day window.
         * 3) If the time portion is available then this is the End time and cannot be < APPT_FROM_DATE
         *
         * 09/10/2021  LISG-14952 Changed suffix from _DT to _DTTM to allow change to mthods in the transformers in Java
         */
        this.appointmentConfirmToDateTime = undefined;
        /**
         *
         */
        this.areaInstId = undefined;
        /**
         * When a Pickup Request is Re-scheduled, this indicator is updated to 'Y'. Values Permited 'Y' or 'N'
         */
        this.rescheduleInd = undefined;
        /**
         * Dock drop means customer will drop their shipments at our dock
         */
        this.dockDropInd = undefined;
        /**
         * Increased length from 10 to 11.  11/11/2021  LISG-15549
         */
        this.trailerNbr1 = undefined;
        /**
         * Increased length from 10 to 11.  11/11/2021  LISG-15549
         */
        this.trailerNbr2 = undefined;
        /**
         * Increased length from 10 to 11.  11/11/2021  LISG-15549
         */
        this.trailerNbr3 = undefined;
        /**
         * TRailer Count
         */
        this.trailerCount = undefined;
        /**
         * Identify possibole duploicate shipments from the same Pickup Request that has the following similar criteria
         * 1)   Shipments created under the same Pickup Request with the same  consignee zip code and weight with a threshold of plus or minus 10 percent.
         */
        this.possibleDuplicateShipmentInd = undefined;
        /**
         * Indicates if the customer location is residential, commercial, construction ..
         *
         * Valid Values:
         * BusinessCommercialBUSINESS/COMMERCIAL
         * DistributionCenterDISTRIBUTION CENTER
         * GroceryWareHouseGROCERY WAREHOUSE
         * ShoppingMallSHOPPING MALL/STRIP MALL
         * UnversityCollegeUNIVERSITY/COLLEGE
         * ConstructionSiteCONSTRUCTION/UTILITY SITES: CONSTRUCTION SITE
         * ConstructionUtilitySiteCONSTRUCTION/UTILITY SITES: UTILITY SITE
         * GovtMineGOVERNMENT SITES: MINE
         * GovtGasOilFieldGOVERNMENT SITES: NATURAL GAS OR OIL FIELD
         * GovtPostOfficeGOVERNMENT SITES: POST OFFICE
         * GovtMilitaryGOVERNMENT SITES: MILITARY
         * GovtPrisonCorrectionGOVERNMENT SITES: PRISON/CORRECTION FACILITY
         * GovtAirportGOVERNMENT SITES: AIRPORT
         * GovtOtherGOVERNMENT SITES: OTHER GOVERNMENT SITES
         * PierContainerFreightStationPIERS, WHARFS, CFS: CONTAINER FREIGHT STATION
         * PierWharfPIERS, WHARFS, CFS: PIER OR WHARF
         * ResidentialHomeRESIDENTIAL: RESIDENCE
         * ResidentialApartmentRESIDENTIAL: APARTMENT
         * ResidentialPlaceofWorshipRESIDENTIAL: PLACE OF WORSHIP
         * ResidentialSchoolRESIDENTIAL: SCHOOL (K-12)
         * ResidentialCampRESIDENTIAL: CAMP
         * ResidentialFarmRESIDENTIAL: FARM
         * ResidentialPublicStorageRESIDENTIAL: PUBLIC STORAGE FACILITY
         * ResidentialBusinessRESIDENTIAL: BUSINESS OPERATING WITHIN A PRIVATE RESIDENCE
         * ExhibitionConvCtrEXHIBITION SITES: EXHIBITION SITE OR CONVENTION CENTER
         */
        this.locationTypeCd = undefined;
        /**
         * Pickup Request cancelled after Driver has arrived at the Customer/Shipper Location.
         * Values Allowed (Y/N)
         * Default Value 'N'
         */
        this.cancelAfterDsrArrivalInd = undefined;
        /**
         * Pickup Request re-scheduled after Driver has arrived at the Customer/Shipper Location.
         * Values Allowed (Y/N)
         * Default Value 'N'
         */
        this.rescheduleAfterDsrArrivalInd = undefined;
        /**
         * Indicates if the DSR has to notify the pickup location contact on arrival to the shipper location.  Added 07/28/2021  LISG-14046
         */
        this.notifyShipperOnArrivalInd = undefined;
        /**
         * Indicates if the pickup request appointment is set.  Added 07/28/2021  LISG-14046
         */
        this.appointmentConfirmInd = undefined;
        /**
         * Email of the Pickup Location contact.  Added 07/28/2021  LISG-14046
         */
        this.contactEmail = undefined;
        /**
         * Business key to uniquely identify a pickup request from SCO Application. Format: SIC-DD-nnn where
         * 1)  SIC is the SIC code that received the request
         * 2) DD is the two digit date section of the date
         * 3)  nnn is the running sequence number
         *
         * This column is added in order to preserve the SCO Call Number which will be used in the application until SCO is retired.
         * Once SCO is retired, application will switch to the new CALL_NBR_TX
         */
        this.callNbrLegacy = undefined;
        /**
         * Identifies if the pickup location is in XPO Customer database, or is a Future (potential) Customer.  Added 08/10/2021  LISG-14344
         */
        this.shipperCustomerTypeCd = undefined;
        /**
         * When a Pickup Request is Re-Scheduled, capture the Company name.  Added 08/12/2021  LISG-14408
         */
        this.rescheduleContactCompanyName = undefined;
        /**
         * Contact Phone Number extension of the person authorizing or requesting the reschedule of the Shipment.  Added 08/12/2021  LISG-14408
         */
        this.rescheduleContactPhoneExt = undefined;
        /**
         * When a Pickup request is cancelled, capture name of the contact person requesting cancellation either from shipper -or- consignee -or- 3PL.  Added 08/12/2021  LISG-14408
         */
        this.cancelContactName = undefined;
        /**
         * Contact Phone Number extension of the person authorizing or requesting the cancelling of the Shipment.  Added 08/12/2021  LISG-14408
         */
        this.cancelContactPhoneExt = undefined;
        /**
         * When a Pickup Request is Cancelled, capture the Company name.  Added 08/12/2021  LISG-14408
         */
        this.cancelContactCompanyName = undefined;
        /**
         * Identifies the Last generated Sequence Number for the PUR Delivery Location Item for the Pickup Request. Added 10/18/2021  LISG-15338
         */
        this.lastUsedSequenceNbr = undefined;
        /**
         * Original Source Code of Pickup Request.   Added 02/25/2022  LISG-16213
         *
         * Values (need to switch to longer ENUMS when appropriate):
         * 1 - WEB
         * 2 - EDI
         * 3 - DAILY
         * 5 - INTERNAL
         */
        this.originalSourceCd = undefined;
        /**
         * Identifier of the Pickup contact.  Added 03/14/2022 LISG-16358
         */
        this.contactKeyNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * when a pickup request is merged with another, this records the PKR_PICKUP_REQUEST_ID of the request with which this pickup request is merged. The status of this pickup request is set to MERGED_TO, which also means this pickup request is no more to be used (logically deleted)
         */
        this.parentMergeToPkrPickupRequestId = undefined;
        /**
         * This allows further sub categorization of the codes specifically for rescheduling purposes.
         */
        this.rescheduleReasonSubCategory = undefined;
        /**
         * The long description for the code which is specific to rescheduling.
         */
        this.rescheduleReasonDescription = undefined;
        /**
         * This allows further sub categorization of the codes specifically for cancellation purposes.
         */
        this.cancelReasonSubCategory = undefined;
        /**
         * The long description for the code which is specific to cancellation.
         */
        this.cancelReasonDescription = undefined;
    }
}
/**
 * Customer might request multiple shipments to be picked up from a shipper, typically going to different destinations. This entity records various shipments to be picked up as part of a given pickup request.
 *
 * e.g. A pickup request could be have 3 shipments to be picked up for the following destinations: Dallas, LA, San Jose.
 * Note, CSR/DSR might determine that one of the shipments is not picked up today but instead as part of pickup scheduled for another date. In this case, that line might be moved from one pickup request to another.
 *
 *
 */
class PkrShipment {
    constructor() {
        /**
         * System Generated ID to uniquely identify a record.
         * This entity has its own surrogate key and does not use relationship to the PKR_PICKUP_REQUEST as part of the identifier because,
         * CSR might move a line from one pickup  equest to another.
         *
         * If this shipment line is moved to a different pickup request, the original pickup req under which this shipment was originally requested can be obtained using the link to the PKR_RCVD_PKUP_REQ_LINE, which is the copy of Shipment line when this shipment line was first created.
         */
        this.pkrShipmentId = undefined;
        /**
         * Consignee Zip code.
         */
        this.destinationZip6 = undefined;
        /**
         * Expanded Name : Destination terminal SIC
         *
         * Desc : SIC responsible for the delivery of the Shipment.
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * NEW - when the line is created
         *
         * MERGED - When duplicate pickup requests are entered (e.g. one by CSR and another from EDI), they can be merged into a single pickup request (e.g. same shipper, same date before 5pm). Example: P1 is merged into P2.  P1 has shipment S1, P2 has shipment S2. During the merge, it is determined that S1 and S2 are the same (based on consigee, weight etc). In this case S1 will be set with status MERGED and at the same time MERGE_TO_PKR_PKUP_RQST_SHP_ID is set to S2 indicating that this line (S1) is logically deleted and merged into S2.
         *
         * DELETED - CSR/DSR might delete one shipment line when they determine that the shipper will not ship this shipment, but is shipping other shipments for this Pickup request
         */
        this.statusCd = undefined;
        /**
         * Expanded Name:  PRO Number
         *
         * Desc: The PRO number of the shipment.  This is typically entered at the time the pickup has been completed (freight on board).
         */
        this.proNbr = undefined;
        /**
         * When a shipment has been confirmed as picked up, a shipment record (SHM_SHIPMENT) is created and this attribute is set with the identifier of that shipment record.
         */
        this.shipmentInstanceId = undefined;
        /**
         * Desc: Internal identifier of the eBol (BOL_DOC).
         * When a BOL is created either by a customer or by EDI, a pickup request with shipment lines is created. This attribute links the shipment line with the BOL Identifier that created this shipment line for the pickup request.
         */
        this.bolInstanceId = undefined;
        /**
         * Expanded Name : pallet count
         *
         * Desc : Number of pallets in the shipment.
         */
        this.palletsCount = undefined;
        /**
         * Expanded Name : Total pieces count
         *
         * Desc : Total Loose pieces from all commodities in the
         * shipment.
         */
        this.loosePiecesCount = undefined;
        /**
         * Expanded Name: Total weight (in pounds)
         *
         * Desc : Total weight of the Shipment in pounds.
         */
        this.weightLbs = undefined;
        /**
         * Expanded Name:  Cube
         *
         * Desc: Specifies the amount of trailer area that the shipment will occupy.  A cube of 1.000 indicates that the entire trailer will be filled by the shipment.  A cube of 0.500 indicates that half of the trailer will be filled by the shipment.
         */
        this.cubeNbr = undefined;
        /**
         * Desc: The method used to calculate the volume of the freight (TOT_VOL_CFT).
         *
         * VALUES
         * ACTL - Actual dimensions captured by the driver
         * (length x width x height)
         * DEST - Shipper profile for the shipment.s destination
         * ZIP (average shipment volume when the shipper ships to
         * that ZIP)
         * DFLT - Default shipper profile (average shipment
         * volume for shipper regardless of ZIP)
         * SIC - Service center profile (average shipment volume
         * across all shipments at that SIC)
         * SYS - System profile (average shipment volume across
         * all shipments in LTL)
         *
         * 08/31/2016 Cathy Doucet Added as per Rajesh for P2Ds part in WNI changes.
         */
        this.cubicFeetProfileMethodCd = undefined;
        /**
         * Desc: If a default or destination shipper profile was used to calculate the volume of the freight, this field describes the type of shipper profile used.
         *
         * Allowed values:
         * FTPRNT - Footprint piece profile
         * VOLSHP - Volume-shipment
         * VOLPCE - Volume-piece
         * DNSITY - Density shipment
         * HEIGHT - Height piece
         *
         * 08/31/2016 Cathy Doucet Added as per Rajesh for P2Ds part in WNI changes.
         */
        this.cubicFeetProfileTypeCd = undefined;
        /**
         * Total Volume in Cubic Feet:
         *
         * Cubic feet of the Shipment.  This may be either the sum of the measured dimensions, or the estimate calculated from the shipment characteristics using the customer profile of location default density.
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * Expanded Name : Guaranteed Indicator
         *
         * Desc : Indicates if the shipment is under Guaranteed Service Program.
         *
         * Values : Y/N
         */
        this.guaranteedInd = undefined;
        /**
         * Expanded Name : Hazardous material indicator
         *
         * Desc : Indicates whether a hazardous material
         * commodity is being carried on a Shipment.
         *
         * Valid Values :
         * Y - Has hazardous materials
         * N - No hazardous materials
         */
        this.hazardousMaterialInd = undefined;
        /**
         * Expanded Name : Freezable Indicator
         *
         * Desc : Indicates whether shipment requires special
         * handling to prevent freezing during harsh weather.
         *
         * Valid Values : Y/N
         *
         * Y - Can be damaged by freezing
         */
        this.freezableInd = undefined;
        /**
         * Expanded Name: Food indicator
         *
         * Desc: Indicates whether foodstuffs, feed or other edible material intended for consumption by humans or animals is included in this shipment.
         *
         * Valid Values:
         * Y - Has food, feed or other edible material included in shipment
         * N - No food included in shipment
         */
        this.foodInd = undefined;
        /**
         * Expanded Name : Head Load Indicator
         *
         * Desc :  Indicates that the shipment has been placed in the nose of a trailer and will not need to be removed from the trailer for outbound.  Typically, the dispatcher or driver would update an existing pickup request with this information at the time the freight is on board.
         *
         * Valid Values: Y/N  ( Y - Is a head load )
         */
        this.headloadInd = undefined;
        /**
         * Is set to 'Y' if Consignee requests that the shipment be delivered on a Weekend (Saturday) or a Holiday. Otherwise, is set to 'N'
         */
        this.holidayDeliveryInd = undefined;
        /**
         * Expanded Name : Bulk Liquid indicator
         *
         * Desc : Indicates whether shipment contains a bulk liquid. If volume is known, this applies to shipments >119 gallons.
         *
         * Valid Values :
         * Y - Has Bulk Liquid
         * N - No Bulk Liquid
         *
         * Added 8/5/14 by Paul Bramhall for Tanker Endorsement Project.
         * -------------------------------------------------------------
         */
        this.bulkLiquidInd = undefined;
        /**
         * Desc: Indicates if the cube entered for the pickup line might be invalid.
         */
        this.suspectCubeInd = undefined;
        /**
         * Desc: Indicates if the pickup line item needs to be reviewed for accuracy.
         */
        this.reviewRequiredInd = undefined;
        /**
         * Expanded name:  Service type code.
         *
         * Description:  Defines the specific type of service
         * provided for a shipment.
         *
         * Values:
         * NORMAL
         * RRS - Rapid Remote Service
         * G12 - Guaranteed by Noon (G12)
         */
        this.serviceTypeCd = undefined;
        /**
         * Expanded Name:  Early Cut-off Time Code
         *
         * Desc:  Used to designate something about the origin/destination SIC that will require getting this shipment back to the service center earlier than the standard cut-off time for outbound freight.
         *
         * Values :
         * NORMAL - no early cut-off time
         * ESL         - (Extended Service Lane)
         */
        this.earlyCutoffCd = undefined;
        /**
         * Expanded Name:  Motor Moves
         *
         * Desc: Specifies the number of forklift moves (motor moves) that are required to move the shipment.  Typically, one pallet or barrel equals one motor move.
         */
        this.motorMovesNbr = undefined;
        /**
         * Desc: Sender-id of the EDI Customer.
         */
        this.ediSenderId = undefined;
        /**
         * Desc: Shipment identifier of the EDI Pkup Req supplied by the EDI Customer.
         */
        this.ediSenderShipmentId = undefined;
        /**
         * Opt out by:
         * The userid of the DSR who explicitly opted out of taking measurements at pickup time.
         */
        this.optOutBy = undefined;
        /**
         * Expanded Name: Remarks
         *
         * Desc : Freeform textual field to hold any additional information relevant to a Shipment on a Pickup Request.
         */
        this.remarks = undefined;
        /**
         * A same value is assigned to CORRELATION id of various rows from different tables that form a single business transactions. In other words, this groups multipple rows across various tables for a single business transaction..
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tion.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id.
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         */
        this.eventId = undefined;
        /**
         * Expanded Name : Override Source Code
         *
         * Desc : Indicates the source or origination of the shipment that is part of a pickup request. After pickup request is created, shipments can be added later on, including during confirming on-board the pickup.
         *
         * Valid Values:
         * WEB - Pickup Request web page for customers
         * EDI   - set 204 or set 211
         * EDGE - Application used by employees, such as CSR
         * MIXED - More than one source at the PKR Line level.  (i.e.  'EDI' , 'WEB)
         * DAILY - Batch Generated Pickup Request based on customer profile preferences (example. Pickup on Wed at 12noon)
         * OPER  Shipments added to the pickup request during its operational course
         */
        this.overrideSourceCd = undefined;
        /**
         * Indicates that the PRO is exempted to be tracked via piece level. SLC (Shipper Loaded Count) shipments are generally exempted. Pickups with 15 or more pieces are also allowed to be exempted.    Added 12/10/2020  LISG-9067  Renamed 01/07/2021
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         * An explanation of why a pro is exempted from piece level tracking.  Added 12/10/2020   LISG-9067 Renamed 01/07/2021
         */
        this.handlingUnitExemptionReason = undefined;
        /**
         * An appointment should be created for delivering the shipment.  Added 03/11/2021 Cathy Doucet LISG-10771
         */
        this.appointmentRequiredInd = undefined;
        /**
         * Identifies if a destination SIC override has already occurred - in which case update of line item should NOT change dest SIC.  Added for Kroger 10/16/2020
         */
        this.destinationSicOverrideInd = undefined;
        /**
         * Expanded Name : Source Code
         *
         * Desc : Indicates the source or origination of the Pickup Request.
         *
         * Valid Values:
         * WEB - Pickup Request web page for customers
         * EDI   - set 204 or set 211
         * MANUAL- Application used by employees, such as CSR
         * MIXED - More than one source at the PKR Line level.  (i.e.  'EDI' , 'WEB)
         * DAILY - Batch Generated Pickup Request based on customer profile preferences (example. Pickup on Wed at 12noon)
         */
        this.sourceCd = undefined;
        /**
         * Pickup Request Line Level sequence Number from PUR_DELIVERY_LOC in SCO
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         * Indicates whether Child Pro Entry was opted out when confirming on board a shipment.  Added 04/17/2023  LISG-53654
         */
        this.childProOptOutInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * This shipment line is merged with another shipment line as identified by this attribute.  Also see STATUS_CD=MERGED
         */
        this.parentMergeToPkrShipmentId = undefined;
        /**
         * Manually added. This is the old delivery location seqNbr that is required to support old processes using the PKR DTOs.
         */
        this.sequenceNbr = undefined;
        /**
         * When a shipment is moved from one pickup request to another capture the pickup request identifier from which a shipment is moved.
         */
        this.parentOriginalPickupRequestId = undefined;
        /**
         * This shipment line currently belongs to the Pickup Request identified by this attribute. Note CSR could move a shipment line to a different pickup request. e.g. if one of the many shipments was not ready today and needs to be rescheduled under a different pickup tomorrow.
         */
        this.parentPkrPickupRequestId = undefined;
    }
}
/**
 * Optionally stores the dimension (length, width, height) for a shipment line of the pick up request.
 *
 *
 */
class PkrShipmentDimension {
    constructor() {
        /**
         * The ID of the pickup request shipment line for which dimensions are captured
         */
        this.pkrShipmentId = undefined;
        /**
         * Allows multiple dimensions to be recorded for the same shipment
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name : Pieces count
         *
         * Desc : Number of pieces of the shipment this dimensions apply to.
         */
        this.piecesCount = undefined;
        /**
         * Expanded Name: Length
         *
         * Description: This is the length of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment the dimensions apply to.
         */
        this.lengthNbr = undefined;
        /**
         * Expanded Name: Width
         *
         * Description: This is the width of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment the dimensions apply to.
         */
        this.widthNbr = undefined;
        /**
         * Expanded Name: Height
         *
         * Description: This is the height of the whole or part of the shipment. The number of pieces attribute indicates how many pieces of the shipment the dimensions apply to.
         */
        this.heightNbr = undefined;
        /**
         * Expanded Name: Stackable indicator
         *
         * Desc: Indicator that specifies if the box/pallet can be stackable
         *
         * Values:Y = Stackable
         * N = Not stackable
         */
        this.stackableInd = undefined;
        /**
         * A same value is assigned to CORRELATION id of various rows from different tables that form a single business transactions. In other words, this groups multipple rows across various tables for a single business transaction..
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tion.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id.
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         */
        this.eventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * During Pickup completion from HH, they want to capture the dimension capture code.  Added 05/03/2022 LISG-16757
         *
         * Valid Values:
         * P=PICKUP
         * U=PICKUP_DIMENSIONER
         */
        this.dimensionTypeCd = undefined;
    }
}
/**
 *  When a shipment is confirmed on board, a unique tracking# label is stuck to indiividual piece. This records the information about individual piece of a given shipment
 */
class PkrShipmentHandlingUnit {
    constructor() {
        /**
         * The ID of the parent pickup request shipment line for which the handling unit is recorded
         */
        this.pkrShipmentId = undefined;
        /**
         * A system assigned number used as part of how to uniquely identify each handling unit of a shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * Child PRO number identifies a handling unit of a shipment. This is an alternate key of the table.The numbers are printed on labels and are assigned to service centers. Labels are placed on 2 sides of each pieces (usually by pallet) of the shipment pic
         */
        this.childProNbr = undefined;
        /**
         * Weight of this handling unit.
         */
        this.weightLbs = undefined;
        /**
         * Volume in cubic feet of this handling unit.
         */
        this.volumeCubicFeet = undefined;
        /**
         * Length of this handling unit.
         */
        this.lengthNbr = undefined;
        /**
         * Width of this handling unit.
         */
        this.widthNbr = undefined;
        /**
         * Height of this handling unit.
         */
        this.heightNbr = undefined;
        /**
         * Indicates whether the handling unit can be stacked or not.
         */
        this.stackableInd = undefined;
        /**
         * Indicates whether or not the handling unit is a hazardous material.
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether or not the handling unit is a freezable materia
         */
        this.freezableInd = undefined;
        /**
         * A same value is assigned to CORRELATION id of various rows from different tables that form a single business transactions. In other words, this groups multipple rows across various tables for a single business transaction..
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tion.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id.
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         */
        this.eventId = undefined;
        /**
         * The type of handling unit.  Added 10/29/2020
         *
         * Valid Values:
         * MOTOR
         * LOOSE
         */
        this.typeCd = undefined;
        /**
         *
         */
        this.statusCd = undefined;
        /**
         * This is the volume of the handling unit expressed as a percentage of a full pup (28 foot long trailer).Added 10/25/2021  LISG-15410
         */
        this.pupVolumePercentage = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * The business identifier for the parent shipment.
         */
        this.parentProNbr = undefined;
        /**
         * Used to be able to identify based on the PUR_DELIVERY_LOC key.
         */
        this.parentSequenceNbr = undefined;
        /**
         * During Pickup completion from HH, they want to capture the dimension capture code.  Added 05/03/2022 LISG-16757
         *
         * Valid Values:
         * PICKUP
         * PICKUP_DIMENSIONER
         */
        this.dimensionTypeCd = undefined;
        /**
         * Indicates whether the shipment is poorly packaged.
         */
        this.poorlyPackagedInd = undefined;
    }
}
/**
 * Describes hazardous material details for one pickup request line item.
 *
 */
class PkrShipmentHazMat {
    constructor() {
        /**
         * The ID of the pickup request shipment line for which dimensions are captured
         */
        this.pkrShipmentId = undefined;
        /**
         * Expanded Name: Sequence number
         *
         * Desc: Used to uniquely identify a hazmat row of the shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name: UN/NA Number
         *
         * Desc: The UN or NA identification number for a hazardous material.  Format UN0009 or NA0009 (2 letters followed by 4 numbers).
         */
        this.hazmatUnna = undefined;
        /**
         * Expanded Name: Hazard Class Code
         *
         * Desc: The Primary Hazard Class Code of this hazardous material.
         */
        this.hazmatClassCd = undefined;
        /**
         * Expanded Name: Class Qualifier
         *
         * Desc: Describes the Primary Hazard Class of this hazardous material.
         */
        this.hazmatClassQualifier = undefined;
        /**
         * Expanded Name: Subsidiary Hazard Class 1
         *
         * Desc:  The first Subsidiary Hazard Class of this hazardous material (if any).
         */
        this.hazmatSubsidiaryClass1Cd = undefined;
        /**
         * Expanded Name: Subsidiary Qualifier 1
         *
         * Desc: Describes the first Subsidiary Hazard Class (if any).
         */
        this.hazmatSubsidiaryQualifier1 = undefined;
        /**
         * Expanded Name: Subsidiary Hazard Class 2
         *
         * Desc: The second Subsidiary Hazard Class of this hazardous material (if any).
         */
        this.hazmatSubsidiaryClass2Cd = undefined;
        /**
         * Expanded Name: Subsidiary Qualifier 2
         *
         * Desc: Describes the second Subsidiary Hazard Class (if any).
         */
        this.hazmatSubsidiaryQualifier2 = undefined;
        /**
         * Expanded Name: Weight in Pounds
         *
         * Desc: The weight, in pounds, of this hazardous material.
         */
        this.hazmatWeightLbs = undefined;
        /**
         * Expanded Name: Bulk quantity code
         *
         * Desc: Indicates the set of federal regulations to impose based on the volume of this hazardous material.
         * NON_BULK Non-bulk
         * BULK = Bulk
         * LIMITED_QTY = Limited Quantity
         */
        this.hazmatBulkQuantityCd = undefined;
        /**
         * Expanded Name: Residue indicator
         *
         * Desc: Y = Only the residue of the previous contents remains in the hazmat container.
         */
        this.hazmatResidueInd = undefined;
        /**
         * A same value is assigned to CORRELATION id of various rows from different tables that form a single business transactions. In other words, this groups multipple rows across various tables for a single business transaction..
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tion.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id.
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         */
        this.eventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
class Accessorial {
    constructor() {
        this.accessorialCd = undefined;
        this.quantity = undefined;
        this.quantityUom = undefined;
        /**
         * Description of the Accessorial
         */
        this.accessorialDesc = undefined;
        /**
         * Accessorial Amount
         */
        this.chargeAmt = undefined;
    }
}
class Appointment {
    constructor() {
        this.apptTypeCd = undefined;
        /**
         * A system generated sequence number to uniquely identify a nootification for a shipment
         */
        this.seq = undefined;
        this.startDateTime = undefined;
        this.endDateTime = undefined;
        this.callDateTime = undefined;
        /**
         * *** Needs Review
         */
        this.apptContact = undefined;
        /**
         * This might be any special instructions for accessing customer dock
         */
        this.apptNote = undefined;
        /**
         * customer provided reference number for the appointment
         */
        this.apptConfirmation = undefined;
        /**
         * Reason for rescheduling the appt.
         */
        this.rescheduleReasonCd = undefined;
        this.apptStatus = undefined;
        /**
         * SIC that will delivery freight according to this appt.
         */
        this.dlvrySIC = undefined;
        this.references = undefined;
    }
}
/**
 *
 */
class Bond {
    constructor() {
        /**
         * The IT, TE or WDTE number (7,8 or a 9 digit number) on the in-bond document. It is used to identify the Shipment while it is in the customs warehouse.
         */
        this.bondNbr = undefined;
        /**
         * The name of the city where the customs inspection is to be made.
         */
        this.city = undefined;
        /**
         * The state of the city where the customs inspection is to be made.
         */
        this.state = undefined;
    }
}
/**
 * Details for cash on delivery payments.
 */
class CashOnDelivery {
    constructor() {
        /**
         * The description of the payment method.
         */
        this.description1 = undefined;
        /**
         * The description of the COD amount.
         */
        this.description2 = undefined;
        /**
         * The COD amount.
         */
        this.amount = undefined;
    }
}
class ChemicalCharacteristics {
    constructor() {
        this.chemProperShippingName = undefined;
        this.chemTechnicalName1 = undefined;
        this.chemTechnicalName2 = undefined;
        this.chemTechnicalName3 = undefined;
        this.classPrimary = undefined;
        this.classSecondary = undefined;
        this.classTertiary = undefined;
        this.contentWeight = undefined;
        this.contentWeightUOM = undefined;
        this.reportableQuantityInd = undefined;
        this.reportQuantityWeight = undefined;
        this.reportQuantityWeightUOM = undefined;
        this.packagingGroupCd = undefined;
        this.specialProvision = undefined;
        this.emergencyGuideBookName = undefined;
        this.hotInd = undefined;
        this.residueInd = undefined;
        this.poisonousInd = undefined;
        this.notOtherwiseSpecifiedInd = undefined;
        this.limitedQuantityInd = undefined;
        this.toxicInhalationInd = undefined;
        this.passengerAircraftForbidInd = undefined;
        this.commercialAircraftForbidInd = undefined;
        this.massivePollutantInd = undefined;
        this.oilContainedInd = undefined;
        this.temperatureUOM = undefined;
        this.flashPointTemperature = undefined;
        this.emergencyTemperature = undefined;
        this.controlTemperature = undefined;
    }
}
/**
 * ***Needs Review
 */
class CommodityLine {
    constructor() {
        /**
         * Might be versions of a commodity line - original, corrected, as-rated
         */
        this.cmdyLineTypeCd = undefined;
        /**
         * sequence on shipment
         */
        this.seq = undefined;
        /**
         * ***Needs Review - will there be dimensions on commodities?
         */
        this.dimensions = undefined;
        /**
         * commodity and packing info including hazmat
         */
        this.commodityInfo = undefined;
        this.commoditySubLine = undefined;
        /**
         * this will have the rate and charge information. if weight was changed based on rated as, then the new weight will be in quantity. The class will be reflected in asRatedNmfcClass
         */
        this.charge = undefined;
        /**
         * this is an FAK that has overridden the as entered class when rated
         */
        this.asRatedNmfcClass = undefined;
        /**
         * This is value declared by the shipper. This might have implications for the claims.
         */
        this.declaredValue = undefined;
        /**
         * These are refenence numbers provided by the party on the bill (shipper) specific to this commodity line.
         */
        this.suppRef = undefined;
        this.reference = undefined;
    }
}
class CommodityInfo {
    constructor() {
        /**
         * number of commodity items
         */
        this.pieceCnt = undefined;
        /**
         * packaging information
         */
        this.packaging = undefined;
        /**
         * total weight for package and item together
         */
        this.grossWeight = undefined;
        /**
         * weight of commodity without packaging
         */
        this.tareWeight = undefined;
        this.volume = undefined;
        /**
         * Commodity description
         */
        this.desc = undefined;
        this.nmfcClass = undefined;
        this.nmfcItemCd = undefined;
        /**
         * Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         * Y - Can be damaged by freezing
         */
        this.freezableInd = undefined;
        /**
         * Indicates whether the commodity contains hazardous materials
         */
        this.hazmatInd = undefined;
        this.hazmatInfo = undefined;
        this.chemicalCharacteristics = undefined;
        this.emergencyContactName = undefined;
        this.emergencyContactPhone = undefined;
        /**
         * Indicates whether the piece, skid, or pallet can be stacked due to its shape or packaging.
         */
        this.stackableInd = undefined;
    }
}
/**
 * Shipment delivery instructions.
 */
class DoNotHoldDeliveryLine {
    constructor() {
        /**
         * The first line showing the description.
         */
        this.description1 = undefined;
        /**
         * The second line showing the description.
         */
        this.description2 = undefined;
    }
}
/**
 * Document details for FBDS/Copy-Bill for a shipment
 */
class FBDSDocument {
    constructor() {
        /**
         * The unique identifier of a shipment.
         */
        this.shipmentInstId = undefined;
        /**
         * The business identifier for the shipment.
         */
        this.proNbr = undefined;
        /**
         * The business identifier for the shipment that is related to the parent PRO.
         */
        this.childProNbr = undefined;
        /**
         * The business identifier which is formatted for display (pppX-SSSSSc).
         */
        this.formattedProNbr = undefined;
        /**
         * Identifies the type of shipment.
         */
        this.billClassCd = undefined;
        /**
         * The formatted serial number for the shipment.
         */
        this.shipperNbr = undefined;
        /**
         * The equipment number associated with the shipment.
         */
        this.equipmentNbr = undefined;
        /**
         * The date on which the shipment is picked up.
         */
        this.pickupDate = undefined;
        /**
         * The origin location for the shipment.
         */
        this.originSic = undefined;
        /**
         * The destination location for the shipment.
         */
        this.destinationSic = undefined;
        /**
         * The number of times the FBDS document was printed for the shipment.
         */
        this.fbdsPrintCount = undefined;
        /**
         * The shipment's shipper information.
         */
        this.shipper = undefined;
        /**
         * The shipment's consignee message.
         */
        this.consigneeMessage = undefined;
        /**
         * The shipment's consignee information.
         */
        this.consignee = undefined;
        /**
         * The customer to whom the shipment is being billed.
         */
        this.billTo = undefined;
        /**
         * The list of commodities for the shipment.
         */
        this.commodities = undefined;
        /**
         * The list of accessorials for the shipment.
         */
        this.accessorials = undefined;
        /**
         * The type of payment.
         */
        this.paymentType = undefined;
        /**
         * A summary containing descriptions of all items in the current shipment.
         */
        this.finalItemsDescription = undefined;
        /**
         * The In Bond description.
         */
        this.inBondDescription = undefined;
        /**
         * The Freezable text.
         */
        this.freezableText = undefined;
        /**
         * The Warranty text.
         */
        this.warrantyText = undefined;
        /**
         * The list of Customer Reference numbers.
         */
        this.customerReferenceNbrs = undefined;
        /**
         * The list of PO numbers.
         */
        this.poNbrs = undefined;
        /**
         * The list of other reference numbers.
         */
        this.otherReferenceNbrs = undefined;
        /**
         * The CTS revenue amount.
         */
        this.ctsRevenueAmount = undefined;
        /**
         * The list of PRO numbers of the child shipments of the current shipment.
         */
        this.childProNbrs = undefined;
        /**
         * The advanced carrier revenue amount.
         */
        this.advancedRevenueAmount = undefined;
        /**
         * The beyond carrier revenue amount.
         */
        this.beyondRevenueAmount = undefined;
        /**
         * The collector of custom message.
         */
        this.collectorOfCustomMessage = undefined;
        /**
         * The code associatd with the delivery route.
         */
        this.deliveryRoute = undefined;
        /**
         * The clearance bill text for the MOVR/astray freight segment shipment (BillClassCd = 'I').
         */
        this.movrClearanceBillText = undefined;
        /**
         * Clearance bill text of the remaining pieces for the MOVR/astray freight segment shipment (BillClassCd = 'I').
         */
        this.movrClearancePiecesOutstandingText = undefined;
        /**
         * Verification of Hazardous Material commodities for the MOVR/astray freight segment shipment (BillClassCd = 'I').
         */
        this.movrClearanceBillHazMatText = undefined;
        /**
         * The COD payment method for COD type miscellaneous line items.
         */
        this.codPaymentMethod = undefined;
        /**
         * The COD calculated amount for COD type miscellaneous line items.
         */
        this.codAmountText = undefined;
        /**
         * The total number of pieces for the shipment.
         */
        this.totalPieces = undefined;
        /**
         * The total charge amount on line one.
         */
        this.totalChargeAmountTextLine1 = undefined;
        /**
         * The total charge amount on line two.
         */
        this.totalChargeAmountTextLine2 = undefined;
        /**
         * The total weight of the shipment.
         */
        this.totalWeight = undefined;
        /**
         * The total charge amount for the shipment.
         */
        this.totalAmount = undefined;
        /**
         * Advance carrier (type code 1).
         */
        this.advanceCarrier = undefined;
        /**
         * The notification information for the current shipment.
         */
        this.notification = undefined;
        /**
         * Indicates if the shipment is under the Con-Way Guaranteed Service Program.
         */
        this.guaranteedInd = undefined;
        /**
         * Estimated delivery date of the shipment.
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * Indicates credit status, if the driver needs to collect frieght amount.
         */
        this.driverCollectDescription = undefined;
        /**
         * Description of the discount provided.
         */
        this.discountMsgDescription = undefined;
        /**
         * FBDS Rates and Charges info.
         */
        this.ratesAndCharges = undefined;
        /**
         * Remarks for Shipment authority line text.
         */
        this.authorityLineRemark = undefined;
        /**
         * Remarks for Shipment delivery attachment.
         */
        this.deliveryAttachmentRemark = undefined;
        /**
         * Shipment biller initials.
         */
        this.billerInitials = undefined;
        /**
         * Remarks for Shipment by the Shipper.
         */
        this.shipmentRemark = undefined;
        /**
         * Remarks for HazMat items in the Shipment.
         */
        this.hazmatRemark = undefined;
        /**
         * Remarks for Shipment associated Canadian freight.
         */
        this.canadianGoodsServicesRemark = undefined;
        /**
         * Remarks for Shipment GST associated freight transported from/to Quebec.
         */
        this.quebecGstRemark = undefined;
        /**
         * Count of copies of FBDS document printed.
         */
        this.nbrOfCopiesText = undefined;
        /**
         * The list of handling units.
         */
        this.handlingUnits = undefined;
        /**
         * Indicates whether the shipment is tracked using handling units.
         */
        this.trackWithHandlingUnitsInd = undefined;
        /**
         * The code which represents results for a specific delivery activity.
         */
        this.deliveryQualifierCd = undefined;
        /**
         * The billing status of the shipment.
         */
        this.billStatusCd = undefined;
        /**
         * Indentifies the party responsible for paying the shipment.
         */
        this.chargeToCd = undefined;
        /**
         * Additional notes for the shipment.
         */
        this.additionalNotes = undefined;
    }
}
class FreightExceptions {
    constructor() {
        /**
         * sequence number of the movement for which this exception applies
         */
        this.movementSeq = undefined;
        this.exception = undefined;
        /**
         * Over Short and Damage
         */
        this.osdPieces = undefined;
    }
}
class HazardousCharacteristics {
    constructor() {
        this.countryCd = undefined;
        /**
         * UN/NA Hazardous codes
         */
        this.hazardousCd = undefined;
        this.desc = undefined;
    }
}
class Packaging {
    constructor() {
        this.packageCd = undefined;
        this.packageWeight = undefined;
        this.packageDimensions = undefined;
        this.packageVolume = undefined;
    }
}
/**
 * Information about FBDS rates and charges.
 */
class RateAndCharge {
    constructor() {
        /**
         * Rates and charges information based on shipment weight.
         */
        this.ratedAsWeight = undefined;
        /**
         * Reduced charge or discount details.
         */
        this.reducedCharge = undefined;
        /**
         * Details for Part collect, Part prepaid, Cash prepaid, and Freight charges.
         */
        this.shipmentCharges = undefined;
        /**
         * Shipment delivery instructions.
         */
        this.doNotHoldDeliveryLine = undefined;
        /**
         * Details of cash on delivery payments.
         */
        this.cashOnDelivery = undefined;
    }
}
/**
 * Rates and charges information based on shipment weight.
 */
class RatedAsWeight {
    constructor() {
        /**
         * The description for rates and charges based on shipment weight.
         */
        this.ratedAsWeightDescription = undefined;
        /**
         * The rated as weight quantity.
         */
        this.quantity = undefined;
        /**
         * The text for the tariff rate.
         */
        this.tariffRateTxt = undefined;
        /**
         * The rated as weight amount.
         */
        this.amount = undefined;
    }
}
/**
 * The reduced charge or discount information.
 */
class ReducedCharge {
    constructor() {
        /**
         * The description of the reduced charge.
         */
        this.reducedChargeText = undefined;
        /**
         * The reduced charge amount.
         */
        this.amount = undefined;
        /**
         * The reduction percentage.
         */
        this.percentage = undefined;
    }
}
/**
 * Details for Part collect, Part prepaid, Cash prepaid, and Freight charges.
 */
class ShipmentCharge {
    constructor() {
        /**
         * The type of charge - Part collect, Part prepaid, Cash prepaid, or Freight charge.
         */
        this.chargeType = undefined;
        /**
         * The type of payment.
         */
        this.paymentType = undefined;
        /**
         * The description of the charge amount.
         */
        this.description = undefined;
        /**
         * The Charge amount received.
         */
        this.amount = undefined;
    }
}
/**
 * Information about measurements for the pieces on a shipment.
 */
class ShipmentDimension {
    constructor() {
        /**
         * The length measurement for the piece(s)
         */
        this.length = undefined;
        /**
         * The width measurement for the piece(s)
         */
        this.width = undefined;
        /**
         * The height measurement for the piece(s)
         */
        this.height = undefined;
        /**
         * The weight of the piece(s)
         */
        this.weight = undefined;
        /**
         * The number of pieces for which the measurement and weight values apply.
         */
        this.piecesCnt = undefined;
        /**
         * Indicates whether the piece(s) can be stacked.
         */
        this.stackableInd = undefined;
    }
}
/**
 * Notification information for a shipment.
 */
class ShipmentNotification {
    constructor() {
        /**
         * The nofiication message for a shipment.
         */
        this.message = undefined;
        /**
         * The observation for the notification message.
         */
        this.messageObservation = undefined;
        /**
         * The custom FBDS document notification message.
         */
        this.fbdsMessage = undefined;
        /**
         * The date of the notification.
         */
        this.notificationDate = undefined;
        /**
         * The time of the notification.
         */
        this.notificationTime = undefined;
        /**
         * The contact name associated with the notification.
         */
        this.contactName = undefined;
    }
}
class ShipmentParty {
    constructor() {
        /**
         * A sequential number used to identify a specifc shipment party in a database.
         */
        this.shipmentPartySeq = undefined;
        /**
         * An internal identifier to the customer that this shipment party references.
         */
        this.custInstID = undefined;
        /**
         * A business key that identifies the customer that this shipment party references.
         */
        this.custMadCd = undefined;
        /**
         * Identifies the type of shipment party that this is: (e.g. Shipper; Consignee; etc.  This will only be used in otherShipmentParties element
         */
        this.shipmentPartyTypeCd = undefined;
        /**
         * This is the name and address information that was provided by the customer directly.  This could be keyed from a paper BOL or provided via EDI or some other electronic means.  This is sometimes referred to as the 'as entered' address.
         */
        this.shipmentPartyBOLAddress = undefined;
        /**
         * This is the shipment party location information that comes from the customer that the shipment party was matched to.
         */
        this.shipmentPartyLocation = undefined;
        /**
         * The time stamp of the last time that this shipment party was matched to a customer.
         */
        this.lastMatchedDateTime = undefined;
        /**
         * Indicates whether this shipment party is a debtor for this shipment.  Note that a 'bill-to' associated with a shipper/consignee is not a debtor.  They are actiing on behalf of the debtor.
         */
        this.debtorInd = undefined;
        /**
         * Indicates whether all shipments for this shipment party are to be billed a prepaid.
         */
        this.allPrepaidInd = undefined;
        /**
         * Indicates whether the address for this shipment party, to be used on an invoice, should be the one provided by the customer instead of the one on the customer that was matched.
         */
        this.useAsEnteredInd = undefined;
        /**
         * Indicates whether this shipment party requires a 'Proof of Delivery' document to be captured and provided with an invoice.
         */
        this.proofOfDlvryRequiredInd = undefined;
        /**
         * Indicates whether a 'Proof of Delivery' image has been recorded for this shipment party for this shipment.
         */
        this.proofOfDlvryImagedInd = undefined;
        /**
         * This iindicates that type of credit that this shipment party has.  Values: Credit; Non-credit; Bad Debt; A/R Control; Voluntary; Cash Only
         */
        this.creditStatusCd = undefined;
        /**
         * Defines the currency that this shipment party prefers using.
         */
        this.preferredCurrency = undefined;
        /**
         * This is an internal identifier to the customs broker that this shipment party uses for a shipment that will cross a border.
         */
        this.brokerInstID = undefined;
        /**
         * This is a business key that identifies the customs broker that this shipment party uses for a shipment that will cross a border.
         */
        this.brokerBusinessKey = undefined;
        /**
         * This is a code that defines the relationship that a bill-to shipment party has to the shipper and the consignee.  Values are: None; Shipper; Consignee; Both
         */
        this.bil2RelationshipCd = undefined;
        this.suppRef = undefined;
        /**
         * Match status from CIS matching. Valid Values :
         * The following values ARE ACTIVE for Forward Sync:
         * Spaces - Initial value, matching activity has not yet occurred.
         * '70' - Full Match
         * '60' - Un-matched (valid name / address but does not exist in CIS)
         * The following values ARE NOT ACTIVE for Forward Sync:
         * '15' - Possible matches found
         * '30' - Invalid address (Bad US postal address as per Code-1)
         * '50' - Blank bill2 - no bill-to was entered
         */
        this.mchStatCd = undefined;
        /**
         * Contains the initials of the Review Clerk who performed matching on a pro, or forced the MAD code on a pro to a different MAD using a Pro Override.
         */
        this.mchInitTxt = undefined;
        /**
         * Used to group customer oriented service reports and manifests for direct customer access via the online system.
         */
        this.directCd = undefined;
        /**
         * Flag to indicate whether the Bill-To is related to the Shipper.
         */
        this.bil2RelToShipperInd = undefined;
        /**
         * Flag to indicate whether the Bill-To is related to the Consignee.
         */
        this.bil2RelToConsigneeInd = undefined;
        /**
         * Contains the customer key to an uncoded customer in the customer component. These are pickup and delivery locations that have been a part of at least one shipment in the Con-way system. (Note that they are not currently stored in the P and D table in the customer component.) They do not have an assigned MAD code (uncoded) and are therefore identified and matched separately so that we know when we service the same physical location.
         */
        this.alternateCustNbr = undefined;
        /**
         * Phone information for the party on the shipment.
         */
        this.phone = undefined;
    }
}
class ShipmentPartyBasic {
    constructor() {
        /**
         * An internal identifier to the customer that this shipment party references.
         */
        this.custInstID = undefined;
        /**
         * A business key that identifies the customer that this shipment party references.
         */
        this.custMadCd = undefined;
        /**
         * Identifies the type of shipment party that this is: (e.g. Shipper; Consignee; etc.  This will only be used in otherShipmentParties element
         */
        this.shipmentPartyTypeCd = undefined;
        /**
         * This is the name and address information that was provided by the customer directly.  This could be keyed from a paper BOL or provided via EDI or some other electronic means.  This is sometimes referred to as the 'as entered' address.
         */
        this.shipmentPartyBOLAddress = undefined;
        this.suppRef = undefined;
    }
}
/**
 * A generic representation of an indicator for special treatment of a delivery/pickup.
 */
class ShipmentSpecialServiceSummary {
    constructor() {
        /**
         * The types of special services.
         */
        this.specialService = undefined;
        /**
         * A boolean value indicating if the indicator type is applicable.
         */
        this.applicableInd = undefined;
    }
}
/**
 *
 */
class AccessorialService {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name:  Sequence Number
         *
         * Desc : Sequential number assigned to uniquely identify  each extra service for the shipment.
         *
         * Source : Generated
         *
         * Design Considerations :
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name : Accessorial  code
         *
         * Desc : Indicates the type of accessorial service requested or performed
         */
        this.accessorialCd = undefined;
        /**
         * Expanded Name : Tariff rate
         *
         * Desc : This is the rate used to calculate the accessorial charges for an accessorial service . The rate is multiplied by the unit of measure to calculate the total charges.
         *
         * Source : MBF Variable Segment -  MBCRATE
         */
        this.tariffsRate = undefined;
        /**
         * Expanded Name :  Charge Amount
         *
         * Desc : The dollar amount of the charge for the accessorial service.
         */
        this.amount = undefined;
        /**
         * Expanded Name: Percent Prepaid
         *
         * Desc: Percenatge of the charge amount for the accessorial is to be paid by the shipper. The rest of it is paid by the consignee.
         */
        this.prepaidPercentage = undefined;
        /**
         * Expanded Name : Minimum charge indicator
         *
         * Desc : Indicates if the charges associated with the accessorial are the minimum charges for the extra service.
         *
         * Source : MBF: root: MBMINCHG (x 10  of MBFLAG7)
         *
         * Valid Values :  Y/N
         */
        this.minimumChargeInd = undefined;
        /**
         * Expanded Name : Description
         *
         * Desc : A textual description of the service.
         *
         * Source : MBF  Variable Segment :
         */
        this.description = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         * Indication whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Specifies the units for the quantity for which the accessorial fee is charged.
         *
         * Valid Values
         * 1- Labour Hour
         * 2- 1/4 hour
         * 3- 1/2 hour
         * 4- CWT
         * 5- CWT/Day
         * 6- Check
         * 7- Correction
         * 8- Day
         * 9- Document
         * A- Package
         * B- Shipment
         * C- Vehicle
         * D- Mile
         * E- Pound
         * ' ' - Not applicable
         */
        this.accessorialUnitOfMeasure = undefined;
        /**
         * Specifies the quantity of units (in AC_UOM) for which the accessorial fee is charged.
         */
        this.accessorialQuantity = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         *
         */
        this.chrgToCd = undefined;
    }
}
/**
 *
 */
class AdvanceBeyondCarrier {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Sequence number
         *
         * Desc : A system assigned number to uniquely identify each carrier for a shipment. There can be at most two other carriers for a shipment one advance and one beyond.
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name : Type code
         *
         * Desc : Identifies the type movement carried out by the carrier.
         *
         *
         * Valid Values:
         * 1 = Advance carrier
         * 2 = Beyond carrier
         */
        this.typeCd = undefined;
        /**
         * Expanded Name: Standard Carrier Abbreviation Code
         *
         * Desc : Other Carrier s identification code for Advance and Beyond movements for the shipment.
         *
         * This is the identifying code for the carrier from whom CTS picked up (or transfers to) the freight. If the code is unknown, NONE is entered by the bill entry personnel.
         *
         * Source : MBF root  -  MBADSCAC
         */
        this.carrierScacCd = undefined;
        /**
         * Expanded Name : PRO number (in text format)
         *
         * Desc : This is  the other carrier s PRO number that identifies the shipment for the carrier in their systems.
         */
        this.carrierProNbr = undefined;
        /**
         * Expanded Name: Carrier pick up date
         *
         * Desc: This is the date the carrier picked up the shipment.
         *
         * In case of an advance carrier this is the date the carrier picked it up from the customer.
         *
         * 	In case of beyond carriers, it is the date the carrier picked up the shipment from CTS.
         */
        this.carrierPickupDate = undefined;
        /**
         * Expanded Name : From terminal SIC
         *
         * Desc : SIC where the shipment originates for the carrrier.
         *
         * For advance carriers it is the sic that services the shipper and for beyond carrier this is CTS service center that delivers teh PRO to the beyond carrier.
         *
         * This is mostly stored for Beyond carriers.
         *
         * Source :
         */
        this.fromTerminalSicCd = undefined;
        /**
         * Expanded Name : To terminal SIC
         *
         * Desc : This is CTS SIC where an advance carrier dropped the shipment for further movement. For beyond carrier this is the SIC code that services the consignee.
         *
         * Source :
         */
        this.toTerminalSicCd = undefined;
        /**
         * Expanded Name :  Charge Amount
         *
         * Desc : The dollar amount of the advance or beyond charge.
         */
        this.chargeAmount = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class AsMatchedParty {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Sequence Number
         *
         * Desc : A system assigned sequential number to uniquely identify each As Entered Customer for a Shipment.
         *
         * There are always at least two customers for a shipment and atmost 6 customers for a shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name :  Type code
         *
         * Desc : Specifies the nature of relationship of the customer with respect to the Service Item in question. For Shipments, a Customer can be the shipper, consignee, bill-to, requestor or contact.
         *
         * Permitted Values:
         * 										1=Shipper address
         * 										2=Consignee address
         * 										3=Inbound bill-to address
         * 										4=Outbound bill-to address
         * 										5=Requestor address
         * 										6=Contact address
         *
         * Source : Internal
         */
        this.typeCd = undefined;
        /**
         * Expanded Name : Debtor indicator
         *
         * Desc : Specifies whether the customer is also responsible for paying some or all of the charges for a Service Item. Invoices, allocations (if any) are created only for debtors.
         *
         * Valid Values : Y/N
         */
        this.debtorInd = undefined;
        /**
         * Expanded Name : Name Line 1 (text format)
         *
         * Desc : Line 1 of the customer name
         *
         * Source : MBF variable segments
         * 													AA  Shipper segment
         * 													AB  Consignee segment
         * 													AC  Bill to segment
         */
        this.name1 = undefined;
        /**
         * Expanded Name : Name Line 2 (text format)
         *
         * Desc : Second line (if any) of customer name
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.name2 = undefined;
        /**
         * Expanded Line : Address
         *
         * Desc : Street address of the customer location.
         *
         * Source: MBF variable segments
         * 	AA  Shipper segment
         * 	AB  Consignee segment
         * 	AC  Bill to segment
         */
        this.address = undefined;
        /**
         * Expanded Name : City
         *
         * Desc : City where the customer is located
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.city = undefined;
        /**
         * Expanded Name : State (code)
         *
         * Desc : State where the customer is located
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.stateCd = undefined;
        /**
         * Expanded Name : Country Code
         *
         * Desc : Specifies the code of the country where the customer is located
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.countryCd = undefined;
        /**
         * Expanded Name : Zip (code) first 5 (characters) (6 characters for Canadian zips)
         *
         * Desc : First 5 characters of the zip code for a US address or first 6 characters of the Canadian zip code of the address where the customer is located.
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.zip6 = undefined;
        /**
         * Expanded Name : Zip (Code) last 4 (characters)
         *
         * Desc : Last 4 characters of the zip code for a US address
         *
         * Source: MBF variable segments
         * 	AA  - Shipper segment
         * 	AB  - Consignee segment
         * 	AC  - Bill to segment
         */
        this.zip4RestUs = undefined;
        /**
         * Expanded Name : Matching Status
         *
         * Desc : Match status from CIS matching.
         *
         * Valid Values :
         *
         * The following values ARE ACTIVE for Forward Sync:
         *
         * Spaces - Initial value, matching activity has not yet occurred.
         * 	70  - Full Match
         * 	60  - Un-matched (valid name / address but does not exist in CIS)
         *
         * The following values ARE NOT ACTIVE for Forward Sync:
         *
         * 	15  - Possible matches found
         * 	30  - Invalid address (Bad US postal address as per Code-1)
         * 	50  - Blank bill2 - no bill-to was entered
         *
         * The following was added by C.Doucet 10/12/2001:
         *
         * 	CM  - CIS Customer Merge correction changed the CIS cust nbr value
         */
        this.matchedStatusCd = undefined;
        /**
         * Expanded Name : Matcher s Initials
         *
         * Desc : Contains the initials of the Review Clerk who performed matching on a pro, or forced the MAD code on a pro to a different MAD using a Pro Override.
         *
         * Source : Extended Master Bill File. These initials are the same as those stored on the EMB (JABCOB).
         */
        this.matchedInitials = undefined;
        /**
         * Expanded Name : CIS Customer Number
         *
         * Desc : Identifier of the appropriate customer in CIS, determined by the matching sub-routine
         */
        this.cisCustNbr = undefined;
        /**
         * Expanded Name : As-Matched MAD code
         *
         * Desc : Customer Account code.  This is the MAD code that came from CIS at the time of Customer Matching.
         *
         * Source : Customer Information System
         */
        this.asMatchedMadCd = undefined;
        /**
         * Expanded Name : Direct code
         *
         * Desc : Used to group customer oriented service reports and manifests for direct customer access via the online system.
         *
         * This is a de-normalisation as direct code is available only for CIS customers and it should be picked up from appropriate CIS table.
         *
         * Source : MBF: root: MBSCUST
         */
        this.dirCd = undefined;
        /**
         * Expanded Name : Credit Status Code
         *
         * Desc : Specifies the credit rating / status for a Customer, if not set up in CIS. If the customer exists in CIS, it is copied here for performance reasons.
         *
         * Source : MBF: root: MBONOST (Out-bound)
         * 														MBF: root: MBINOST (In-bound)
         *
         *
         * Valid Values :
         *
         * B=Bad debt/MBOBAD
         * C=Credit/MBOCRED
         * N=Non-credit/MBONOCRD
         * P=PCO Control/MBOPCO
         * V=Voluntary/MBOVOLON
         * $=Cash only/MBOCASH
         */
        this.creditStatusCd = undefined;
        /**
         * Expanded Name:  Bill to Relationship Code
         *
         * Desc: Indicates who the Bill to customer is related to (Shipper or Consignee) in the CIS system. This field applies only to BILL TO type of customers.
         *
         * Valid Values:
         * 				- Not Applicable
         * S - Bill To is related to Shipper
         * C - Bill To is related to Consignee
         * B - Bill To is related to Both
         * N - Bill To is related to None
         */
        this.billToRelationshipCd = undefined;
        /**
         * Expanded Name : Use as entered indicator
         *
         * Desc :
         *
         * Source : E-commerce
         *
         * Valid Values : Y/N
         */
        this.useAsEntrdInd = undefined;
        /**
         * Expanded Name : All shipments (must be) prepaid indicator
         *
         * Desc : Specifies whether all shipments from the customer have to be pre-paid
         *
         * Source : MBF: root: MBR4PPDA (x 02  of MBRGFLG4)
         *
         * Valid Values : Y/N
         */
        this.allShipmentPrepaidInd = undefined;
        /**
         * Expanded Name :   Proof Of Delivery  required indicator
         *
         * Desc : Indicates whether the customer (usually shipper and / or consignee) requires a Proof Of Delivery.
         *
         * Source : MBF: root: MBSPD (x 80  of MBFLAGD)
         *
         * Valid Values : Y/N
         */
        this.proofOfDeliveryRequiredInd = undefined;
        /**
         * Expanded Name :  Proof Of Delivery  image indicator
         *
         * Desc : Specifies that an image of the delivery receipt will suffice, instead of an original
         *
         * Source : MBF: root: MBSMG (x 40  of MBFLAGD)
         *
         * Valid values : Y/N
         */
        this.proofOfDeliveryImageInd = undefined;
        /**
         * Expanded Name : Broker customer key number
         *
         * Desc : For international shipments, identifies the CIS customer number of any broker for the shipper or consignee.
         *
         * Source : MBF: root: MBBRKKEY
         */
        this.brokerCustKeyNbr = undefined;
        /**
         * Expanded Name :  Customer E-mail Id
         *
         * Desc : E-mail address of the Customer on a bill, used as supplemental information in case that customer needs to be contacted via e-mail.
         */
        this.eMailId = undefined;
        /**
         * Expanded Name : Phone Country Code
         *
         * Desc : Country code for the phone number of the customer (if any) for a Shipment.
         *
         * Source : E-commerce
         */
        this.phoneCountryCdNbr = undefined;
        /**
         * Expanded Name :  Phone Area Code
         *
         * Desc : Area Code for phone number of the customer (if any) for a Shipment.
         *
         * Source : E-commerce
         */
        this.phoneAreaCdNbr = undefined;
        /**
         * Expanded Name : Customer Phone
         *
         * Desc : Phone number of the customer (if any) for a Shipment.
         *
         * Source : E-commerce
         */
        this.phoneNbr = undefined;
        /**
         * Expanded Name : Customer Phone Extension Number
         *
         * Desc : Phone Extension of the customer (if any) for a Shipment.
         *
         * Source : E-commerce
         */
        this.phoneExtensionNbr = undefined;
        /**
         * Expanded Name : Last Match Timestamp
         *
         * Desc : Identifies the last time Customer Matching was performed against this particular customer for this Service Item.
         *
         * Source : MBF root: MBTMDTE
         */
        this.lastMatchedDateTime = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         * Expanded Name: Preferred Payment Currency Code
         *
         * Desc: The customer prefers to make payments in this currecny.
         *
         * Valid Values:
         *
         * USD - US Dollars
         * CDN - Canadian Dollars
         */
        this.preferredPaymentCurrencyCd = undefined;
        /**
         * Expanded Name: Alternate Customer Number
         *
         * Desc: Contains the customer key to an uncoded customer in the customer component.  These are pickup and delivery locations that have been a part of at least one shipment in the Con-way system.  (Note that they are not currently stored in the P  table in the customer component.) They do not have an assigned MAD code (uncoded) and are therefore identified and matched separately so that we know when we service the same physical location.
         *
         * OR
         * Contains the non-debtor P location where there were multiple full matches (89% and higher) at the same perentage.  (Changed meaning of attribute 3/1/2010)
         *
         * Added 2/2/2010 Cathy Doucet (for Hand Held Scorecard project)
         */
        this.alternateCustNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Identifies whether the system full matched the party, or if the Biller chose from a list of possibles.
         *
         * Valid Values
         * S=System Matched
         * U=User Selected
         * F=User Selected from Search
         * N=Not matched
         */
        this.matchedSourceCd = undefined;
        /**
         * Identifies if the invoice address should be read from the PICKUP_DELIVERY_LOCATION(self) versus from an associated Bill To.
         */
        this.selfInvoiceInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
class Commodity {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Sequence number
         *
         * Desc : A system assigned number to uniquely identify each commodity for a shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name : (Commodity) class
         *
         * Desc : Identifies the type (class) of commodity being shipped.
         *
         * Examples:  Carpet, Matresses, Computer paper
         *
         * Valid Values : 50, 55, 60, 65, 70, 77.5, 85, 92.5, 100, 110, 125, 150, 175, 200, 250, 300, 350, 400, 500
         *
         * Source: MBF Variable Segment : MBVDESC
         */
        this.classType = undefined;
        /**
         * Expanded Name : NMFC item code
         *
         * Desc : This is the NMFC (National Motor Freight Classification) code for the commodity.
         *
         * Source: MBF Variable Segment - MBNMFC
         */
        this.nmfcItemCd = undefined;
        /**
         * Expanded Name : Source Code
         *
         * Desc : Code indicating the source of a particular Commodity Line.  Provides a way to distinguish between a Commodity Line on a bill that originated from the Common Shipper Bill of Lading (CSBOL) profile or a new Commodity Line that is added onto a bill where CSBOL Commodity Lines already exist.
         *
         * Source : FBES E-Commerce
         *
         * Valid Values :
         * 1 - from CSBOL
         * 2 - Not from CSBOL
         */
        this.sourceCd = undefined;
        /**
         * Expanded Name: Packaging code
         *
         * Desc : Type of packaging the commodity was originally picked up in.
         *
         * Examples: Box, Skid, Case, Roll etc.
         *
         * Source: MBF Variable Segment - MBVDESC
         */
        this.packageCd = undefined;
        /**
         * Expanded Name : Pieces count
         *
         * Desc : Number of pieces of the commodity in the shipment.
         *
         * Source : MBF Variable Segment - MBPIECES
         */
        this.piecesCount = undefined;
        /**
         * Expanded Name : Volume in Cubic feet
         *
         * Desc : The volume of the freight; the height multiplied by the width multiplied by the depth
         *
         * Source :
         */
        this.volumeCubicFeet = undefined;
        /**
         * Expanded Name: Total weight (in pounds)
         *
         * Desc : Total weight of the commdity in pounds.
         *
         * Source: MBF Root - MBTOTWT
         */
        this.weightLbs = undefined;
        /**
         * Expanded Name : Reduced weight
         *
         * Desc : This is the weight deducted from the actual weight of the commodity to get the net weight. This weight is normally the pallet or the container weight. This part of the weight gets a free ride.
         *
         * Source : MBF Variable Segment - MBWT
         */
        this.reducedWeight = undefined;
        /**
         * Expanded Name : Rating Unit of Measure
         *
         * Desc : A code to identify the units in terms of which the quantity is measured for calculating charges. For eg. weight (in pounds) is the most common unit of measure for commodities.
         *
         * Valid Values :
         * 1 - Weight (in pounds)
         * 2 - Yardage (for carpets)
         * 3 - Count
         */
        this.ratingUnitOfMeasure = undefined;
        /**
         * Expanded Name : Quantity
         *
         * Desc : Quantity (measured in terms of UOM) to be used when calculating charges for the commodity.
         */
        this.ratingQuantity = undefined;
        /**
         * Expanded Name : Freezable Indicator
         *
         * Desc : Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         *
         * Source: MBF root - MBFZB (x 08  of MBTRAFIC)
         *
         * Valid Values : Y/N
         *
         * Y - Can be damaged by freezing
         */
        this.freezableInd = undefined;
        /**
         * Expanded Name : Hazardous material indicator
         *
         * Desc : Indicates whether the commodity is a hazardous material.
         *
         * Source : MBF Variable Segment : MBNMHMX
         *
         * Valid Values :
         * Y - Has hazardous materials
         * N - No hazardous materials
         */
        this.hazardousMtInd = undefined;
        /**
         * Expanded Name : Tariff rate
         *
         * Desc : This is the rate used to calculate the total freight charges for a commodity. The rate is multiplied by the unit of measure (weight in most cases) to calculate the total charges.
         *
         * Source : MBF Variable Segment -  MBCRATE, MBRATES
         */
        this.tariffsRate = undefined;
        /**
         * Expanded Name :  Charge Amount
         *
         * Desc : The dollar amount of the charge for the commodity.
         */
        this.amount = undefined;
        /**
         * Expanded Name: Percent Prepaid
         *
         * Desc: Percenatge of the charge amount for the accessorial is to be paid by the shipper. The rest of it is paid by the consignee.
         */
        this.prepaidPercentage = undefined;
        /**
         * Expanded Name : Minimum charge indicator
         *
         * Desc : Indicates if the charges associated with the line are the minimum charges for the commodity.
         *
         * Source : MBF: root: MBMINCHG (x 10  of MBFLAG7)
         *
         * Valid Values :  Y/N
         */
        this.minimumChargeInd = undefined;
        /**
         * Expanded Name : Mixed class commodity exists indicator
         *
         * Desc :
         *
         * Source : MBF: root: MBMXCLS (x 01  of MBFLAGA)
         *
         * Valid Values : Y/N
         */
        this.mixClassCommodityInd = undefined;
        /**
         * Expanded Name : Description
         *
         * Desc : A textual description of the commodity
         */
        this.description = undefined;
        /**
         * Expanded Name : Archive Control Code
         *
         * Desc : Identifies a row of this table as archived or retrieved from archive.  The Princeton Archive tool sets the value upon archive or retrieval of data for selected PROs.
         *
         * FOR USE BY PRINCETON ARCHIVE/RETRIEVE PROCESSING ONLY!
         *
         * Valid Values:
         * A - Row is flagged for Archive processing
         * R - Row has been retrieved from archive
         * blank - row is associated with a currently active PRO (default)
         */
        this.archiveControlCd = undefined;
        /**
         *
         */
        this.asRatedClassCd = undefined;
        /**
         *
         */
        this.chrgToCd = undefined;
        /**
         *
         */
        this.originalDescription = undefined;
        /**
         * Indicates that the biller selected to have the commodity class default to 100 during bill entry since the class was not listed on the Bill of Lading.  This is to distinguish between commodity lines that actually have a true commodity class of 100 and commodity lines where the default situation occurs.  Valid Values :  Y/N
         */
        this.defaultClassSelectedInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         *
         */
        this.hazMat = undefined;
        /**
         *
         */
        this.commodityDimension = undefined;
        /**
         * The numeric ranking (class) that is assigned to the commodity which describes its transportation characteristics.
         */
        this.nmfcClass = undefined;
    }
}
/**
 *
 */
class CommodityDimension {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         *
         */
        this.commoditySequenceNbr = undefined;
        /**
         * Expanded Name: Sequence Number
         *
         * Desc: A system generated sequential number to uniquely identify the recorded dimensions for a shipment.
         */
        this.dimSequenceNbr = undefined;
        /**
         * Expanded Name: Pieces Count
         *
         * Desc: This is the number of pieces the recorded dimensions apply to.
         */
        this.piecesCount = undefined;
        /**
         * Expanded Name: Length
         *
         * Description: This is the length of the whole or part
         * of the shipment. The number of pieces attribute
         * indicates how many pieces of the shipment the
         * dimensions apply to.
         */
        this.lengthNbr = undefined;
        /**
         * Expanded Name: Width
         *
         * Description: This is the width of the whole or part of
         * the shipment. The number of pieces attribute indicates
         * how many pieces of the shipment the dimensions apply
         * to.
         */
        this.widthNbr = undefined;
        /**
         * Expanded Name: Height
         *
         * Description: This is the height of the whole or part of
         * the shipment. The number of pieces attribute indicates
         * how many pieces of the shipment the dimensions apply
         * to.
         */
        this.heightNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of CommodityDimension. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class CommodityDimensionSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         */
        this.before = undefined;
        /**
         * The current snapshot.
         */
        this.after = undefined;
    }
}
/**
 *
 */
class CustomsBond {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Sequence number
         *
         * Desc : System generated sequence number assigned to each instance to uniquely identify each customs bond information for a shipment
         */
        this.sequenceNbr = undefined;
        /**
         * Expanded Name : Bond number text
         *
         * Desc : This is the IT, TE or WDTE number (7,8 or a 9 digit number) on the in-bond document. It is used to identify the Shipment while it is in the customs warehouse.
         *
         * Source: MBF  Variable Segment - MBITNUM
         */
        this.bondNbr = undefined;
        /**
         * Expanded Name : City
         *
         * Desc : Name of the City where the customs inspection is to be made.
         *
         * Source: MBF Variable Segment - MBINBOND
         */
        this.city = undefined;
        /**
         * Expanded Name : State
         *
         * Desc : State of the city where the customs inspection is to be made.
         *
         * Source: MBF Variable Segment - MBINBOND
         */
        this.stateCd = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         * Type of Bond.  Added 08/05/2022  LISG-17338
         *
         * Valid Values:
         * PLANNED
         * UNPLANNED
         */
        this.bondTypeCd = undefined;
        /**
         * The status of the Bond.  Added 08/05/2022 LISG-17338
         *
         * Valid Values:
         * CLEARED
         * UNCLEARED
         */
        this.bondStatusCd = undefined;
        /**
         * The direction of the shipment.  Added 09/12/2022 LISG-24116
         *
         * Valid Values:
         * NORTHBOUND
         * SOUTHBOUND
         */
        this.shipmentDirectionCd = undefined;
        /**
         * The reason for the Customs Bond.  Added 09/12/2022 LISG-24116
         *
         * Valid Values:
         * NEEDS_CLIENT_AUTH     - Broker Needs Client Auth
         * RCVD_PPWK_NOT_SET_UP  - Broker Rcvd PPWK/Did not set up
         * REJECTED              - Broker Rejected - Not Theirs
         * MISC                  - Miscellaneous
         * MISSING_CUSTOMS_PPWK  - Missing Customs PPWK
         * MOVR_PRO              - MOVE Pro
         * NO_BROKER_INDICATED   - No Broker Indicated
         * NO_ORIGIN_COUNTRY     - No Country of Origin
         * OVERAGE               - Overage
         * VALUE_NOT_INDICATED   - Value not Indicated
         * VIASAFE_OPERATOR_ERR  - ViaSafe Operator Error
         */
        this.bondReasonCd = undefined;
        /**
         * Date the Bond was created.  Added 09/12/2022  LISG-24116
         */
        this.bondCreateDate = undefined;
        /**
         * Date the Bond was cleared.  Added 09/12/2022 LISG-24116
         */
        this.bondClearDate = undefined;
        /**
         * The clearance service center to which an in-bond shipment is headed.  Added 09/12/2022  LISG-24116
         */
        this.bondedSicCd = undefined;
        /**
         * Port to which a shipment is bonded. Added 09/16/2022  LISG-24116
         */
        this.bondedPort = undefined;
        /**
         * The value of the freight we are at risk of being penalized if not handled properly. Added 09/16/2022 LISG-24116
         */
        this.bondValueAmount = undefined;
        /**
         * The customs broker.  Added 09/16/2022  LISG-24116
         */
        this.broker = undefined;
        /**
         * CRC audit status to make sure the correct paperwork for release is imaged.  Added 09/16/2022
         *
         * Valid Values:
         * <spaces>
         * IN_PROGRESS
         * COMPLETED
         * FAILED
         */
        this.crcAuditCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of CustomsBond. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class CustomsBondSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         */
        this.eventActionCd = undefined;
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Sequence number
         *
         * Desc : System generated sequence number assigned to each instance to uniquely identify each customs bond information for a shipment
         */
        this.sequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         */
        this.before = undefined;
        /**
         * The current snapshot.
         */
        this.after = undefined;
    }
}
/**
 *
 */
class HandlingUnit {
    constructor() {
        /**
         * Expanded Name : Instance identifierDesc : System generated unique identifier (as per CBD standard).
         */
        this.shipmentInstanceId = undefined;
        /**
         * A system assigned number	used as part of how to uniquely identify each handling unit of a	shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * Child PRO	number identifies a handling unit of a shipment. This is an alternate	key of the table.The numbers are printed on labels and are assigned to service centers.	Labels are placed on 2 sides of each pieces (usually by pallet) of the	shipment picked up from the customer.Child PRO number format is 0ppppSSSSSc where pppp is the prefix from	1001 to 9999 (excluding numbers where last digit is 0, ex: 2000), SSSSS	is a suffix/serial number, and c is a check-digit of the ppppSSSSS	using modulus 7.
         */
        this.childProNbr = undefined;
        /**
         * This is the	parent PRO number of the handling unit. A denormed field from the	parent shipment table.Refer to the main source table for more description.
         */
        this.parentProNbr = undefined;
        /**
         * The date of when a	shipment has to be picked up
         */
        this.pickupDate = undefined;
        /**
         * Weight of this handling unit.
         */
        this.weightLbs = undefined;
        /**
         * Volume in cubic feet of this handling unit.
         */
        this.volumeCubicFeet = undefined;
        /**
         * Length of this handling unit.
         */
        this.lengthNbr = undefined;
        /**
         * Width of this handling unit.
         */
        this.widthNbr = undefined;
        /**
         * Height of this handling unit.
         */
        this.heightNbr = undefined;
        /**
         * SIC where the Shipment currently is.
         */
        this.currentSicCd = undefined;
        /**
         * Trailer	Load Instance ID. A denormalized system generated unique identifier of a piece of equipment that is currently involved with this	handling unit.
         */
        this.currentTrailerInstanceId = undefined;
        /**
         * The current dock location of this handling unit.
         */
        this.currentDockLocation = undefined;
        /**
         * The movement status that reflects the latest movement event on a handling unit.Valid	Values : Spaces - Not applicable1 - On dock2 - On trailer3 - Out for delivery4-  Interim Delivery5 - Final Delivered6 - Not Applicable6 - No	movements allowed7 - Cancell
         */
        this.movementStatusCd = undefined;
        /**
         * Date and time, when the last movement for this handling unit occurred.
         */
        this.lastMovementDateTime = undefined;
        /**
         * Indicates whether the handling unit can be stacked or not.
         */
        this.stackableInd = undefined;
        /**
         * This indicator is set to true (Y) if the handling unit is to be archived. When the record is retrieved from the archives, it is reset to false (N).
         */
        this.archiveInd = undefined;
        /**
         * The type of handling unit.  Added 10/20/2020  LISG-8170
         *
         * Valid Values:
         * MOTOR
         * LOOSE
         */
        this.typeCd = undefined;
        /**
         * Identifies the type of movement of the child PRO.   Added 12/10/2020  LISG-9067
         *
         * Valid Values:
         * MISSING - The child PRO is marked as short. When found, it can switch to normal or astray.
         * NORMAL - The child PRO is with the rest of the child PROs of the parent.
         * ASTRAY - The child PRO that was once missing has been found but the rest of the shipment has moved elsewhere. It will remain astray until it has caught up with the rest of the shipment, or until it is delivered.
         */
        this.handlingMovementCd = undefined;
        /**
         * Identifies the source of the dimension recorded.  Added 12/10/2020  LISG-9067
         *
         * Valid Values
         * ACCURACY
         * DOCK
         * PICKUP
         */
        this.dimensionTypeCd = undefined;
        /**
         * Indicates if the child PRO has been reweighed or not.  Added 06/28/2021 LISG-13269
         *
         * Valid Values
         * Y -Child PRO has been reweighed
         * N - Child PRO has not been reweighed (default)
         */
        this.reweighInd = undefined;
        /**
         * This is the volume of the handling unit expressed as a percentage of a full pup (28 foot long trailer).Added 10/19/2021  LISG-15366
         */
        this.pupVolumePercentage = undefined;
        /**
         * Indicates if the freight has been poorly packaged or not by the Shipper.  Added 05/04/2022  LISG-16763
         *
         * Valid Values:
         * N - freight is NOT packaged poorly (default)
         * Y - freight IS packaged poorly
         */
        this.poorlyPackagedInd = undefined;
        /**
         * Indicates that the handling unit has been split from the parent and has been authorized to move on its own Added 05/16/2022 LISG-16851
         */
        this.splitInd = undefined;
        /**
         * PLT PROs crossing border that happened to be split requires a MOVR PRO when some of the handling units have crossed border already. This identifies the MOVR PRO associated to the parent PRO which will move this handling unit across border.  Added 06/14/2022 LISG-17035
         */
        this.moverSuffix = undefined;
        /**
         * Denormalized field to store MOVR PRO that is associated to the parent PRO which will move this handling unit across the border.  Added 06/16/2022 LISG-17035
         */
        this.moverProNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         *
         */
        this.positionOnTrailerCd = undefined;
        /**
         * The current location of the handling unit.
         */
        this.currentLocation = undefined;
        /**
         * The scheduled ETA timestamp (string format) for the handling unit.
         */
        this.scheduledEta = undefined;
        /**
         *
         */
        this.handlingUnitMovement = undefined;
    }
}
/**
 * Holds a snapshot of HandlingUnit. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class HandlingUnitSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         */
        this.before = undefined;
        /**
         * The current snapshot.
         */
        this.after = undefined;
    }
}
/**
 *
 */
class HandlingUnitMovement {
    constructor() {
        /**
         * Expanded Name :
         *
         * Instance identifierDesc : System generated unique identifier (as per
         * CBD standard).
         */
        this.shipmentInstanceId = undefined;
        /**
         * A system assigned
         * 	number used as part of how to uniquely identify each handling unit of a
         * 	shipment.
         */
        this.sequenceNbr = undefined;
        /**
         * A system
         * 	assigned number to uniquely identify each movement leg for a movement
         * 	event of a handling unit
         */
        this.movementSequenceNbr = undefined;
        /**
         * Identifies the type of movement or type of action taken on a handling unit. Updated description 06/17/2022 LISG-17035
         *
         * Valid Movement Values :
         * CLOSE
         * DELIVER
         * LOAD
         * PICKUP
         * STAGE
         * UNLOAD
         *
         * Valid Action Values:
         * DOP_EXCP
         * MOVR
         * SCAN
         * SPLIT
         * TRANSFER
         * UNSPLIT
         */
        this.movementTypeCd = undefined;
        /**
         * SIC
         * where the movement event for the unit happened and reported.
         */
        this.movementReportingSicCd = undefined;
        /**
         * Date and
         * time, when the movement event occurred.
         */
        this.movementDateTime = undefined;
        /**
         * Denormed
         * 	trailer instance ID. A system generated unique identifier
         * assigned to a piece of equipment (mostly trailers) used to carry on
         * movements of handling units. This applies to all type of movement except
         * 	for
         * staged on dock.
         */
        this.trailerInstanceId = undefined;
        /**
         * Unique ID of a
         * 	Dock Location. This is the dock location where a shipment is staged on
         * 	dock.
         */
        this.dockInstanceId = undefined;
        /**
         * Expanded
         * 	Name : Archive Control CodeDesc : Identifies a row of this
         * table as archived or retrieved from archive.  The Princeton Archive
         * tool sets the value upon archive or retrieval of data for selected
         * PROs.FOR USE BY PRINCETON ARCHIVE/RETRIEVE PROCESSI
         */
        this.archiveControlCd = undefined;
        /**
         * Expanded Name :
         * 	Exception Type Code
         * Desc : Describes whether the pieces count is for an overage or a
         * 	shortage or damaged or refused hanlding unit.
         * Valid Values :
         * 1 - Over
         * 2 - Short
         * 3 - Damaged
         * 4 - Refused
         * 5 - Undeliverable
         * 6 - Exception Noted
         * 7 - Daamaged But Accepted
         * 8 - Over But Accepted
         */
        this.exceptionTypeCd = undefined;
        /**
         * Expanded Name :
         * 	Refused Reason Code
         * Desc : The reason code  for refused handling unit. Applicable only for
         * 	refusal count.
         * Valid Values :
         * 1 - Unauthorized return
         * 2 - Consignee won't accept freight collect
         * 3 - Arrived too late
         * 4 - Order cancelled
         * 5 - Did not Order
         * 6 - Wrong Order
         * 7 - Customer Wanted Earlier
         * 8 - Insufficient Delivery Time
         * 9 - Manufacturer's Defect
         * A - Arrived too early
         * B - Duplicate Order
         * C - Sent to wrong location
         * U - <used by BI team>
         * Z - Other (Remarks required)
         */
        this.refusedReasonCd = undefined;
        /**
         * Expanded Name
         * 	: Undelivarable Reason Code
         * Desc : The reason code explaining why the handling unit could not be
         * 	delivered. Applicable only for undelivered handling unit.
         * Valid Values :
         * 1 - Construction site, not deliverable within 2 day
         * 2 - No response to arrival notification after 2 working days
         * 3 - Consignee involved in labor dispute
         * 4 - Consignee cannot be located at address or phone number shown
         * 5 - Consignee has moved
         * 6 - Credit Hold
         * 7 - Suspended at Customer Request
         * 8 - Insufficient Delivery Time
         * Z - Other (Remarks required)
         */
        this.undeliveredReasonCd = undefined;
        /**
         * Expanded Name
         * 	: Damaged category
         * Desc : A code further describing the nature of damage.
         * Source : SMART (Dock Automation)
         * Valid Values :
         */
        this.damagedCategoryCd = undefined;
        /**
         * Expanded Name:
         * 	Remarks text
         * Desc : Any remarks noted during the exception or as a response to a
         * 	recorded exception. Sometimes describes the reason for the exception
         * 	when it is not one of the standard reason codes.
         */
        this.remarks = undefined;
        /**
         * Indicates that scanning of the child PRO was bypassed.   Added 12/10/2020  LISG-9067
         */
        this.bypassScanInd = undefined;
        /**
         * The reason why scanning was bypassed.  Added 12/10/2020 LISG-9067
         */
        this.bypassScanReason = undefined;
        /**
         * Timestamp of when the child PRO was scanned.  Added 1210/2020  LISG-9067
         */
        this.scanDateTime = undefined;
        /**
         * The employee id who authorized the split movement.  Added 12/10/2020  LISG-9067
         */
        this.splitAuthorizeBy = undefined;
        /**
         * The timestamp of when the split movement was authorized.  Added 12/10/2020  LISG-9067
         */
        this.splitAuthorizeDateTime = undefined;
        /**
         * Denormed for performance reasons - the door where the trailer is that reported the handling unit movement.  Added 11/17/2022  LISG-37900
         */
        this.doorNbr = undefined;
        /**
         * Denormed for performance reasons - the shift at the time the handling unit movement occurred.  Added 11/17/2022  LISG-37900
         */
        this.shiftCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of HandlingUnitMovement. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class HandlingUnitMovementSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         */
        this.before = undefined;
        /**
         * The current snapshot.
         */
        this.after = undefined;
    }
}
class HazMat {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         *
         */
        this.hazmatSequenceNbr = undefined;
        /**
         *
         */
        this.sourceCd = undefined;
        /**
         *
         */
        this.hazmatUnna = undefined;
        /**
         *
         */
        this.hazmatClassCd = undefined;
        /**
         *
         */
        this.hazmatWeightLbs = undefined;
        /**
         *
         */
        this.hazmatBulkQuantityCd = undefined;
        /**
         *
         */
        this.hazmatResidueInd = undefined;
        /**
         *
         */
        this.zoneCd = undefined;
        /**
         *
         */
        this.packingGroupCd = undefined;
        /**
         *
         */
        this.classLabel = undefined;
        /**
         *
         */
        this.overrideMethodNm = undefined;
        /**
         *
         */
        this.dotSpecialPermit = undefined;
        /**
         *
         */
        this.limitedQuantityInd = undefined;
        /**
         *
         */
        this.reportedQuantityInd = undefined;
        /**
         *
         */
        this.explosiveInd = undefined;
        /**
         *
         */
        this.netExplosiveMassNbr = undefined;
        /**
         *
         */
        this.netExplosiveMassUnitOfMeasure = undefined;
        /**
         *
         */
        this.marinePollutantInd = undefined;
        /**
         *
         */
        this.marinePollutantChemical = undefined;
        /**
         *
         */
        this.radioactiveInd = undefined;
        /**
         *
         */
        this.radioactiveChemicalName = undefined;
        /**
         *
         */
        this.radioactivityNbr = undefined;
        /**
         *
         */
        this.radioactivityUnitOfMeasure = undefined;
        /**
         *
         */
        this.transportIndex = undefined;
        /**
         *
         */
        this.fissileExceptedInd = undefined;
        /**
         *
         */
        this.emergencyContactName = undefined;
        /**
         *
         */
        this.emergencyContactPhoneNbr = undefined;
        /**
         *
         */
        this.technicalName = undefined;
        /**
         *
         */
        this.unnaInstId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LnhDimension {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         *
         */
        this.dimensionsSequenceNbr = undefined;
        /**
         *
         */
        this.piecesCount = undefined;
        /**
         *
         */
        this.lengthNbr = undefined;
        /**
         *
         */
        this.widthNbr = undefined;
        /**
         *
         */
        this.heightNbr = undefined;
        /**
         *
         */
        this.stackableInd = undefined;
        /**
         *
         */
        this.capturedByUserid = undefined;
        /**
         *
         */
        this.capturedByDateTime = undefined;
        /**
         *
         */
        this.capturedByCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of LnhDimension. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class LnhDimensionSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         */
        this.before = undefined;
        /**
         * The current snapshot.
         */
        this.after = undefined;
    }
}
class MiscLineItem {
    constructor() {
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Line type code
         *
         * Desc : Indicates the type of  line item.
         *
         * Source : MBF Variable Segment - MBWEIGHT
         *
         * Valid Values :
         *
         * 1 - As weight
         * 2 - Deficit weight
         * 3 - COD Amount
         * 4 - Discount line (Reduced charge)
         * 5 - Part PPD Line
         * 6 - Part Collect Line
         * 7- Cash Prepaid Line
         * 8 - Cash Collected line
         *
         * Note: As weight - Often the commodities are rated at a higher weight bracket than their net weight,  to get lower freight charges. In these cases the 'as weight'  is the weight used in calculating the freight charges. Most of the time this is sytem generated.
         */
        this.lineTypeCd = undefined;
        /**
         * Expanded Name : Tariff rate
         *
         * Desc : This is the rate used to calculate the  charges for the line item. Not all line items have a charge associated with them. The rate when present is multiplied by the unit of measure  to calculate the total charges.
         *
         * Source : MBF Variable Segment -  MBCRATE, MBRATES
         */
        this.tariffsRate = undefined;
        /**
         * Expanded Name : Unit of Measure
         *
         * Desc : A code to identify the units in terms of which the quantity is measured for calculating charges. For eg. weight (in pounds) is the unit of measure for the AS WEIGHT and  DEFICIT WEIGHT line items. Not all line items have an UOM.
         *
         * Valid Values :
         * space - Where UOM is n/a to the Charge.
         * 1 - Weight (in pounds)
         * 2 - Yardage (for carpets)
         * 3 - Count
         */
        this.unitOfMeasure = undefined;
        /**
         * Expanded Name : Quantity
         *
         * Desc : Quantity (measured in terms of UOM) to be used in calculating charges
         *
         * It represents As Weight on an AS WEIGHT line. Often the commodities are rated at a higher weight bracket than their net weight,  to get lower freight charges. In these cases the 'as weight'  is the weight used in calculating the freight charges. Most of the time this is sytem generated.
         *
         * For some Charge lines where it does not make sense to have a QTY, such as a COD, zeros may be formatted; UOM must be a space in this case.
         *
         * Source: MBF Variable Segment - MBWEIGHT
         */
        this.quantity = undefined;
        /**
         * Expanded Name :  Charge Amount
         *
         * Desc : The dollar amount of the charge associated with the line item.
         */
        this.amount = undefined;
        /**
         * Expanded Name: Percent Prepaid
         *
         * Desc: Percenatge of the charge amount for the accessorial is to be paid by the shipper. The rest of it is paid by the consignee.
         */
        this.prepaidPercentage = undefined;
        /**
         * Expanded Name : Minimum charge indicator
         *
         * Desc : Indicates if the charges associated with the line are the minimum charges for the line item.
         *
         * Source : MBF: root: MBMINCHG (x 10  of MBFLAG7)
         *
         * Valid Values :  Y/N
         */
        this.minimumChargeInd = undefined;
        /**
         * Expanded Name :  Description
         *
         * Desc : A textual description for the line item.
         *
         * Source : MBF  Variable Segment :
         */
        this.description = undefined;
        /**
         * Expanded Name:  Sequence Number
         *
         * Desc : Sequential number assigned to uniquely identify  each miscelleneous charge for a Shipment. This entity stores all the differnt types of charge lines that appear on the invoice for the shipment. Not all of these lines contribute to the CTS revenue.Some examples are COD, As Weight, Deficit Weight lines etc.
         *
         * Source : Generated
         *
         * Design Considerations :
         */
        this.sequenceNbr = undefined;
        this.archiveControlCd = undefined;
        this.paymentMethodCd = undefined;
        this.checkNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        this.chrgToCd = undefined;
    }
}
/**
 *
 */
class Movement {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         *
         */
        this.sequenceNbr = undefined;
        /**
         *
         */
        this.typeCd = undefined;
        /**
         *
         */
        this.movementReportingSicCd = undefined;
        /**
         *
         */
        this.currentSicCd = undefined;
        /**
         *
         */
        this.movementDateTime = undefined;
        /**
         *
         */
        this.trailerInstId = undefined;
        /**
         *
         */
        this.trailerLoadedSequenceNbr = undefined;
        /**
         *
         */
        this.trailerIdPrefix = undefined;
        /**
         *
         */
        this.trailerIdSuffixNbr = undefined;
        /**
         *
         */
        this.rshpCreditedInd = undefined;
        /**
         *
         */
        this.scacCd = undefined;
        /**
         *
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         *
         */
        this.routePrefix = undefined;
        /**
         *
         */
        this.routeSuffix = undefined;
        /**
         *
         */
        this.qlfrReasonCd = undefined;
        /**
         *
         */
        this.customerLocationArrivalDateTime = undefined;
        /**
         * Unique identifier for the carrier that executed this movement.  Added 04/06/2021  LISG-11313
         */
        this.carrierId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * Expanded Name : Movement status
         *
         * Desc : The status of the latest movement for a Shipment from an operations point-of-view. This is a denormalized atribute from the MOVEMENT entity.
         *
         * Source: MBF
         * Name: Various
         *
         * Valid Values :
         * Spaces - Not applicable
         * 1 - On dock
         * 2 - On trailer
         * 3 - Out for delivery
         * 4-  Interim Delivery
         * 5 - Final Delivered
         * 6 - Not Applicable
         * 6 - No movements allowed
         * 7 - Cancelled
         */
        this.movementStatusCd = undefined;
        /**
         *
         */
        this.movementException = undefined;
    }
}
/**
 *
 */
class MovementException {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         *
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         */
        this.sequenceNbr = undefined;
        /**
         *
         */
        this.typeCd = undefined;
        /**
         *
         */
        this.piecesCount = undefined;
        /**
         *
         */
        this.rfsdReasonCd = undefined;
        /**
         *
         */
        this.undlvdReasonCd = undefined;
        /**
         *
         */
        this.dmgdCategoryCd = undefined;
        /**
         *
         */
        this.remarks = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         *
         */
        this.exceptionSequenceNbr = undefined;
        /**
         *
         */
        this.exceptionReportingSicCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * The first name of the createdById user.
         */
        this.createdByFirstName = undefined;
        /**
         * The last name of the createdById user.
         */
        this.createdByLastName = undefined;
        /**
         *
         */
        this.movementExceptionAction = undefined;
    }
}
/**
 * Describes the action that is being taken for a shipment exception as well as the Service Center that is responsible for taking the action and the reason for the action.  Added 01/02/2020
 */
class MovementExceptionAction {
    constructor() {
        /**
         * Part of unique identifier
         */
        this.shipmentInstId = undefined;
        /**
         * Part of unique identifier
         */
        this.movementSequenceNbr = undefined;
        /**
         * Part of unique identifier
         */
        this.movementExceptionSequenceNbr = undefined;
        /**
         * Uniquely identifies a row
         */
        this.sequenceNbr = undefined;
        /**
         * Describes the action that is being taken for a shipment exception as well as the Service Center that is responsible for taking the action and the reason for the action.
         */
        this.reasonCd = undefined;
        /**
         * Responsible sic could be determined to be different from what SHM_movement has recorded
         */
        this.responsibleSicCd = undefined;
        /**
         * Describes what corrective action XPO has taken to address the exception. This is typically shared with the customer.
         */
        this.correctiveAction = undefined;
        /**
         * A unique identifier to correlate multiple Invoices. This is used as a batch# when reprint for Email is requested and they need to be processed as a group.
         * 	This is a value that API gateway assigns for a call. API then loops through creating multiple invoices with the same value
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Indicates whether the carrier was in a position to control or prevent the exception.  Added 03/23/2020 LISG-4722
         */
        this.controlInd = undefined;
    }
}
/**
 *
 */
class Remark {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name :  Type code
         *
         * Desc : This code can be used to categorize the remarks.
         *
         * Valid Values :
         * 1 - Adhoc Hazardous Material Remarks
         * 2 - Shipping Remarks
         * 3 - Authority Line text Remarks
         * 4 - Delivery Attachment Remarks
         * 5 - Operational Freight Handling Remarks
         * 6 - Final Delivery Date Correction Remarks
         *
         * Source: New/Entered
         *
         * Design Considerations : This can be used for subsetting purposes and for programatically pulling certain remarks to display and/or print.
         */
        this.typeCd = undefined;
        /**
         * Expanded Name: Remark Text
         *
         * Desc: Remark Text
         */
        this.remark = undefined;
        /**
         *
         */
        this.archiveControlCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Shipment {
    constructor() {
        /**
         * Expanded Name : Instance identifier
         *
         * Desc : System generated unique identifier (as per CBD standard).
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded Name : Type code
         *
         * Desc : Identifies the type of shipment.
         *
         *
         * Valid Values:
         * A = Normal Movement(NORM)
         * B = Master Shipment(MSTR)
         * C = Segment of a Master shipment (MSEG)
         * D = Revenue Bill for Split segments (PTLT)
         * E = Partial Shipment Segment (PSEG)
         * G = Claims overage Reporting Bill (OREP)
         * H = Genral Claims Business Shipment (GCBZ)
         * I =  Astray Freight Segment (MOVR)
         * J = Company Business Shipment (COBZ)
         * K = Expedite
         *
         *
         * Note:
         * Overage Reporting Bill (OREP) is entered into the system just  to indicate to the claims system there is an overage shipment on dock.
         *
         * Astray freight(MOVR) is used to move freight to it s correct destination after it accidentally ended up somewhere else and its original PRO number is known.
         */
        this.billClassCd = undefined;
        /**
         * Expanded Name : PRO number (in text format)
         *
         * Desc : This number identifies a shipment. This is the identifier given to the customer as a reference.
         *
         * The numbers are printed on labels for each service center.  Labels are put on the Bill-Of-Lading and on the individual pieces of freight for identification.
         *
         * Internal PRO number format is Oppp-sssss-c where 'ppp' is the pro-prefix, 'ssss' is the pro-suffix and 'c' is the check digit (modulus 7). It is usually displayed in the format 'ppp-sssss-c'
         *
         * An expedited shipment may not always have a real PRO number. It may be given a dummy number in the same format and should not be written out to MBF.
         *
         * MBF: root MBPRO
         */
        this.proNbr = undefined;
        /**
         * Expanded Name : Bill Status Code
         *
         * Desc : Current status of the Shipment from billing point of view.
         *
         * Valid Values:
         * 1 - Unbilled
         * 2 - In FBES Suspense Queue
         * 3 - Billed
         * 4 - Rated
         * 5 - Paid
         * 6 - Cancelled
         *
         * Source : MBF, E-commerce
         */
        this.billStatusCd = undefined;
        /**
         * Expanded Name :  Charge to code
         *
         * Desc : Identifies who is responsible for charges for the Shipment - either the Shipper or the Consignee or the responsibility may be split between BOTH parties. For BOTH bills, the split for each line item will be stored along with the line item in the commodity, ac_svc or the misc_line_item table in future. Currently the total PPD and total COLLECT charges are currently stored as separate line items in the misc_line_item entity.
         *
         * Valid Values :
         * 	P    -  Prepaid - shipper responsible for all charges
         * 	C    -  Collect - consignee responsible for all charges
         * 	B    -  Both - shipper and consignee responsible
         * 								-  Valid only for Non-Revenue bills.
         *
         * Source: MBF : MBPRTPPD, MBPRTCOL
         */
        this.chargeToCd = undefined;
        /**
         * Expanded Name : Original terminal SIC
         *
         * Desc : SIC where the Shipment originates.  Usually associated with PRO prefix and can be overriden.
         *
         * Source : MBF: root MBORGIN
         */
        this.originTerminalSicCd = undefined;
        /**
         * Expanded Name : Destination terminal SIC
         *
         * Desc : SIC that is scheduled to deliver the Shipment.
         *
         * Source : MBF: root MBDEST
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * Expanded Name : Current SIC
         *
         * Desc : SIC where the Shipment currently is.
         *
         * This is a denormalization to avoid scanning all movements to find current location.
         *
         * Source : MBF: root MBLOCX
         */
        this.currentSicCd = undefined;
        /**
         * Expanded Name : Source Code
         *
         * Desc : Indicates the source or origination of the Pro.  This code is needed for ACOR processing to determine whether to roll back to the initial data.
         *
         * Valid Values:
         * 	1  - Web        (Pickup Request web page)
         * 	2  - EDI        (set 204 or set 211)
         * 	3  - FTP        (file transfer)
         * 	4  - FBES    (manual Bill Entry)
         * 	5  - TCON or LOAD    (i.e. skeleton TCON or non-TCON LOAD)
         * 	6  - Pickup Request
         *
         * Source : E-commerce
         */
        this.sourceCd = undefined;
        /**
         * Expanded Name : Pickup Date
         *
         * Desc : Earliest available date that Shipment can be
         * picked up from a customer.
         *
         * Source : E-commerce
         */
        this.pickupDate = undefined;
        /**
         * Expanded Name : Ready Time
         *
         * Desc : Earliest available time that freight can be
         * picked up from a customer.
         *
         * Source : E-commerce
         */
        this.readyTime = undefined;
        /**
         * Expanded Name : Close Time
         *
         * Desc : Latest available time that freight can be
         * pickup up from a customer.
         *
         * Source : E-commerce
         */
        this.closeTime = undefined;
        /**
         * Expanded Name : Total pieces count
         *
         * Desc : Total pieces from all commodities in the shipment.
         *
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         *
         * Source : MBF: root: MBTOTPCS
         */
        this.totalPiecesCount = undefined;
        /**
         * Exapnded Name : Motorized piece count
         *
         * Desc : Identifies the number of moves or lifts made with a forklift or a pallet jack to move freight without manual intervention by the driver. This count may be equal to or less than the number of pieces in the shipment.  This is used by the costing system.
         *
         * Source : MBF root -  MBMTRPCS
         */
        this.motorizedPiecesCount = undefined;
        /**
         * Expanded Name : Total weight (in pounds)
         *
         * Desc : Total weight of all the freight being moved as a unit.  If this is a  Mother  bill then this is the total of all of the  Daughter  bills.
         *
         * Any rating weight allowances or variations (AW, DW, RW, NW) are not included.
         *
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         *
         * Source : MBF: root: MBTOTWT
         */
        this.totalWeightLbs = undefined;
        /**
         * Expanded Name : Default Tariff
         *
         * Desc : This identifies the default qualifying tariff for the shipment. If the rating process does not identify any other tariffs for the customer from rate aids, this is used as the rating tariff.
         *
         * Source : MBF root - MBTARIFF
         */
        this.defaultTariffsId = undefined;
        /**
         * Expanded Name : Total charges
         *
         * Desc : Includes all charges that contribute to the CTS revenue minus discount.  Includes advance+beyond carrier charges and COD amount.
         *
         * Source : MBF: root: MBTOTAL
         */
        this.totalChargeAmount = undefined;
        /**
         * Expanded Name : Total charges in US dollars
         *
         * Desc : Includes all charges that contribute to the CTS revenue minus discount in US dollars.  Includes advance+beyond carrier charges and COD amount.
         *
         * Source : MBF: root: MBTOTAL
         *
         * Design Notes: This field was added as a denorm to keep the total charges in USD. Normally this field is same as the tot charges field. However this field is differnt when the rating currncy is not USD.
         */
        this.totalUsdAmount = undefined;
        /**
         * Expanded Name: Split Indicator
         *
         * Desc: Indicates whether the shipment has been split or not.
         *
         * Valid values: Y/N
         *
         * Source: MBF MBCLAS2 -  This actually replaces the BILL CLASS 2 field in the MBF.
         */
        this.splitInd = undefined;
        /**
         * Expanded Name : Hazardous Materials indicator
         *
         * Desc : Indicates whether or not a shipment includes  any commodities with hazardous materials. It is a denormalized attribute for performance puposes.
         *
         * Valid Values : Y/N
         */
        this.hazmatInd = undefined;
        /**
         * Expanded Name : Freezable Indicator
         *
         * Desc : Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         *
         * Ideally, it should be specified at the commodity level, but has been de-normalized for Shipment, since that is level at which it is currently captured
         *
         * Source: MBF root - MBFZB (x 08  of MBTRAFIC)
         *
         * Valid Values : Y/N
         *
         * Y - Can be damaged by freezing
         */
        this.freezableInd = undefined;
        /**
         * Expanded Name : Signature service indicator
         *
         * Desc : Indicates if anyone handling the freight is required to sign on a signature sheet.
         *
         * Source : MBF: root: MBSGSRVC (x 04  of MBFLAG9)
         *
         * Valid Values : Y/N
         */
        this.signatureServiceInd = undefined;
        /**
         * Expanded Name : Revenue Bill Indicator
         *
         * Desc : Indicates whether the shipment will generate revenue for Con-way or not.
         *
         * Valid Values :
         *
         * Y - generates revenue
         * N - does not generate revenue
         */
        this.revenueBillInd = undefined;
        /**
         * Expanded Name : Manual rating indicator
         *
         * Desc : Specifies whether the shipment  in question needs to be manually rated or not. If required, it may be changed to a code indicating the reason as well for manually rating it.
         *
         * It is same as special instructions field on the FBES screen.
         *
         * ==NOTE==
         * When this indicator is set, it means the rates and charges must be manully reviewed before the bill is marked as RATED. Howerver the auto rating system is allowed to put rates and charges on the bill prior to putting it in a manual entry or manual audit queue.
         *
         * This is different from the indicator AUTO_RATEABLE_IND which indicates whether the auto rating system is even allowed to put rates and charges on the bill.
         *
         * Source : MBF: root: MBSCHDI (x 80  of MBFLAGB)
         *
         * Valid Values : Y/N
         */
        this.manualRatingRequiredInd = undefined;
        /**
         * Expanded Name : Audit Required Indicator
         *
         * Desc : Used to determine if the pro requires auditing after rating.
         *
         * Valid Values :
         * Y - Pro does require auditing
         * N - Pro does not require auditing
         *
         * Source : MBF:  Root: MBFBAUDT (X 01  of MBFLAGI)
         */
        this.auditInd = undefined;
        /**
         * Expanded Name : Cash indicator
         *
         * Desc : This indicates if cash was collected at the tim eof pick up or should be collected at the time of delivery.
         *
         * This information is also printed on the delivery set to inform the driver to collect cash.
         *
         * Source : MBF: root: MBCASH (x 10  of MBFLAG2)
         *
         * Valid Values : Y/N
         */
        this.cashInd = undefined;
        /**
         * Expanded Name : Cash collected code
         *
         * Desc : A code indicating whether any cash was
         * collected at the time of pick up or delivery or not. Cash may be collected  regardless of whether it was required or not and if  so, the invoice may need to be stopped.
         *
         * It has been modelled as a code instead of an indicator
         * since it needs to be initialized to a value other than
         * NO.
         *
         * Source : New
         *
         * Valid Values :
         * blank - Initial value
         * Y - Yes, cash was collected
         * N - No cash collected on delivery
         */
        this.cashCollectInd = undefined;
        /**
         * Expanded Name : Government Bill of Lading indicator
         *
         * Desc : Indicates whether this is a government shipment or not.
         *
         * Source : MBF: root: MBGBLT (x 01  of MBTRAFIC)
         *
         * Valid Values : Y/N
         */
        this.govtBolTrafficInd = undefined;
        /**
         * Expanded Name : Guaranteed Indicator
         *
         * Desc : Indicates if the shipment is under the Con-Way Guaranteed Service Program.
         *
         * Values : Y/N
         *
         * Source : MBF, E-commerce
         */
        this.guaranteedInd = undefined;
        /**
         * Expanded Name : Guaranteed Coupon Indicator
         *
         * Desc : Indicates that a Coupon has been used to allow the shipment to participate in the Con-Way Guaranteed Service Program for free.
         *
         * Values : Y/N
         *
         * Source : BASE
         */
        this.guaranteedCouponInd = undefined;
        /**
         * Expanded Name : Purge blocked indicator
         *
         * Desc : Indicates that the details cannot be purged. Usually set when there are inconsistencies for Master / MSEG or Part lot/PSEG  shipments.
         *
         * Valid values : Y/N
         *
         * Source : MBF: root: MBPUBLK (x 10  of MBFLAG3)
         */
        this.purgeBlockInd = undefined;
        /**
         * Expanded Name: Last MOVR PRO Number
         *
         * Desc: The Pro number for the last MOVR PRO billed for this shipment.
         */
        this.lastMoverPro = undefined;
        /**
         * Expanded Name: Archive Indicator
         *
         * Desc: Indicates whether the record for the PRO is an active one or one retrieved from the archive.
         */
        this.archiveInd = undefined;
        /**
         * Expanded Name: COD Indicator
         *
         * Desc: Indictaes whether it is a COD shipment or not. It is a denormalized attribute for performance puposes. The actual COD information is in the MISC_LINE_ITEM entity.
         */
        this.codInd = undefined;
        /**
         * Expanded Name: Discount Code
         *
         * Desc: This is the discount code that was applied to the shipment when it was rated.
         *
         * Source: MBF - MBRCCODE
         */
        this.discountCd = undefined;
        /**
         * Expanded Name :Movement Reporting SIC Code
         *
         * Desc : SIC where the last movement event for the shipment  happened and reported.  This is a denormalized attribute from the MOVEMENT entity for performance purposes.
         *
         * Source : MBF: root MBMOVE
         */
        this.lastMoveRptgSicCd = undefined;
        /**
         * Expanded Name : Movement Timestamp
         *
         * Desc : Date and time, when the last movement for this shipment  occurred. This is a denormalized attribute from the MOVEMENT entity.
         *
         * Source: MBF - MBMVTM
         */
        this.lastMovementDateTime = undefined;
        /**
         * Expanded Name : Movement status
         *
         * Desc : The status of the latest movement for a Shipment from an operations point-of-view. This is a denormalized atribute from the MOVEMENT entity.
         *
         * Source: MBF
         * Name: Various
         *
         * Valid Values :
         * Spaces - Not applicable
         * 1 - On dock
         * 2 - On trailer
         * 3 - Out for delivery
         * 4-  Interim Delivery
         * 5 - Final Delivered
         * 6 - Not Applicable
         * 6 - No movements allowed
         * 7 - Cancelled
         */
        this.movementStatusCd = undefined;
        /**
         * Expanded Name : Delivery qualifier
         *
         * Desc : Code representing results of a specific delivery activity. The values are the same as what used to be  Event that stopped service).
         *
         * This has been denormalized from Movement for performance reasons and should always be kept in sync.
         *
         * Source : MBF: root: MBD1FLG / MBD2FLG
         *
         * Valid Values :
         * A= Over Shipment
         * B=Trapped shipment/MBD1TRAP
         * C=Hold for customs/MBD1CSTM
         * D=Undelivered/MBD1UNDL
         * E=Hold for appointment/MBD1APPT
         * F=On spotted trailer/MBD1SPOT
         * G=Cartage
         * H=Attempted delivery/MBD1ATMP
         * J=All short
         * K=Partial short/MBD1PSRT
         * L=Refused delivery/MBD1RFSD
         * M=Damaged shipment/MBD1RDMG
         * N=Suspense/MBD1SUSP     - Not Used
         * O=Wait/MBD1WAIT              - Not Used
         * P=Purge Blocked/MBD2PBLK
         * R=Return Status/MBD2RTRN
         * T=Transfer/MBD2TSFR
         * Z=Final delivery/MBD1FINL
         */
        this.deliveryQualifierCd = undefined;
        /**
         * Expanded Name : Rating Currency Code
         *
         * Desc: The rates and charges for the shipment were calculated using this currency
         *
         * Valid values:
         *
         * USD - US Dollars
         * CDN - Canadian Dollars
         */
        this.ratingCurrencyCd = undefined;
        /**
         * Expanded Name : Invoicing Currency Code
         *
         * Desc:  PLEASE DO NOT USE THIS ATTRIBUTE. THIS ATTRIBUTE WILL BE DROPPED IN NEAR FUTURE.
         *
         * The total charges for the shipment should be displayed using this currency
         *
         * Valid values:
         *
         * USD - US Dollars
         * CDN - Canadian Dollars
         */
        this.invoicingCurrencyCd = undefined;
        /**
         * Expanded Name: Currency Converstion Factor
         *
         * Desc: PLEASE DO NOT USE THIS ATTRIBUTE. THIS ATTRIBUTE WILL BE DROPPED IN NEAR FUTURE.
         *
         * Provides the currency conversion factor on the day of shipment pick up between the rating currency and invoicing currency, if they are different.
         */
        this.currencyConversionFctr = undefined;
        /**
         * Expanded Name : Required Delivery Date
         *
         * Desc : Date the shipment is required to be delivered
         *
         * Source : E-commerce
         */
        this.requiredDeliveryDate = undefined;
        /**
         * Expanded Name : Delivery Time Start (if any)
         *
         * Desc : The start time of the window specified by the customer for delivering the shipment.
         *
         * Source : E-commerce
         */
        this.startDeliveryTime = undefined;
        /**
         * Expanded Name : Delivery Time End (if any)
         *
         * Desc : The end time of the window specified by the customer for delivering the shipment.
         *
         * Source : E-commerce
         */
        this.endDeliveryTime = undefined;
        /**
         * Expanded Name : International manifest from (port) code
         *
         * Desc : Generated by rating. Identifies port of entry code through which freight will enter the US from another country. This may be associated with the destination city or the customer s broker.
         *
         * Source : MBF: root: MBFROMPT
         */
        this.fromPortCd = undefined;
        /**
         * Expanded Name : International  manifest to (port) code
         *
         * Desc : Generated by rating: Identifies the port of entry through which freight will enter another country.  This is either associated with the destination or with the customer s broker.
         *
         * Source : MBF: root: MBTOPORT
         */
        this.toPortCd = undefined;
        /**
         * Expanded Name : OBC pickup delivery route
         *
         * Desc : Pickup delivery route code from CAD used for sorting to print delivery sets in this order.
         *
         * Source : MBF: root: MBPDRTE
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         * Expanded Name : Customer Profile Instance Id
         *
         * Desc : A unique, randomly-generated number that identifies a registered customer in the Con-Way Customer Profile Component.
         *
         * Source : Customer Profile Component
         */
        this.custProfitabilityInstId = undefined;
        /**
         * Expanded Name :  Rating tariff
         *
         * Desc : This identifies the actual tariff used to rate the shipment.
         *
         * Source : MBF root - MBRATTAR
         */
        this.ratingTariffsId = undefined;
        /**
         * Expanded Name : Rate auditor initials
         *
         * Desc : Initials of the rating auditor who last audited the shipment for rates.
         *
         * Source : MBF: root: MBRTADID
         */
        this.rateAuditorInitials = undefined;
        /**
         * Expanded Name : Rate or rate audit queue name
         *
         * Desc : The name of the rating (or the rate audit) queue used when the shipment was last rated / audited.
         *
         * Source : MBF: root: MBRATEQ
         */
        this.rateOrRateAudtqNm = undefined;
        /**
         *
         */
        this.heaviestCommoditySequenceNo = undefined;
        /**
         * Expanded name:  Service type code.
         *
         * Description:  Defines the specific type of service provided for a shipment.
         *
         * Values:  1 - Normal LTL, 2 - Con-Way Deferred Express.
         */
        this.serviceTypeCd = undefined;
        /**
         * Expanded name: Estimated Delivery Date
         *
         * Description: Date that the shipment should be delivered based on standard lane days.
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * Expanded name: Freight Bill Delivery Set Print Count
         *
         * Description:
         * The number of times that a FBDS has been printed for this shipment.
         */
        this.fbdsPrintCount = undefined;
        /**
         * Expanded Name : Archive Control Code
         *
         * Desc : Identifies a row of this table as archived or retrieved from archive.  The Princeton Archive tool sets the value upon archive or retrieval of data for selected PROs.
         *
         * FOR USE BY PRINCETON ARCHIVE/RETRIEVE PROCESSING ONLY!
         *
         * Valid Values:
         * A - Row is flagged for Archive processing
         * R - Row has been retrieved from archive
         * blank - row is associated with a currently active PRO (default)
         */
        this.archiveControlCd = undefined;
        /**
         * Expanded name: Delivery Information Required Code
         *
         * Desc: This code indicates that there is a requirement to capture delivery information for this shipment because of customer special requirements.  This is usually an EDI customer requirement that must be met.  The name of the person that signed for delivery and the timestamp are also captured in this record.
         *
         * Values:
         * R - delivery info is required
         * C - delivery informaiton has been captured  and exists with this record
         * blank - No delivery information required for this shipment
         */
        this.deliveryInformationRqdCd = undefined;
        /**
         * Expanded name: Delivery Signature Name
         *
         * Desc: This is the name of the person that signed for the delivery of the freight.  This name is required by some customers and is passed along to them via EDI.  This name is captured if the DLVR_UNFO_RQD_CD is set.
         *
         * Since a shipment can be delivered in parts, (part short, etc) there can be more than one signature.  This field will hold the name of the last delivery movement.  The previous signatures can be retrieved from shipment history records.
         */
        this.deliverySignatureNm = undefined;
        /**
         * Expanded name: Delivery Signature TimeStamp
         *
         * Desc: This is the date and time recorded when the person named in DLVR_SIG_NM_TXT signed for the shipment.
         */
        this.deliverySignatureDateTime = undefined;
        /**
         * Expanded Name : Standard Transit Days (in number of days)
         *
         * Desc : The standard number of days it should take to move a shipment from origin to destination, as defined in the OSS_SVC_STDS_A/B tables.
         *
         * Source : OSS_SVC_STDS_A/B - TRNST_DAYS
         */
        this.standardTransitDays = undefined;
        /**
         * Expanded Name : Actual Transit Days (in number of days)
         *
         * Desc : The number of days it actually takes to move a shipment from shipper to consignee.
         *
         * Source : calculated by subtracting PKUP_DT from the date portion of the (LST_)MVMT_TMST of the qualifying delivery event / movement, adjusted appropriately for non-work days occuring between the two dates.  There are a number of interim delivery qualifiers (DLVRY_QALFR_CD) that can cause the calculation  (SPOT, PSRT?, RDMG?, RFSD?, FINL).
         */
        this.actualTransitDays = undefined;
        /**
         * Expanded Name : Transit Movement Sequence Number
         *
         * Desc : The sequence number identifying the movement (qualifying delivery event) for the calculation of ACTL_TRNST_DAYS.
         * NOTE - VALUE CAN BE ZERO FOR PARTLOT (PTLT) PROS.
         *
         * Source : SHM_MOVEMENT - MVMT_SEQ_NBR
         */
        this.transitMovementSequenceNbr = undefined;
        /**
         * Expanded Name : Warranty Indicator
         *
         * Desc : Indicates whether the shipment is eligible for the money-back guarantee if moving between direct points under Tariff CNWY-599.
         *
         * Valid Values :
         *
         * Y - eligible for warranty
         * N - not eligible for warranty - default value
         */
        this.warrantyInd = undefined;
        /**
         * Expanded Name : Warranty Status Code
         *
         * Desc : Identifies the warranty status of a shipment
         *
         * For example, one value of this code would indicate that a warranty  claim has been filed  by the debtor if a shipment has failed service.
         *
         * Valid Values:
         * 0 - default value; This means either the shipment is not eligible (Warranty flag =  N ) or it is eligible and no one has filed a claim.
         * 1 - The customer has filed a claim and it has not been audited.
         * 2 - The customer has filed a claim and it was approved.
         * 3 - The customer has filed a claim and it was denied.
         */
        this.warrantyStatusCd = undefined;
        /**
         * Expanded name: Notification Code
         *
         * Desc: Indicates whether or not an notification exists for this shipment.  If it exists, the details will exist in the SHM NOTFICATION table.  The notification is created in the SCO (Smart4) system.
         *
         * Values:
         * A - Appointment exists
         * N - Notification exists
         * O -Appointment Not Required
         * R- Reappointment candidate.  PSRT/RDMG Pro  could be reappointment for delivery
         *
         * blank - Neither exist
         */
        this.notificationCd = undefined;
        /**
         * Expanded Name: Absolute minimum charge indicator
         *
         * Desc: This inidcates if the charge for this shipment is the absolute minimum charge.
         */
        this.absoluteMinimumChargeInd = undefined;
        /**
         * Expanded Name: Discount Percentage
         *
         * Desc: This is the percentage discount applied to the freigt chrages and discountable accessorial charges of the shipment.
         */
        this.discountPercentage = undefined;
        /**
         * Expanded Name: Pricing Agreement Instance Id
         *
         * Desc: This is the instance id of the pricing agreement that was used to rate the shipment.
         *
         * ==NOTE== Link to BASE 5 PRC component
         */
        this.priceAgreementId = undefined;
        /**
         * Expanded Name: Rule set Number
         *
         * Desc: This identifies the rule set of the pricing agreement that was used to rate the shipment.
         *
         * ==NOTE== link to BASE 5 PRC component
         */
        this.priceRulesetNbr = undefined;
        /**
         * Expanded Name: Route prefix
         *
         * Desc: Identifies the last Route the shipment was put on.
         *
         * ==NOTE== Link to SMART 4 SCO component
         */
        this.routePrefix = undefined;
        /**
         * Expanded Name: Route Suffix
         *
         * Desc: Identifies the last Route the shipment was put on.
         *
         * ==NOTE== Link to SMART 4 SCO component
         */
        this.routeSuffix = undefined;
        /**
         * Expanded Name: Route Type Code
         *
         * Desc: Identifies whether the shipment is currently on a  Route (either planning route or dispatched route) Staged (available) for Routing, or is Not on a route.
         *
         * Valid Values
         * 				- Not Routed
         * R - Routed
         * S - Staged
         */
        this.routeTypeCd = undefined;
        /**
         * Expanded Name : Volume in Cubic feet
         *
         * Desc : The volume of the freight; derived from the dimensions captured by driver, or entered by a CSR or dock worker for an SL  (Shipper Load and Count), or from one of a variety of profiles. For details, see the description of CFT_PRFL_MTHD_CD.
         *
         * 06/21/2016 Cathy Doucet modified description as per Ariel/Sunya.
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * Expanded Name: Total Pallet Count
         *
         * Desc: Total Number of Pallets in the Shipment
         */
        this.totalPalletsCount = undefined;
        /**
         * Expanded Name: Area instance Id
         *
         * Desc: Each service center is divided into multiple geographic areas for delivery. This identifies the delivery area of destination service center in which this shipment s consignee is located.
         *
         * Source: SMART 4 Requirement
         *
         * == NOTE ==  Ties back to the geo-area stored in Oracle spatial database for each service center.
         */
        this.areaInstId = undefined;
        /**
         * Expanded Name: Auto Rateable Indicator
         *
         * Desc: This indicates whether the auto rating system is allowed to put rates and charges on the bill. This is irrespective of whether the bill needs to be manually reviewed or not before being marked RATED.
         *
         * Valid Values:
         * Y - Auto rating system may put rates and charges
         * N - Auto Rating system should not out or change any rates and charges on the bill
         */
        this.autoRateableInd = undefined;
        /**
         * Expanded Name: Motorized-Move Pieces Known Indicator
         *
         * Desc: This indicates whether MTRZD_PCS_CNT is known or applicable..
         *
         * Valid Values:
         * Y - Yes, MTRZD_PCS_CNT is known/applicable
         * N - No, MTRZD_PCS_CNT is NOT known/applicable
         *
         * Source:  FBES
         */
        this.motorizedPiecesKnownInd = undefined;
        /**
         * Expanded Name : Estimated Transit Days (in number of days)
         *
         * Desc : The standard number of days it should take to move a shipment from origin to destination, as defined in the OSS_SVC_STDS_A/B tables, adjusted by +1 if LATE_TENDER_IND =  Y
         *
         * Source : STD_TRNST_DAYS +1, if LATE_TENDER_IND =  Y
         */
        this.estimatedTransitDays = undefined;
        /**
         * Expanded Name : Calculated Service Days (in number of days)
         *
         * Desc : The number of days it takes to move a shipment from shipper until it reaches a service stopping event.
         *
         * Source : calculated by subtracting PKUP_DT from the date portion of the (LST_)MVMT_TMST of the first service-stopping event / movement, adjusted appropriately for non-work days occuring between the two dates.  There are a number of interim delivery qualifiers (DLVRY_QALFR_CD) that can cause the calculation (ie. stop service).
         */
        this.calculatedServiceDays = undefined;
        /**
         * Expanded Name : Calculated Service Timestamp
         *
         * Desc : The timestamp of a service stopping event.
         *
         * Source : (LST_)MVMT_TMST of the first service-stopping event / movement.  There are a number of interim delivery qualifiers (DLVRY_QALFR_CD) that can cause the calculation (ie. stop service).
         */
        this.calculatedServiceDateTime = undefined;
        /**
         * Expanded Name : Calculated Movement Sequence Number
         *
         * Desc : The sequence number identifying the movement (service-stopping event) for the calculation of CALC_SVC_DAYS.
         * NOTE - VALUE CAN BE ZERO FOR PARTLOT (PTLT) PROS.
         *
         * Source : SHM_MOVEMENT - MVMT_SEQ_NBR
         */
        this.calculatedMovementSequenceNbr = undefined;
        /**
         * Expanded Name : Difference of Calculated Days
         *
         * Desc : Difference between CALC_SVC_DAYS and EST_TRNST_DAYS.
         *
         * Source : CALC_SVC_DAYS - EST_TRNST_DAYS.
         */
        this.diffCalculatedDays = undefined;
        /**
         * Expanded Name : Difference of Transit Days
         *
         * Desc : Difference between ACTL_TRNST_DAYS and EST_TRNST_DAYS.
         *
         * Source : ACTL_TRNST_DAYS - EST_TRNST_DAYS.
         */
        this.diffTransitDays = undefined;
        /**
         * Expanded Name : Late Tender Code
         *
         * Desc : Indicates whether shipment could not be picked up in time (due to late tender by shipper) to make service.
         *
         * Values: Y - Late Tender; blank or N - Not Late Tender
         *
         * Source : Bill Entry/FBES; can be populated at Pick-up Request create time if a skeleton PRO is available; may be changed in Corrections
         */
        this.lateTenderCd = undefined;
        /**
         * Expanded Name : Shipment Service Status Code
         *
         * Desc : Indicates whether shipment met service standards.
         *
         * Values: Fail, Success, Exempt, Unknown
         *
         * Source : Calculated
         */
        this.shipmentServiceStatusCd = undefined;
        /**
         * Expanded Name : Service Calculation Status Code
         *
         * Desc : Indicates whether shipment service calculations have been performed.
         *
         * Values:
         * 			0 - Not Calculated Yet
         * 			1 - Cannot Calculate (all variables not defined)
         * 			? - Calculated from (service stopping event or appointment - replace '?' with DLVRY_QALFR_CD values)
         *
         * Source : Calculated
         */
        this.serviceCalculatedStatusCd = undefined;
        /**
         * Expanded Name : Exemption Reason Code
         *
         * Desc : Indicates why a shipment may be exempt from meeting service standards.
         *
         * Values:
         * 			blank - Not Exempt;
         * 			any valid exemption reason code
         *
         * Source : OPS_EXEMPT_SHPMT; shipment exemptions are created immediately upon full trailer and service center exemption events.
         */
        this.exemptReasonCd = undefined;
        /**
         * Expanded Name : Pickup Date Back-Date Indicator
         *
         * Desc : Indicates whether a shipment pickup date was backdated during bill entry.
         *
         * Values:
         * 			Y - Shipment pickup date was backdated at bill entry
         * 			N - Shipment pickup date = bill entry date
         *
         * Source : Bill Entry/FBES.
         */
        this.pickupBackdateInd = undefined;
        /**
         * Expanded Name: FOOD OR POISON CODE
         *
         * Desc; Indicates whether the shipment contains food or posion. Assumption: A shipment will never contain both.
         *
         * Valid Values:
         *
         * 1 - Neither
         * 2 - Food
         * 3 -  Poison
         */
        this.foodPoisonCd = undefined;
        /**
         * Expanded Name: Rating Override Code
         *
         * Desc: Indicates if a rating override has been indicated during billing. For example to use a spot quote or lineal feet rating.
         *
         * Valid Values:
         * 1: Spot Quote Number Specified for rating
         * 2: Lineal Feet Rating should be used
         */
        this.ratingOverrideCd = undefined;
        /**
         * Expanded Name : Pick-Up Time
         *
         * Desc : Time when the shipment was picked up. This will be required for Late Tender shipments and optional for other shipments.
         *
         * Source : Bill Entry/FBES; can be populated at Pick-up
         * Request create time if a skeleton PRO is available;
         * may be changed in Corrections
         */
        this.pickupTime = undefined;
        /**
         * Expanded Name : Service Start Date
         *
         * Desc : Business date on which the service clock starts.  This value will be calculated automatically for all shipments, based on the values of PKUP_DT and LATE_TENDER_CD.  If a shipment is tendered late, the service start date will be set to the next business date after the pick-up date.
         *
         * Source : Will be populated at pkup request create time if a skeleton PRO is available, during bill entry, through the late tender correction screen.
         */
        this.serviceStartDate = undefined;
        /**
         * Expanded Name: Inspected Indicator
         *
         * Desc: Indicates whether the shipment has been inspected or not.
         */
        this.inspectedInd = undefined;
        /**
         * Expanded Name: Spot Quote ID
         *
         * Desc: The Spot Quote ID that was entered during Billing. This may be different from the one that was used for rating.  For the latest Spot Quote ID that was used for raing, please look at the rating info record.
         */
        this.spotQuoteId = undefined;
        /**
         * Expanded Name: Shipper to Consignee Miles
         *
         * Desc: This captures the mileage from shipper to consignee as calculated by the Milemaker package (Rand McNally)
         *
         * Added by C.Doucet 05/06/09 as per Shibashis
         */
        this.shipperToConsigneeMiles = undefined;
        /**
         * Expanded name: Shipper loaded trailer code
         *
         * Desc: Identifies whether a shipper loaded a trailer, and if so, where Con-way took possession of trailer.
         *
         * Values:
         * N  Shipper did not load trailer (default)
         * H  Hook loaded; a trailer is loaded by shipper and picked up by Con-way at shipper s site
         * D  Dock Drop; a trailer is loaded by shipper and dropped at Con-way dock by shipper
         */
        this.shipperLoadedTrlrCd = undefined;
        /**
         * Expanded Name: Consignee unloaded trailer code
         *
         * Desc: Identifies whether a consignee unloaded a trailer, and if so, where consignee took possession of trailer.
         *
         * Values:
         * N  Consignee did not unload trailer (default)
         * D  Dock Pickup; a loaded trailer is picked up at Con-way dock by consignee to be unloaded by consignee
         * S  Spot loaded; a loaded trailer is left at the consignee site for consignee to unload
         */
        this.consigneeUnloadTrlrCd = undefined;
        /**
         * Expanded Name: Lineal Foot Total Number
         *
         * Desc: This is the length in feet that a shipment will take up in a trailer.  This dimension is typically used when the freight is long and narrow and cannot have anything stacked on top of it (e.g. carpet rolls).  For this reason it takes a larger portion of the trailer volume than a shipment of the same weight that is packaged on pallets.  This value can then be used in the planning of trailer loads and to rate shipments that have these characteristics.
         */
        this.linealFootTotalNbr = undefined;
        /**
         * Expanded Name: Single Shipment Acquired Indicator                                                                                                                                                Desc:                                                                                                      This indicates whether this was the only Shipment that we acquired from the Customer at the time that we received this one.
         * Values:
         * Y  Yes:  This was the only Shipment Acquired at the time that we received this one.
         * N  No: There were other Shipments Acquired at the time that we received this one.
         */
        this.singleShipmentAcquiredInd = undefined;
        /**
         * Desc: This code identifies the method in which Con-way received the freight from the customer.
         * Current values are:
         * PU  Regular Pickup:  This is when the driver goes to the customer dock and loads the Shipment on the trailer to return to the service center.
         * HL  Hook Loaded: This is when the driver goes to the customer site and pickup a loaded trailer that this Shipment was on.
         * DD  Dock Drop:  This is when the customer delivers the Shipment to a Con-way Service Center, so no driver went to the Customer site
         */
        this.shipmentAcquiredTypeCd = undefined;
        /**
         * Expanded Name : Loose pieces count
         *
         * Desc : Total loose pieces from all commodities in the shipment.
         *
         * Count of non Motor Move pieces associated with a shipment. This count plus Motor Moves defines the total number of pieces moving within the Con-way system for Operations productivity.  This does not necessarily balance with the total pieces or commodity pieces entered during bill entry.
         */
        this.loosePiecesCount = undefined;
        /**
         * Expanded Name: PUP_VOLUME_PERCENTAGE
         *
         * Desc: This is the volume of the shipment expressed as the percentage of a full pup (28 feet long trailer).
         */
        this.pupVolumePercentage = undefined;
        /**
         * Desc: Instance id of the Pickup Request that is associated with this Shipment during the Confirm On-Board process.
         */
        this.purInstId = undefined;
        /**
         * Expanded Name: Bulk Liquid Indicator
         *
         * Desc: Identifies the shipment as containing bulk liquid.  If volume is known, this applies to shipments >119 gallons.
         *
         * Added 8/5/14 by Paul Bramhall for Tanker Endorsement Project.
         * -------------------------------------------------------------
         */
        this.bulkLiquidInd = undefined;
        /**
         *
         */
        this.cubicFeetProfileMthdCd = undefined;
        /**
         *
         */
        this.cubicFeetProfileTypeCd = undefined;
        /**
         * In the event a customer requires a shipment to travel from origin to destination
         * without the loading of any additional shipments on the trailer(s), the shipment is considered Exclusive Use.
         */
        this.exclusiveUseInd = undefined;
        /**
         * Indicates that the customer would like to insure the shipment due to excessive value of the freight.
         */
        this.excessiveValueInd = undefined;
        /**
         * The value of the freight as declared by the customer.
         */
        this.declaredValueAmount = undefined;
        /**
         * Indicates that this shipment is marked as a Mexico Door to Door shipment.
         */
        this.mexicoDoorToDoorInd = undefined;
        /**
         * Indicates that this shipment is time date critical and operations needs to call for a delivery appointment.
         */
        this.callForAppointmentInd = undefined;
        /**
         * Indicates whether the payment terms were flipped on a bill after biller submit, based on input shipment party data.
         */
        this.debtorTermFlipInd = undefined;
        /**
         * Identifier for unit of work on Shipment.  Added 02/13/2020
         */
        this.transactionId = undefined;
        /**
         * Indicates that the PRO is exempted to be tracked via piece level. SLC (Shipper Loaded Count) shipments are generally exempted. Pickups with 15 or more pieces are also allowed to be exempted.    Added 12/10/2020  LISG-9067 Renamed 01/07/2021
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         * An explanation of why a pro is exempted from piece level tracking.  Added 12/10/2020   LISG-9067 Renamed 01/07/2021
         */
        this.handlingUnitExemptionReason = undefined;
        /**
         * An appointment should be created for delivering the shipment.  Added 03/11/2021 Cathy Doucet LISG-10771
         */
        this.appointmentRequiredInd = undefined;
        /**
         * The consignee should be notified upon arrival of the shipment at destination. During the notification, if the consignee requires an appointment, an appointment will be created, and the shipment will be charged for both services.  Added 03/11/2021  Cathy Doucet LISG-10771.
         */
        this.destinationNotifyInd = undefined;
        /**
         * The shipment total weight at the time of reweigh (if a reweigh occurred).  Added 06/28/2021  LISG-13269
         */
        this.reweighWeightLbs = undefined;
        /**
         * Indicates if the freight has been poorly packaged or not by the Shipper.  Added 05/04/2022  LISG-16763
         *
         * Valid Values:
         * N - freight is NOT packaged poorly (default)
         * Y - freight IS packaged poorly
         */
        this.poorlyPackagedInd = undefined;
        /**
         * Indicates that one or more of the handling units associated with this shipment has become separated from the others.Added 05/16/2022 LISG-16851
         */
        this.handlingUnitSplitInd = undefined;
        /**
         * Indicates that one or more of the handling units associated with this shipment is missing.Added 05/16/2022 LISG-16851
         */
        this.handlingUnitPartialInd = undefined;
        /**
         * PLT PROs crossing border that happened to be split requires a MOVR PRO when some of the handling units have crossed border already. This identifies the MOVR PRO associated to the parent PRO which will move this handling unit across border.  Added 06/14/2022 LISG-17035
         */
        this.moverSuffix = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
        /**
         *
         */
        this.handlingUnit = undefined;
        /**
         *
         */
        this.remark = undefined;
        /**
         *
         */
        this.movement = undefined;
    }
}
/**
 *
 */
class TimeDateCritical {
    constructor() {
        /**
         *
         */
        this.shipmentInstId = undefined;
        /**
         * Expanded: Time Date Critical Source Code
         *
         * Desc: Where the Time Date Critical information was entered.
         *
         * Valid Values:
         * BIL=Bill Entered
         * PUR=Pick Up Request
         * EDI=EDI
         * WEB=Web
         * COR=Corrections
         */
        this.tdcSourceCd = undefined;
        /**
         * Expanded: Time Date Critical Date Type Code
         *
         * Desc: What kind the dates on the TDC shipment is/are.  There are 3 main flavors of date on Time Date Critical shipments: Deliver on a date, Deliver by a date, or a Deliver sometime within a date range
         *
         * Valid Values:
         * ON=On
         * BY=By
         * RNG=Range
         */
        this.tdcDateTypeCd = undefined;
        /**
         * Expanded: Time Date Critical Date #1
         *
         * Desc: There are 3 flavors of date for a TDC shipment.  This attribute captures the following flavor of date: ON, BY or FROM
         */
        this.tdcDate1 = undefined;
        /**
         * Expanded: Time Date Critical Date #2
         *
         * Desc: There are 3 flavors of date for a TDC shipment.  This attribute captures the TO date if the type is a date range.
         */
        this.tdcDate2 = undefined;
        /**
         * Expanded: Time Date Critical Time Type
         *
         * Desc: What kind the times on the TDC shipment is/are.  There are 4 main flavors of time for Time Date Critical shipments: Deliver at a time, Deliver before a time, Deliver after a time, or a Deliver sometime within a time range
         *
         * Valid Values:
         * AT=At
         * BEF=Before
         * AFT=After
         * RNG=Range
         */
        this.tdcTimeTypeCd = undefined;
        /**
         * Expanded: Time Date Critical Time #1
         *
         * Desc: There are 4 flavors of time for a TDC shipment.  This attribute captures the following flavor of time: AT, AFTER, BEFORE, FROM
         */
        this.tdcTime1 = undefined;
        /**
         * Expanded: Time Date Critical Time #2
         *
         * Desc: There are 4 flavors of time for a TDC shipment.  This attribute captures the TO time if the type is a time range.
         */
        this.tdcTime2 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         */
        this.auditInfo = undefined;
    }
}
class XrtAttributeFilter {
    constructor() {
        this.equals = undefined;
        this.min = undefined;
        this.max = undefined;
        this.startsWith = undefined;
        this.values = undefined;
        this.query = undefined;
        this.exclude = undefined;
        this.radius = undefined;
        this.radiusMeasurementUnit = undefined;
        this.lat = undefined;
        this.lon = undefined;
        this.points = undefined;
        this.convert = undefined;
        this.contains = undefined;
        this.distanceFeature = undefined;
        this.exists = undefined;
    }
}
class XrtDistanceFeature {
    constructor() {
        this.point = undefined;
        this.distance = undefined;
    }
}
class XrtGeoPoint {
    constructor() {
        this.lat = undefined;
        this.lon = undefined;
    }
}
class XrtSortExpression {
    constructor() {
        this.isDescendingSort = undefined;
        this.column = undefined;
        this.direction = undefined;
    }
}
class XrtSearchQueryHeader {
    constructor() {
        this.pageNumber = undefined;
        this.sortExpressions = undefined;
        this.pageSize = undefined;
        this.fields = undefined;
        this.excludeFields = undefined;
    }
}
class XrtSearchRespHeader {
    constructor() {
        /**
         * Duration of query
         */
        this.duration = undefined;
        /**
         * Current page number of result set
         */
        this.pageNumber = undefined;
        /**
         * Number of rows contained in a page
         */
        this.pageSize = undefined;
        /**
         * Number of results
         */
        this.resultCount = undefined;
    }
}
class XrtExportQueryHeader {
    constructor() {
        this.fields = undefined;
        this.fileType = undefined;
    }
}
/**
 * Information about global accessorials and how to calculate their charge amounts
 */
class AccessorialChargePricing {
    constructor() {
        /**
         * This code also identifies the accessorial charge.
         */
        this.accessorialCd = undefined;
        /**
         * Indicates whether the charge for the accesorial service is discountable or not.
         */
        this.accessorialDiscInd = undefined;
        /**
         * This is the unit of measure for specifying the maximum and minimum limits for the accessorial service.
         */
        this.accessorialUom = undefined;
        /**
         * 1- Flat Rate per UOM
         * 2 - % of Specified Charge type
         */
        this.chargeTypeCd = undefined;
        /**
         * Indicates whether the AC is a literal or not.
         */
        this.literalInd = undefined;
        /**
         * This is the maximum charge amount that will be charged if the accessorial service was performed.
         */
        this.overrideMaxChgAmt = undefined;
        /**
         * The maximum units for which this charge applies
         */
        this.overrideMaxUnitCount = undefined;
        /**
         * This indicates if the charges for the accessorial service are tiered by weight or other units of measure.
         */
        this.overrideMinChgAmt = undefined;
        /**
         * The minimum units for which this charge applies.
         */
        this.overrideMinUnitCount = undefined;
        /**
         * This indicates if the accessorial charge will always be charged on every shipment for the customer that gets rated using this ruleset irrespective of whether the Accessorial service was performed or not.
         * Valid Values:
         * Y - Always Apply
         * N- Apply only when service is performed
         */
        this.alwaysApplyInd = undefined;
        /**
         * This is the override type that overrides the default AC service. Based on this type code charges will be derived. i.e., charges can be from standard default or the override value.
         * Valid Values:
         * 1. Selected without changes (Charges will float)
         * 2. Modified (Charges are frozen as modified)
         * 3. Waived (Charges are frozen at 0.00)
         * 4. Frozen (Charges are fozen at the default value during ruleset setup)
         * 5. Modified-Float (Charges will float, but will use min/max units from override)
         */
        this.overrideTypeCode = undefined;
        /**
         * Specifies the type of charge which is used for calculating the charges for the accessorial service using the RATE_PCT.
         * Valid Values:
         *
         * 1: COD Amount
         * 2: Linehaul Charges
         * 3: Advance Amount
         * 4: Order Notify Amount
         * 5: Excess Value Amount Declared
         */
        this.overridePctTypeCode = undefined;
        /**
         * This is the rate at which the accessorial service is charged. This is mutually exclusive with ratePct and will not be specified if ratePct is specified.
         */
        this.overrideAmt = undefined;
        /**
         * This specfies the percentage to be used for calculating the charges for the accessorial service. Mutually exclusive with rateAmt
         */
        this.overridePct = undefined;
        this.termCreditCd = undefined;
        /**
         * This indicates if the charges for the accessorial service are tiered by weight or other units of measure.
         */
        this.tieredInd = undefined;
        this.tierSeqNbr = undefined;
    }
}
/**
 * Accessorial overrides from the Pricing Agreement
 */
class AccessorialOverride {
    constructor() {
        /**
         * accessorial code to be overridden
         */
        this.accessorialCd = undefined;
        /**
         * Valid Values:
         * 1. Selected without changes (Charges will float)
         * 2. Modified (Charges are frozen as modified)
         * 3. Waived (Charges are frozen at 0.00)
         * 4. Frozen (Charges are fozen at the default value during ruleset setup)
         */
        this.accOverrideTypeCd = undefined;
    }
}
/**
 * Information about the Contract Terms for the Pricing Agreement
 */
class AgreementContractTerm {
    constructor() {
        /**
         * Information about the Pricing Agreement
         */
        this.prcAgreement = undefined;
        /**
         * This indicates whether the discount percentage will be displayed in the discount line text on the customers invoice. For example, whether the discount line should be
         * CON-WAY DISOCUNT SAVES YOU 70% or
         * CON-WAY DISCOUNT SAVES YOU
         *
         * Note: Even if the indicator is turned on, it will not display the discount on a minimum charge shipment.
         *
         * Valid Values:
         * Y- Display Discount
         * N- Do not Display Discount
         */
        this.displayDiscountInd = undefined;
        /**
         * This is the number of days the customer has for paying the freight charges. This will update the default payment terms in CIS when the agreement is approved. When the agreement is expired or cancelled it will reset the CIS value to default 15 days.
         */
        this.paymentTerm = undefined;
        /**
         * This pallet weight value is used for two purposes:
         * The first is to provide an average weight per pallet for calculating the total shipment pallet weight tolerance for Con-Firm / re-weigh when the PLLT_WAIVER_IND is set to Y. This is also use to indicate the average weight per pallet for calculating reduced weight (reduced charge) on palletized shipments when the REDUCE_PLLT_WGT_IND is set to Y.
         */
        this.avgPalletWeight = undefined;
        /**
         * Indicates that the customer has a pallet weight allowance for re-weigh purposes. A value of 'Y' also requires that there to be a value in AVG_PLLT_WGT_LBS. Some customers may have a reduced weight (reduced charge) allowance for the weight of their pallets (see REDUCE_PLLT_WGT_IND ), but that same customer doesn't necessarily get a pallet weight allowance for re-weigh purposes, unless this indicator is set.
         */
        this.palletWaiverInd = undefined;
        /**
         * Indicates that the customer is not be charged for the weight of their pallets. A value of 'Y' also requires that there to be a value in AVG_PLLT_WGT_LBS. Some customers may have a pallet weight allowance for re-weigh purposes (see PLLT_WAIVER_IND), but that same customer doesn't necessarily get a reduced weight (reduced charge) for the weight of the pallet(s) on their shipments, unless this indicator is set.
         */
        this.reducedPalletWgtInd = undefined;
    }
}
class ClassOverrideBasic {
    constructor() {
        /**
         * commodityClassCode
         */
        this.commodityClass = undefined;
        /**
         * Commodity class that overrides the commodityClass
         */
        this.overrideClass = undefined;
    }
}
/**
 * Commodity class overrides in the Pricing Agreement
 */
class ClassOverridexx {
    constructor() {
        /**
         * Commodity NMFC class
         */
        this.commodityClass = undefined;
        /**
         * NMFC item that along with class uniquely defines the type of Freight
         */
        this.commodityNmfcItem = undefined;
        /**
         * FAK that overrides the NMFC class code and NMFC Item
         */
        this.commodityFak = undefined;
    }
}
/**
 * Information about the Class Rate Ruleset
 */
class ClassRate {
    constructor() {
        /**
         * Indicates whether any AC has been overridden for the ruleset
         */
        this.acOverrideInd = undefined;
        this.agrmtContractTerm = undefined;
        /**
         * Identifies the rate audit queue the shipments will be put into if they are rated using this rule set.
         */
        this.auditQueueName = undefined;
        /**
         * Indicates whether any Class has been overridden for the ruleset. Valid values are Y or N
         */
        this.classOverrideInd = undefined;
        this.classOverride = undefined;
        this.commodityPricingInd = undefined;
        this.commodityPricing = undefined;
        this.corpFsc = undefined;
        /**
         * This indicates if this ruleset should be used to rate a a shipment even if this ruleset is not from the debtor of the shipment and the debtor of the shipment has his own ruleset that is applicable to the shipment.
         */
        this.debtorOverrideInd = undefined;
        /**
         * Indicates if the ruleset is defined with default discount. Values are Y or N
         */
        this.defaultDiscInd = undefined;
        /**
         * Indicates whether Deferred Override exists.
         */
        this.deferredOverrideInd = undefined;
        /**
         * Indicates if the discounts are defined by weight bracket. In this case the value in the DISC_PCT attribute should be ignored
         */
        this.discByWgtInd = undefined;
        this.discountPgm = undefined;
        this.discountTier = undefined;
        /**
         * Identifies the entry queue the shipments will be put into if they qualify to be rated using this rule set.
         *
         * If this is non blank, the pro will not be auto rated.
         */
        this.entryQueueName = undefined;
        /**
         * This is the discount that will be applied when the fall back tariff is used to rate the shipment
         */
        this.fallBackDiscPct = undefined;
        /**
         * This field is applicable for frozen rate bases or tariffs. When this rule set cannot rate a shipment using a frozen rate base the fall back tariff will be used to rate the shipment.
         */
        this.fallBackTariffName = undefined;
        /**
         * Indicates whether the FSC has been overridden or waived for the ruleset.
         * Valid Values:
         *
         * 1- FSC neither Waived nor Overridden
         * 2 - FSC Waived
         * 3 - FSC Overridden (Other FSC Tariff)
         * 4 - FSC Overridden (CNWY190 Tariff)
         * 5 - Universal (this value indicates the overrides are defined in universal ruleset i.e., rs seq nbr zero record)
         */
        this.fscOverrideCd = undefined;
        /**
         * Name of the tariff that governs how the fuel surcharge will be applied by the rule set.
         */
        this.fscTariffName = undefined;
        /**
         * Indicates that the bill should be held for manual processing following any autorating.
         */
        this.holdForManualRateInd = undefined;
        /**
         * Indicates whether the rule set applies on various combinations of direct and interline shipments
         * Valid Values:
         * 1 - Applies on Advance Carrier Interline only
         * 2 - Applies on Direct and Advance Carrier Interline only
         * 3 - Applies on Advance and Beyond interline but not on direct shipments
         * 4 - Applies on all shipments
         * 5 - Applies on Beyond Interline shipments only
         * 6 - Applies on Direct Shipments only
         * 7 - Applies on Direct and Beyond Interline only
         */
        this.interlineApplyCd = undefined;
        /**
         * The discount percentage to be applied for lineal foot rates. This is only valid if the Lineal foot rates are overridden
         */
        this.linealFtDiscPct = undefined;
        /**
         * Indicates whether a shipment qualified to be rated using this rule set is exempt from lineal foot rates or not.
         */
        this.linealFtExemptInd = undefined;
        /**
         * Indicates whether the lineal foot has been overridden for the ruleset.
         */
        this.linealFtOverrideInd = undefined;
        this.linealFtRate = undefined;
        /**
         * Indicates lineal foot queuing is required for shipments rated with this ruleset
         *
         * Valid Values:
         *
         * Y- Yes (automatic queuing of lineal foot shipments)
         * N - No (no LF queuing is required).
         */
        this.linealFtQueInd = undefined;
        /**
         * extra services that are not accessorial fees that are associated with a customer's pricing
         */
        this.miscSvcOverride = undefined;
        /**
         * Indicates whether NMFC has been overridden or not. Values are Y or N
         */
        this.nmfcOverrideInd = undefined;
        /**
         * NMFC numbers for which the class is overridden to a different class value.
         */
        this.nmfcOverride = undefined;
        this.nonTieredAccessorial = undefined;
        /**
         * This indicates if another parties discounts or the default discounts applicable to certain regions should apply to the bill if these dicounts result in a lower rate for the customer.
         */
        this.overrideAllowedInd = undefined;
        this.ratingTariffName = undefined;
        /**
         * Effective date of the Ruleset customer record
         */
        this.rulesetCustEffDate = undefined;
        /**
         * Expiry date of ruleset customer record
         */
        this.rulesetCustExpDate = undefined;
        /**
         * Effective Date of the Ruleset
         */
        this.rulesetEffDate = undefined;
        /**
         * Expiry date of the Ruleset
         */
        this.rulesetExpDate = undefined;
        /**
         * Ruleset Sequence Number
         */
        this.rulesetNbr = undefined;
        /**
         * Ruleset rating instruction
         */
        this.ratingInstr = undefined;
        /**
         * Name of the rules tariff applicable to the rule set
         */
        this.rulesTariffName = undefined;
        /**
         * This is the factor by which the rates from the rating tariff will be multiplied while rating a shipment. The Pricing analysts can set this field. The AEs and NAEs will be allowed to view this field but they will not be able to change it.
         */
        this.tariffFactor = undefined;
        /**
         * This is the factor by which the rates from the rating tariff minimum charge will be multiplied while rating a shipment. The Pricing analysts can set this field. The AEs and NAEs will be allowed to view this field but they will not be able to change it.
         */
        this.tariffMcFactor = undefined;
        this.tieredAccessorial = undefined;
        this.weightRestriction = undefined;
        /**
         * Indicates whether any weight restrictions exist for the ruleset
         */
        this.weightRestrInd = undefined;
    }
}
/**
 * Information about the commodity rates for a ruleset
 */
class CommodityPricing {
    constructor() {
        /**
         * A system assigned sequential number to uniquely
         * identify the rate entries
         */
        this.seqNbr = undefined;
        /**
         * Identifies the lowest unit count for which the commodity pricing is to be applied
         */
        this.lowRangeCnt = undefined;
        /**
         * Identifies the highest unit count for which the commodity pricing is to be applied.
         */
        this.highRangeCnt = undefined;
        /**
         * Minimum Charge Amount - A shipment rated using this ruleset's commodity pricing may not be charged less than this amount.
         */
        this.minChargeAmt = undefined;
        /**
         * Price per unit (Ex. $35 per each pallet).
         */
        this.unitRate = undefined;
        /**
         * Rate type is used for various total charge calculation types.
         *
         * Valid values:
         * 1 - Per Unit (Ex. Total Charge will be $150.00 (50*3), rate per unit is $50 and 3 unit are used).
         * 2 - Total Charges (Ex. Total Charge will be $60 for one unit, $100 for two units, $140 for three units).
         * 3 - Both (Ex. Total charge will be $ 250 (175+60) for 5 units, i.e., for $175 for first four units and $60 per each additional unit).
         */
        this.rateTypeCode = undefined;
        /**
         * Desc:
         * 1. When rt_typ_cd is '2', this is the total charge for the all the commodity units together.
         * 2. When rt_typ_cd is '3', this is the base rate that will be added to the (unit_rt * (total units - base_rt_unit_cnt)).
         */
        this.baseRate = undefined;
        /**
         * This is the number of units for which the base rate is applied. It must be specified when rt_typ_cd is '3'.
         */
        this.baseRateUnitCount = undefined;
        /**
         * This indicates how the fuel surcharge to be applied.
         *
         * Valid Values:
         * 0 - FSC applies.
         * 1 - FSC is waived for all the shipments.
         * 2 - FSC is waived for intra SIC shipments only.
         * 3 - FSC is waived for intra state shipments only.
         * 4 - FSC is waived for intra US shipments only.
         * 5 - FSC is waived for intra Canadian shipments only.
         */
        this.fscCode = undefined;
    }
}
/**
 * Information about the Discount Program related to a Ruleset
 */
class DiscountPgm {
    constructor() {
        /**
         * System assigned sequential number to unqiuely identify each discount program for a ruleset
         */
        this.discountPgmSeqNbr = undefined;
        /**
         * Applicable discount in %. This attribute does not have a value when the discounts are by weight bracket
         */
        this.discountPct = undefined;
        /**
         * Applicable discount in %, when minimum charges are applied to a line item.
         */
        this.minChrgDiscountPct = undefined;
        /**
         * Absolute Minimum Charge Amount - A shipment rated using the rule set may not be charged less than this amount.
         */
        this.absMinChargeAmt = undefined;
    }
}
/**
 * Tiered discount structure
 */
class DiscountTier {
    constructor() {
        /**
         * This is the lower limit of the range of weight or volume for which the ruleset is applicable
         */
        this.lowRange = undefined;
        /**
         * This is the higher limit of the range of the weight or volume for which the ruleset is applicable
         */
        this.highRange = undefined;
        /**
         * Applicable discount pct
         */
        this.discountPct = undefined;
        this.rngLabelText = undefined;
    }
}
/**
 * Information about the Fuel Surcharge
 */
class FuelSurcharge {
    constructor() {
        this.typeCode = undefined;
        this.chargeAmt = undefined;
        this.pct = undefined;
        this.tlFactorNbr = undefined;
    }
}
/**
 * Information about the Lineal Feet pricing from the Ruleset
 */
class LinealFeetRate {
    constructor() {
        /**
         * A system assigned sequential number to uniquely identify each lineal foot rate line for a ruleset.
         */
        this.seqNbr = undefined;
        /**
         * This identifies the trailer type to which the overridden lineal foot rate applies.
         *
         * Valid Values:
         * 1 - Single 28 Feet
         * 2 - Double 28 Feet
         * 3 - Single 40 Feet
         */
        this.trailerTypeCode = undefined;
        /**
         * This specifies the minimum loading space on the trailer the shipment should occupy to be rated using this rule set.
         */
        this.minLoadSpaceFt = undefined;
        /**
         * This specifies the maximum loading space on the trailer the shipment should occupy to be rated using this rule set.
         */
        this.maxLoadSpaceFt = undefined;
        /**
         * This is the rate per mile lineal feet rate.
         */
        this.rateAmt = undefined;
        /**
         * This is the minimum amount that will be charged for the shipment that qualifies for rating using these overridden rate.
         */
        this.minChargeAmt = undefined;
        /**
         * This is the minimum miles for which this rates apply.
         */
        this.minMiles = undefined;
        /**
         * This is the maximum miles for which this rates apply.
         */
        this.maxMiles = undefined;
        /**
         * Defines the unit of measure for the rate
         *
         * Valid Values:
         *
         * 1 - per mile per feet
         * 2 - per mile
         */
        this.rateUom = undefined;
    }
}
/**
 * Information about extra services that are not accessorial fees that are associated with a customer's pricing
 *
 *
 */
class MiscSvcOverride {
    constructor() {
        /**
         * A system assigned sequential number to uniquely
         * identify each service for a Pricing rule set.
         */
        this.seqNbr = undefined;
        /**
         * Identifies the type of charge for the Service. For certain type of services it may be a discount amount or percentage that will be applied to the shipment. For other type of services it may be an extra charge amount or percentage applied to the shipment.
         *
         * Valid Values:
         * 1. Deferred Service Discount
         */
        this.chargeTypeCode = undefined;
        /**
         * This is the amount that will either be charged or discounted for this service based on the charge type.
         */
        this.svcAmt = undefined;
        /**
         * This is the percentage of total charge of the shipment that will be either discounted or applied to the bill for the service based on the chareg type
         */
        this.svcPct = undefined;
    }
}
/**
 * NMFC Clase overrides in the Pricing Agreement
 */
class NmfcClassOverride {
    constructor() {
        /**
         * A system assigned sequential number to uniquely
         * identify each NMFC number included or excluded for a Pricing rule set.
         */
        this.seqNbr = undefined;
        /**
         * Commodity NMFC class
         */
        this.commodityClass = undefined;
        /**
         * NMFC class that overrides the commodity class
         */
        this.overrideClass = undefined;
    }
}
/**
 * NMFC Item Number overrides in the Pricing Agreement
 */
class NmfcItemOverride {
    constructor() {
        /**
         * Commodity NMFC Item Number
         */
        this.nmfcItemNbr = undefined;
        /**
         * Override NMFC Item Number for commodity
         */
        this.nmfcItemOverride = undefined;
    }
}
/**
 * Information about the Id of the Pricing Agreement
 */
class PricingAgreementId {
    constructor() {
        /**
         * This is the unique database key of the agreement.
         */
        this.agreementId = undefined;
        /**
         * The version of the  pricing agreement
         */
        this.agreementCustVersion = undefined;
        /**
         * The sequence number within the version of pricing agreement
         */
        this.agreementSeqNbr = undefined;
        /**
         * The instance ID of the customer that negotiated this pricing agreement
         */
        this.leadAcctId = undefined;
        /**
         * Values :
         * 1 - LTL Pricing
         * 2 - Spot Quote
         * 3 - Pallet Pricing
         */
        this.paTypeCd = undefined;
        /**
         * Indicates if Pricing Agreement is active. Valid values are Y or N.This is set to N when either the Pricing Agreement Active Ind = N or the Ruleset Active Ind = N
         */
        this.activeInd = undefined;
    }
}
/**
 * Ruleset Identification Information
 */
class RulesetId {
    constructor() {
        this.agreementId = undefined;
        /**
         * Ruleset Sequence Number
         */
        this.rulesetNbr = undefined;
    }
}
/**
 * Information about the Weight restrictions in class rates ruleset
 */
class WeightRestriction {
    constructor() {
        this.minWgt = undefined;
        this.maxWgt = undefined;
        this.minWgtPerPce = undefined;
        this.maxWgtPerPce = undefined;
    }
}
class PalletCommodity {
    constructor() {
        this.palletTypeCd = undefined;
        this.palletCount = undefined;
        this.palletWeight = undefined;
        this.palletStackableInd = undefined;
        this.palletVolume = undefined;
        this.palletVolumeUom = undefined;
    }
}
/**
 * Indicates whose ruleset was actually used for rating: S - Shipper; C - Consignee; B - Bill-to (Third Party).
 */
class PricingAgreement {
    constructor() {
        this.prcAgreementInstId = undefined;
        this.prcRulesetNbr = undefined;
        this.prcAgreementNbrTxt = undefined;
        this.ratingCustomerNbr = undefined;
        this.prcAgreementCustomerAcctId = undefined;
        this.overrideFactor = undefined;
        /**
         * Pricing Agreement Absolute Minimum Charge Amount
         */
        this.agreementAmcAmt = undefined;
        /**
         * Pricing Agreement Effective Date
         */
        this.pricingAgreementEffectiveDate = undefined;
        /**
         * Offshore Tariff
         */
        this.offshoreTariff = undefined;
        /**
         * Indicates whose ruleset was actually used for rating: S - Shipper; C - Consignee; B - Bill-to (Third Party).
         */
        this.rulesetOwnerCd = undefined;
    }
}
class Rating {
    constructor() {
        this.rateRequestTypeCd = undefined;
        this.rateRequestSubTypeCd = undefined;
        this.requestId = undefined;
        this.cts599RatingInd = undefined;
        this.rerateInd = undefined;
        this.requestAccOnlyInd = undefined;
        this.disallowDeficitWeightRatingInd = undefined;
        this.doNotApplyFakInd = undefined;
        this.doNotOverrideFscInd = undefined;
        this.doNotApplySpecialDiscountInd = undefined;
        this.useClassRatesInd = undefined;
        this.overrideDiscountInd = undefined;
        this.consumerCallingProgram = undefined;
        this.reducedWeightCommodityLineCnt = undefined;
    }
}
class RatingAccessorial {
    constructor() {
        this.sequenceNbr = undefined;
        this.accessorialCd = undefined;
        /**
         * Description of the Accessorial
         */
        this.accessorialDesc = undefined;
        this.minChargeInd = undefined;
        /**
         * Accessorial Amount
         */
        this.chargeAmt = undefined;
        this.unitRate = undefined;
        this.unitQty = undefined;
        this.maxChargeInd = undefined;
        this.chargeTypeDesc = undefined;
        this.rateTypeCd = undefined;
        this.literalInd = undefined;
    }
}
/**
 * ***Needs Review
 */
class RatingCommodityLine {
    constructor() {
        /**
         * Might be versions of a commodity line - original, corrected, as-rated
         */
        this.commodityLineTypeCd = undefined;
        /**
         * sequence on shipment
         */
        this.shipmentSequenceNbr = undefined;
        this.dimensionMeasurement = undefined;
        this.dimensions = undefined;
        /**
         * commodity and packing info including hazmat
         */
        this.commodity = undefined;
        this.commoditySubLines = undefined;
        /**
         * this will have the rate and charge information. if weight was changed based on rated as, then the new weight will be in quantity. The class will be reflected in asRatedNmfcClass
         */
        this.charge = undefined;
        /**
         * this is an FAK that has overridden the as entered class when rated
         */
        this.asRatedNmfcClass = undefined;
        /**
         * This is value declared by the shipper. This might have implications for the claims.
         */
        this.declaredValue = undefined;
        /**
         * Commodity Line Override Charge Amount.
         */
        this.overrideCharge = undefined;
        /**
         * These are refenence numbers provided by the party on the bill (shipper) specific to this commodity line.
         */
        this.suppRefs = undefined;
        this.references = undefined;
    }
}
/**
 * Account IDs and address
 */
class RatingParty {
    constructor() {
        /**
         * Database key for customer
         */
        this.acctInstId = undefined;
        /**
         * Business key for customer
         */
        this.acctMadCd = undefined;
        /**
         * Primary name
         */
        this.name = undefined;
        /**
         * Applies to mailing address of a person, where the address is actually in another entity's name.
         */
        this.careOfName = undefined;
        /**
         * Address line that includes Street name, direction and optionally building number, unit# etc.
         * e.g. 1000 SW Broadway st
         */
        this.addressLine1 = undefined;
        /**
         * Address line that includes Street name, direction and optionally building number, unit# etc.
         * e.g. 1000 SW Broadway st
         */
        this.addressLine2 = undefined;
        /**
         * PO Box typically applies to a mailing address. This is the standard PO Box# of an address.
         */
        this.postOfficeBox = undefined;
        /**
         * City Name part of the address.
         */
        this.cityName = undefined;
        /**
         * County Name part of the address.
         */
        this.countyName = undefined;
        /**
         * Standard Postal abbreviation for state name. Example: OR for Oregon.
         */
        this.stateCd = undefined;
        /**
         * standard Postal abbreviation for a country. Example: CA for Canada.
         */
        this.countryCd = undefined;
        /**
         * Postal Code are aka Zip code in USA. US and Mexico use 5 digit postal codes. Canada uses 6 char postal codes.
         */
        this.postalCd = undefined;
        /**
         * This is a 4 digit extension to US 5 digit zip code.
         */
        this.usZip4 = undefined;
        /**
         * Describes the location type of a rating party.
         */
        this.ratingPartyLocationTypeCd = undefined;
    }
}
class RatingRequest {
    constructor() {
        this.chargeToCd = undefined;
        this.guaranteedInd = undefined;
        this.overrideRatingTariff = undefined;
        this.advanceScacCd = undefined;
        this.advanceRevenueAmt = undefined;
        this.beyondScacCd = undefined;
        this.beyondRevenueAmt = undefined;
        this.overrideDiscountPct = undefined;
        this.overrideMinimumChargeDiscountPct = undefined;
        this.overrideFscPct = undefined;
        this.overrideFuelPrice = undefined;
        this.rulesTarifffDate = undefined;
        this.fuelTariffDate = undefined;
        this.discountSourceCd = undefined;
        this.overrideRulesTariff = undefined;
        this.overrideFuelTariff = undefined;
        this.classOverride = undefined;
        this.overrideAbsoluteMinimumChargeAmt = undefined;
        /**
         * The Dynamic Pricing external rule ID for Dynamic Pricing evaluation.
         */
        this.dpExternalRuleId = undefined;
        /**
         * The Dynamic Pricing quote number for Dynamic Pricing evaluation.
         */
        this.dpQuoteNbr = undefined;
    }
}
class RatingResponse {
    constructor() {
        /**
         * Density Linehaul Charge Amount
         */
        this.densityLinehaulAmt = undefined;
        /**
         * Density Calculated Class Code
         */
        this.densityCalculatedClassCd = undefined;
        /**
         * Density Source Type Code
         */
        this.densitySourceTypeCd = undefined;
        /**
         * Commodity As Weight or Deficit Weight Description
         */
        this.asDeficitWeightDescription = undefined;
        /**
         * Commodity As Weight or Deficit Weight
         */
        this.asDeficitWeight = undefined;
        /**
         * Commodity As Weight or Deficit Rate
         */
        this.asDeficitWeightRate = undefined;
        /**
         * Commodity As Weight or Deficit Amount
         */
        this.asDeficitWeightAmt = undefined;
        /**
         * Rated As Weight
         */
        this.ratedAsWeight = undefined;
        /**
         * Rating Tariff Name
         */
        this.ratingTariff = undefined;
        /**
         * Rating Tariff Version
         */
        this.tariffVersion = undefined;
        /**
         * Rate Base Tariff Name
         */
        this.infoRatingTariff = undefined;
        /**
         * Rules Tariff Name
         */
        this.rulesTariff = undefined;
        /**
         * Rules Tariff Version
         */
        this.rulesTariffVersion = undefined;
        /**
         * Fuel Surcharge Tariff Name
         */
        this.fuelSurchargeTariff = undefined;
        /**
         * Rating Currency Code
         */
        this.ratingCurrencyCd = undefined;
        /**
         * Applicable Discount Percentage
         */
        this.applicableDiscountPct = undefined;
        /**
         * Actual Discount Percentage
         */
        this.actualDiscountPct = undefined;
        /**
         * Fuel Price Amount
         */
        this.fuelPriceAmt = undefined;
        /**
         * Fuel Price Effective Date
         */
        this.fuelPriceEffectiveDate = undefined;
        /**
         * FSC Rate Type Unit of Measue
         */
        this.fscRateUom = undefined;
        /**
         * FSC Rate Type
         */
        this.fscRateNbr = undefined;
        /**
         * FSC Overrride Code
         */
        this.fscOverrideInd = undefined;
        /**
         * Discount Source Code
         */
        this.discountSourceCd = undefined;
        /**
         * Currency Exchange Rate
         */
        this.currencyExchangeRate = undefined;
        /**
         * Class Override Code
         */
        this.classOverrideCd = undefined;
        /**
         * Multiple Class Indicator
         */
        this.multipleClassInd = undefined;
        /**
         * Invoicing Currency Code
         */
        this.invoicingCurrencyCd = undefined;
        /**
         * Reduced Weight
         */
        this.reducedWeight = undefined;
        /**
         * Rating Origin Zip Code
         */
        this.ratingOrigZipCd = undefined;
        /**
         * Rating Destination Zip Code
         */
        this.ratingDestZipCd = undefined;
        /**
         * Tariff Type Code
         */
        this.tariffTypeCd = undefined;
        /**
         * Revenue Amount
         */
        this.ctsRevenueAmt = undefined;
        /**
         * Revenue Amount in USD
         */
        this.ctsRevenueAmtInUsd = undefined;
        /**
         * Volume Shipment Base Charge Amount
         */
        this.trueLtlPricingBaseChargeAmt = undefined;
        /**
         * Volume Shipment Factor Number
         */
        this.trueLtlPricingFactorNbr = undefined;
        /**
         * Volume Shipment Miles Rate
         */
        this.trueLtlPricingPerMileRate = undefined;
        /**
         * Absolute Minimum Charge Amount
         */
        this.absoluteMinimumChargeAmt = undefined;
        /**
         * Rating Tariff Effective Date
         */
        this.ratingTariffEffectiveDate = undefined;
        /**
         * Absolute Minimum Charge Indicator
         */
        this.absoluteMinimumChargeInd = undefined;
        /**
         * Corporate Absolute Minimum Charge Indicator
         */
        this.corporateAbsoluteMinimumChargeInd = undefined;
        /**
         * The unique identifier for the Dynamic Pricing Rule.
         */
        this.dpRuleHeaderId = undefined;
        /**
         * The Dynamic Pricing external rule ID for Dynamic Pricing evaluation.
         */
        this.dpExternalRuleId = undefined;
        /**
         * The calculated CDI (Common Discount Impact) percentage from the applicable pricing agreement.
         */
        this.agreementCdiPercentage = undefined;
        /**
         * This indicates whether the dynamic shipment is rated with Absolute Minimum Charge (AMC).  Permitted values: DP_RULE, DP_GLOBAL, AGREMENT, and TARIFF.
         */
        this.amcAppliedCd = undefined;
        /**
         * This indicates whether there are dynamic pricing accessorials. Permitted values: DP_RULE, DP_GLOBAL, AGREMENT, and CNWY199.
         */
        this.accessorialAppliedCd = undefined;
    }
}
class RatingRule {
    constructor() {
        /**
         * The name for the rate rules.
         */
        this.rateRulesName = undefined;
        /**
         * The value associated with the rate rules.
         */
        this.rateRulesValue = undefined;
    }
}
class RatingShipmentRequest {
    constructor() {
        this.proNbr = undefined;
        this.pickupDate = undefined;
        this.estimatedDeliveryDate = undefined;
        this.destTerminalSic = undefined;
        this.origTerminalSic = undefined;
        this.materializedPcs = undefined;
        this.hazmatInd = undefined;
        this.freezableInd = undefined;
        this.totalPalletCnt = undefined;
        this.shipmentInstId = undefined;
        this.codAmt = undefined;
        this.manualRatingRequiredInd = undefined;
        this.invoiceCurrencyCd = undefined;
        this.spotQuoteNbr = undefined;
        this.floorSpace = undefined;
        this.floorSpaceUom = undefined;
        this.equipmentTypeCd = undefined;
        this.shipmentValue = undefined;
        this.dimensions = undefined;
        this.dimensionMeasurement = undefined;
        this.diameter = undefined;
        this.grossWeight = undefined;
        this.linealFootTotalNbr = undefined;
        this.linealUom = undefined;
        this.totalVolume = undefined;
        this.totalVolumeUom = undefined;
        /**
         * The code that is associated with the party that is responsible for paying for the shipment.
         */
        this.chargeToCd = undefined;
        /**
         * This indicates whether the shipment is under the XPO Guaranteed Service Program.
         */
        this.guaranteedInd = undefined;
        /**
         * This overrides the rating tariff that is specified in the rule set during rating.
         */
        this.overrideRatingTariff = undefined;
        /**
         * The overriding discount percentage.
         */
        this.overrideDiscountPercentage = undefined;
        /**
         * The Absolute Minimum Charged (AMC) to be used during rating.
         */
        this.overrideAbsoluteMinimumChargeAmount = undefined;
    }
}
class RatingShipmentResponse {
    constructor() {
        /**
         * codAmt
         */
        this.codAmt = undefined;
        /**
         * Shipper To Consignee Miles
         */
        this.totalDistance = undefined;
        /**
         * Number of Trailers
         */
        this.trailerCnt = undefined;
        /**
         * Offshore US Port Identifier
         */
        this.offshoreUSPort = undefined;
        /**
         * Offshore Zone Code
         */
        this.offshoreZoneCd = undefined;
        /**
         * Carrier SCAC Code
         */
        this.scac = undefined;
        /**
         * Carrier SCAC Name
         */
        this.carrierName = undefined;
        /**
         * Warranty Eligible Indicator
         */
        this.warrantyInd = undefined;
        /**
         * Spot Quote instance id
         */
        this.spotQuoteInstId = undefined;
    }
}
class RatingTotal {
    constructor() {
        /**
         * Total Accessorial Amount
         */
        this.totalAccessorialAmt = undefined;
        /**
         * Total Charge Amount
         */
        this.totalChargeAmt = undefined;
        /**
         * Linehaul Charge Amount
         */
        this.linehaulChargeAmt = undefined;
        /**
         * Total Discount Amount
         */
        this.totalDiscountAmt = undefined;
        /**
         * Total FSC Amount
         */
        this.totalFscAmt = undefined;
        /**
         * Total Tax Amount
         */
        this.totalTaxAmt = undefined;
        /**
         * Total Weight
         */
        this.totalWeight = undefined;
        /**
         * Offshore Accessorial Amount
         */
        this.offshoreAccessorialChargeAmt = undefined;
        /**
         * Offshore Linehaul Charge Amount
         */
        this.offshoreLinehaulChargeAmt = undefined;
        /**
         * Offshore FSC Charge Amount
         */
        this.offshoreFscChargeAmt = undefined;
        /**
         * Total Charge Amount in USD
         */
        this.totalChargeAmtInUsd = undefined;
    }
}
class TransactionContext {
    constructor() {
        /**
         * Details of the user making this request
         */
        this.user = undefined;
        /**
         * The authorization token used to invoke this API
         */
        this.authorization = undefined;
        /**
         * The ID of the application using this API
         */
        this.srcApplicationId = undefined;
        /**
         * Http Method
         */
        this.httpMethod = undefined;
        /**
         * Passed from f5 to find out where they came from
         */
        this.xForwardedFor = undefined;
        /**
         * A unique ID for the business transaction.
         * The purpose of this id is to tie multiple computer transactions across multiple technologies for a given business transaction.
         * The scope of the business transaction is determined by the initiator of the transaction.
         * The same id should be used across multiple tiers for a given business transaction.
         * For example, bill entry will use the same correlationId to record the bill details in the database and by TIBCO in backsyncing to DB2.
         * This will generated by the API gateway if one is not passed by the client.
         */
        this.correlationId = undefined;
        /**
         * A unique ID for the database transaction.
         * This will be generated by the REST resource bean before invoking the EJB.
         */
        this.transactionId = undefined;
    }
}
/**
 * Conversation message details.
 */
class XFlowConversation {
    constructor() {
        this.applicationInstId = undefined;
        this.conversationId = undefined;
        this.participants = undefined;
        this.message = undefined;
    }
}
/**
 * Conversation message details.
 */
class XFlowConversationGroup {
    constructor() {
        this.groupId = undefined;
        this.groupOwner = undefined;
        this.groupDescription = undefined;
        this.groupCreateBy = undefined;
        this.participants = undefined;
        this.conversations = undefined;
        this.messages = undefined;
    }
}
/**
 * Item information.
 */
class XFlowItem {
    constructor() {
        this.itemInstId = undefined;
        this.queueName = undefined;
        this.itemStatus = undefined;
        this.priorityCd = undefined;
    }
}
/**
 * Item Count.
 */
class XFlowItemCount {
    constructor() {
        this.queueName = undefined;
        this.newItemCount = undefined;
    }
}
/**
 * Conversation message details.
 */
class XFlowMessage {
    constructor() {
        this.messageId = undefined;
        this.text = undefined;
        this.attachmentURL = undefined;
        this.sender = undefined;
        this.date = undefined;
        this.groupId = undefined;
        this.items = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ARDebtorCd = {
    AR_COLL_DEBTOR: 'ArCollDebtor',
    AR_PPD_DEBTOR: 'ArPpdDebtor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AccessorialCheckCd = {
    TDC_VS_APT: 'TdcVsApt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AccessorialUnitOfMeasureCd = {
    CHECK: 'Check',
    CORRECTION: 'Correction',
    CWT: 'Cwt',
    CWT_DAY: 'CwtDay',
    DAY: 'Day',
    DOCUMENT: 'Document',
    HALF_HR: 'HalfHr',
    LABOUR_HR: 'LabourHr',
    MILE: 'Mile',
    NOT_APPLICABLE: 'NotApplicable',
    PACKAGE: 'Package',
    POUND: 'Pound',
    QUARTER_HR: 'QuarterHr',
    SHIPMENT: 'Shipment',
    VEHICLE: 'Vehicle',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ActionCd = {
    ADD: 'Add',
    DELETE: 'Delete',
    EXPIRE: 'Expire',
    NO_ACTION: 'NoAction',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ActivityStatusCd = {
    ASSIGNED: 'Assigned',
    COMPLETED: 'Completed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AddressTypeCd = {
    BILL_TO: 'Bill-To',
    CLAIMANT: 'Claimant',
    COD_REMIT_TO_PARTY: 'COD Remit To Party',
    CONSIGNEE: 'Consignee',
    CUSTOM_BROKER: 'Custom Broker',
    EMERGENCY_CONTACT: 'Emergency Contact',
    FINANCIAL_LOCATION: 'Financial Location',
    PAYEE: 'Payee',
    PICKUP_CONTACT: 'Pickup Contact',
    PICKUP_REQUESTER: 'Pickup Requester',
    SHIPPER: 'Shipper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AdvanceBeyondTypeCd = {
    ADV_CARR: 'AdvCarr',
    BYD_CARR: 'BydCarr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AgendaItemStatusCd = {
    CANCELLED: 'Cancelled',
    MET: 'Met',
    NOT_DUE: 'Not Due',
    NOT_MET: 'Not Met',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AgendaOwnerTypeCd = {
    INVOICES: 'invoices',
    LINEHAUL_SCHEDULES: 'linehaul-schedules',
    PICKUP_REQUESTS: 'pickup-requests',
    PND_TRIPS: 'pnd-trips',
    SHIPMENTS: 'shipments',
    TRAILERS: 'trailers',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiAuthTypeCd = {
    APPLICATION: 'Application',
    APPLICATION_AND_APPLICATION_USER: 'ApplicationAndApplicationUser',
    APPLICATION_USER: 'ApplicationUser',
    NONE: 'None',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractExceptionSeverityCd = {
    ERROR: 'Error',
    INFO: 'Info',
    WARNING: 'Warning',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractImplApiMethodCd = {
    DELETE: 'DELETE',
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractImplProtocolCd = {
    REST: 'REST',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractImplTechnology = {
    JAX_RS: 'JAX-RS',
    PYTHON: 'PYTHON',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractStatusCd = {
    ARCHIVED: 'Archived',
    CANCELLED: 'Cancelled',
    DELETED: 'Deleted',
    IMPLEMENTED: 'Implemented',
    PENDING: 'Pending',
    SAVED: 'Saved',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiContractTypeCategoryCd = {
    CUSTOM_TYPE: 'CustomType',
    HEADER: 'Header',
    PATH: 'Path',
    QUERY: 'Query',
    REQUEST: 'Request',
    RESPONSE: 'Response',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiFeatureStatusCd = {
    CANCELLED: 'Cancelled',
    IMPLEMENTED: 'Implemented',
    PENDING: 'Pending',
    SAVED: 'Saved',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiThrottlingTierCd = {
    FIFTY_K_PER_MIN: 'FiftyKPerMin',
    TEN_K_PER_MIN: 'TenKPerMin',
    TWENTY_K_PER_MIN: 'TwentyKPerMin',
    UNLIMITED: 'Unlimited',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiTypeAttributeDataTypeCd = {
    ANY_TYPE: 'anyType',
    ANY_URI: 'anyURI',
    BASE_64_BINARY: 'base64Binary',
    BOOLEAN: 'boolean',
    BYTE: 'byte',
    DATE: 'date',
    DATE_TIME: 'dateTime',
    DECIMAL: 'decimal',
    DOUBLE: 'double',
    INT: 'int',
    INTEGER: 'integer',
    LONG: 'long',
    SHORT: 'short',
    STRING: 'string',
    TIME: 'time',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiTypeCategoryCd = {
    CUSTOM: 'Custom',
    ENUM: 'Enum',
    GENERATED: 'Generated',
    PRIMITIVE: 'Primitive',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApiTypeStatusCd = {
    ARCHIVED: 'Archived',
    CANCELLED: 'Cancelled',
    DELETED: 'Deleted',
    IMPLEMENTED: 'Implemented',
    PENDING: 'Pending',
    SAVED: 'Saved',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApplicationCd = {
    DOCK_AUTO: 'DockAuto',
    INSPECTION: 'Inspection',
    LNHL_OPS: 'LnhlOps',
    MIMS: 'Mims',
    PDOPS: 'PDOPS',
    XDOCK: 'XDOCK',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AppointmentNotificationStatCd = {
    ACTIVE: 'Active',
    CANCELLED: 'Cancelled',
    DELIVERY_COMPLETED: 'DeliveryCompleted',
    INACTIVE: 'Inactive',
    NOT_NEEDED: 'NotNeeded',
    REMOVED_FROM_APPOINTMENT: 'RemovedFromAppointment',
    RESCHEDULED: 'Rescheduled',
    RETURN: 'Return',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AppointmentStatusCd = {
    APPOINTMENT_MISSING: 'AppointmentMissing',
    APPOINTMENT_PRESENT: 'AppointmentPresent',
    NO_APPOINTMENT: 'NoAppointment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ApprovalStatusCd = {
    APPROVED: 'Approved',
    NOT_APPLICABLE: 'NotApplicable',
    PENDING: 'Pending',
    REJECTED: 'Rejected',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ArchiveControlCd = {
    ACTIVE_PRO: 'ActivePro',
    FLAGGED_FOR_ARCHIVE: 'FlaggedForArchive',
    RETRIEVED_FROM_ARCHIVE: 'RetrievedFromArchive',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AttemptReasonCd = {
    CASH_NOT_AVAILABLE: 'CashNotAvailable',
    CLOSED_HOLIDAY: 'ClosedHoliday',
    CLOSED_INVENTORY: 'ClosedInventory',
    COD_REQUIRED: 'CodRequired',
    CONSIGNEE_RELATED: 'ConsigneeRelated',
    CREDIT_HOLD: 'CreditHold',
    CUSTOMER_REQUEST_FUTURE_DELIVERY: 'CustomerRequestFutureDelivery',
    CUSTOMER_SHUTDOWN: 'CustomerShutdown',
    CUSTOMER_STRIKE: 'CustomerStrike',
    IMPROPER_UNLOAD_EQUIPMENT: 'ImproperUnloadEquipment',
    INSUFFICIENT_DELIVERY_TIME: 'InsufficientDeliveryTime',
    OTHER: 'Other',
    RECIPIENT_UNAVAILABLE: 'RecipientUnavailable',
    RESIDENTIAL_NOT_HOME: 'ResidentialNotHome',
    SHIPPER_RELATED: 'ShipperRelated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const AvailableStatusCd = {
    AVAILABLE: 'Available',
    SICK: 'Sick',
    TRAINING: 'Training',
    UNAVAILABLE: 'Unavailable',
    VACATION: 'Vacation',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BatchFrameworkArgumentTypeCd = {
    ARGUMENT: 'Argument',
    CONFIG: 'Config',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconItemStatusCd = {
    NEW: 'New',
    READ: 'Read',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconOwnerTypeCd = {
    CUSTOMER: 'Customer',
    DOOR_PLAN: 'DoorPlan',
    LANE: 'Lane',
    LOAD: 'Load',
    SCHEDULE: 'Schedule',
    SHIPMENT: 'Shipment',
    TRAILER: 'Trailer',
    TRIP: 'Trip',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconPriorityCd = {
    HIGH: 'High',
    LOW: 'Low',
    MEDIUM: 'Medium',
    URGENT: 'Urgent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconSourceCd = {
    DOCK_OPERATIONS: 'DockOperations',
    INSPECTIONS: 'Inspections',
    LINEHAUL: 'Linehaul',
    PICKUP_REQUEST: 'PickupRequest',
    PN_D: 'PnD',
    RADAR: 'Radar',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconStatusCd = {
    ACKNOWLEDGED: 'Acknowledged',
    APPROVED: 'Approved',
    CANCELLED: 'Cancelled',
    CLOSED: 'Closed',
    DECLINED: 'Declined',
    EXPIRED: 'Expired',
    NEW: 'New',
    RESOLVED: 'Resolved',
    SCHEDULED: 'Scheduled',
    SENT: 'Sent',
    UNDER_REVIEW: 'UnderReview',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BeaconTypeCd = {
    ALERT: 'Alert',
    EXCEPTION: 'Exception',
    MESSAGE: 'Message',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillClassCd = {
    ACCESSORIAL_ONLY: 'AccessorialOnly',
    ASTRAY_FRT_SEGMENT: 'AstrayFrtSegment',
    CLAIMS_OVRG_RPTG_BILL: 'ClaimsOvrgRptgBill',
    CO_BUS_SHPMT: 'CoBusShpmt',
    EXPEDITE: 'Expedite',
    GENERAL_CLAIMS_BUS_SHPMT: 'GeneralClaimsBusShpmt',
    MASTER_SEGMENT: 'MasterSegment',
    MASTER_SHPMT: 'MasterShpmt',
    NORMAL_MVMT: 'NormalMvmt',
    NOT_APPLICABLE: 'NotApplicable',
    PARTIAL_SEGMENT: 'PartialSegment',
    SPLIT_SEGMENT: 'SplitSegment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillCorrectionStatusCd = {
    ERRORS: 'ERRORS',
    LOCKED: 'LOCKED',
    NEED_MORE_INFO: 'NEED_MORE_INFO',
    PENDING: 'PENDING',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillStatusCd = {
    BILLED: 'Billed',
    CANCELLED: 'Cancelled',
    IN_FBES_SUSPENSE_QUEUE: 'InFbesSuspenseQueue',
    PAID: 'Paid',
    RATED: 'Rated',
    UNBILLED: 'Unbilled',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillToRelationCd = {
    NOT_APPLICABLE: 'NotApplicable',
    RELATED_TO_BOTH: 'RelatedToBoth',
    RELATED_TO_CONS: 'RelatedToCons',
    RELATED_TO_SHPR: 'RelatedToShpr',
    UNRELATED: 'Unrelated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillTypeCd = {
    COLLECT: 'Collect',
    PREPAID: 'Prepaid',
    THIRD_PARTY: 'ThirdParty',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BillingRemarkTypeCd = {
    BILL_TO: 'BillTo',
    CONS: 'Cons',
    HZMT: 'Hzmt',
    OPERATIONS: 'Operations',
    SHPR: 'Shpr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BolPartyTypeCd = {
    BILL_TO: 'BillTo',
    BLIND_SHPR: 'BlindShpr',
    CONS: 'Cons',
    SHPR: 'Shpr',
    TRUE_BLIND_SHPR: 'TrueBlindShpr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BolUsageTypeCd = {
    BILLING: 'Billing',
    SR_UPDATE: 'SRUpdate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BondReasonCd = {
    BROKER_NEEDS_CLIENT_AUTHENTICATION: 'broker_needs_client_authentication',
    BROKER_REJECTED: 'broker_rejected',
    MISCELLANEOUS: 'miscellaneous',
    MISSING_CUSTOMS_PPWK: 'missing_customs_ppwk',
    MOVR_PRO: 'movr_pro',
    NO_BROKER_INDICATED: 'no_broker_indicated',
    NO_ORIGIN_COUNTRY: 'no_origin_country',
    OVERAGE: 'overage',
    RCVD_PPWK_NOT_SET_UP: 'rcvd_ppwk_not_set_up',
    VALUE_NOT_INDICATED: 'value_not_indicated',
    VIASAFE_OPERATOR_ERR: 'viasafe_operator_err',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BondStatusCd = {
    CANCELLED: 'Cancelled',
    CLEARED: 'Cleared',
    UNCLEARED: 'Uncleared',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BondTypeCd = {
    PLANNED: 'Planned',
    UNPLANNED: 'Unplanned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const BusinessMetricCd = {
    LOAD_FACTOR: 'LoadFactor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CarrierDetailCd = {
    CARRIERS: 'Carriers',
    LOCATIONS: 'Locations',
    LOCATION_SIC: 'LocationSic',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CarrierLocationTypeCd = {
    CORPORATE: 'Corporate',
    TERMINAL: 'Terminal',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CarrierTenderGroupStatusCd = {
    ACCEPTED: 'Accepted',
    ACCEPTED_WITH_EXCEPTIONS: 'AcceptedWithExceptions',
    PARTIALLY_ACCEPTED: 'PartiallyAccepted',
    PARTIALLY_ACCEPTED_WITH_EXCEPTIONS: 'PartiallyAcceptedWithExceptions',
    PARTIALLY_ROUTED: 'PartiallyRouted',
    PARTIALLY_ROUTED_WITH_EXCEPTIONS: 'PartiallyRoutedWithExceptions',
    ROUTED: 'Routed',
    ROUTED_WITH_EXCEPTIONS: 'RoutedWithExceptions',
    TENDERED: 'Tendered',
    TENDERED_WITH_EXCEPTIONS: 'TenderedWithExceptions',
    WITHDRAWN: 'Withdrawn',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CarrierTenderStatusCd = {
    ACCEPTED: 'Accepted',
    ACCEPTED_WITH_EXCEPTION: 'AcceptedWithException',
    ACKNOWLEDGED: 'Acknowledged',
    REJECTED: 'Rejected',
    ROUTED: 'Routed',
    TENDERED: 'Tendered',
    TENDER_FAILED: 'TenderFailed',
    WITHDRAWN: 'Withdrawn',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CbolRespMessageStatusCd = {
    FAIL: 'FAIL',
    PASS: 'PASS',
    WARNING: 'WARNING',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ChangeRsnCd = {
    ACCIDENT: 'Accident',
    BREAKDOWN: 'Breakdown',
    CUSTOMS: 'Customs',
    DEPT_OF_TRANSP: 'DeptOfTransp',
    DRIVER: 'Driver',
    ENTRY_ERROR: 'EntryError',
    ETA_ADJUSTMENT: 'ETAAdjustment',
    HRS_OF_SERVICE: 'HrsOfService',
    ROAD_CLOSURE: 'RoadClosure',
    SCHD_TERMINATED: 'SchdTerminated',
    TRAFFIC: 'Traffic',
    WEATHER: 'Weather',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ChargeToCd = {
    BOTH: 'Both',
    COLL: 'Coll',
    PPD: 'Ppd',
    VALID_ONLY_FOR_NON_REV_BILLS: 'ValidOnlyForNonRevBills',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CheckpointEventStatusCd = {
    CANCELLED: 'Cancelled',
    OPEN: 'Open',
    PROCESSED: 'Processed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CheckpointMasterActionCd = {
    APPOINTMENT_SET: 'AppointmentSet',
    CITY_ARRIVE: 'CityArrive',
    CLOSE_FOR_DELIVERY: 'CloseForDelivery',
    FINAL_DELIVERY: 'FinalDelivery',
    LINEHAUL_ARRIVE: 'LinehaulArrive',
    LINEHAUL_CLOSE: 'LinehaulClose',
    LINEHAUL_DISPATCH: 'LinehaulDispatch',
    LINEHAUL_LOADING_AT_DOCK: 'LinehaulLoadingAtDock',
    LOAD: 'Load',
    UNLOAD: 'Unload',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CisRequestApprovalStatusCd = {
    APPROVED: 'Approved',
    BLANK: 'Blank',
    PENDING: 'Pending',
    REJECTED: 'Rejected',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CisRequestPriorityCd = {
    NO_SPECIAL_PRIORITY: 'NoSpecialPriority',
    REQUIRED_FOR_BILLING: 'RequiredForBilling',
    RFP_PENDING: 'RFPPending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CisRequestStatusCd = {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    DUMMY: 'Dummy',
    EXPIRED: 'Expired',
    HOLD: 'Hold',
    NEW: 'New',
    OPEN: 'Open',
    REJECTED: 'Rejected',
    SUBMITTED: 'Submitted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimAdditionalPaymentReasonCd = {
    CUSTOMER_ADDED_ADDITIONAL_ITEMS_OR_FREIGHT: 'CustomerAddedAdditionalItemsOrFreight',
    CUSTOMER_PROVIDED_MISSING_INFORMATION: 'CustomerProvidedMissingInformation',
    INCORRECT_LIABILITY_LIMIT_USED: 'IncorrectLiabilityLimitUsed',
    LEGAL_DECISION: 'LegalDecision',
    OTHER: 'Other',
    SHOULD_HAVE_PAID_FREIGHT_CHARGES: 'ShouldHavePaidFreightCharges',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimChargeabilityReasonCd = {
    BOL_NOT_SIGNED_CORRECTLY: 'BOLNotSignedCorrectly',
    CONSIGNEE_UNLOAD_WITHOUT_DOCS: 'ConsigneeUnloadWithoutDocs',
    DEFINITE_EVIDENCE_OF_DAMAGE_OR_LOSS: 'DefiniteEvidenceOfDamageOrLoss',
    FREIGHT_DISPOSED_WITHOUT_PROCESS: 'FreightDisposedWithoutProcess',
    INSPECTION_NOT_PERFORMED: 'InspectionNotPerformed',
    INTERNAL_HISTORY_SHARED: 'InternalHistoryShared',
    NO_DMG_DXFO_PHOTOS: 'NoDmgDXFOPhotos',
    NO_DR_IN_IMAGE: 'NoDRInImage',
    SHORTAGE_RESEARCH_INCOMPLETE: 'ShortageResearchIncomplete',
    SLC_NOT_FOLLOWED: 'SLCNotFollowed',
    VAGUE_EXCEPTION_ON_DR: 'VagueExceptionOnDR',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimCurrencyCd = {
    CANADIAN_DOLLARS: 'CanadianDollars',
    US_DOLLARS: 'USDollars',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimDecisionCategoryCd = {
    AGREEMENT: 'Agreement',
    AUTO_APPROVED: 'AutoApproved',
    CANCELLED_BY_CUSTOMER: 'CancelledByCustomer',
    CLEAR_DELIVERY: 'ClearDelivery',
    CONCEALED_DAMAGE: 'ConcealedDamage',
    CONSIGNEE_DROP_TRAILER_PROCEDURE_VIOLATION: 'ConsigneeDropTrailerProcedureViolation',
    CROSS_OR_OVER_DELIVERY: 'CrossOrOverDelivery',
    DAMAGED_AT_PICKUP: 'DamagedAtPickup',
    DAMAGE_DUE_TO: 'DamageDueTo',
    DUPLICATE_CLAIM: 'DuplicateClaim',
    FAILED_TO_HOLD_CONTAINER_PACKAGING_OR_CONTENTS: 'FailedToHoldContainerPackagingOrContents',
    FILED_LATE: 'FiledLate',
    INADEQUATE_DOCUMENTS: 'InadequateDocuments',
    LIABILITY_NOT_MITIGATED_BY_CLAIMANT: 'LiabilityNotMitigatedByClaimant',
    LOADING: 'Loading',
    NOT_HANDLED_BY_XPO: 'NotHandledByXpo',
    PACKAGING: 'Packaging',
    POLICY_PAY_DAMAGE: 'PolicyPayDamage',
    POLICY_PAY_LOSS: 'PolicyPayLoss',
    RETURNED_TO_SHIPPER: 'ReturnedToShipper',
    SHIPMENT_FULL_DELIVERY: 'ShipmentFullDelivery',
    SHIPPER_AGREEMENT: 'ShipperAgreement',
    SHIPPER_LOAD_AND_COUNT: 'ShipperLoadAndCount',
    SHIPPER_LOAD_AND_COUNT_PROCEDURE_VIOLATION: 'ShipperLoadAndCountProcedureViolation',
    SHORTAGE_FROM_OPEN_OR_DAMAGED_CARTON: 'ShortageFromOpenOrDamagedCarton',
    SHORTAGE_PARTIALLY_CLEARED: 'ShortagePartiallyCleared',
    SHORT_AT_ARRIVAL: 'ShortAtArrival',
    SHORT_AT_DELIVERY: 'ShortAtDelivery',
    SHORT_AT_DESTINATION: 'ShortAtDestination',
    SHORT_AT_ORIGIN: 'ShortAtOrigin',
    SHORT_AT_PICKUP: 'ShortAtPickup',
    SHORT_DUE_TO_BILLING_ERROR: 'ShortDueToBillingError',
    SHORT_DUE_TO_MISLOAD: 'ShortDueToMisload',
    SHRINK_WRAP_BROKEN: 'ShrinkWrapBroken',
    SHRINK_WRAP_INTACT: 'ShrinkWrapIntact',
    SPECIAL_DAMAGES_XPO_NOT_LIABLE: 'SpecialDamagesXpoNotLiable',
    SUPERVISED_LOAD_OR_UNLOAD: 'SupervisedLoadOrUnload',
    THEFT: 'Theft',
    UNDETERMINED: 'Undetermined',
    VAGUE_DELIVERY_EXCEPTION: 'VagueDeliveryException',
    VEHICULAR_ACCIDENT: 'VehicularAccident',
    WRECK_AND_FIRE: 'WreckAndFire',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimDecisionSubCategoryCd = {
    AT_DESTINATION_FROM_FAC: 'AtDestinationFromFac',
    AT_DESTINATION_SIC: 'AtDestinationSic',
    AT_FAC: 'AtFac',
    AT_FAC_FROM_ORIGIN_SIC: 'AtFacFromOriginSic',
    AT_FAC_FROM_PRIOR_FAC: 'AtFacFromPriorFac',
    AT_ORIGIN_SC: 'AtOriginSc',
    AUTO_APPROVED: 'AutoApproved',
    CANCELLED_BY_CUSTOMER: 'CancelledByCustomer',
    CARRIER_LIABILITY_NOT_ESTABLISHED: 'CarrierLiabilityNotEstablished',
    CLAIMANT_REFUSED_TO_AMEND_CLAIM: 'ClaimantRefusedToAmendClaim',
    COMPROMISE_SETTLEMENT: 'CompromiseSettlement',
    CONTAMINATION: 'Contamination',
    DIRECTIONAL_MARKINGS_NOT_FOLLOWED: 'DirectionalMarkingsNotFollowed',
    DOMESTIC_FORWARDER_CLAIM_NOT_FILED_WITHIN_90_DAYS: 'DomesticForwarderClaimNotFiledWithin90Days',
    DSR_UNDER_SHIPPEROR_CONSIGNEE_SUPERVISION: 'DsrUnderShipperorConsigneeSupervision',
    DUPLICATE_CLAIM: 'DuplicateClaim',
    EXCEPTION_NOTED_AT_FIRST_CHECKPOINT: 'ExceptionNotedAtFirstCheckpoint',
    EXCEPTION_NOTED_ON_BILL_OF_LADING: 'ExceptionNotedOnBillOfLading',
    FAC: 'Fac',
    FORKLIFT: 'Forklift',
    FREEZING: 'Freezing',
    FREIGHT_RECOVERED: 'FreightRecovered',
    FREIGHT_RETURNED_ON_NON_REVENUE_ORDER: 'FreightReturnedOnNonRevenueOrder',
    FREIGHT_UNPROTECTED: 'FreightUnprotected',
    HEAT: 'Heat',
    IMPROPER_BLOCKING: 'ImproperBlocking',
    IMPROPER_STACKING: 'ImproperStacking',
    INTL_FORWARDER_CLAIM_NOT_FILED_WITHIN_120_DAYS: 'IntlForwarderClaimNotFiledWithin120Days',
    INTL_FORWARDER_INTENT_NOT_WITHIN_7_DAYS_FROM_DLVY: 'IntlForwarderIntentNotWithin7DaysFromDlvy',
    LIABILITY_NOT_MITIGATED_BY_CLAIMANT: 'LiabilityNotMitigatedByClaimant',
    LOADED_HEAVY_FREIGHT_ON_LIGHT_FREIGHT: 'LoadedHeavyFreightOnLightFreight',
    LOST_PROFIT_INCOME_ATTY_FEE_CONSEQUENTIAL_DMG: 'LostProfitIncomeAttyFeeConsequentialDmg',
    MERCHANDISE_NOT_IN_SAME_CONDITION_AS_DELIVERED: 'MerchandiseNotInSameConditionAsDelivered',
    MISDELIVERY: 'Misdelivery',
    MISHANDLING: 'Mishandling',
    NOCLAIMS_UNDER_SPECIFIC_DOLLAR_THRESHOLD: 'NoclaimsUnderSpecificDollarThreshold',
    NOT_HELD_FOR_INSPECTION_OR_SALVAGE: 'NotHeldForInspectionOrSalvage',
    NO_3_PL_SUPPORT: 'No3PLSupport',
    NO_FORKLIFT_EXTENSION: 'NoForkliftExtension',
    NO_FORWARDER_SUPPORT: 'NoForwarderSupport',
    NO_PROOF_OF_LOSS: 'NoProofOfLoss',
    NO_RECORD_OF_RECEIPT_AND_OR_HANDLING: 'NoRecordOfReceiptAndOrHandling',
    NO_REPAIR_INVOICE: 'NoRepairInvoice',
    NO_STRAPS: 'NoStraps',
    NO_WEIGHT_PROVIDED: 'NoWeightProvided',
    OCEAN_AND_NOT_WITHIN_ONE_YR_OF_DLVY_DATE: 'OceanAndNotWithinOneYrOfDlvyDate',
    ONLY_THE_SHIPPER_WILL_CLAIM_VS_CUSTOMER: 'OnlyTheShipperWillClaimVsCustomer',
    ON_DELIVERY_AT_DESTINATION_SIC: 'OnDeliveryAtDestinationSic',
    OPEN_CARTON_AT_DELIVERY_OR_NO_INSPECTION_BY_DSR: 'OpenCartonAtDeliveryOrNoInspectionByDsr',
    ORIGINAL_INVOICE_NOT_PROVIDED: 'OriginalInvoiceNotProvided',
    ORIGINATED_IN_CANADA_NOT_WITHIN_60_DAYS_OF_DLVY: 'OriginatedInCanadaNotWithin60DaysOfDlvy',
    ORIGINATED_IN_US_NOT_WITHIN_9_MONTHS_OF_DLVY: 'OriginatedInUsNotWithin9MonthsOfDlvy',
    ORIGIN_PICKUP_FREIGHT_IMPROPERLY_PACKAGED: 'OriginPickupFreightImproperlyPackaged',
    ORIGIN_SC: 'OriginSc',
    OVER_DELIVERY: 'OverDelivery',
    PAPER_BAG_DAMAGE: 'PaperBagDamage',
    PART_SHORTAGE_LOCATED_OR_DELIVERED: 'PartShortageLocatedOrDelivered',
    PER_SHIPPER_DIRECTIONSCLAIMS_TO_BE_DECLINED: 'PerShipperDirectionsclaimsToBeDeclined',
    POLICY_PAY_DAMAGE: 'PolicyPayDamage',
    POLICY_PAY_LOSS: 'PolicyPayLoss',
    REFER_TO_SHIPPER_FOR_CREDIT_AND_OR_REPLACEMENT: 'ReferToShipperForCreditAndOrReplacement',
    REQUESTED_DOCUMENTATION_NOT_PROVIDED: 'RequestedDocumentationNotProvided',
    RETURNED_TO_SHIPPER: 'ReturnedToShipper',
    SAFE_STACK_IMPROPERLY_INSTALLED: 'SafeStackImproperlyInstalled',
    SHIPPER_LOAD_AND_COUNT_DESTINATION_VIOLATION: 'ShipperLoadAndCountDestinationViolation',
    SHORT_DUE_TO_BILLING_ERROR: 'ShortDueToBillingError',
    SHORT_OFF_DOCK: 'ShortOffDock',
    SHORT_OFF_DROP_OR_TRAP_TRAILER: 'ShortOffDropOrTrapTrailer',
    SHORT_OFF_PICKUP_AND_DELIVERY_UNIT: 'ShortOffPickupAndDeliveryUnit',
    SHORT_OPEN_OR_DAMAGED: 'ShortOpenOrDamaged',
    SHRINK_WRAP_INTACT: 'ShrinkWrapIntact',
    UNDETERMINED: 'Undetermined',
    VAGUE_DELIVERY_EXCEPTION: 'VagueDeliveryException',
    WATER: 'Water',
    WRECK_AND_FIRE: 'WreckAndFire',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimEmailTemplateFieldCd = {
    APPROVE_LINK: 'APPROVE_LINK',
    CHK_NBR: 'CHK_NBR',
    CLAIMANT_NAME: 'CLAIMANT_NAME',
    CLAIMANT_REF_NBR: 'CLAIMANT_REF_NBR',
    CLM_AMOUNT: 'CLM_AMOUNT',
    CLM_ID: 'CLM_ID',
    CONSIGNEE: 'CONSIGNEE',
    DECLINE_LINK: 'DECLINE_LINK',
    EMAIL_NOTE: 'EMAIL_NOTE',
    EXAMINER_CITY: 'EXAMINER_CITY',
    EXAMINER_COUNTRY: 'EXAMINER_COUNTRY',
    EXAMINER_NAME: 'EXAMINER_NAME',
    EXAMINER_PHONE: 'EXAMINER_PHONE',
    EXAMINER_ROLE: 'EXAMINER_ROLE',
    EXAMINER_STATE: 'EXAMINER_STATE',
    EXAMINER_STREET: 'EXAMINER_STREET',
    EXAMINER_ZIP: 'EXAMINER_ZIP',
    FILING_DT: 'FILING_DT',
    MAX_LBLTY_AMT: 'MAX_LBLTY_AMT',
    PMT_AMT: 'PMT_AMT',
    PRO_NBR_AND_PKUP_DT: 'PRO_NBR_AND_PKUP_DT',
    PRO_NBR_TXT: 'PRO_NBR_TXT',
    SHIPPER: 'SHIPPER',
    SHPM_DLVRY_DT: 'SHPM_DLVRY_DT',
    SHP_INST_ID: 'SHP_INST_ID',
    TOTAL_PAYOUT_AMT: 'TOTAL_PAYOUT_AMT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimEmailTemplateTypeCd = {
    APPROVAL: 'Approval',
    BLANK_TEMPLATE: 'BlankTemplate',
    CLAIM_ACKNOWLEDGEMENT: 'ClaimAcknowledgement',
    CLEAR_DR_DECLINATION: 'ClearDrDeclination',
    ESCALATION_APPROVAL: 'EscalationApproval',
    INVOICE_REQUEST: 'InvoiceRequest',
    NINE_MONTH_LIMIT_DECLINATION: 'NineMonthLimitDeclination',
    POLICY_PAY: 'PolicyPay',
    REBUTTAL_ACKNOWLEDGEMENT: 'RebuttalAcknowledgement',
    REPAIR_INVOICE_REQUEST: 'RepairInvoiceRequest',
    SHORTAGE_REQUEST_FOR_INFO: 'ShortageRequestForInfo',
    SHRINK_WRAPPED_PALLET_DECLINATION: 'ShrinkWrappedPalletDeclination',
    SLC_DECLINATION: 'SlcDeclination',
    SUBRO_CLAIM_SUBMISSION: 'SubroClaimSubmission',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimEventTypeCd = {
    CLAIMANT_ADDED: 'ClaimantAdded',
    CLAIMANT_CHANGED: 'ClaimantChanged',
    CLAIM_APPROVAL_PENDING_CEO: 'ClaimApprovalPendingCeo',
    CLAIM_APPROVAL_PENDING_CLAIMS_MANAGER: 'ClaimApprovalPendingClaimsManager',
    CLAIM_APPROVAL_PENDING_DIRECTOR_OF_CLAIMS: 'ClaimApprovalPendingDirectorOfClaims',
    CLAIM_APPROVAL_PENDING_EXAMINER: 'ClaimApprovalPendingExaminer',
    CLAIM_APPROVAL_PENDING_PRESIDENT: 'ClaimApprovalPendingPresident',
    CLAIM_APPROVAL_PENDING_RVP: 'ClaimApprovalPendingRvp',
    CLAIM_APPROVAL_PENDING_RVP_SALES: 'ClaimApprovalPendingRvpSales',
    CLAIM_APPROVAL_PENDING_SVP_OPS: 'ClaimApprovalPendingSvpOps',
    CLAIM_APPROVAL_PENDING_SVP_SALES: 'ClaimApprovalPendingSvpSales',
    CLAIM_APPROVED: 'ClaimApproved',
    CLAIM_CANCELLED_BY_CUSTOMER: 'ClaimCancelledByCustomer',
    CLAIM_DECLINED: 'ClaimDeclined',
    CLAIM_DELETED_BY_CUSTOMER: 'ClaimDeletedByCustomer',
    CLAIM_FIELDS_UPDATED_ONLY: 'ClaimFieldsUpdatedOnly',
    CLAIM_REASSIGNED: 'ClaimReassigned',
    CLAIM_SAVED_AS_DRAFT: 'ClaimSavedAsDraft',
    CLAIM_SUBMITTED: 'ClaimSubmitted',
    CLAIM_UNDER_REVIEW: 'ClaimUnderReview',
    CLAIM_VIEWED: 'ClaimViewed',
    CONTACT_CHANGED: 'ContactChanged',
    DMS_DOCUMENT_ADDED: 'DMSDocumentAdded',
    INCOMING_EMAIL: 'IncomingEmail',
    NOTE_ADDED: 'NoteAdded',
    PAYEE_ADDED: 'PayeeAdded',
    PAYEE_CHANGED: 'PayeeChanged',
    PAYMENT_CHECK_CANCELLED: 'PaymentCheckCancelled',
    PAYMENT_CHECK_CASHED: 'PaymentCheckCashed',
    PAYMENT_CHECK_ISSUED: 'PaymentCheckIssued',
    PAYMENT_DECLINED: 'PaymentDeclined',
    PAYMENT_ON_HOLD: 'PaymentOnHold',
    PAYMENT_PENDING_TRANSMISSIONTO_AP: 'PaymentPendingTransmissiontoAP',
    PAYMENT_SENT_TO_AP: 'PaymentSentToAP',
    PAYMENT_VOIDED: 'PaymentVoided',
    REBUTTAL_APPROVAL_PENDING_CEO: 'RebuttalApprovalPendingCeo',
    REBUTTAL_APPROVAL_PENDING_CLAIMS_MANAGER: 'RebuttalApprovalPendingClaimsManager',
    REBUTTAL_APPROVAL_PENDING_DIRECTOR_OF_CLAIMS: 'RebuttalApprovalPendingDirectorOfClaims',
    REBUTTAL_APPROVAL_PENDING_EXAMINER: 'RebuttalApprovalPendingExaminer',
    REBUTTAL_APPROVAL_PENDING_PRESIDENT: 'RebuttalApprovalPendingPresident',
    REBUTTAL_APPROVAL_PENDING_RVP: 'RebuttalApprovalPendingRVP',
    REBUTTAL_APPROVAL_PENDING_RVP_SALES: 'RebuttalApprovalPendingRvpSales',
    REBUTTAL_APPROVAL_PENDING_SVP_OPS: 'RebuttalApprovalPendingSvpOps',
    REBUTTAL_APPROVAL_PENDING_SVP_SALES: 'RebuttalApprovalPendingSvpSales',
    REBUTTAL_APPROVED: 'RebuttalApproved',
    REBUTTAL_CANCELLED_BY_CUSTOMER: 'RebuttalCancelledByCustomer',
    REBUTTAL_DECLINED: 'RebuttalDeclined',
    REBUTTAL_RECEIVED: 'RebuttalReceived',
    REBUTTAL_UNDER_REVIEW: 'RebuttalUnderReview',
    SUBROGATION_PAYMENT_APPROVED: 'SubrogationPaymentApproved',
    SUBROGATION_PAYMENT_DECLINED: 'SubrogationPaymentDeclined',
    SUBROGATION_PAYMENT_RECEIVED: 'SubrogationPaymentReceived',
    SUBROGATION_SUBMITTED_TO_CARRIER: 'SubrogationSubmittedToCarrier',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimExternalStatusCd = {
    APPROVED: 'Approved',
    CUSTOMER_CANCELLED: 'CustomerCancelled',
    DECLINED: 'Declined',
    SUBMITTED: 'Submitted',
    UNDER_REVIEW: 'UnderReview',
    UNSUBMITTED: 'Unsubmitted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimExternalVisibilityCd = {
    REGISTERED_EXTERNAL_USER: 'RegisteredExternalUser',
    UNREGISTERED_EXTERNAL_USER: 'UnregisteredExternalUser',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimFieldName = {
    APPROVED_AMOUNT: 'approvedAmount',
    CLAIMANT_NAME: 'claimantName',
    CLAIMANT_REFERENCE_NBR: 'claimantReferenceNbr',
    CLAIMED_AMOUNT: 'claimedAmount',
    CLAIM_ID: 'claimId',
    CLOSED_DATE_TIME: 'closedDateTime',
    CURRENT_ASSIGNEE_EMPLOYEE_ID: 'currentAssigneeEmployeeId',
    EXAMINED_BY_EMPLOYEE_ID: 'examinedByEmployeeId',
    FILING_DATE: 'filingDate',
    INTERNAL_STATUS_CD: 'internalStatusCd',
    MAX_LIABILITY_AMOUNT: 'maxLiabilityAmount',
    PAID_AMOUNT: 'paidAmount',
    PICKUP_DATE: 'pickupDate',
    PRO_NBR: 'proNbr',
    REBUTTAL_IND: 'rebuttalInd',
    RECEIVED_DATE_TIME: 'receivedDateTime',
    REVIEW_REQUIRED_DESCRIPTION: 'reviewRequiredDescription',
    UPDATES_FLAG: 'updatesFlag',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimFilingMethodCd = {
    API: 'API',
    EMAIL: 'Email',
    FAX: 'Fax',
    MAIL: 'Mail',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimInternalStatusCd = {
    APPROVED: 'Approved',
    CEO_PENDING_APPROVAL: 'CeoPendingApproval',
    CUSTOMER_CANCELLED: 'CustomerCancelled',
    DECLINED: 'Declined',
    DIRECTOR_PENDING_APPROVAL: 'DirectorPendingApproval',
    MANAGER_PENDING_APPROVAL: 'ManagerPendingApproval',
    PRESIDENT_PENDING_APPROVAL: 'PresidentPendingApproval',
    RVP_PENDING_APPROVAL: 'RVPPendingApproval',
    RVP_SALES_PENDING_APPROVAL: 'RVPSalesPendingApproval',
    SUBMITTED: 'Submitted',
    SVP_OF_OPS_PENDING_APPROVAL: 'SVPOfOpsPendingApproval',
    SVP_SALES_PENDING_APPROVAL: 'SVPSalesPendingApproval',
    UNDER_REVIEW: 'UnderReview',
    UNSUBMITTED: 'Unsubmitted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimNoteTypeCd = {
    EMAIL: 'Email',
    EXAMINER_USE: 'ExaminerUse',
    SERVICE_CENTER_CHARGEABILITY: 'ServiceCenterChargeability',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimNoteVisibilityCd = {
    CLAIMS_DEPT: 'ClaimsDept',
    EXTERNAL: 'External',
    XPO: 'XPO',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimPartyTypeCd = {
    CLAIMANT: 'Claimant',
    PAYEE: 'Payee',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimPaymentMethodCd = {
    CHECK: 'Check',
    ELECTRONIC_FUNDS_TRANSFER: 'ElectronicFundsTransfer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimRelatedShipmentTypeCd = {
    MANUALLY_RELATED: 'ManuallyRelated',
    OPERATIONALLY_RELATED: 'OperationallyRelated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimTypeCd = {
    DAMAGE: 'Damage',
    SHORTAGE: 'Shortage',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ClaimantSameAsCd = {
    BILL_TO: 'Bill-To',
    CONSIGNEE: 'Consignee',
    SHIPPER: 'Shipper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CloseReasonCd = {
    DISPOSED_OF_AT_SIC: 'disposed_of_at_sic',
    DISP_FROM_SHIPPER: 'disp_from_shipper',
    DUPLICATE_ENTRY: 'duplicate_entry',
    MATCHED_TO_PRO: 'matched_to_pro',
    SALVAGE_RQST: 'salvage_rqst',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CmsTripTypeCd = {
    CARRIER_TERMINAL: 'CarrierTerminal',
    CITY: 'City',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CollectMoneyAtDeliveryCd = {
    BOTH: 'Both',
    COD: 'Cod',
    FREIGHT: 'Freight',
    NONE: 'None',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CommodityClaimTypeCd = {
    CREDIT: 'Credit',
    DAMAGE: 'Damage',
    FREIGHT: 'Freight',
    MISCELLANEOUS: 'Miscellaneous',
    SHORTAGE: 'Shortage',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CommodityClassCd = {
    CLSS_100: 'Clss100',
    CLSS_110: 'Clss110',
    CLSS_125: 'Clss125',
    CLSS_150: 'Clss150',
    CLSS_175: 'Clss175',
    CLSS_200: 'Clss200',
    CLSS_250: 'Clss250',
    CLSS_300: 'Clss300',
    CLSS_350: 'Clss350',
    CLSS_400: 'Clss400',
    CLSS_50: 'Clss50',
    CLSS_500: 'Clss500',
    CLSS_55: 'Clss55',
    CLSS_60: 'Clss60',
    CLSS_65: 'Clss65',
    CLSS_70: 'Clss70',
    CLSS_775: 'Clss775',
    CLSS_85: 'Clss85',
    CLSS_925: 'Clss925',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CommodityConditionTypeCd = {
    NEW: 'New',
    USED: 'Used',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CommodityPackageCd = {
    AMMO_PACK: 'AmmoPack',
    ATTM: 'Attm',
    BAG: 'Bag',
    BALE: 'Bale',
    BANDING: 'Banding',
    BARGE: 'Barge',
    BARREL: 'Barrel',
    BASKET: 'Basket',
    BEAM: 'Beam',
    BELTING: 'Belting',
    BIN: 'Bin',
    BING_CHEST: 'BingChest',
    BOBBIN: 'Bobbin',
    BOTTLE: 'Bottle',
    BOX: 'Box',
    BOX_WITH_CONTAINER: 'BoxWithContainer',
    BRACING: 'Bracing',
    BUCKET: 'Bucket',
    BULK: 'Bulk',
    BULK_CARGO: 'BulkCargo',
    BUNDLE: 'Bundle',
    CABINET: 'Cabinet',
    CAGE: 'Cage',
    CAN: 'Can',
    CAN_CASE: 'CanCase',
    CARBOY: 'Carboy',
    CARR: 'Carr',
    CARTON: 'Carton',
    CAR_LOAD_RAIL: 'CarLoadRail',
    CASE: 'Case',
    CASK: 'Cask',
    CHEESES: 'Cheeses',
    CHEST: 'Chest',
    COIL: 'Coil',
    CONES: 'Cones',
    CONTAINER: 'Container',
    CORE: 'Core',
    CORNER_REINFORCEMENT: 'CornerReinforcement',
    CRADLE: 'Cradle',
    CRATE: 'Crate',
    CYLINDER: 'Cylinder',
    DOUBLE_RACK: 'DoubleRack',
    DOUBLE_SKID: 'DoubleSkid',
    DOUBLE_TOTE_BIN: 'DoubleToteBin',
    DRUM: 'Drum',
    DRY_BULK: 'DryBulk',
    EDGE_PROTECTION: 'EdgeProtection',
    EGG_CRATING: 'EggCrating',
    ENVELOPE: 'Envelope',
    FIRKIN: 'Firkin',
    FLASK: 'Flask',
    FLO_BIN: 'FloBin',
    FORWARD_REEL: 'ForwardReel',
    FRAME: 'Frame',
    HALF_RACK: 'HalfRack',
    HALF_TOTE_BIN: 'HalfToteBin',
    HANGER_RACK: 'HangerRack',
    HEADS_BEEF: 'HeadsBeef',
    HOGSHEAD: 'Hogshead',
    HOPPER_TRUCK: 'HopperTruck',
    INT_BULK_CTR: 'IntBulkCtr',
    JAR: 'Jar',
    JERRYCAN: 'Jerrycan',
    JUG: 'Jug',
    KEG: 'Keg',
    KIT: 'Kit',
    KNOCKDOWN_RACK: 'KnockdownRack',
    KNOCKDOWN_TOTE_BIN: 'KnockdownToteBin',
    LID_TOP: 'LidTop',
    LIFTS: 'Lifts',
    LIFT_VAN: 'LiftVan',
    LINERS: 'Liners',
    LOG: 'Log',
    LOOSE: 'Loose',
    LQD_BULK: 'LqdBulk',
    LUG: 'Lug',
    MISCELLANEOUS: 'Miscellaneous',
    MIXED_CONTAINER: 'MixedContainer',
    MULTI_RACK: 'MultiRack',
    NOIL: 'Noil',
    ON_OWN_WHEEL: 'OnOwnWheel',
    PACKED: 'Packed',
    PAIL: 'Pail',
    PALLET: 'Pallet',
    PALLET_2_WAY: 'Pallet2Way',
    PALLET_4_WAY: 'Pallet4Way',
    PARTIONING: 'Partioning',
    PCS: 'Pcs',
    PIMS: 'Pims',
    PIPELINE: 'Pipeline',
    PIPE_RACK: 'PipeRack',
    PKG: 'Pkg',
    PLATFORM: 'Platform',
    PRIMARY_LIFT_CONTAINER: 'PrimaryLiftContainer',
    PRIVATE_VEHCLE: 'PrivateVehcle',
    QUARTER_BEEF: 'QuarterBeef',
    RACK: 'Rack',
    RAIL_SEMICONDUCTOR: 'RailSemiconductor',
    REEL: 'Reel',
    REINFORCEMNT: 'Reinforcemnt',
    REVERSE_REEL: 'ReverseReel',
    ROLL: 'Roll',
    SACK: 'Sack',
    SEPARATOR: 'Separator',
    SHEET: 'Sheet',
    SHOOK: 'Shook',
    SHRINK_WRAP: 'ShrinkWrap',
    SIDE_OF_BEEF: 'SideOfBeef',
    SKID: 'Skid',
    SKID_ELEVATE: 'SkidElevate',
    SLEEVE: 'Sleeve',
    SLIP_SHEET: 'SlipSheet',
    SPIN_CYLINDERS: 'SpinCylinders',
    SPOOL: 'Spool',
    TANK: 'Tank',
    TANK_CAR: 'TankCar',
    TANK_TRUCK: 'TankTruck',
    TIERCE: 'Tierce',
    TOTE_BIN: 'ToteBin',
    TRAILER_CONTAINER_LOAD: 'TrailerContainerLoad',
    TRAY: 'Tray',
    TRUNK_CHEST: 'TrunkChest',
    TRUNK_SAMPLE: 'TrunkSample',
    TUB: 'Tub',
    TUBE: 'Tube',
    UNIT: 'Unit',
    UNPACKED: 'Unpacked',
    VAN_PACK: 'VanPack',
    VEHICLES: 'Vehicles',
    WHEELED_CAR: 'WheeledCar',
    WRAPPED: 'Wrapped',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConeColorCd = {
    GREEN: 'Green',
    ORANGE: 'Orange',
    RED: 'Red',
    YELLOW: 'Yellow',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConfigurationValueTypeCd = {
    BOOLEAN: 'Boolean',
    NUMBER: 'Number',
    STRING: 'String',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConsigneeUnloadedTrailerCd = {
    NOT_UNLD_BY_CONS: 'NotUnldByCons',
    TRAILER_NOT_UNLD: 'TrailerNotUnld',
    UNLD_BY_CONS: 'UnldByCons',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ContactRoleCd = {
    ACCOUNTS_PAYABLE: 'AccountsPayable',
    BALANCE_DUE: 'BalanceDue',
    CLAIMS: 'Claims',
    DELIVERY: 'Delivery',
    EDI: 'EDI',
    FREIGHT_PAYMENT_PLAN: 'FreightPaymentPlan',
    INVOICING: 'Invoicing',
    NOA: 'NOA',
    OPERATIONS: 'Operations',
    OS_AND_D: 'OSAndD',
    PAYMENT_PLAN: 'PaymentPlan',
    PICKUP: 'Pickup',
    PURCHASING: 'Purchasing',
    SALES: 'Sales',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConversationActionItemStatCd = {
    COMPLETED: 'Completed',
    OPEN: 'Open',
    REASSIGNED: 'Reassigned',
    REVIEWED: 'Reviewed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConversationSourceCd = {
    INSPECTIONS_CNV: 'Inspections-CNV',
    LINEHAUL_CNV: 'Linehaul-CNV',
    PICKUP_REQUEST_CNV: 'PickupRequest-CNV',
    PN_D_CNV: 'PnD-CNV',
    RADER_CNV: 'Rader-CNV',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CorrectionQueueNameCd = {
    AC_CORR: 'AC/ CORR',
    CMX: 'CMX',
    CONFIRM: 'CONFIRM',
    CONTENT: 'CONTENT',
    CWYAUDLVL_1: 'CWYAUDLVL1',
    CWYAUDLVL_2: 'CWYAUDLVL2',
    CWYAUDLVL_3: 'CWYAUDLVL3',
    CWYAUDLVL_4: 'CWYAUDLVL4',
    CWYMASS: 'CWYMASS',
    DRVR_WAIT: 'DRVR WAIT',
    FIA: 'FIA',
    FIA_599: 'FIA-599',
    GEN_CORR: 'GEN CORR',
    HOLD: 'HOLD',
    MANBOTHBIL: 'MANBOTHBIL',
    OFFSHORE: 'OFFSHORE',
    PRIORITY: 'PRIORITY',
    SICWRTEOFF: 'SICWRTEOFF',
    WRNTY: 'WRNTY',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CorrectionReasonCd = {
    CORR_1001: 'Corr1001',
    CORR_1002: 'Corr1002',
    CORR_1004: 'Corr1004',
    CORR_1008: 'Corr1008',
    CORR_1102: 'Corr1102',
    CORR_1103: 'Corr1103',
    CORR_1107: 'Corr1107',
    CORR_1112: 'Corr1112',
    CORR_1117: 'Corr1117',
    CORR_120: 'Corr120',
    CORR_2002: 'Corr2002',
    CORR_2003: 'Corr2003',
    CORR_3001: 'Corr3001',
    CORR_3002: 'Corr3002',
    CORR_3003: 'Corr3003',
    CORR_3005: 'Corr3005',
    CORR_4003: 'Corr4003',
    CORR_4004: 'Corr4004',
    CORR_4005: 'Corr4005',
    CORR_4008: 'Corr4008',
    CORR_4012: 'Corr4012',
    CORR_4013: 'Corr4013',
    CORR_4014: 'Corr4014',
    CORR_4015: 'Corr4015',
    CORR_5002: 'Corr5002',
    CORR_5003: 'Corr5003',
    CORR_7001: 'Corr7001',
    CORR_7002: 'Corr7002',
    CORR_7004: 'Corr7004',
    CORR_76: 'Corr76',
    CORR_8002: 'Corr8002',
    CORR_8003: 'Corr8003',
    CORR_8004: 'Corr8004',
    CORR_9001: 'Corr9001',
    CORR_9002: 'Corr9002',
    CORR_91: 'Corr91',
    CORR_9101: 'Corr9101',
    CORR_9102: 'Corr9102',
    CORR_94: 'Corr94',
    CORR_95: 'Corr95',
    CORR_96: 'Corr96',
    CORR_97: 'Corr97',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CorrectionStatusCd = {
    APR: 'APR',
    APY: 'APY',
    DCL: 'DCL',
    LCK: 'LCK',
    MAP: 'MAP',
    OAP: 'OAP',
    PND: 'PND',
    SAV: 'SAV',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CorrectionTypeCd = {
    ADD_ACC: 'ADD ACC',
    CORR_ACC: 'CORR ACC',
    DEL_ACC: 'DEL ACC',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CostCardTypeCd = {
    ESTIMATE: 'ESTIMATE',
    EST_OVERRIDE: 'EST_OVERRIDE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CountryCd = {
    CANADA: 'Canada',
    MEXICO: 'Mexico',
    UNITED_STATES: 'UnitedStates',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CouponCd = {
    CAP_AT_VSP: 'CapAtVsp',
    DEFAULT_DISCOUNT: 'DefaultDiscount',
    LINEAL_FOOT: 'LinealFoot',
    PALLET_WEIGHT_EXCLUDE: 'PalletWeightExclude',
    PALLET_WEIGHT_INCLUDE: 'PalletWeightInclude',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CrcAuditCd = {
    COMPLETED: 'completed',
    FAILED: 'failed',
    IN_PROGRESS: 'in_progress',
    NOT_AVAILABLE: 'not_available',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CredStatCd = {
    BANK_RUPTURE: 'BankRupture',
    CASH: 'Cash',
    CREDIT: 'Credit',
    NO_CREDIT: 'NoCredit',
    VOLUNTARY: 'Voluntary',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CssClassCd = {
    ASSIGN_ACTIONS: 'AssignActions',
    BACKGROUND_INFO: 'BackgroundInfo',
    BACKGROUND_INFO_MCA: 'BackgroundInfoMCA',
    COMMENTS: 'Comments',
    DISCIPLINE_RECOGNITION: 'DisciplineRecognition',
    ISSUES_QUESTIONS: 'IssuesQuestions',
    QUESTIONS: 'Questions',
    TOPICS_DISCUSSED: 'TopicsDiscussed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CubicFeetProfileMthdCd = {
    ACTUAL_DIMENSIONS_CAPTURED_BY_DRIVER: 'Actual Dimensions captured by driver',
    AVERAGE_SHIPMENT_VOLUME_FOR_ZIP: 'Average Shipment Volume for Zip',
    DEFAULT_SHIPPER_PROFILE: 'Default shipper profile',
    DESTINATION_BASED_SHIPPER_PROFILE: 'Destination based shipper profile',
    SERVICE_CENTER_PROFILE: 'Service center profile',
    SYSTEM_PROFILE: 'System profile',
    UNDEFINED: 'Undefined',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CubicFeetProfileTypeCd = {
    DENSITY_SHIPMENT: 'Density shipment',
    FOOTPRINT_PIECE_PROFILE: 'Footprint piece profile',
    HEIGHT_PIECE: 'Height piece',
    UNDEFINED: 'Undefined',
    VOLUME_PIECE: 'Volume-piece',
    VOLUME_SHIPMENT: 'Volume-shipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CurrencyCd = {
    CANADIAN_DOLLARS: 'CanadianDollars',
    MEXICAN_PESO: 'MexicanPeso',
    US_DOLLARS: 'USDollars',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustOperationHoursTypeCd = {
    AUTO_GEN: 'AutoGen',
    DELIVERY_RECEIVING: 'DeliveryReceiving',
    OPERATIONS_GENERAL: 'OperationsGeneral',
    PICKUP_SHIPPING: 'PickupShipping',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustOperationNoteTypeCd = {
    DELIVERY_INSTRUCTIONS: 'DeliveryInstructions',
    NOTIFY_ON_ARRIVAL_NOTE: 'NotifyOnArrivalNote',
    OPERATIONS: 'Operations',
    PICKUP_INSTRUCTIONS: 'PickupInstructions',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustOperationsPickupTypeCd = {
    HOOK_EMPTY: 'HookEmpty',
    HOOK_LOADED: 'HookLoaded',
    NORMAL: 'Normal',
    SPOT_EMPTY: 'SpotEmpty',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerAccountTypeCd = {
    INHERIT_FROM_PARENT: 'InheritFromParent',
    LOCAL_ACCOUNT: 'LocalAccount',
    NATIONAL_ACCOUNT: 'NationalAccount',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerAddressValidationCd = {
    INVALID: 'Invalid',
    UNAVAILABLE: 'Unavailable',
    VALID: 'Valid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerContactRoleCd = {
    ACCOUNTS_PAYABLE: 'AccountsPayable',
    BALANCE_DUE: 'BalanceDue',
    CLAIMS: 'Claims',
    DELIVERY: 'Delivery',
    EDI: 'EDI',
    INVOICING: 'Invoicing',
    NOA: 'NOA',
    OPERATIONS: 'Operations',
    OSD: 'OSD',
    PAYMENT_PLAN: 'PaymentPlan',
    PICKUP: 'Pickup',
    PURCHASING: 'Purchasing',
    SALES: 'Sales',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerCreditStatusCd = {
    BANKRUPT: 'Bankrupt',
    CASH: 'Cash',
    CREDIT: 'Credit',
    NO_CREDIT: 'NoCredit',
    PAY_PLAN: 'PayPlan',
    VOLUNTARY: 'Voluntary',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerDetailCd = {
    ACCOUNT: 'Account',
    ALIAS: 'Alias',
    CONTACT: 'Contact',
    INVOICE_INSTRUCTIONS: 'InvoiceInstructions',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerExpiryReasonCd = {
    INACTIVE: 'Inactive',
    MERGED: 'Merged',
    OTHER: 'Other',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerFunctionCd = {
    BILL_TO: 'Bill-To',
    CORPORATE: 'Corporate',
    PICKUP_OR_DELIVERY: 'PickupOrDelivery',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerHoldCategoryCd = {
    COLL_EXCEPTION: 'COLL_EXCEPTION',
    COLL_HOLD: 'COLL_HOLD',
    COLL_RMV_HOLD: 'COLL_RMV_HOLD',
    CREDIT_EXCEPTION: 'CREDIT_EXCEPTION',
    CREDIT_HOLD: 'CREDIT_HOLD',
    CREDIT_RMV_HOLD: 'CREDIT_RMV_HOLD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerIdTypeCd = {
    CUSTOMER_LOCATION_FUNCTION_ID: 'CustomerLocationFunctionId',
    LEGACY_CIS_CUSTOMER_NUMBER: 'LegacyCisCustomerNumber',
    MAD_CODE: 'MadCode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerInvoiceCd = {
    BAL_DUE: 'BalDue',
    CORRECTED: 'Corrected',
    ORIGINAL: 'Original',
    TRUE_DEBTOR: 'TrueDebtor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerLineStatusCd = {
    APPROVED: 'Approved',
    CREDIT_REVIEWED: 'CreditReviewed',
    HELD: 'Held',
    NOT_IN_PROCESS: 'NotInProcess',
    NO_UPDATE: 'NoUpdate',
    PENDING_CREDIT: 'PendingCredit',
    REJECTED: 'Rejected',
    SALES_APPROVED: 'SalesApproved',
    SALES_PENDING: 'SalesPending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerMatchRequestTypeCd = {
    DETAILED: 'Detailed',
    IDENTIFIER: 'Identifier',
    MAD_CODE: 'MadCode',
    ORDER_ENTRY_DETAILED: 'OrderEntryDetailed',
    PARTIAL_DETAILED: 'PartialDetailed',
    PHONE_NUMBER: 'PhoneNumber',
    PND_DETAILED: 'PndDetailed',
    SIMPLE: 'Simple',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerMatchResultTypeCd = {
    ALIAS: 'Alias',
    CUSTOMER: 'Customer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNoteForCd = {
    ACCOUNT: 'Account',
    ALIAS: 'Alias',
    CONTACT: 'Contact',
    FUNCTION_NOTE: 'FunctionNote',
    FUNCTION_REMARK: 'FunctionRemark',
    INVOICE: 'Invoice',
    REQUEST: 'Request',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNoteTypeCd = {
    APPROVER: 'Approver',
    CREDIT: 'Credit',
    GENERAL: 'General',
    REQUESTER: 'Requester',
    SPECIALIST: 'Specialist',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationActionFormatCd = {
    EMAIL: 'Email',
    TEXT: 'Text',
    UI_COMPONENT: 'UiComponent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationBroadcastCd = {
    APP: 'App',
    BEACON: 'Beacon',
    EMAIL: 'Email',
    IVR: 'IVR',
    TEXT: 'Text',
    USER: 'User',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationLevelCd = {
    ALERT: 'Alert',
    EXCEPTION: 'Exception',
    MESSAGE: 'Message',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationPayloadFormatCd = {
    EMAIL: 'Email',
    JSON: 'JSON',
    TEXT: 'Text',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationPriorityCd = {
    HIGH: 'High',
    LOW: 'Low',
    MEDIUM: 'Medium',
    URGENT: 'Urgent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerNotificationTypeCd = {
    DELETE: 'Delete',
    NEW: 'New',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerPaymentTermsCd = {
    DELINQUENT: 'Delinquent',
    IMMEDIATE: 'Immediate',
    TERM_120_DAYS: 'Term120Days',
    TERM_15_DAYS: 'Term15Days',
    TERM_180_DAYS: 'Term180Days',
    TERM_20_DAYS: 'Term20Days',
    TERM_30_DAYS: 'Term30Days',
    TERM_35_DAYS: 'Term35Days',
    TERM_40_DAYS: 'Term40Days',
    TERM_45_DAYS: 'Term45Days',
    TERM_50_DAYS: 'Term50Days',
    TERM_55_DAYS: 'Term55Days',
    TERM_60_DAYS: 'Term60Days',
    TERM_75_DAYS: 'Term75Days',
    TERM_90_DAYS: 'Term90Days',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerProfileDetailCd = {
    NOTE: 'Note',
    PROFILE: 'Profile',
    SCHEDULE: 'Schedule',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerRequestPriorityCd = {
    NONE: 'None',
    REQD_BILLING: 'ReqdBilling',
    RFP_PENDING: 'RfpPending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerRequestQueueNameCd = {
    CREDIT: 'Credit',
    LOCAL: 'Local',
    MEXICO: 'Mexico',
    NAQQ: 'NAQQ',
    NATIONAL: 'National',
    OTHERS: 'Others',
    PRIORITY: 'Priority',
    SPECIAL: 'Special',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerRequestStatusCd = {
    CANCEL: 'Cancel',
    COMPLETED: 'Completed',
    EXPIRED: 'Expired',
    NEW: 'New',
    PROCESS: 'Process',
    SUBMITTED: 'Submitted',
    WAIT_APPROVER: 'WaitApprover',
    WAIT_REQUESTOR: 'WaitRequestor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerStatusCd = {
    ACTIVE: 'Active',
    EXPIRED: 'Expired',
    INACTIVE: 'Inactive',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerTypeCd = {
    BILL_TO: 'BillTo',
    CORPORATE: 'Corporate',
    FUTURE: 'Future',
    PICKUP_DELIVERY: 'PickupDelivery',
    SERVICE_RECIPIENT: 'ServiceRecipient',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomerTypeOfSvcIndicatorCd = {
    LOGISTICS: 'Logistics',
    RESTRICTED: 'Restricted',
    TRAFFIC: 'Traffic',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomsControlTypeCd = {
    CANADA_TO_US: 'CanadaToUs',
    US_TO_CANADA: 'UsToCanada',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomsPortCd = {
    BLAINE_WASHINGTON: 'BlaineWashington',
    BUFFALO_NIAGARA_FALLS_NEW_YORK: 'BuffaloNiagaraFallsNewYork',
    CALAIS_MAINE: 'CalaisMaine',
    DETROIT_MICHIGAN: 'DetroitMichigan',
    GRAND_PORTAGE_MINNESOTA: 'GrandPortageMinnesota',
    HARTFORD_CONNECTICUT: 'HartfordConnecticut',
    HIGHGATE_SPRINGS_ALBANY_VERMONT: 'HighgateSpringsAlbanyVermont',
    HOULTON_MAINE: 'HoultonMaine',
    PEMBINA_NORTH_DAKOTA: 'PembinaNorthDakota',
    PORTAL_NORTH_DAKOTA: 'PortalNorthDakota',
    PORT_HURON_MICHIGAN: 'PortHuronMichigan',
    PROVIDENCE_RHODE_ISLAND: 'ProvidenceRhodeIsland',
    SWEETGRASS_MONTANA: 'SweetgrassMontana',
    TEMP_0231: 'Temp0231',
    TEMP_0351: 'Temp0351',
    TEMP_0427: 'Temp0427',
    TEMP_0440: 'Temp0440',
    TEMP_0453: 'Temp0453',
    TEMP_0475: 'Temp0475',
    TEMP_0705: 'Temp0705',
    TEMP_0712: 'Temp0712',
    TEMP_0813: 'Temp0813',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const CustomsReasonCd = {
    BROKER_CLOSED: 'BrokerClosed',
    CLIENT_CLEAR: 'ClientClear',
    CLIENT_CREDIT: 'ClientCredit',
    CUSTOMS_IMPORT_EXPORT: 'CustomsImportExport',
    FAILED_PARS: 'FailedPars',
    GOVERNMENT_DOCS_REQUIRED: 'GovernmentDocsRequired',
    INCORRECT_BROKER: 'IncorrectBroker',
    INFO_MISSING: 'InfoMissing',
    INT_NON_CARRIER_DELIVERY: 'IntNonCarrierDelivery',
    NO_BROKER: 'NoBroker',
    OTHER: 'Other',
    PAPERWORK_ISSUE: 'PaperworkIssue',
    WAITING_INSPECTION: 'WaitingInspection',
    WRONG_PRO: 'WrongPro',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DamageTypeCd = {
    CONCEALED: 'Concealed',
    WRECK_AND_FIRE: 'WreckAndFire',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DebtorCd = {
    BILL_TO_IS_DEBTOR: 'BillToIsDebtor',
    CONSIGNEE_IS_DEBTOR: 'ConsigneeIsDebtor',
    DEBTOR_NOT_DETERMINED: 'DebtorNotDetermined',
    NO_DEBTOR: 'NoDebtor',
    SHIPPER_IS_DEBTOR: 'ShipperIsDebtor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeliveryDateTypeCd = {
    CRITICAL: 'Critical',
    STANDARD: 'Standard',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeliveryInfoRequiredCd = {
    CAPTURED: 'Captured',
    NOT_RQRD: 'NotRqrd',
    RQRD: 'Rqrd',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeliveryQualifierCd = {
    ALL_SHORT: 'AllShort',
    APPT: 'Appt',
    ATTEMPTED: 'Attempted',
    CARTAGE: 'Cartage',
    DAMAGED: 'Damaged',
    FINAL: 'Final',
    HOLD_FOR_CUSTOMS: 'HoldForCustoms',
    NOT_APPLICABLE: 'NotApplicable',
    OVER_SHPMT: 'OverShpmt',
    PARTIAL_SHORT: 'PartialShort',
    PRG_BLOCKED: 'PrgBlocked',
    REFUSED: 'Refused',
    RETURNED: 'Returned',
    SPOTTED: 'Spotted',
    SUSPENSE: 'Suspense',
    TRANSFER: 'Transfer',
    TRAPPED: 'Trapped',
    UNDELIVERED: 'Undelivered',
    WAIT: 'Wait',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeliveryQualifierReasonCd = {
    ATTEMPT_CONSIGNEE_RELATED: 'AttemptConsigneeRelated',
    ATTEMPT_SHIPPER_RELATED: 'AttemptShipperRelated',
    BROKER_CLOSED: 'BrokerClosed',
    CASH_NOT_AVAILABLE: 'CashNotAvailable',
    CLIENT_CLEAR: 'ClientClear',
    CLIENT_CREDIT: 'ClientCredit',
    CLOSED_FOR_HOLIDAY: 'ClosedForHoliday',
    CLOSED_HOLIDAY: 'ClosedHoliday',
    CLOSED_INVENTORY: 'ClosedInventory',
    COD_REQUIRED: 'CodRequired',
    CREDIT_HOLD: 'CreditHold',
    CUSTOMER_REQUESTED_CONSOLIDATION: 'CustomerRequestedConsolidation',
    CUSTOMER_REQUEST_FUTURE_DELIVERY: 'CustomerRequestFutureDelivery',
    CUSTOMER_SHUTDOWN: 'CustomerShutdown',
    CUSTOMER_STRIKE: 'CustomerStrike',
    CUSTOMS_IMPORT_EXPORT: 'CustomsImportExport',
    DOCK_PICKUP_REQUIRED: 'DockPickupRequired',
    DRIVER_RELATED: 'DriverRelated',
    FAILED_PARS: 'FailedPars',
    FINAL_CONSIGNEE_RELATED: 'FinalConsignee-related',
    FINAL_SHIPPER_RELATED: 'FinalShipper-related',
    GOVERNMENT_DOCS_REQUIRED: 'GovernmentDocsRequired',
    HELD_FOR_PROTECTIVE_SERVICE: 'HeldForProtectiveService',
    IMPROPER_UNLOAD_EQUIPMENT: 'ImproperUnloadEquipment',
    INCORRECT_BROKER: 'IncorrectBroker',
    INFO_MISSING: 'InfoMissing',
    INSUFFICIENT_DELIVERY_TIME: 'InsufficientDeliveryTime',
    INSUFFICIENT_TIME_TO_COMPLETE_DELIVERY: 'InsufficientTimeToCompleteDelivery',
    INT_NON_CARRIER_DELIVERY: 'IntNonCarrierDelivery',
    LIFTGATE_REQUIRED_FOR_DELIVERY: 'LiftgateRequiredForDelivery',
    MECHANICAL_BREAKDOWN: 'MechanicalBreakdown',
    MISSED_DELIVERY: 'MissedDelivery',
    NO_BROKER: 'NoBroker',
    OTHER: 'Other',
    OTHER_CARRIER_RELATED_REASON: 'OtherCarrier-relatedReason',
    PACKAGE_MIS_SORTED: 'PackageMis-sorted',
    PAPERWORK_ISSUE: 'PaperworkIssue',
    PREVIOUS_STOP_CAUSED_DELAY: 'PreviousStopCausedDelay',
    RECEIVING_TIMES_RESTRICTED: 'ReceivingTimesRestricted',
    RECIPIENT_UNAVAILABLE: 'RecipientUnavailable',
    RESIDENTIAL_NOT_HOME: 'ResidentialNotHome',
    RETURN_SHIPPER_RELATED: 'ReturnShipperRelated',
    WAITING_INSPECTION: 'WaitingInspection',
    WRONG_PRO: 'WrongPro',
    XPO_RELATED: 'XPO-related',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeliveryShipmentIndexCd = {
    CROSS_DOCK_TRAILER_SHIPMENTS: 'CrossDockTrailerShipments',
    DELIVERY_SHIPMENTS: 'DeliveryShipments',
    UNASSIGNED_DELIVERIES: 'UnassignedDeliveries',
    UNASSIGNED_DELIVERIES_WITH_UNMAPPED: 'UnassignedDeliveriesWithUnmapped',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeltaSignCd = {
    NEGATIVE: 'Negative',
    NEUTRAL: 'Neutral',
    POSITIVE: 'Positive',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeltaVarianceTypeCd = {
    BAD: 'Bad',
    GOOD: 'Good',
    NEUTRAL: 'Neutral',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DensitySourceCd = {
    HYBRID: 'Hybrid',
    MANL: 'Manl',
    PRFL: 'Prfl',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DependentFreightTypeCd = {
    SATELLITE: 'SATELLITE',
    ZONE: 'ZONE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeviceApplicationCd = {
    PDOPS: 'PDOPS',
    XDOCK: 'XDOCK',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeviceShiftCd = {
    DAY_RESHIP: 'DayReship',
    INBOUND: 'Inbound',
    NIGHT_FAC: 'NightFAC',
    OUTBOUND: 'Outbound',
    PICKUP_AND_DELIVERY: 'PickupAndDelivery',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DeviceTypeCd = {
    HANDHELD: 'Handheld',
    MOBILE_DEVICE_V_1: 'MobileDeviceV1',
    NEXTEL: 'Nextel',
    PAGER: 'Pager',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DimensionSourceCd = {
    COMMODITY: 'Commodity',
    HANDLING_UNIT: 'HandlingUnit',
    LINEHAUL: 'Linehaul',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DimensionUomCd = {
    CENTIMETERS: 'Centimeters',
    FEET: 'Feet',
    INCHES: 'Inches',
    METERS: 'Meters',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DirectedLoadingExceptionTypeCd = {
    SHIPMENT: 'Shipment',
    TRAILER: 'Trailer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DirectedLoadingLaneTypeCd = {
    OUTBOUND_DIVERSION: 'OutboundDiversion',
    OUTBOUND_LANE: 'OutboundLane',
    STANDARD_FLOW: 'StandardFlow',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeAreaCd = {
    EASTERN: 'Eastern',
    MIDWESTERN_CENTRAL: 'MidwesternCentral',
    SOUTHERN: 'Southern',
    WESTERN: 'Western',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeCsvFileStatusCd = {
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    PROCESSING: 'Processing',
    SUBMITTED: 'Submitted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeCsvFileUploadStatusCd = {
    COMPLETE: 'Complete',
    FAILED: 'Failed',
    IN_PROGRESS: 'InProgress',
    PENDING: 'Pending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeDecisionReasonSubTypeCd = {
    ACCESSORIAL_CHARGE: 'AccessorialCharge',
    ACCESSORIAL_DISPUTE: 'AccessorialDispute',
    AMENDED_CLAIM: 'AmendedClaim',
    APPROVED_PROCESSED_SUBMITTED_IN_ERROR: 'ApprovedProcessedSubmittedInError',
    AUDIT_COMPANY_REQUESTED_CLAIM_CANCELLATION: 'AuditCompanyRequestedClaimCancellation',
    AUTO_DECLINED: 'AutoDeclined',
    BACKDATING_DUE_TO_RULESET_BUILDER_BANDWIDTH: 'BackdatingDueToRulesetBuilderBandwidth',
    BACKDATING_FOR_ADD_LOCATION: 'BackdatingForAddLocation',
    BACKDATING_FOR_DOCS_RECEIVED_LATE_EXTERNAL_ISSUE: 'BackdatingForDocsReceivedLateExternalIssue',
    BACKDATING_FOR_DOCS_RECEIVED_LATE_INTERNAL_ISSUE: 'BackdatingForDocsReceivedLateInternalIssue',
    BACKDATING_FOR_NEW_OPPORTUNITY: 'BackdatingForNewOpportunity',
    BACKDATING_FOR_PRICING_INCREASE: 'BackdatingForPricingIncrease',
    BAD_DEBT_WRITE_OFF: 'BadDebtWriteOff',
    BILLING_ERROR: 'BillingError',
    CARGO_LOSS_DAMAGE_DISPUTE: 'CargoLossDamageDispute',
    CLASS_CHANGE: 'ClassChange',
    CLASS_CORRECTLY_BILLED: 'ClassCorrectlyBilled',
    CODE_MATCHING: 'CodeMatching',
    CONTRACTUAL_EXCEPTIONS: 'ContractualExceptions',
    CORRECTED_VIA_ANOTHER_PROCESS: 'CorrectedViaAnotherProcess',
    CUSTOMER_ERROR: 'CustomerError',
    CUSTOMER_SATISFACTION: 'CustomerSatisfaction',
    DELAY_DUE_TO_DOCUMENT_RATE_INTERPRETATION: 'DelayDueToDocumentRateInterpretation',
    DRP_DECLINED: 'DRPDeclined',
    DUPLICATE_CLAIM: 'DuplicateClaim',
    DUPLICATE_CLAIM_PRO_NUMBER: 'DuplicateClaimProNumber',
    DUPLICATE_PAYMENT: 'DuplicatePayment',
    EMPLOYEE_ERROR: 'EmployeeError',
    EMPLOYEE_NO_LONGER_WITH_XPO: 'EmployeeNoLongerWithXPO',
    GUARANTEED: 'Guaranteed',
    HIERARCHY_CHANGED_CAUSING_STRANDED_PRICING: 'HierarchyChangedCausingStrandedPricing',
    INCORRECT_ADJUSTMENT_AMOUNT: 'IncorrectAdjustmentAmount',
    INCORRECT_INVOICE_NUMBER: 'IncorrectInvoiceNumber',
    INSPECTION: 'Inspection',
    INSPECTOR_ERROR: 'InspectorError',
    INSUFFICIENT_SUPPORTING_INFORMATION: 'InsufficientSupportingInformation',
    INTERNAL_SYSTEM_ERROR: 'InternalSystemError',
    INVALID_PRO_NUMBER_NOT_A_CONWAY_INVOICE: 'InvalidProNumberNotAConwayInvoice',
    LINEAL_FOOT: 'LinealFoot',
    MISCELLANEOUS: 'Miscellaneous',
    NEED_MORE_INFORMATION: 'NeedMoreInformation',
    NON_ERROR_CORRECTION: 'NonErrorCorrection',
    NO_DUPLICATE_PAYMENT: 'NoDuplicatePayment',
    OPEN_INVOICE: 'OpenInvoice',
    OTHER: 'Other',
    POLICY_PAY_CHANGE: 'PolicyPayChange',
    PRC_DECLINED: 'PRCDeclined',
    PREVIOUSLY_REFUNDED: 'PreviouslyRefunded',
    PURSUING_COLLECTION_EFFORT: 'PursuingCollectionEffort',
    RATES_SUSPENDED_AND_NOT_REINSTATED_IN_ERROR: 'RatesSuspendedAndNotReinstatedInError',
    RATE_DISPUTE: 'RateDispute',
    RATING_ERROR: 'RatingError',
    REALLOCATE_WORKLOAD: 'ReallocateWorkload',
    REFUND_OF_CREDIT_BALANCE: 'RefundOfCreditBalance',
    REWEIGH: 'Reweigh',
    REWEIGH_ADJUSTMENT: 'ReweighAdjustment',
    RULESET_ERROR: 'RulesetError',
    RULESET_ERROR_RATE_DISC_FAK_FUEL_ACCESSORIAL: 'RulesetErrorRateDiscFAKFuelAccessorial',
    STATUTE_OF_LIMITATION: 'StatuteOfLimitation',
    SYSTEM_ISSUE: 'SystemIssue',
    TARIFF_OR_CONTRACT: 'TariffOrContract',
    TERMS_BILLED_CORRECTLY_PER_BILL_OF_LADING: 'TermsBilledCorrectlyPerBillOfLading',
    WEIGHT_CORRECTION: 'WeightCorrection',
    WI_APPEAL_NOT_APPROVED: 'WIAppealNotApproved',
    WRONG_AUDIT_COMPANY: 'WrongAuditCompany',
    WRONG_CODE_USED_WRONG_ADDRESS: 'WrongCodeUsedWrongAddress',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeDecisionReasonTypeCd = {
    AMEND: 'Amend',
    APPROVE: 'Approve',
    CANCEL: 'Cancel',
    DECLINE: 'Decline',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeDrpCategoryCd = {
    DRP_COLLECTIONS_ESCALATION: 'DRPCollectionsEscalation',
    DRP_DEBTOR_CHANGE: 'DRPDebtorChange',
    DRP_REGULAR: 'DRPRegular',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeEmailTemplateTypeCd = {
    ACKNOWLEDGE_EMAIL: 'AcknowledgeEmail',
    BLANK_TEMPLATE: 'BlankTemplate',
    CSV_FILE_UPLOAD: 'CsvFileUpload',
    DECLINE_PER_ACCESSORIAL_CHARGE: 'DeclinePerAccessorialCharge',
    DECLINE_PER_CLASS: 'DeclinePerClass',
    DECLINE_PER_DUPLICATE_CLAIM: 'DeclinePerDuplicateClaim',
    DECLINE_PER_INSPECTION: 'DeclinePerInspection',
    DECLINE_PER_INVALID_PRO: 'DeclinePerInvalidPro',
    DECLINE_PER_NO_PAYMENT_RECEIVED: 'DeclinePerNoPaymentReceived',
    DECLINE_PER_PREVIOUSLY_REFUNDED: 'DeclinePerPreviouslyRefunded',
    DECLINE_PER_PRICING_AGREEMENT: 'DeclinePerPricingAgreement',
    DECLINE_PER_REWEIGH: 'DeclinePerReweigh',
    DECLINE_PER_STATUTE_OF_LIMITATION: 'DeclinePerStatuteOfLimitation',
    DECLINE_PER_TARIFF_OR_CONTRACT: 'DeclinePerTariffOrContract',
    DECLINE_PER_UNABLE_TO_PROCESS_CLAIM: 'DeclinePerUnableToProcessClaim',
    DEFAULT_TEMPLATE: 'DefaultTemplate',
    DISPUTE_ACKNOWLEDGEMENT: 'DisputeAcknowledgement',
    DRP_APPROVAL: 'DrpApproval',
    DRP_BLANK_TEMPLATE: 'DRPBlankTemplate',
    DRP_CSV_FILE_UPLOAD: 'DrpCsvFileUpload',
    DRP_NOTIFICATION_EMAIL: 'DrpNotificationEmail',
    MRRA_APPROVAL: 'MrraApproval',
    MRRA_NOTIFICATION_EMAIL: 'MrraNotificationEmail',
    OCC_AMENDMENT: 'OccAmendment',
    OCC_APPROVAL: 'OccApproval',
    OCC_BLANK_TEMPLATE: 'OccBlankTemplate',
    OCC_NOTIFICATION_EMAIL: 'OccNotificationEmail',
    WNI_AMENDMENT: 'WniAmendment',
    WNI_APPROVAL: 'WniApproval',
    WNI_BLANK_TEMPLATE: 'WniBlankTemplate',
    WNI_NOTIFICATION_EMAIL: 'WniNotificationEmail',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeEventTypeCd = {
    CLAIMANT_ADDED: 'ClaimantAdded',
    CLAIMANT_CHANGED: 'ClaimantChanged',
    CLAIMANT_CONTACT_ADDED: 'ClaimantContactAdded',
    DISPUTE_AMENDED: 'DisputeAmended',
    DISPUTE_APPROVED: 'DisputeApproved',
    DISPUTE_ASSIGNED: 'DisputeAssigned',
    DISPUTE_CANCELLED: 'DisputeCancelled',
    DISPUTE_CLOSED: 'DisputeClosed',
    DISPUTE_CORRECTIONS_IN_PROGRESS: 'DisputeCorrectionsInProgress',
    DISPUTE_DECLINED: 'DisputeDeclined',
    DISPUTE_DELETED: 'DisputeDeleted',
    DISPUTE_FIELDS_UPDATED_ONLY: 'DisputeFieldsUpdatedOnly',
    DISPUTE_REASSIGNED: 'DisputeReassigned',
    DISPUTE_SAVED_AS_DRAFT: 'DisputeSavedAsDraft',
    DISPUTE_SHIPMENT_ADDED_OR_REMOVED: 'DisputeShipmentAddedOrRemoved',
    DISPUTE_SHIPMENT_SPREADSHEET_UPLOADED: 'DisputeShipmentSpreadsheetUploaded',
    DISPUTE_SUBMITTED: 'DisputeSubmitted',
    DISPUTE_SUBMITTED_FOR_REVIEW: 'DisputeSubmittedForReview',
    DISPUTE_UNASSIGNED: 'DisputeUnassigned',
    DISPUTE_UNDER_REVIEW: 'DisputeUnderReview',
    DMS_DOCUMENT_ADDED: 'DmsDocumentAdded',
    INCOMING_EMAIL: 'IncomingEmail',
    NOTE_ADDED: 'NoteAdded',
    ON_BEHALF_OF_ADDED: 'OnBehalfOfAdded',
    ON_BEHALF_OF_CHANGED: 'OnBehalfOfChanged',
    ON_BEHALF_OF_CONTACT_ADDED: 'OnBehalfOfContactAdded',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeFilingMethodCd = {
    EMAIL: 'Email',
    FAX: 'Fax',
    INTERNAL_REQUEST: 'InternalRequest',
    MAIL: 'Mail',
    NOT_APPLICABLE: 'NotApplicable',
    OTHER: 'Other',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeNoteTypeCd = {
    APPROVER_NOTES: 'ApproverNotes',
    GENERAL: 'General',
    NEEDS_MORE_INFO: 'NeedsMoreInfo',
    REQUESTER_NOTES: 'RequesterNotes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputePartyTypeCd = {
    CLAIMANT: 'Claimant',
    CURRENT_DEBTOR: 'CurrentDebtor',
    NEW_DEBTOR: 'NewDebtor',
    ON_BEHALF_OF: 'OnBehalfOf',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeProValidationStatusCd = {
    NOT_VALIDATED: 'NotValidated',
    VALIDATED: 'Validated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeReassignReasonCd = {
    CLAIM_GRAB_IN_ERROR_REASSIGN_TO_VALID_AUDITOR: 'ClaimGrabInErrorReassignToValidAuditor',
    EMPLOYEE_NO_LONGER_WITH_XPO: 'EmployeeNoLongerWithXpo',
    OTHER: 'Other',
    REALLOCATE_WORKLOAD: 'ReallocateWorkload',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeRequestReasonCd = {
    DRPEDI_NON_REVENUE_ADJUSTMENT: 'DRPEDINonRevenueAdjustment',
    DRPEDI_TRANSMISSION_ERROR: 'DRPEDITransmissionError',
    DRPFSC_DISPUTE: 'DRPFSCDispute',
    DRPOTW_ADJUSTMENT: 'DRPOTWAdjustment',
    DRP_ACCESSORIAL_DISPUTE: 'DRPAccessorialDispute',
    DRP_CARGO_LOSS_DAMAGE_DISPUTE: 'DRPCargoLossDamageDispute',
    DRP_CLAIM_DISPUTE: 'DRPClaimDispute',
    DRP_CLASS_CHANGE: 'DRPClassChange',
    DRP_CUSTOMER_ERROR: 'DRPCustomerError',
    DRP_CUSTOMER_NON_COMPLIANCE_NON_REVENUE_ADJUSTMENT: 'DRPCustomerNonComplianceNonRevenueAdjustment',
    DRP_CUSTOMER_SATISFACTION: 'DRPCustomerSatisfaction',
    DRP_EMPLOYEE_ERROR: 'DRPEmployeeError',
    DRP_FRAUD: 'DRPFraud',
    DRP_GUARANTEED_ADJUSTMENT: 'DRPGuaranteedAdjustment',
    DRP_INSPECTION_ADJUSTMENT: 'DRPInspectionAdjustment',
    DRP_INVOICE_DELIVERED_PAST_STATUTE: 'DRPInvoiceDeliveredPastStatute',
    DRP_LATE_DELIVERY: 'DRPLateDelivery',
    DRP_LATE_FEE: 'DRPLateFee',
    DRP_LINEAL_FOOT_DISPUTE: 'DRPLinealFootDispute',
    DRP_OTHER_DISPUTE: 'DRPOtherDispute',
    DRP_RATE_DISPUTE: 'DRPRateDispute',
    DRP_RATE_QUOTE_ERROR: 'DRPRateQuoteError',
    DRP_REWEIGH_ADJUSTMENT: 'DRPReweighAdjustment',
    DRP_SERVICE_RECOVERY: 'DRPServiceRecovery',
    DRP_SETTLEMENT: 'DRPSettlement',
    DRP_SYSTEM_ERROR: 'DRPSystemError',
    MRRAPRC_DECLINED: 'MRRAPRCDeclined',
    MRRA_BACKDATING_DUE_TO_RULESET_BUILDER_BANDWIDTH: 'MRRABackdatingDueToRulesetBuilderBandwidth',
    MRRA_BACKDATING_FOR_ADD_LOCATION: 'MRRABackdatingForAddLocation',
    MRRA_BACKDATING_FOR_DOCS_RECEIVED_LATE_EXTERNALISSUE: 'MRRABackdatingForDocsReceivedLateExternalissue',
    MRRA_BACKDATING_FOR_DOCS_RECEIVED_LATE_INTERNALISSUE: 'MRRABackdatingForDocsReceivedLateInternalissue',
    MRRA_BACKDATING_FOR_NEW_OPPORTUNITY: 'MRRABackdatingForNewOpportunity',
    MRRA_BACKDATING_FOR_PRICING_INCREASE: 'MRRABackdatingForPricingIncrease',
    MRRA_DELAY_IMPLEMENTING_DUE_DOC_OR_RATE_INTERPRETATION: 'MRRADelayImplementingDueDocOrRateInterpretation',
    MRRA_GOOD_WILL_DRP: 'MRRAGoodWillDRP',
    MRRA_HIERARCHY_CHANGED_DURING_NEGOTIATIONS: 'MRRAHierarchyChangedDuringNegotiations',
    MRRA_RATES_SUSPENDED_AND_NOT_REINSTATED_DUE_TO_ERROR: 'MRRARatesSuspendedAndNotReinstatedDueToError',
    MRRA_RULESET_ERROR: 'MRRARulesetError',
    OCCWI_APPEAL_NOT_APPROVED: 'OCCWIAppealNotApproved',
    OCC_ACCESSORIAL_CHARGE: 'OCCAccessorialCharge',
    OCC_APPROVAL_OF_AMENDED_CLAIM: 'OCCApprovalOfAmendedClaim',
    OCC_BILLED_IN_ERROR: 'OCCBilledInError',
    OCC_CLASS_ERROR: 'OCCClassError',
    OCC_CODE_MATCHING: 'OCCCodeMatching',
    OCC_CONTRACTUAL_EXCEPTIONS: 'OCCContractualExceptions',
    OCC_DECLINED_PER_OPEN_INVOICE: 'OCCDeclinedPerOpenInvoice',
    OCC_DUPLICATE_PAYMENT: 'OCCDuplicatePayment',
    OCC_INSPECTION: 'OCCInspection',
    OCC_INSUFFICIENT_SUPPORTING_INFORMATION: 'OCCInsufficientSupportingInformation',
    OCC_INVALID_PRO_NUMBER_OR_NOTAN_XPO_INVOICE: 'OCCInvalidProNumberOrNotanXPOInvoice',
    OCC_LINEAL_FOOT: 'OCCLinealFoot',
    OCC_MISCELLANEOUS: 'OCCMiscellaneous',
    OCC_NO_DUPLICATE_PAYMENT: 'OCCNoDuplicatePayment',
    OCC_OVERPAYMENT: 'OCCOverpayment',
    OCC_PREVIOUSLY_REFUNDED: 'OCCPreviouslyRefunded',
    OCC_RATING_ERROR: 'OCCRatingError',
    OCC_REBUTTAL_OF_CLAIM: 'OCCRebuttalOfClaim',
    OCC_REFUND_OF_CREDIT_BALANCE: 'OCCRefundOfCreditBalance',
    OCC_REWEIGH: 'OCCReweigh',
    OCC_RULESET_ERROR: 'OCCRulesetError',
    OCC_STATUTEOF_LIMITATION: 'OCCStatuteofLimitation',
    OCC_TARIFF_OR_CONTRACT: 'OCCTariffOrContract',
    OCC_WEIGHT_ERROR: 'OCCWeightError',
    WNI_INSPECTOR_ERROR: 'WNIInspectorError',
    WNI_OVERCHARGE_CLAIM: 'WNIOverchargeClaim',
    WNI_RATING_ERROR: 'WNIRatingError',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeShipmentCurrencyCd = {
    CAD: 'CAD',
    USD: 'USD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeShipmentPaymentStatusCd = {
    OPEN: 'Open',
    PAID_IN_FULL: 'PaidInFull',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeShpIneligibilityRsnCd = {
    INVOICE_NOT_FULLY_PAID: 'InvoiceNotFullyPaid',
    PICKUP_DATE_GREATER_THAN_180_DAYS: 'PickupDateGreaterThan180Days',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeStatusCd = {
    AMENDED: 'Amended',
    APPROVED: 'Approved',
    CANCELLED: 'Cancelled',
    CLOSED: 'Closed',
    COLLECTIONS_ESCALATION_UNDER_REVIEW: 'CollectionsEscalationUnderReview',
    CORRECTIONS_UNDER_PROGRESS: 'CorrectionsUnderProgress',
    DECLINED: 'Declined',
    DELETED: 'Deleted',
    DRAFT: 'Draft',
    PENDING_APPROVAL: 'PendingApproval',
    PENDING_DIRECTOR_APPROVAL: 'PendingDirectorApproval',
    PENDING_FINANCE_APPROVAL: 'PendingFinanceApproval',
    PENDING_SUPERVISOR_APPROVAL: 'PendingSupervisorApproval',
    PENDING_SVP_APPROVAL: 'PendingSVPApproval',
    PENDING_VPS_APPROVAL: 'PendingVPSApproval',
    PENDING_VP_APPROVAL: 'PendingVPApproval',
    RERATE_APPROVED: 'RerateApproved',
    SUBMITTED: 'Submitted',
    SUBMITTED_FOR_REVIEW: 'SubmittedForReview',
    UNASSIGNED: 'Unassigned',
    UNDER_REVIEW: 'UnderReview',
    WHAT_IF_ANALYSIS_IN_PROGRESS: 'WhatIfAnalysisInProgress',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DisputeTypeCd = {
    DISPUTE_RESOLUTION_PROCESS: 'DisputeResolutionProcess',
    INSPECTION_APPEALS: 'InspectionAppeals',
    MASS_RE_RATE: 'MassReRate',
    OVERCHARGE_CLAIMS: 'OverchargeClaims',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DmsDocTypeCd = {
    ACTL: 'ACTL',
    ARIN: 'ARIN',
    BL: 'BL',
    BLAT: 'BLAT',
    CHKS: 'CHKS',
    CLAT: 'CLAT',
    CLM: 'CLM',
    CLMH: 'CLMH',
    CLMN: 'CLMN',
    CUPD: 'CUPD',
    CUST: 'CUST',
    DR: 'DR',
    DRAT: 'DRAT',
    DRRR: 'DRRR',
    DXFO: 'DXFO',
    FLYS: 'FLYS',
    IR: 'IR',
    IRFO: 'IRFO',
    LOA: 'LOA',
    MMAK: 'MMAK',
    NCIC: 'NCIC',
    OSDF: 'OSDF',
    PXFC: 'PXFC',
    WI: 'WI',
    WRFO: 'WRFO',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockActivityCd = {
    DELIVERY: 'Delivery',
    PICKUP: 'Pickup',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockManifestReportTypeCd = {
    DOCK_MANIFEST: 'DockManifest',
    INBOUND_LOAD_AND_ROUTE_MANIFEST: 'InboundLoadAndRouteManifest',
    INBOUND_STRIP_MANIFEST: 'InboundStripManifest',
    LINEHAUL_CLOSED_LOAD_MANIFEST: 'LinehaulClosedLoadManifest',
    LINEHAUL_LOAD_MANIFEST: 'LinehaulLoadManifest',
    LINEHAUL_STRIP_MANIFEST: 'LinehaulStripManifest',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockOperationsReportTypeCd = {
    STRIP_MANIFEST_REPORT: 'StripManifestReport',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockShipmentListTypeCd = {
    DIVERTED: 'Diverted',
    EXCLUDED: 'Excluded',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockShipmentProgressCd = {
    NOT_STRIPPED: 'NotStripped',
    STRIPPED: 'Stripped',
    TCONNED: 'TConned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DockShipmentTypeCd = {
    DOCK: 'Dock',
    PICKUP: 'Pickup',
    RESHIP: 'Reship',
    STRAND: 'Strand',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DocumentFormTypeCd = {
    COPY_BILL: 'CopyBill',
    FBDS: 'FBDS',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DoorMatchCd = {
    AREA: 'Area',
    TRAILER: 'Trailer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DoorPlanActionCd = {
    COPY: 'Copy',
    MERGE: 'Merge',
    MOVE: 'Move',
    REVERT: 'Revert',
    SWAP: 'Swap',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DoorPlanProfileTypeCd = {
    CURRENT: 'Current',
    DEFAULT: 'Default',
    STATIC: 'Static',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DoorPreferenceTypeCd = {
    EMBARGO: 'Embargo',
    LOAD_UNLOAD: 'LoadUnload',
    STEP_SAVER_EXCLUDE: 'StepSaverExclude',
    TRAP: 'Trap',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DriverJobTypeCd = {
    BID: 'Bid',
    FLEX: 'Flex',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DriverMessageOperationCd = {
    ARRIVE: 'Arrive',
    LIST: 'List',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DriverSourceCd = {
    BOTH: 'Both',
    LINEHAUL: 'Linehaul',
    PN_D: 'PnD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DriverTurnTypeCd = {
    CITY_TURN: 'CityTurn',
    DOUBLE_TURN: 'DoubleTurn',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DsrLicenseCd = {
    ACTIVE: 'Active',
    ACTIVE_BUT_EXPIRES_WITHIN_30_DAYS: 'ActiveButExpiresWithin30Days',
    EXPIRED: 'Expired',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DsrSelectionTypeCd = {
    AUTOMATED_SELECTION_BASED_ON_RANDOM_POOL: 'AutomatedSelectionBasedOnRandomPool',
    AUTOMATED_SELECTION_BASED_ON_UNCHECKED_POOL: 'AutomatedSelectionBasedOnUncheckedPool',
    MANUAL_SELECTION_BY_FOS: 'ManualSelectionByFOS',
    RECHECK_DUE_TO_COACHING: 'RecheckDueToCoaching',
    SELECTION_DUE_TO_A_FLAGGED_PU_ON_THE_TRIP: 'SelectionDueToAFlaggedPUOnTheTrip',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DwellPeriodTypeCd = {
    ANY: 'Any',
    ARRIVAL: 'Arrival',
    BETWEEN_TRIPS: 'BetweenTrips',
    DEPARTURE: 'Departure',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DwellReasonTypeCd = {
    ACTIVE: 'Active',
    ALL: 'All',
    INACTIVE: 'Inactive',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DwellSourceCd = {
    APP_LAUNCH: 'AppLaunch',
    COMPLETE_STOP: 'CompleteStop',
    ENTER_GATE: 'EnterGate',
    INSIDE_GATE: 'InsideGate',
    KRONOS_PUNCH: 'KronosPunch',
    LEAVE_GATE: 'LeaveGate',
    OUTSIDE_GATE: 'OutsideGate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceApiNameCd = {
    BULK_UPDATE_DYNAMIC_PRICING_RULE_BY_TYPE: 'BulkUpdateDynamicPricingRuleByType',
    CREATE_DYNAMIC_PRICING_RULE_HEADER: 'CreateDynamicPricingRuleHeader',
    EXECUTE_DYNAMIC_PRICING_RULE_HEADER: 'ExecuteDynamicPricingRuleHeader',
    GET_RATE_REQUEST_DYNAMIC_PRICING_RULE: 'GetRateRequestDynamicPricingRule',
    UPDATE_DYNAMIC_PRICING_RULE_HEADER: 'UpdateDynamicPricingRuleHeader',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceApplicationTypeCd = {
    DESTINATION: 'Destination',
    ORIGIN: 'Origin',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceEventTypeCd = {
    CREATE_DYN_PRICE_RULE: 'CreateDynPriceRule',
    RATE_REQUEST_RESPONSE: 'RateRequestResponse',
    UPDATE_DYN_PRICE_RULE: 'UpdateDynPriceRule',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceLTLBillStatusCd = {
    BILLED: 'Billed',
    CANCELLED: 'Cancelled',
    IN_FBES_SUSPENSE_QUEUE: 'InFBESSuspenseQueue',
    PAID: 'Paid',
    RATED: 'Rated',
    UNBILLED: 'Unbilled',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceLaneTypeCd = {
    BACK_HAUL: 'BackHaul',
    HEAD_HAUL: 'HeadHaul',
    NEUTRAL: 'Neutral',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceLocationTypeCd = {
    BILL_TO: 'BillTo',
    CORPORATE: 'Corporate',
    PICKUP_AND_DELIVERY: 'PickupAndDelivery',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceQualifierTypeCd = {
    COUNTRY: 'Country',
    DISTRICT: 'District',
    LOCATION: 'Location',
    REGION: 'Region',
    SIC: 'SIC',
    STATE: 'State',
    ZIP_CODE: 'ZipCode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceRateTypeCd = {
    FLAT_RATE: 'FlatRate',
    PCT_RATE_BY_LINEHAUL: 'PctRateByLinehaul',
    PCT_RATE_BY_TOTAL: 'PctRateByTotal',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceRestrictionTypeCd = {
    EXCLUDE: 'Exclude',
    INCLUDE: 'Include',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DynamicPriceStatusCd = {
    ACTIVE: 'Active',
    EXPIRED: 'Expired',
    INACTIVE: 'Inactive',
    PENDING: 'Pending',
    QUOTE_OFF: 'QuoteOff',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EarlyCutoffCd = {
    ESL: 'ESL',
    HAS_EARLY_CUTOFF: 'Has Early Cutoff',
    NO_EARLY_CUTOFF: 'No Early Cutoff',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EcmGoalTypeCd = {
    STD_GOAL: 'StdGoal',
    WEEKLY_GOAL: 'WeeklyGoal',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EcmSummaryCountTypeCd = {
    LIFETIME: 'Lifetime',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EdiSlashPoundCd = {
    P: 'P',
    S: 'S',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EmailDirectionTypeCd = {
    INBOUND: 'Inbound',
    OUTBOUND: 'Outbound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EmailFormatCd = {
    HTML: 'HTML',
    TEXT: 'text',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EmployeeIdTypeCd = {
    RACF_ID: 'RACFId',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EmployeeRoleCd = {
    DR_APPROVER: 'DRApprover',
    DR_REVIEWER: 'DRReviewer',
    DR_TEST_APPROVER: 'DRTestApprover',
    DR_TEST_REVIEWER: 'DRTestReviewer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EnsembleExecutionStatusCd = {
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    KILLED: 'Killed',
    LOCK_FAILED: 'LockFailed',
    LOCK_WAIT: 'LockWait',
    LOCK_WAIT_FAILED: 'LockWaitFailed',
    NOT_IMPLEMENTED: 'NotImplemented',
    NOT_STARTED: 'NotStarted',
    PAUSED: 'Paused',
    STARTED: 'Started',
    SUBMITTED: 'Submitted',
    SUSPENDED: 'Suspended',
    THREAD_WAIT: 'ThreadWait',
    THREAD_WAIT_FAILED: 'ThreadWaitFailed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EnsembleListenerModeCd = {
    AQ_LISTENER: 'AQ_LISTENER',
    AQ_WAIT_LISTENER: 'AQ_WAIT_LISTENER',
    CHANNEL_LISTENER: 'CHANNEL_LISTENER',
    EMAIL_LISTENER: 'EMAIL_LISTENER',
    HUB: 'HUB',
    JMS_LISTENER: 'JMS_LISTENER',
    LISTENER: 'LISTENER',
    LOCKABLE_AQ_LISTENER: 'LOCKABLE_AQ_LISTENER',
    LOCKABLE_CHANNEL_LISTENER: 'LOCKABLE_CHANNEL_LISTENER',
    LOCKABLE_JMS_LISTENER: 'LOCKABLE_JMS_LISTENER',
    LOCKABLE_PUBSUB_LISTENER: 'LOCKABLE_PUBSUB_LISTENER',
    PUBSUB_FILE_LISTENER: 'PUBSUB_FILE_LISTENER',
    PUBSUB_LISTENER: 'PUBSUB_LISTENER',
    PUBSUB_RETRIGGER_LISTENER: 'PUBSUB_RETRIGGER_LISTENER',
    TIMER_LISTENER: 'TIMER_LISTENER',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EnvironmentCd = {
    DEV: 'Dev',
    PRE_PROD: 'PreProd',
    PROD: 'Prod',
    TEST: 'Test',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentEventReasonCd = {
    BRACING: 'Bracing',
    DUNNAGE: 'Dunnage',
    SAFESTACK: 'Safestack',
    STRAPS: 'Straps',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentEventSubTypeCd = {
    FULL_PHOTO: 'FullPhoto',
    LOAD_QUALITY_RATING: 'LoadQualityRating',
    THUMBNAIL_PHOTO: 'ThumbnailPhoto',
    TRAILER_PHOTO: 'TrailerPhoto',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentEventTypeCd = {
    CLOSE: 'Close',
    LOAD: 'Load',
    OPEN: 'Open',
    UNLOAD: 'Unload',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentQualifierCd = {
    EMPTY: 'Empty',
    HEADLOAD: 'Headload',
    LOADED: 'Loaded',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentSizeCd = {
    OK_EVEN_IN_A_GEOGRAPHIC_AREA_OTHERWISE_RESTRICTED_TO_PU: 'OKEvenInAGeographicAreaOtherwiseRestrictedToPU',
    PUP_OR_SMALLER_REQUIRED: 'PupOrSmallerRequired',
    STRAIGHT_TRUCK_BOX_TRUCK_REQUIRED: 'StraightTruckBoxTruckRequired',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentStatusCd = {
    APPOINTMENT: 'Appointment',
    ARRIVAL: 'Arrival',
    AVAILABLE: 'Available',
    CITY: 'City',
    CITY_ARRIVAL: 'CityArrival',
    CITY_LOADING_AT_DOCK: 'CityLoadingAtDock',
    CLOSE: 'Close',
    CLOSED_FOR_DELIVERY: 'ClosedForDelivery',
    DELAYED: 'Delayed',
    DISPATCHED: 'Dispatched',
    DROP: 'Drop',
    EMPTY: 'Empty',
    ENROUTE: 'Enroute',
    HELD: 'Held',
    LOADING_AT_CUSTOMER: 'LoadingAtCustomer',
    LOADING_AT_DOCK: 'LoadingAtDock',
    OUT_OF_SERVICE: 'OutOfService',
    OVERHEAD: 'Overhead',
    PICKUP_AND_DELIVERY_ROUTE: 'PickupAndDeliveryRoute',
    TRAP: 'Trap',
    UNLOADING_AT_CUSTOMER: 'UnloadingAtCustomer',
    UNLOADING_AT_DOCK: 'UnloadingAtDock',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentStatusQualifierCd = {
    AVAILABLE: 'Available',
    LIMITED_AVAILABILITY: 'LimitedAvailability',
    NOT_AVAILABLE: 'NotAvailable',
    OUT_OF_SERVICE: 'OutOfService',
    UNDEFINED: 'Undefined',
    WORK_REQUEST: 'WorkRequest',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentTypeCd = {
    DOLLY: 'Dolly',
    L_H_TRAILER: 'L/HTrailer',
    OTHER: 'Other',
    RENTAL: 'Rental',
    STRAIGHT_TRUCK: 'StraightTruck',
    TRACTOR: 'Tractor',
    VAN: 'Van',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EquipmentTypeDetailCd = {
    DOLLY_OWNED: 'DollyOwned',
    MISC_OTHER_FORKLIFT_OWNED: 'MiscOtherForkliftOwned',
    MISC_OTHER_HOSTLER_OWNED: 'MiscOtherHostlerOwned',
    MISC_OTHER_PICKUP_OWNED: 'MiscOtherPickupOwned',
    MISC_OTHER_SATELLITE_OWNED: 'MiscOtherSatelliteOwned',
    MISC_OTHER_SWEEPER_OWNED: 'MiscOtherSweeperOwned',
    MISC_OTHER_VAN_OWNED: 'MiscOtherVanOwned',
    POWER_HVY_DUTY_SUBSVC: 'PowerHvyDutySubsvc',
    POWER_LGT_DUTY_RENTAL: 'PowerLgtDutyRental',
    POWER_LGT_DUTY_SUBSVCL: 'PowerLgtDutySubsvcl',
    POWER_LH_OWNED: 'PowerLHOwned',
    POWER_PN_D_OWNED: 'PowerPnDOwned',
    STRAIGHT_STRT_TRK_OWNED: 'StraightStrtTrkOwned',
    STRAIGHT_STRT_TRK_RENTAL: 'StraightStrtTrkRental',
    STRAIGHT_STRT_TRK_SUBSERVICE: 'StraightStrtTrkSubservice',
    X_28_LH_TRAILER_OWNED: 'x28LHTrailerOwned',
    X_28_LH_TRAILER_RENTAL: 'x28LHTrailerRental',
    X_28_LH_TRAILER_SUBSERVICE: 'x28LHTrailerSubservice',
    X_28_PN_D_TRAILER_RENTAL: 'x28PnDTrailerRental',
    X_28_PN_D_TRAILER_SUBSERVICE: 'x28PnDTrailerSubservice',
    X_28_PN_D_TRAILER_W_LIFT_GATE_OWNED: 'x28PnDTrailerWLiftGateOwned',
    X_32_LH_TRAILER_OWNED: 'x32LHTrailerOwned',
    X_32_LH_TRAILER_RENTAL: 'x32LHTrailerRental',
    X_32_LH_TRAILER_SUBSERVICE: 'x32LHTrailerSubservice',
    X_32_PN_D_TRAILER_OWNED: 'x32PnDTrailerOwned',
    X_32_PN_D_TRAILER_RENTAL: 'x32PnDTrailerRental',
    X_32_PN_D_TRAILER_SUBSERVICE: 'x32PnDTrailerSubservice',
    X_33_LH_TRAILER_OWNED: 'x33LHTrailerOwned',
    X_33_PN_D_TRAILER_OWNED: 'x33PnDTrailerOwned',
    X_42_LH_TRAILER_OWNED: 'x42LHTrailerOwned',
    X_42_LH_TRAILER_SUBSERVICE: 'x42LHTrailerSubservice',
    X_42_LH_TRAILTER_RENTAL: 'x42LHTrailterRental',
    X_42_PN_D_TRAILER_OWNED: 'x42PnDTrailerOwned',
    X_42_PN_D_TRAILER_RENTAL: 'x42PnDTrailerRental',
    X_45_LH_TRAILER_OWNED: 'x45LHTrailerOwned',
    X_45_LH_TRAILER_RENTAL: 'x45LHTrailerRental',
    X_45_LH_TRAILER_SUBSERVICE: 'x45LHTrailerSubservice',
    X_45_PN_D_TRAILER_OWNED: 'x45PnDTrailerOwned',
    X_45_PN_D_TRAILER_RENTAL: 'x45PnDTrailerRental',
    X_45_PN_D_TRAILER_SUBSERVICE: 'x45PnDTrailerSubservice',
    X_48_LH_TRAILER_OWNED: 'x48LHTrailerOwned',
    X_48_LH_TRAILER_RENTAL: 'x48LHTrailerRental',
    X_48_LH_TRAILER_SUBSERVICE: 'x48LHTrailerSubservice',
    X_48_PN_D_TRAILER_OWNED: 'x48PnDTrailerOwned',
    X_48_PN_D_TRAILER_RENTAL: 'x48PnDTrailerRental',
    X_48_PN_D_TRAILER_SUBSERVICE: 'x48PnDTrailerSubservice',
    X_53_LH_TRAILER_OWNED: 'x53LHTrailerOwned',
    X_53_LH_TRAILER_RENTAL: 'x53LHTrailerRental',
    X_53_LH_TRAILER_SUBSERVICE: 'x53LHTrailerSubservice',
    X_53_PN_D_TRAILER_RENTAL: 'x53PnDTrailerRental',
    X_53_PN_D_TRAILER_SUBSERVICE: 'x53PnDTrailerSubservice',
    X_53_PN_D_TTRAILER_OWNED: 'x53PnDTtrailerOwned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EslCd = {
    REGULAR: 'Regular',
    SOLO: 'Solo',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EventLogSubTypeCd = {
    ALL_SHORT_DLVY: 'AllShortDlvy',
    APPOINTMENT_DLVY: 'AppointmentDlvy',
    ARCHIVE_NORMAL_PURGE: 'ArchiveNormalPurge',
    ATTEMPTED_DLVY: 'AttemptedDlvy',
    AUTO_RATED: 'AutoRated',
    BOL_IMAGED: 'BOLImaged',
    BOL_SKEL_4_SUP_REF: 'BOLSkel4SupRef',
    BORDER_CROSS_CN_TO_US: 'BorderCrossCNToUS',
    BORDER_CROSS_MX_TO_US: 'BorderCrossMXToUS',
    BORDER_CROSS_US_TO_CN: 'BorderCrossUSToCN',
    BORDER_CROSS_US_TO_MX: 'BorderCrossUSToMX',
    CARTAGE_DLVY: 'CartageDlvy',
    CCOR_UPDATE: 'CCORUpdate',
    CHILD_PRO_DLVY: 'ChildProDlvy',
    COMPRESS_LOCX_DLVY: 'CompressLOCXDlvy',
    CORRECT_MOVR_MOTHER: 'CorrectMOVRMother',
    CUBE_UPDATE: 'CubeUpdate',
    CUSTOMER_MATCH: 'CustomerMatch',
    CUSTOMER_MATCH_DIRECT_CODE: 'CustomerMatchDirectCode',
    CUSTOMS_CSA_ALTERED_CN: 'CustomsCSAAlteredCN',
    CUSTOMS_CSA_ALTERED_MX: 'CustomsCSAAlteredMX',
    CUSTOMS_CSA_ALTERED_US: 'CustomsCSAAlteredUS',
    CUSTOMS_HOLD_DLVY: 'CustomsHoldDlvy',
    DAMAGED_DLVY: 'DamagedDlvy',
    DELIVERY_RECEIPT_IMAGED: 'DeliveryReceiptImaged',
    DELIVERY_RECEIPT_PRINTED: 'DeliveryReceiptPrinted',
    EDIBOL_CREATE: 'EDIBOLCreate',
    FINAL_DLVY: 'FinalDlvy',
    FORCE_SHIP_PURGE: 'ForceShipPurge',
    LINEHAUL_ARRIVAL: 'LinehaulArrival',
    LINEHAUL_DELAY: 'LinehaulDelay',
    LINEHAUL_DISPATCH: 'LinehaulDispatch',
    LOADING_SKEL_PRO: 'LoadingSkelPro',
    LOAD_BY_PRO: 'LoadByPro',
    LOAD_BY_TRAILER: 'LoadByTrailer',
    MISSING: 'Missing',
    NON_TCON_UNLOAD: 'NonTCONUnload',
    OVER_DLVY: 'OverDlvy',
    PART_SHORT_DLVY: 'PartShortDlvy',
    PCO_PURGE: 'PCOPurge',
    PICKUP_REQUEST: 'PickupRequest',
    PORT_CD_ALTERED_CN: 'PortCdAlteredCN',
    PORT_CD_ALTERED_MX: 'PortCdAlteredMX',
    PORT_CD_ALTERED_US: 'PortCdAlteredUS',
    PURGE_BLOCK_DLVY: 'PurgeBlockDlvy',
    RATED_BILL: 'RatedBill',
    RATE_AUDITOR_RATED: 'RateAuditorRated',
    RATE_AUDITOR_UNRATED: 'RateAuditorUnrated',
    REFUSED_DLVY: 'RefusedDlvy',
    RETURN_DLVY: 'ReturnDlvy',
    REV_BILL_ENTRY: 'RevBillEntry',
    SENT_2_RATE_AUDIT: 'Sent2RateAudit',
    SHIPMENT_CORRECTION: 'ShipmentCorrection',
    SHIP_PURGE_PRO_AVAIL: 'ShipPurgeProAvail',
    SHIP_RESET_4_BILL_ENTRY: 'ShipReset4BillEntry',
    SPLIT: 'Split',
    SPOTTED_DLVY: 'SpottedDlvy',
    SUSPENSE_DLVY: 'SuspenseDlvy',
    TRANSFER_DLVY: 'TransferDlvy',
    TRAPPED_DLVY: 'TrappedDlvy',
    UNDELIVERED_DLVY: 'UndeliveredDlvy',
    UNLOAD_ASSUMPTIVE_STRIP: 'UnloadAssumptiveStrip',
    UNLOAD_BY_PRO: 'UnloadByPro',
    UNLOAD_BY_TRAILER: 'UnloadByTrailer',
    UNLOAD_FORCE_STRIP: 'UnloadForceStrip',
    UPDATE_DLVY: 'UpdateDlvy',
    WAIT_DLVY: 'WaitDlvy',
    WEB_BOL_CREATE: 'WebBOLCreate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EventLogTypeCd = {
    ARCHIVED: 'Archived',
    BILL_ENTRY: 'BillEntry',
    CORRECTIONS: 'Corrections',
    CUSTOMER_MATCH: 'CustomerMatch',
    CUSTOMS: 'Customs',
    DLVY_RCPT_PRINT: 'DlvyRcptPrint',
    DOC_IMAGES: 'DocImages',
    EQUIPMENT_TRACKING: 'EquipmentTracking',
    PICKUP: 'Pickup',
    PURGED: 'Purged',
    RATING: 'Rating',
    SHIPMENT_DLVY: 'ShipmentDlvy',
    SHIPMENT_UPDATE: 'ShipmentUpdate',
    STRIP: 'Strip',
    TRLR_CONTENTS: 'TrlrContents',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EventSourceCd = {
    AUTO_GENNED: 'Auto-genned',
    EDI: 'EDI',
    FTP: 'FTP',
    INTERNAL: 'Internal',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const EventTypeCd = {
    ADD_SHIPMENT_TO_PICKUP: 'Add Shipment to Pickup',
    CANCEL_PICKUP: 'Cancel Pickup',
    COMPLETE_PICKUP: 'Complete Pickup',
    CREATE_SCHEDULE_PICKUP: 'Create/Schedule Pickup',
    DELETE_SHIPMENT_FROM_PICKUP: 'Delete Shipment from Pickup',
    DIMENSION_UPDATE: 'Dimension Update',
    DISPATCH_PICKUP: 'Dispatch Pickup',
    HAZMAT_UPDATE: 'Hazmat Update',
    RESCHEDULE_PICKUP: 'Reschedule Pickup',
    STRAND_PICKUP: 'Strand Pickup',
    UPDATE_PICKUP: 'Update Pickup',
    UPDATE_SHIPMENT_ON_PICKUP: 'Update Shipment on Pickup',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExadataDatabaseCd = {
    ALL: 'All',
    LTLAPDEV: 'Ltlapdev',
    LTLAPTST: 'Ltlaptst',
    PRDRDRSTBYX_6: 'Prdrdrstbyx6',
    PRDRDR_SRV: 'PrdrdrSrv',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionCategoryCd = {
    OPTIMIZER: 'Optimizer',
    SCO: 'SCO',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionLocationTypeCd = {
    DISTRICT: 'District',
    HSS_REGION: 'HSSRegion',
    LINEHAUL_REGION: 'LinehaulRegion',
    LINEHAUL_SIC: 'LinehaulSIC',
    OPERATIONAL_REGION: 'OperationalRegion',
    OPERATION_SIC: 'OperationSIC',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionStatusCd = {
    ACKNOWLEDGED: 'Acknowledged',
    APPROVED: 'Approved',
    CANCELLED: 'Cancelled',
    CLOSED: 'Closed',
    COMPLETED: 'Completed',
    DECLINED: 'Declined',
    EXPIRED: 'Expired',
    NEW: 'New',
    NEW_SIC: 'NewSIC',
    PENDING: 'Pending',
    RESOLVED: 'Resolved',
    RESPONDED: 'Responded',
    UNDER_REVIEW_LH: 'UnderReviewLH',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionSummaryCd = {
    LOAD: 'Load',
    POWER_MANAGEMENT: 'PowerManagement',
    SHIPMENT: 'Shipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionSummaryTypeCd = {
    ALERT: 'Alert',
    EXCEPTION: 'Exception',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExceptionTypeCd = {
    ADD_LOAD_REQUEST: 'AddLoadRequest',
    CUT_LOAD_REQUEST: 'CutLoadRequest',
    GMISLOAD: 'GMisload',
    HSS: 'HSS',
    LOAD_REQUEST: 'LoadRequest',
    PARTIAL_BYPASS: 'PartialBypass',
    PROGRESSIVE_LOAD: 'ProgressiveLoad',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExemptReasonCd = {
    ACCIDENT: 'Accident',
    CUSTOMS: 'Customs',
    DEFERRED: 'Deferred',
    NOT_EXEMPT: 'NotExempt',
    OTHER: 'Other',
    PREFER_VOL_SHPMT: 'PreferVolShpmt',
    ROAD_CLOSURE: 'RoadClosure',
    TORNADO: 'Tornado',
    WEATHER: 'Weather',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExpectationOwnerTypeCd = {
    DOOR: 'Door',
    SERVICER_CENTER: 'ServicerCenter',
    SHIPMENT: 'Shipment',
    TRAILER: 'Trailer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExpectationStatusCd = {
    EXCEPTION: 'Exception',
    MET: 'Met',
    NEW: 'New',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExpireReasonCd = {
    CITY_NAME_CHANGED: 'CITY_NAME_CHANGED',
    LOCATION_CLOSED: 'LOCATION_CLOSED',
    MISC_ADDR_FIELDS_CHG: 'MISC_ADDR_FIELDS_CHG',
    MOVED_TO_NEW_ADDRESS: 'MOVED_TO_NEW_ADDRESS',
    PRIMARY_ADDR_CHANGED: 'PRIMARY_ADDR_CHANGED',
    STREET_NAME_CHANGED: 'STREET_NAME_CHANGED',
    ZIP_CODE_CHANGED: 'ZIP_CODE_CHANGED',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExtendedServiceLaneTypeCd = {
    ESL: 'Esl',
    ESL_SOLO: 'EslSolo',
    NO_ESL: 'NoEsl',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ExternalShipmentStatusCd = {
    ARRIVED_AT_DELIVERY: 'ArrivedAtDelivery',
    ARRIVED_AT_PICKUP: 'ArrivedAtPickup',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    CONFIRM_ON_BOARD: 'ConfirmOnBoard',
    DRIVER_ALLOCATED: 'DriverAllocated',
    ENROUTE_TO_DELIVERY: 'EnrouteToDelivery',
    ENROUTE_TO_PICKUP: 'EnrouteToPickup',
    FINDING_DRIVER: 'FindingDriver',
    RETURNED: 'Returned',
    TRANSFER: 'Transfer',
    UNALLOCATED: 'Unallocated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FbdsPrintCountCd = {
    ALL_PRINTED: 'AllPrinted',
    NO_PRINTS: 'NoPrints',
    PARTIAL_PRINTS: 'PartialPrints',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FbdsVersionCd = {
    BILINGUAL: 'Bilingual',
    DEFAULT: 'Default',
    FRENCH: 'French',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FieldDisplayTypeCd = {
    BUTTON: 'Button',
    CHECKBOX: 'Checkbox',
    DATE_PICKER: 'DatePicker',
    FIELD_DISPLAY_TEXT: 'FieldDisplayText',
    MULTI_LINE_TEXT_BOX: 'MultiLineTextBox',
    MULTI_SELECT_DROP_DOWN: 'MultiSelectDropDown',
    RADIO_BUTTON: 'RadioButton',
    RADIO_GROUP: 'RadioGroup',
    SINGLE_LINE_TEXT_BOX: 'SingleLineTextBox',
    SINGLE_SELECT_DROP_DOWN: 'SingleSelectDropDown',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FinalStandardAddressSourceCd = {
    ADDRESS_VALIDATION_API_UNAVAILABLE: 'AddressValidationApiUnavailable',
    GOOGLE_STANDARD_ADDRESS: 'GoogleStandardAddress',
    PITNEY_BOWES_STANDARD_ADDRESS: 'PitneyBowesStandardAddress',
    UNABLE_TO_VALIDATE_ADDRESS_FROM_LOTUS: 'UnableToValidateAddressFromLotus',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FinancialFunctionCd = {
    ACROSS_SOB_ELIMINATIONS: 'ACROSS_SOB_ELIMINATIONS',
    ACROSS_SOB_THIRD_PARTY_CONTRAC: 'ACROSS_SOB_THIRD_PARTY_CONTRAC',
    ADMINISTRATIVE: 'ADMINISTRATIVE',
    ADMIN_SUPPORT: 'ADMIN_SUPPORT',
    BALANCE_SHEET: 'BALANCE_SHEET',
    CARTAGE: 'CARTAGE',
    CNET_POSTAL: 'CNET_POSTAL',
    CONSULTING: 'CONSULTING',
    CWF_SALES: 'CWF_SALES',
    DEDICATED_FLEET: 'DEDICATED_FLEET',
    DOMESTIC_OPS: 'DOMESTIC_OPS',
    E_COMMERCE: 'E_COMMERCE',
    FLIGHT_CREWS: 'FLIGHT_CREWS',
    FREIGHT_MANAGEMENT: 'FREIGHT_MANAGEMENT',
    GROUND_HANDLING: 'GROUND_HANDLING',
    HUB_FAC: 'HUB_FAC',
    INCENTIVE: 'INCENTIVE',
    INTEREST_OTHER: 'INTEREST_OTHER',
    INTL_OPERATIONS: 'INTL_OPERATIONS',
    LEGAL_VS_MGMT: 'LEGAL_VS_MGMT',
    LINEHAUL_OPS: 'LINEHAUL_OPS',
    MAINTENANCE_SHOPS: 'MAINTENANCE_SHOPS',
    MANUFACTURE_ASSEMBLY: 'MANUFACTURE_ASSEMBLY',
    OPS_SUPPORT: 'OPS_SUPPORT',
    OTHER_OPS: 'OTHER_OPS',
    PMPC: 'PMPC',
    PRINT_SHOP: 'PRINT_SHOP',
    RECLASS: 'RECLASS',
    REVENUE_AIRLINE: 'REVENUE_AIRLINE',
    REVENUE_SALES: 'REVENUE_SALES',
    SW_DEVELOPMENT: 'SW_DEVELOPMENT',
    TAX: 'TAX',
    TRUCKLOAD_OPERATIONS: 'TRUCKLOAD_OPERATIONS',
    WAREHOUSE: 'WAREHOUSE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FoodPoisonCd = {
    FOOD: 'Food',
    NEITHER: 'Neither',
    POISON: 'Poison',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FreightMaintenanceTypeCd = {
    EXTERNAL_MAINTENANCE: 'EXTERNAL_MAINTENANCE',
    MAINTENANCE_MISC: 'MAINTENANCE_MISC',
    PARTS_DISTBN_CENTER: 'PARTS_DISTBN_CENTER',
    SHOP: 'SHOP',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FreightOperationTypeCd = {
    DEPENDENT_SIC: 'DEPENDENT_SIC',
    FREIGHT_SVC_CENTER: 'FREIGHT_SVC_CENTER',
    MATCHING_CENTER: 'MATCHING_CENTER',
    MEET_AND_TURN: 'MEET_AND_TURN',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FreightServiceAreaTypeCd = {
    CITY_OPERATIONS: 'CITY_OPERATIONS',
    SATELLITE: 'SATELLITE',
    ZONE: 'ZONE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const FreightStatusCd = {
    DELIVERED_CLEAR: 'DeliveredClear',
    DELIVERED_WITH_EXCEPTIONS: 'DeliveredWithExceptions',
    NOT_SET: 'NotSet',
    RETURNS: 'Returns',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const GeoLocationTypeCd = {
    CUSTOMER_LOCATION: 'CustomerLocation',
    DROP_LOCATION: 'DropLocation',
    SERVICE_CENTER: 'ServiceCenter',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const GlobalSearchDetailCd = {
    CLAIM_RESULT: 'ClaimResult',
    DISPUTE_RESULT: 'DisputeResult',
    DMS_RESULT: 'DMSResult',
    INVOICE_RESULT: 'InvoiceResult',
    PICKUP_RESULT: 'PickupResult',
    PN_D_RESULT: 'PnDResult',
    SHIPMENT_RESULT: 'ShipmentResult',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const GoalLevelCd = {
    DISTRICT: 'District',
    LANE: 'Lane',
    REGION: 'Region',
    SERVICE_CENTER_OR_ZONE: 'ServiceCenterOrZone',
    SIC: 'SIC',
    ZONE: 'Zone',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const GoalTypeCd = {
    LINEHAUL: 'Linehaul',
    PN_D: 'PnD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HandlingUnitDimensionTypeCd = {
    ACCURACY: 'Accuracy',
    DOCK: 'Dock',
    PICKUP: 'Pickup',
    PICKUP_DIMENSIONER: 'PickupDimensioner',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HandlingUnitMovementTypeCd = {
    ADD: 'Add',
    CLOSE: 'Close',
    DELIVER: 'Deliver',
    DOCK_OPERATIONS_EXCEPTION: 'DockOperationsException',
    LOAD: 'Load',
    MOVER_SHIPMENT: 'MoverShipment',
    PICKUP: 'Pickup',
    REPLACE: 'Replace',
    SCAN: 'Scan',
    SPLIT: 'Split',
    STAGE: 'Stage',
    SWAP: 'Swap',
    TRANSFER: 'Transfer',
    UNLOAD: 'Unload',
    UNSPLIT: 'Unsplit',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HandlingUnitTypeCd = {
    LOOSE: 'Loose',
    MOTOR: 'Motor',
    UNKNOWN: 'Unknown',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HazmatBulkQuantityCd = {
    BULK: 'Bulk',
    LIMITED_QUANTITY: 'Limited Quantity',
    NON_BULK: 'Non-Bulk',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HazmatSourceCd = {
    BILL_OF_LADING: 'BillOfLading',
    DRIVER: 'Driver',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HierarchyGroupCategoryCd = {
    OPERATIONS_AREA: 'OPERATIONS AREA',
    OPERATIONS_REGION: 'OPERATIONS REGION',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HookCategoryCd = {
    DROP: 'Drop',
    SPOT: 'Spot',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HookStatusCd = {
    ASSIGNED: 'Assigned',
    UNASSIGNED: 'Unassigned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HostlerInstructionCd = {
    MOVE: 'Move',
    OTHER: 'Other',
    SWAP: 'Swap',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HssRegionCd = {
    HSSLN: 'HSSLN',
    HSSU: 'HSSU',
    HSSX: 'HSSX',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const HttpMethod = {
    DELETE: 'DELETE',
    GET: 'GET',
    HEAD: 'HEAD',
    HTTP_METHOD_UNSPECIFIED: 'HTTP_METHOD_UNSPECIFIED',
    OPTIONS: 'OPTIONS',
    PATCH: 'PATCH',
    POST: 'POST',
    PUT: 'PUT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const IdentifiedLocationTypeCd = {
    DOCK: 'Dock',
    TRAILER: 'Trailer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InstructionStatCd = {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'InProgress',
    PENDING: 'Pending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const IntermodalSatelliteTypeCd = {
    AIRPORT: 'AIRPORT',
    PORT: 'PORT',
    RAILHEAD: 'RAILHEAD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvPaymentChrgToCd = {
    BOTH_COLLECT: 'Both Collect',
    BOTH_PREPAID: 'Both Prepaid',
    COLLECT: 'Collect',
    PREPAID: 'Prepaid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceAccuracyConstraintCd = {
    ACCESSORIAL_CD: 'AccessorialCd',
    BILL_2_CUST_NUMBER: 'Bill2CustNumber',
    BILL_TO_RELATED_CODE_1: 'BillToRelatedCode1',
    BILL_TO_RELATED_CODE_2: 'BillToRelatedCode2',
    CONSIGNEE_CUST_NUMBER: 'ConsigneeCustNumber',
    COUPON_CD: 'CouponCd',
    CUST_TYPE_CODE: 'CustTypeCode',
    PRICING_AGREEMENT_ID: 'PricingAgreementId',
    RATING_TARIFF_NAME: 'RatingTariffName',
    SHIPPER_CUST_NUMBER: 'ShipperCustNumber',
    TOTAL_CHARGE_AMOUNT: 'TotalChargeAmount',
    TOTAL_PALLET_CNT: 'TotalPalletCnt',
    TRUE_DEBTOR_CUSTOMER_NUMBER: 'TrueDebtorCustomerNumber',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceAddressCd = {
    AS_ENTERED: 'AsEntered',
    BILL_TO_RATES: 'BillToRates',
    PICKUP_DELIVERY_RATES: 'PickupDeliveryRates',
    SAME: 'Same',
    THIRD_PARTY_RATES: 'ThirdPartyRates',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceAttachmentCd = {
    BOL: 'BOL',
    BOTH: 'BOTH',
    DR: 'DR',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceCurrencyCd = {
    CANADIAN_DOLLAR: 'CanadianDollar',
    US_DOLLAR: 'UsDollar',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceDetailDataTypeCd = {
    INV: 'INV',
    XML: 'XML',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceDocumentCd = {
    INDIVIDUAL: 'Individual',
    INVOICE: 'Invoice',
    MANIFEST: 'Manifest',
    NONE: 'None',
    STATEMENT: 'Statement',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceEvalOperCd = {
    EQUAL_TO: 'EqualTo',
    GREATER_THAN: 'GreaterThan',
    IN: 'In',
    LESS_THAN: 'LessThan',
    NOT_EQUAL_TO: 'NotEqualTo',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceHoldReasonCd = {
    AC_PENDING_CORR: 'ACPendingCorr',
    FAILED_GUARANTEE: 'FailedGuarantee',
    HOLD: 'Hold',
    HOLD_FOR_X_DAYS: 'HoldForXDays',
    MISSING_DR: 'MissingDR',
    MISSING_RFC: 'MissingRFC',
    MX_DOOR_TO_DOOR: 'MXDoorToDoor',
    NOT_DELIVERED: 'NotDelivered',
    PENDING_CORR: 'PendingCorr',
    SRN_CORR: 'SRNCorr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceModeCd = {
    EDI: 'EDI',
    EDI_LEGACY: 'EDILegacy',
    EDI_TEST: 'EDITest',
    EDI_TRANSFORMATION: 'EDITransformation',
    EMAIL: 'Email',
    FAX: 'Fax',
    FTP: 'FTP',
    PAPER: 'PAPER',
    SELF_PAID: 'SelfPaid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoicePostDeliveryStatusCd = {
    ACCEPTED: 'Accepted',
    ACCEPTED_BY_CUSTOMER: 'AcceptedByCustomer',
    ACCEPTED_WITH_ERRORS: 'AcceptedWithErrors',
    DEFERRED: 'Deferred',
    PARTIALLY_ACCEPTED: 'PartiallyAccepted',
    REJECTED: 'Rejected',
    SENT_TO_CUSTOMER: 'SentToCustomer',
    SENT_TO_SI: 'SentToSi',
    SENT_TO_SI_TEST: 'SentToSiTest',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoicePreferenceCd = {
    ALL: 'All',
    TRANS_MODE: 'TransMode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoicePreferenceConstraintCd = {
    ACCESSORIAL_CD: 'AccessorialCd',
    BILLING_TYPE_CD: 'BillingTypeCd',
    INVOICE_CURRENCY: 'InvoiceCurrency',
    INVOICE_TYPE_CD: 'InvoiceTypeCd',
    SHIPMENT_WEIGHT: 'ShipmentWeight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoicePresentationFormatCd = {
    CSV: 'CSV',
    CSV_ACC: 'CSV-ACC',
    INDIVIDUAL: 'Individual',
    MANIFEST: 'Manifest',
    NO_ATTACHMENT: 'NoAttachment',
    PDF: 'PDF',
    PDF_IMAGE: 'PDF-IMAGE',
    STATEMENT: 'Statement',
    XML: 'XML',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceRequirementCategoryCd = {
    POST_RATING: 'PostRating',
    PRE_RATING: 'PreRating',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceRequirementTypeCd = {
    DEFAULT_TARIFF_RULE: 'DefaultTariffRule',
    PALLET_GROSS_WEIGHT_RULE: 'PalletGrossWeightRule',
    PALLET_NET_WEIGHT_RULE: 'PalletNetWeightRule',
    REQUIRED_TARIFF_RULE: 'RequiredTariffRule',
    THREE_PARTY_MATCH_RULE: 'ThreePartyMatchRule',
    UNIVERSAL_CTS_599_TARIFF_RULE: 'UniversalCTS599TariffRule',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceSendStatusCd = {
    EXPIRED: 'Expired',
    HOLD: 'Hold',
    NEW: 'New',
    PAID: 'Paid',
    READY: 'Ready',
    SENT: 'Sent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceTransmissionFormatCd = {
    INVOICE: 'Invoice',
    MANIFEST: 'Manifest',
    STATEMENT: 'Statement',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceTransmitStatusCd = {
    DO_NOT_TRANSMIT: 'Do Not Transmit',
    EXPIRED: 'Expired',
    NOT_READY: 'NotReady',
    NO_REVENUE: 'NoRevenue',
    PAID: 'Paid',
    PAID_BELOW_THRESHOLD: 'Paid_BelowThreshold',
    PAID_CASH_COLLECTED: 'Paid_CashCollected',
    PAID_CASH_PPD: 'Paid_CashPpd',
    PAID_SELF_PAID: 'Paid_SelfPaid',
    TRANSMIT: 'Transmit',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const InvoiceTypeCd = {
    BAL_DUE: 'BalDue',
    CORRECTED: 'Corrected',
    ORIGINAL: 'Original',
    PAST_DUE_BILL: 'PastDueBill',
    PAST_DUE_STMT: 'PastDueStmt',
    THIRD_PARTY_BAL_DUE: 'ThirdPartyBalDue',
    THIRD_PARTY_CORRECTED: 'ThirdPartyCorrected',
    THIRD_PARTY_ORIGINAL: 'ThirdPartyOriginal',
    THIRD_PARTY_PAST_DUE_BILL: 'ThirdPartyPastDueBill',
    THIRD_PARTY_PAST_DUE_STMT: 'ThirdPartyPastDueStmt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JSPLaborRollupTypeCd = {
    COST: 'Cost',
    DSR_PICKUP_AND_DELIVERY: 'DSR pickup and delivery',
    DSR_PICKUP_AND_DELIVERY_FLEX: 'DSR pickup and delivery flex',
    FULL_TIME_DOCK_WORKER: 'Full time dock worker',
    FULL_TIME_DOCK_WORKER_FLEX: 'Full time dock worker flex',
    PART_TIME_DOCK_WORKER: 'Part time dock worker',
    PART_TIME_DOCK_WORKER_FLEX: 'Part time dock worker flex',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JSPShiftTimeNameTypeCd = {
    DAY_RE_HANDLE: 'Day re-handle',
    FAC_ALLOCATED: 'FAC allocated',
    FAC_RE_HANDLE: 'FAC re-handle',
    INBOUND_ALLOCATED: 'Inbound allocated',
    INBOUND_RE_HANDLE: 'Inbound re-handle',
    OUTBOUND_ALLOCATED: 'Outbound allocated',
    OUTBOUND_RE_HANDLE: 'Outbound re-handle',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JSPShiftTimeTypeCd = {
    ALLOCATED: 'Allocated',
    RE_HANDLE: 'Re-handle',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JSPWorkerTypeCd = {
    DSR_LINEHAUL: 'DSR linehaul',
    DSR_LINEHAUL_FLEX: 'DSR linehaul flex',
    DSR_PICKUP_AND_DELIVERY: 'DSR pickup and delivery',
    DSR_PICKUP_AND_DELIVERY_FLEX: 'DSR pickup and delivery flex',
    FULL_TIME_DOCK_WORKER: 'Full time dock worker',
    FULL_TIME_DOCK_WORKER_FLEX: 'Full time dock worker flex',
    PART_TIME_DOCK_WORKER: 'Part time dock worker',
    PART_TIME_DOCK_WORKER_FLEX: 'Part time dock worker flex',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JobSelectionCd = {
    AM_FLEXIBLE: 'AMFlexible',
    ANYTIME_FLEXIBLE: 'ANYTIMEFlexible',
    CITY: 'City',
    DAY_LINEHAUL: 'DayLinehaul',
    DOCK: 'Dock',
    NIGHT_LINEHAUL: 'NightLinehaul',
    PM_FLEXIBLE: 'PMFlexible',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const JobStateTypeCd = {
    DISABLED: 'Disabled',
    ENABLED: 'Enabled',
    PAUSED: 'Paused',
    STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
    UPDATE_FAILED: 'UpdateFailed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LabelShippingStatusCd = {
    ORDERED: 'Ordered',
    SHIPPED: 'Shipped',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LateTenderCd = {
    LATE_TENDER: 'LateTender',
    NOT_A_LATE_TENDER: 'NotALateTender',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LegalTermsTypeCd = {
    CREDIT_CARD_REGISTRATION: 'Credit Card Registration',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LengthUomCd = {
    FEET: 'Feet',
    INCHES: 'Inches',
    METERS: 'Meters',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LhoEventTypeCd = {
    ADDLANE: 'ADDLANE',
    DVRTBYP: 'DVRTBYP',
    DVRTFRT: 'DVRTFRT',
    DVRTTRLR: 'DVRTTRLR',
    EDITDSRCNT: 'EDITDSRCNT',
    EDITPUPCNT: 'EDITPUPCNT',
    EDITVIA: 'EDITVIA',
    RLSESTAT: 'RLSESTAT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LicenseEquipmentBodyCd = {
    BOMM_DOLLY: 'BommDolly',
    CONTAINER: 'Container',
    CONVERTER_DOLLY: 'ConverterDolly',
    CRANE: 'Crane',
    DROM_BOX: 'DromBox',
    DRY_VAN: 'DryVan',
    DUMP_TRUCK: 'DumpTruck',
    EMPTY: 'Empty',
    FLAT_BED: 'FlatBed',
    FULL_TRAILER: 'FullTrailer',
    GRADER: 'Grader',
    HOPPER: 'Hopper',
    JEEP_AXLE: 'JeepAxle',
    LIFT_TRUCK: 'LiftTruck',
    LOW_BED: 'LowBed',
    OPEN_TOP_VAN: 'OpenTopVan',
    PANEL: 'Panel',
    PASSENGER_CAR: 'PassengerCar',
    PICKUP: 'Pickup',
    RADIO: 'Radio',
    REEFER_UNIT: 'ReeferUnit',
    REFRIDGERATION_VAN: 'RefridgerationVan',
    SEDAN: 'Sedan',
    SEMI_TRAILER: 'SemiTrailer',
    SHOP_MULE: 'ShopMule',
    SNOW_PLOW: 'SnowPlow',
    TANK: 'Tank',
    TRACTOR: 'Tractor',
    TRUCK: 'Truck',
    TRUCK_TRACTOR: 'TruckTractor',
    YARD_SWEEPER: 'YardSweeper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LicenseEquipmentFuelTypeCd = {
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    EMPTY: 'Empty',
    GAS: 'Gas',
    HYDROGEN: 'Hydrogen',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LicenseEquipmentOwnedLeaseCd = {
    EMPTY: 'Empty',
    LEASE: 'Lease',
    OWNED: 'Owned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LicenseEquipmentTypeCd = {
    CONVERT_GEAR: 'ConvertGear',
    EMPTY: 'Empty',
    HOSTLING_YARD_TRACTOR: 'HostlingYardTractor',
    PASSENGER_CAR: 'PassengerCar',
    SEMI_TRAILER: 'SemiTrailer',
    TRACTOR: 'Tractor',
    TRUCK: 'Truck',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LicenseValidityCd = {
    EXPIRED: 'Expired',
    VALID: 'Valid',
    WARNING: 'Warning',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LineItemChargeToCd = {
    COLL: 'Coll',
    PPD: 'Ppd',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LoadGroupTypeCd = {
    BYPASS: 'BYPASS',
    HEADLOAD: 'HEADLOAD',
    MISC: 'MISC',
    PART_BYPASS: 'PART_BYPASS',
    PART_HEADLOAD: 'PART_HEADLOAD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LoadUnloadIdentifierCd = {
    CUSTOMER_LOADS_AND_OR_UNLOADS_OUR_TRAILERS: 'CustomerLoadsAndOrUnloadsOurTrailers',
    DSR_LOADS_OR_UNLOADS_OUR_TRAILERS: 'DSRLoadsOrUnloadsOurTrailers',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationAddressTypeCd = {
    MAIL: 'MAIL',
    PHYSICAL: 'PHYSICAL',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationDetailCd = {
    LOC_CON_WAY_CORPORATION: 'LocConWayCorporation',
    LOC_REFERENCE: 'LocReference',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationHierarchyTypeCd = {
    DISTRICT: 'District',
    REGION: 'Region',
    SIC: 'Sic',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationOperationTypeCd = {
    BUSINESS_COMMERCIAL: 'BusinessCommercial',
    CONSTR_SITE: 'ConstrSite',
    CONSTR_UTILITY_SITE: 'ConstrUtilitySite',
    DISTRIBUTION_CENTER: 'DistributionCenter',
    EXHIBITION_CONV_CTR: 'ExhibitionConvCtr',
    GOVT_AIRPORT: 'GovtAirport',
    GOVT_GAS_OIL_FIELD: 'GovtGasOilField',
    GOVT_MILITARY: 'GovtMilitary',
    GOVT_MINE: 'GovtMine',
    GOVT_OTHER: 'GovtOther',
    GOVT_POST_OFFICE: 'GovtPostOffice',
    GOVT_PRISON_CORRECTION: 'GovtPrisonCorrection',
    GROCERY_WAREHOUSE: 'GroceryWarehouse',
    PIER_CFS: 'PierCFS',
    PIER_WHARF: 'PierWharf',
    RESIDENTIAL_BUSINESS: 'ResidentialBusiness',
    RES_APARTMENT: 'ResApartment',
    RES_CAMP: 'ResCamp',
    RES_FARM: 'ResFarm',
    RES_HOME: 'ResHome',
    RES_PLACE_OF_WORSHIP: 'ResPlaceOfWorship',
    RES_PUBLIC_STORAGE: 'ResPublicStorage',
    RES_SCHOOL: 'ResSchool',
    SHOPPING_MALL: 'ShoppingMall',
    UNVERSITY_COLLEGE: 'UnversityCollege',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationPhoneTypeCd = {
    FAX: 'FAX',
    INTERNAL: 'INTERNAL',
    TOLL_FREE: 'TOLL_FREE',
    VOICE: 'VOICE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LocationTypeCd = {
    ACCOUNTING: 'ACCOUNTING',
    ADMINISTRATION: 'ADMINISTRATION',
    OPERATIONS: 'OPERATIONS',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LogLevel = {
    DEBUG: 'DEBUG',
    ERROR: 'ERROR',
    FATAL: 'FATAL',
    INFO: 'INFO',
    WARN: 'WARN',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const LookerResultFormatCd = {
    CSV: 'csv',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ManifestReportTypeCd = {
    DELIVERED_MANIFEST: 'DeliveredManifest',
    EXCEPTIONS_MANIFEST: 'ExceptionsManifest',
    GUARANTEED_MANIFEST: 'GuaranteedManifest',
    NEW_SHIPMENT_MANIFEST: 'NewShipmentManifest',
    OUT_FOR_DELIVERY_MANIFEST: 'OutForDeliveryManifest',
    REGULAR_MANIFEST: 'RegularManifest',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MatchedPartySourceCd = {
    NOT_MATCHED: 'NotMatched',
    NOT_MATCHED_INVALID_ADDRESS_OVERRIDE: 'NotMatchedInvalidAddressOverride',
    SYSTEM_MATCHED: 'SystemMatched',
    USER_SELECTED: 'UserSelected',
    USER_SELECTED_SEARCH: 'UserSelectedSearch',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MatchedPartyStatusCd = {
    DERIVED_BILL_TO: 'DerivedBillTo',
    INVALID_ADDRESS: 'InvalidAddress',
    MCH: 'Mch',
    NO_DERIVED_BILL_TO: 'NoDerivedBillTo',
    NO_DERIVED_BILL_TO_SELF_INV: 'NoDerivedBillToSelfInv',
    POSSIBLES_FOUND: 'PossiblesFound',
    UN_MCH: 'UnMch',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MatchedPartyTypeCd = {
    BILL_TO_INB: 'BillToInb',
    BILL_TO_OTB: 'BillToOtb',
    CONS: 'Cons',
    CONTACT_ADDRESS: 'Contact Address',
    REQUESTOR_ADDRESS: 'RequestorAddress',
    SHPR: 'Shpr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MessageLogStatusCd = {
    ACKNOWLEGED: 'Acknowleged',
    PROCESSING_FAILED: 'ProcessingFailed',
    PROCESSING_SUCCESSFUL: 'ProcessingSuccessful',
    RESENT: 'Resent',
    SEND_FAILED: 'SendFailed',
    SEND_SUCCESSFUL: 'SendSuccessful',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MessagePriorityCd = {
    HIGH: 'High',
    LOW: 'Low',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricPredictionTypeCd = {
    ACTUAL: 'Actual',
    PLAN: 'Plan',
    PREDICTION: 'Prediction',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricStageCd = {
    DISPATCHED: 'Dispatched',
    DOCK: 'Dock',
    PLANNING: 'Planning',
    POST_OPTIMIZER: 'PostOptimizer',
    POST_OPT_ROUTES: 'PostOptRoutes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricStageSubCd = {
    RELEASED: 'Released',
    SEQUENCED: 'Sequenced',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricThresholdContextCd = {
    GOAL: 'Goal',
    VARIANCE: 'Variance',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricThresholdValueTypeCd = {
    PCT: 'Pct',
    UOM: 'Uom',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricTypeCd = {
    ROUTE: 'Route',
    SERVICE_CENTER: 'ServiceCenter',
    TRIP: 'Trip',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricValueKeyCd = {
    COST_PER_CWT: 'CostPerCwt',
    DELIVERY_COST: 'DeliveryCost',
    DELIVERY_COST_PER_CWT: 'DeliveryCostPerCwt',
    DELIVERY_COST_PER_TRIP: 'DeliveryCostPerTrip',
    DELIVERY_MILES: 'DeliveryMiles',
    DELIVERY_MILES_PER_STOP: 'DeliveryMilesPerStop',
    DELIVERY_MOTOR_MOVES: 'DeliveryMotorMoves',
    DELIVERY_PERCENT_BY_1400: 'DeliveryPercentBy1400',
    DELIVERY_PERCENT_BY_NOON: 'DeliveryPercentByNoon',
    DELIVERY_PPMH: 'DeliveryPpmh',
    DELIVERY_SERVICE_RISK_SHIPMENTS: 'DeliveryServiceRiskShipments',
    DELIVERY_STOPS_PER_HOUR: 'DeliveryStopsPerHour',
    DELIVERY_STOPS_PER_TRIP: 'DeliveryStopsPerTrip',
    DELIVERY_WEIGHT_PER_TRIP: 'DeliveryWeightPerTrip',
    LABOR_PN_D_COST: 'LaborPnDCost',
    LOAD_AVERAGE: 'LoadAverage',
    OUTBOUND_AND_INBOUND_CWT: 'OutboundAndInboundCWT',
    PN_D_WEIGHT: 'PnDWeight',
    TOTAL_BILLS: 'TotalBills',
    TOTAL_HOURS: 'TotalHours',
    TOTAL_ROUTES: 'TotalRoutes',
    TOTAL_STOPS: 'TotalStops',
    WFP_CITY_DELIVERY_TRIP: 'WFPCityDeliveryTrip',
    WFP_CITY_DELIVERY_WEIGHT: 'WFPCityDeliveryWeight',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MetricVarianceCd = {
    ABOVE: 'Above',
    BELOW: 'Below',
    NEUTRAL: 'Neutral',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MinuetExecutionStatusCd = {
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    NOT_STARTED: 'NotStarted',
    SKIPPED: 'Skipped',
    STARTED: 'Started',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MiscLineItemCd = {
    AS_WGT: 'AsWgt',
    CASH_COLLECTED_LN: 'CashCollectedLn',
    CASH_PPD_LN: 'CashPpdLn',
    COD_AMT: 'CodAmt',
    COD_PMT: 'CodPmt',
    DEFICIT_WGT: 'DeficitWgt',
    DISC_LN: 'DiscLn',
    PART_COLL_LN: 'PartCollLn',
    PART_PPD_LN: 'PartPpdLn',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MiscLineItemPaymentMethodCd = {
    CERTIFIED_FUND: 'CertifiedFund',
    COMPANY_CHECK: 'CompanyCheck',
    CUSTOMER_CHECK: 'CustomerCheck',
    DEMAND_DRAFT: 'DemandDraft',
    MONEY_ORDER: 'MoneyOrder',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ModelGroupCd = {
    CENTRAL: 'Central',
    EASTERN: 'Eastern',
    WESTERN: 'Western',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ModuleExecutorDataExtractTypeCd = {
    CONSTANT: 'Constant',
    PERIOD_CODE: 'PeriodCode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ModuleExecutorDatasetTypeCd = {
    CONFIGURATION: 'Configuration',
    MODIFIED_DATA_EXTRACT: 'Modified DataExtract',
    ORIGINAL_DATA_EXTRACT: 'Original DataExtract',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ModuleExecutorParmsArgTypeCd = {
    CONFIGURATION: 'Configuration',
    CONSTANT_DATASET: 'ConstantDataset',
    DATA_SET: 'DataSet',
    DYNAMIC_CONFIG: 'DynamicConfig',
    FILE: 'File',
    PERIOD_CODE: 'PeriodCode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ModuleExecutorSuccessfulCd = {
    FAILURE: 'Failure',
    SUCCESSFUL: 'Successful',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MoveModeCd = {
    EXCLUSIVE: 'Exclusive',
    LINEHAUL: 'Linehaul',
    SUPPLEMENTAL: 'Supplemental',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MovementExceptionTypeCd = {
    AD_HOC: 'AdHoc',
    DAMAGED: 'Damaged',
    DAMAGED_BUT_ACCEPTED: 'DamagedButAccepted',
    EXCP_NOTED: 'ExcpNoted',
    OVER: 'Over',
    OVER_BUT_ACCEPTED: 'OverButAccepted',
    REFUSED: 'Refused',
    SHORT: 'Short',
    UNDELIVERABLE: 'Undeliverable',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const MovementStatusCd = {
    CANCELLED: 'Cancelled',
    FINAL_DLVD: 'FinalDlvd',
    INTERIM_DLVRY: 'InterimDlvry',
    NOT_APPLICABLE: 'NotApplicable',
    NO_MVMT_ALLOWED: 'NoMvmtAllowed',
    ON_DOCK: 'OnDock',
    ON_TRAILER: 'OnTrailer',
    OUT_FOR_DLVRY: 'OutForDlvry',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NetExplosiveMassUomCd = {
    GRAMS: 'Grams',
    KILOGRAMS: 'Kilograms',
    MILLIGRAMS: 'Milligrams',
    OUNCES: 'Ounces',
    POUNDS: 'Pounds',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NextBestActionTypeCd = {
    LOAD: 'Load',
    STAGE: 'Stage',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NextBusinessDayOperationCd = {
    EAM_DAY: 'EamDay',
    HOLIDAY: 'Holiday',
    LH_DAY: 'LHDay',
    NEXT_BUSINESS_DAY: 'NextBusinessDay',
    NON_WK_DY: 'NonWkDy',
    PN_D_DAY: 'PnDDay',
    REVENUE: 'Revenue',
    SVC_DAY: 'SvcDay',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NodeTypeCd = {
    CARTAGE_AGENT: 'CartageAgent',
    CUSTOMER_LOCATION: 'CustomerLocation',
    DROP_LOCATION: 'DropLocation',
    SERVICE_CENTER: 'ServiceCenter',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NonDriveTimeLocationCd = {
    ANY: 'Any',
    DESTINATION: 'Destination',
    ENROUTE: 'Enroute',
    ORIGIN: 'Origin',
    UNKNOWN: 'Unknown',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NonDriveTimePaidCd = {
    PAID: 'Paid',
    SPECIAL: 'Special',
    UNPAID: 'Unpaid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NonWorkDayTypeCd = {
    HOLIDAY: 'Holiday',
    PN_D_PARTIAL_DAY: 'PnDPartialDay',
    SERVICE_EXEMPT_DAY: 'ServiceExemptDay',
    WEEKEND: 'Weekend',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NoteTypeCd = {
    OVERRIDE_DELIVERY_INSTRUCTIONS: 'OverrideDeliveryInstructions',
    OVERRIDE_INSTRUCTIONS: 'OverrideInstructions',
    OVERRIDE_OPERATIONS: 'OverrideOperations',
    OVERRIDE_PICKUP_INSTRUCTIONS: 'OverridePickupInstructions',
    ROUTE: 'Route',
    STOP: 'Stop',
    TRIP: 'Trip',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NotificationCd = {
    APPT_EXISTS: 'ApptExists',
    APPT_NOT_RQRD: 'ApptNotRqrd',
    NTFICTN_EXISTS: 'NtfictnExists',
    RE_APPT_CANDIDATE: 'ReApptCandidate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OptimizerParameterCd = {
    EQPCOSTMULTIPLIER: 'EQPCOSTMULTIPLIER',
    EQPCPH: 'EQPCPH',
    EQPCPHAFTERSOFTENDTM: 'EQPCPHAFTERSOFTENDTM',
    EQPCPHAFTERSOFTMAX: 'EQPCPHAFTERSOFTMAX',
    EQPCPHBFSOFTSTARTTM: 'EQPCPHBFSOFTSTARTTM',
    EQPCPKM: 'EQPCPKM',
    EQPCPUAFTRSOFTMXLOAD: 'EQPCPUAFTRSOFTMXLOAD',
    EQPCSTAFTRSOFTENDTM: 'EQPCSTAFTRSOFTENDTM',
    EQPFXCOST: 'EQPFXCOST',
    EQPLOADFACTOR: 'EQPLOADFACTOR',
    EQPMAXSOFTDURINSS: 'EQPMAXSOFTDURINSS',
    EQPPKUPCAPACITYLB: 'EQPPKUPCAPACITYLB',
    EQPPKUPCAPACITYPUP: 'EQPPKUPCAPACITYPUP',
    EQPRTDURINSS: 'EQPRTDURINSS',
    EQPSOFTENDTM: 'EQPSOFTENDTM',
    EQPSOFTSTARTENDTIME: 'EQPSOFTSTARTENDTIME',
    EQPSOFTSTARTTIME: 'EQPSOFTSTARTTIME',
    EQPSTARTENDTIME: 'EQPSTARTENDTIME',
    EQPTRVLDURMULTIPLE: 'EQPTRVLDURMULTIPLE',
    OPZCSTPERKMNXTPKUP: 'OPZCSTPERKMNXTPKUP',
    OPZDISTANCELIMIT: 'OPZDISTANCELIMIT',
    OPZDISTLMTNXTPKUP: 'OPZDISTLMTNXTPKUP',
    OPZDSTNCLMTCOSTPKM: 'OPZDSTNCLMTCOSTPKM',
    OPZEXPARM_10: 'OPZEXPARM10',
    OPZGBLENDTM: 'OPZGBLENDTM',
    OPZGBLSTARTTM: 'OPZGBLSTARTTM',
    OPZGRPDELAYDUR_0: 'OPZGRPDELAYDUR0',
    OPZGRPDELAYDUR_1: 'OPZGRPDELAYDUR1',
    OPZGRPDELAYDUR_2: 'OPZGRPDELAYDUR2',
    OPZINCLUDEPICKUPS: 'OPZINCLUDEPICKUPS',
    OPZMAXSEARCHLMT: 'OPZMAXSEARCHLMT',
    OPZPKUPFACTOR: 'OPZPKUPFACTOR',
    OPZPRIMRY: 'OPZPRIMRY',
    OPZTMOUT: 'OPZTMOUT',
    OPZVISITTYPEFXCOST: 'OPZVISITTYPEFXCOST',
    OPZVISITTYPEKMCOST: 'OPZVISITTYPEKMCOST',
    SEQ_VAR_THRESHOLD: 'SEQ_VAR_THRESHOLD',
    SHMCPH_AFTER_STARTTM: 'SHMCPH_AFTER_STARTTM',
    SHMCPH_B_4_STARTTM: 'SHMCPH_B4_STARTTM',
    SHMDLVRSOFTENDTM: 'SHMDLVRSOFTENDTM',
    SHMLOCK_STATCD: 'SHMLOCK_STATCD',
    SHMPKUPSTARTTM: 'SHMPKUPSTARTTM',
    SHMPRPTM: 'SHMPRPTM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OptimizerParameterTypeCd = {
    DRIVER: 'Driver',
    EQUIPMENT: 'Equipment',
    OPTIMIZER: 'Optimizer',
    SHIPMENT: 'Shipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OptimizerResultReasonCd = {
    EXTRATRLR: 'EXTRATRLR',
    LARGEPSE: 'LARGEPSE',
    UNRTD_1: 'UNRTD1',
    UNRTD_2: 'UNRTD2',
    UNRTD_3: 'UNRTD3',
    UNRTD_4: 'UNRTD4',
    UNRTD_5: 'UNRTD5',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OptimizerResultStatusCd = {
    ERROR: 'Error',
    SUCCESS: 'Success',
    WARNING: 'Warning',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OptimizerStatusCd = {
    ABORTED: 'Aborted',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    IN_PROGRESS: 'InProgress',
    NEW: 'New',
    REQUEST_UPLOADED: 'RequestUploaded',
    ROUTES_COMPLETED: 'RoutesCompleted',
    ROUTES_FAILED: 'RoutesFailed',
    TIME_OUT: 'TimeOut',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OriginalSourceCd = {
    DAILY: 'Daily',
    EDI: 'EDI',
    INTERNAL: 'Internal',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OsdCategoryCd = {
    DAMAGED: 'Damaged',
    OVERAGE: 'Overage',
    REFUSED: 'Refused',
    SHORT: 'Short',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OsdPayloadTypeCd = {
    EDGE_OSD: 'edge_osd',
    HH: 'hh',
    OVERAGE_APP: 'overage_app',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const OsdStatusCd = {
    D_CLOSED: 'd_closed',
    D_DISPO_NOT_RECEIVED: 'd_dispo_not_received',
    D_DISPO_RECEIVED: 'd_dispo_received',
    D_INSP_IN_PROGRESS: 'd_insp_in_progress',
    D_INSP_RECEIVED: 'd_insp_received',
    D_NOT_STARTED: 'd_not_started',
    D_ON_HAND_NOTICE: 'd_on_hand_notice',
    D_READY_TO_SHIP: 'd_ready_to_ship',
    D_SEND_SALVAGE_RQST: 'd_send_salvage_rqst',
    D_WAITING_FOR_SHPR: 'd_waiting_for_shpr',
    O_CLOSED: 'o_closed',
    O_CONS_FOUND: 'o_cons_found',
    O_ENTRY_IN_OVRG_APP: 'o_entry_in_ovrg_app',
    O_MATCH_FOUND: 'o_match_found',
    O_MATCH_NOT_FOUND: 'o_match_not_found',
    O_NOT_STARTED: 'o_not_started',
    O_READY_TO_SHIP: 'o_ready_to_ship',
    O_SALVAGE_APPROVAL: 'o_salvage_approval',
    O_SEND_SALVAGE_RQST: 'o_send_salvage_rqst',
    O_SHPR_FOUND: 'o_shpr_found',
    R_CLOSED: 'r_closed',
    R_DISPO_NOT_RECEIVED: 'r_dispo_not_received',
    R_DISPO_RECEIVED: 'r_dispo_received',
    R_INSP_IN_PROGRESS: 'r_insp_in_progress',
    R_INSP_RECEIVED: 'r_insp_received',
    R_NOT_STARTED: 'r_not_started',
    R_ON_HAND_NOTICE: 'r_on_hand_notice',
    R_READY_TO_SHIP: 'r_ready_to_ship',
    R_SEND_SALVAGE_RQST: 'r_send_salvage_rqst',
    R_WAITING_FOR_SHPR: 'r_waiting_for_shpr',
    S_APB_EMAIL_SENT: 's_apb_email_sent',
    S_CHECKLIST_COMPLETE: 's_checklist_complete',
    S_CLOSED: 's_closed',
    S_CONTACTED_CONS: 's_contacted_cons',
    S_CONTACTED_SHPR: 's_contacted_shpr',
    S_INITIATE_IMS_RPT: 's_initiate_ims_rpt',
    S_NOT_STARTED: 's_not_started',
    S_READY_TO_SHIP: 's_ready_to_ship',
    S_SHPMT_FOUND: 's_shpmt_found',
    S_SHPMT_NOT_FOUND: 's_shpmt_not_found',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ParentActivityTypeCd = {
    DOCK_ACTIVITY: 'DockActivity',
    TRIP_ACTIVITY: 'TripActivity',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ParkingLocationTypeCd = {
    APPT_TRAILERS: 'ApptTrailers',
    EMPTY_TRAILERS: 'EmptyTrailers',
    TRACTORS: 'Tractors',
    TRAP: 'Trap',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PartyRoleCd = {
    INBOUND: 'Inbound',
    INBOUND_AND_OUTBOUND: 'InboundAndOutbound',
    OUTBOUND: 'Outbound',
    THIRD_PARTY: 'ThirdParty',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PartyShipmentRoleCd = {
    ALL: 'All',
    BILL_TO: 'Bill-To',
    CONSIGNEE: 'Consignee',
    SHIPPER: 'Shipper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PayformActivityLocCd = {
    ANY: 'Any',
    DEST: 'Dest',
    ENROUTE: 'Enroute',
    ORIGIN: 'Origin',
    UNKNOWN: 'Unknown',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PayformDetailCd = {
    DRIVER_ACTIVITIES: 'DriverActivities',
    DRIVER_PAYFORMS: 'DriverPayforms',
    EMPLOYEE_DETAILS: 'EmployeeDetails',
    NON_DRIVE_TIME_TYPES: 'NonDriveTimeTypes',
    NOTES: 'Notes',
    SCHEDULES: 'Schedules',
    SCHEDULE_DETOURS: 'ScheduleDetours',
    SCHEDULE_TRAILERS: 'ScheduleTrailers',
    WORK_STANDARDS: 'WorkStandards',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PayformNoteTypeCd = {
    ACTIVITY: 'Activity',
    DETOUR: 'Detour',
    PAYFORM: 'Payform',
    SCHEDULE: 'Schedule',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PayformPaidTypeCd = {
    PAID: 'Paid',
    SPECIAL: 'Special',
    UNPAID: 'Unpaid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PayformStatusCd = {
    APPROVED: 'Approved',
    DELETED: 'Deleted',
    NEW: 'New',
    RETURNED: 'Returned',
    SUBMITTED: 'Submitted',
    TRANSMITTED: 'Transmitted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PaymentMethodCd = {
    BOTH: 'Both',
    COLL: 'Coll',
    PPD: 'Ppd',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PaymentStatusExternalCd = {
    CHECK_CASHED: 'CheckCashed',
    DECLINED: 'Declined',
    NO_PAYMENT_STATUS: 'NoPaymentStatus',
    PAYMENT_ISSUED: 'PaymentIssued',
    PAYMENT_PROCESSING: 'PaymentProcessing',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PaymentStatusInternalCd = {
    CHECK_CASHED: 'CheckCashed',
    CHECK_VOIDED: 'CheckVoided',
    DECLINED: 'Declined',
    PAYMENT_CANCELLED: 'PaymentCancelled',
    PAYMENT_ISSUED: 'PaymentIssued',
    PAYMENT_ON_HOLD: 'PaymentOnHold',
    PAYMENT_REQUESTED: 'PaymentRequested',
    PENDING_TRANSMISSION: 'PendingTransmission',
    SENT_TO_ORACLE: 'SentToOracle',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PaymentTypeCd = {
    CASH: 'Cash',
    COD: 'COD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PhotoTypeCd = {
    CLOSE_PHOTO: 'ClosePhoto',
    LOAD_PHOTO: 'LoadPhoto',
    OPEN_PHOTO: 'OpenPhoto',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestHoldTypeCd = {
    CREDIT: 'Credit',
    OPERATIONS: 'Operations',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestReasonCategoryCd = {
    CANCEL_REASON: 'CancelReason',
    RESCHEDULE_REASON: 'RescheduleReason',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestReasonCategoryRefCd = {
    ADMIN_ISSUE: 'AdminIssue',
    CARGO_ISSUE: 'CargoIssue',
    EQUIPMENT_PLANNING_ISSUE: 'EquipmentPlanningIssue',
    EXTERNAL_ISSUE: 'ExternalIssue',
    TIMING_ISSUE: 'TimingIssue',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestReasonSubCategoryRefCd = {
    CUSTOMER_RELATED: 'CustomerRelated',
    OTHER: 'Other',
    XPO_RELATED: 'XpoRelated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestReasonTypeCd = {
    BOTH_REASON: 'BothReason',
    CANCEL_REASON: 'CancelReason',
    RESCHEDULE_REASON: 'RescheduleReason',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequestReinstateTypeCd = {
    PICKUP_REQUEST: 'PickupRequest',
    PICKUP_REQUEST_SHIPMENT: 'PickupRequestShipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupRequesterRoleCd = {
    CONSIGNEE: 'Consignee',
    SHIPPER: 'Shipper',
    THIRD_PARTY: 'ThirdParty',
    UNDEFINED: 'Undefined',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupShipmentSourceCd = {
    DAILY: 'Daily',
    EDI: 'EDI',
    INTERNAL: 'Internal',
    MANUAL: 'Manual',
    MIXED: 'Mixed',
    OPERATIONAL: 'Operational',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupShipmentStatusCd = {
    ASSIGNED: 'Assigned',
    CANCELLED: 'Cancelled',
    CONFIRM_ON_BOARD: 'ConfirmOnBoard',
    DELETED: 'Deleted',
    DISPATCHED: 'Dispatched',
    MERGED: 'Merged',
    NEW: 'New',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupShipmetActionCd = {
    ADD: 'Add',
    DELETE: 'Delete',
    MOVE: 'Move',
    NO_ACTION: 'NoAction',
    OPERATIONAL_MOVE: 'OperationalMove',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupSourceCd = {
    DAILY: 'Daily',
    EDI: 'EDI',
    INTERNAL: 'Internal',
    MANUAL: 'Manual',
    MIXED: 'Mixed',
    OPERATIONAL: 'Operational',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupStatusCd = {
    ASSIGNED: 'Assigned',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    CONFIRM_ON_BOARD: 'ConfirmOnBoard',
    DELETED: 'Deleted',
    DISPATCHED: 'Dispatched',
    MERGED_TO: 'MergedTo',
    NEW: 'New',
    PRE_ASSIGNED: 'Pre-assigned',
    SCHEDULED: 'Scheduled',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PickupTypeCd = {
    DT: 'DT',
    HE: 'HE',
    HL: 'HL',
    PU: 'PU',
    SE: 'SE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PnDAutoPrintOptionCd = {
    DISPATCH: 'Dispatch',
    DO_NOT_AUTO_PRINT: 'DoNotAutoPrint',
    TRAILER_CLOSE: 'TrailerClose',
    TRIP_COMPLETE: 'TripComplete',
    TRIP_RETURN: 'TripReturn',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PnDReportTypeCd = {
    OUTBOUND_BREAKOUT_MANIFEST: 'OutboundBreakoutManifest',
    PN_D_MANIFEST: 'PnDManifest',
    STRING_MANIFEST_REPORT: 'StringManifestReport',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PnDRoleCd = {
    DISPATCHER: 'Dispatcher',
    PLANNER: 'Planner',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PolygonTypeCd = {
    AREA: 'Area',
    BOUNDARY: 'Boundary',
    FENCE: 'Fence',
    SERVICE_CENTER: 'ServiceCenter',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PricingAnalysisRunTypeCd = {
    ADHOC: 'Adhoc',
    RFP: 'RFP',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PricingRulesetOwnerCd = {
    BILL_TO: 'BillTo',
    CONSIGNEE: 'Consignee',
    SHIPPER: 'Shipper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PricingTypeCd = {
    REGIONAL: 'Regional',
    STRATEGIC: 'Strategic',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const PrintFBDSDocumentsTypeCd = {
    DOT_MATRIX: 'DotMatrix',
    LASER: 'Laser',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProBolUsageStatusCd = {
    ASSIGNED: 'Assigned',
    IN_USE: 'InUse',
    LABEL_CHECKOUT: 'LabelCheckout',
    UNASSIGNED: 'Unassigned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProCheckoutTypeCd = {
    CUSTOMER: 'Customer',
    DRIVER: 'Driver',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProInUseCd = {
    ELECTRONIC: 'Electronic',
    GENERAL_CLAIMS_BUSINESS: 'GeneralClaimsBusiness',
    LABEL: 'Label',
    LEGACY: 'Legacy',
    MOVER_SHIPMENT: 'MoverShipment',
    NOT_USED: 'NotUsed',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProNbrTypeCd = {
    GENERAL_CLAIMS_BUSINESS: 'GeneralClaimsBusiness',
    MOVER: 'Mover',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProPadTypeCd = {
    CA_BLUE: 'CaBlue',
    CA_BLUE_YELLOW: 'CaBlueYellow',
    US_BLUE: 'UsBlue',
    US_BLUE_YELLOW: 'UsBlueYellow',
    YELLOW: 'Yellow',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProPrintedLabelStatusCd = {
    ASSIGNED: 'Assigned',
    IN_WAREHOUSE: 'InWarehouse',
    PRINT_ORDERED: 'PrintOrdered',
    SHIPPED: 'Shipped',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProRequestDetailStatusCd = {
    APPROVED: 'Approved',
    CANCEL: 'Cancel',
    DECLINED: 'Declined',
    IN_PROCESS: 'InProcess',
    NEW: 'New',
    WAITING_REQUESTER_RESPONSE: 'WaitingRequesterResponse',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProRequestStatusCd = {
    CANCEL: 'Cancel',
    COMPLETED: 'Completed',
    IN_PROCESS: 'InProcess',
    NEW: 'New',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProStatusCd = {
    ASSIGNED_TO_EBILL: 'AssignedToEbill',
    AVAILABLE: 'Available',
    IN_USE_BY_EBILL: 'InUseByEbill',
    NO_STICKER_AVAILABLE: 'NoStickerAvailable',
    RECEIVED_ON_FILE_AND_BILLED: 'ReceivedOnFileAndBilled',
    RECEIVED_ON_FILE_BUT_NOT_BILLED: 'ReceivedOnFileButNotBilled',
    RECEIVED_PURGED_MAYBE_ON_FBA: 'ReceivedPurgedMaybeOnFba',
    VOIDED: 'Voided',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProSummaryTypeCd = {
    CUSTOMER: 'Customer',
    SIC: 'Sic',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProTrackingLabelStatusCd = {
    ASSIGNED: 'Assigned',
    IN_USE: 'InUse',
    LABEL_CHECKOUT: 'LabelCheckout',
    UNASSIGNED: 'Unassigned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ProcessStatusCd = {
    COMPLETED: 'Completed',
    FAILED: 'Failed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const QueueNameCd = {
    CREDIT: 'Credit',
    GOVERNMENT: 'Government',
    GROUPING: 'Grouping',
    LOCAL_REQUEST: 'LocalRequest',
    MEXICO: 'Mexico',
    NAQQ: 'NAQQ',
    NATIONAL_REQ: 'NationalReq',
    NMI: 'NMI',
    PRIORITY: 'Priority',
    SPECIAL_ACCOUNTS: 'SpecialAccounts',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RadioactivityUomCd = {
    CURIE: 'Curie',
    GIGABECQUEREL: 'Gigabecquerel',
    KILOBECQUEREL: 'Kilobecquerel',
    MEGABECQUEREL: 'Megabecquerel',
    MICROCURIE: 'Microcurie',
    MILLICURIE: 'Millicurie',
    NANOCURIE: 'Nanocurie',
    TERABECQUEREL: 'Terabecquerel',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateDiscountSourceCd = {
    DPRT: 'DPRT',
    DPWT: 'DPWT',
    DSTD: 'DSTD',
    DTLP: 'DTLP',
    LNFT: 'LNFT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateQuoteAccessorialCd = {
    AFTER_BUSINESS_HOURS_DELIVERY: 'AfterBusinessHoursDelivery',
    APPOINTMENT: 'Appointment',
    BLIND_SHIPMENT: 'BlindShipment',
    COD_CANCEL_CHANGE: 'CODCancelChange',
    CONTAINER_SPOT_DELIVERY: 'ContainerSpotDelivery',
    CONTAINER_STATION: 'ContainerStation',
    CORRECTION_TO_BOL: 'CorrectionToBOL',
    CUBIC_CAPACITY: 'CubicCapacity',
    DEST_CONSOLIDATION_HANDLING: 'DestConsolidationHandling',
    DEST_CONSTRUCTION_UTILITY: 'DestConstructionUtility',
    DEST_HOLIDAY_WEEKEND: 'DestHolidayWeekend',
    DEST_INSIDE_DELIVERY: 'DestInsideDelivery',
    DEST_MINE_GOVT_AIRPORT: 'DestMineGovtAirport',
    DEST_RECONSIGNMENT: 'DestReconsignment',
    DEST_SORTING_SEGREGATING: 'DestSortingSegregating',
    EXCESSIVE_LENGTH: 'ExcessiveLength',
    EXCESSIVE_VALUE_CHARGE: 'ExcessiveValueCharge',
    EXHIBITION_DESTINATION: 'ExhibitionDestination',
    EXHIBITION_ORIG: 'ExhibitionOrig',
    FREEZABLE_PROTECTION: 'FreezableProtection',
    GUARANTEED_BY_NOON: 'GuaranteedByNoon',
    INSPECTION_OF_SHIPMENT: 'InspectionOfShipment',
    INSTANT_GUARANTEED_SERVICE: 'InstantGuaranteedService',
    IN_BOND_CUSTOMS_INSP_DELAY: 'InBondCustomsInspDelay',
    IN_BOND_CUSTOMS_REL_FORMS: 'InBondCustomsRelForms',
    IN_BOND_FREIGHT: 'InBondFreight',
    IN_BOND_TIR_CARNET: 'InBondTIRCarnet',
    LIFT_GATE_SERVICE: 'LiftGateService',
    LIFT_GATE_SERVICES: 'LiftGateServices',
    NOTIFICATION_PRIOR_TO_DELIVERY: 'NotificationPriorToDelivery',
    ORIG_CONSOLIDATION_HANDLING: 'OrigConsolidationHandling',
    ORIG_CONSTRUCTION_UTILITY: 'OrigConstructionUtility',
    ORIG_CONTAINER_STATION: 'OrigContainerStation',
    ORIG_HOLIDAY_WEEKEND: 'OrigHolidayWeekend',
    ORIG_INSIDE_PICKUP: 'OrigInsidePickup',
    ORIG_MINE_GOVT_AIRPORT: 'OrigMineGovtAirport',
    ORIG_RECONSIGNMENT: 'OrigReconsignment',
    ORIG_SORTING_SEGREGATING: 'OrigSortingSegregating',
    PIERS_WHARVES_LOADING: 'PiersWharvesLoading',
    PIERS_WHARVES_UNLOADING: 'PiersWharvesUnloading',
    RAPID_REMOTE_SERVICE: 'RapidRemoteService',
    REDELIVERY: 'Redelivery',
    RESIDENTIAL_DESTINATION: 'ResidentialDestination',
    RESIDENTIAL_ORIG: 'ResidentialOrig',
    RETURN_CHECK: 'ReturnCheck',
    RETURN_UNDELIVERED_SHIPMENT: 'ReturnUndeliveredShipment',
    SINGLE_SHIPMENT: 'SingleShipment',
    SUFFERANCE_CANADA_NBONQC: 'SufferanceCanadaNBONQC',
    SUFFERANCE_CANADA_OTHER: 'SufferanceCanadaOther',
    SUFFERANCE_EXAMINATION: 'SufferanceExamination',
    SUFFERANCE_HANDLING: 'SufferanceHandling',
    SUFFERANCE_INSPECTION_DELAY: 'SufferanceInspectionDelay',
    SUFFERANCE_REMANIFEST: 'SufferanceRemanifest',
    TIME_DATE_CRITICAL: 'TimeDateCritical',
    WEIGH_REWEIGH_OF_SHIPMENT: 'WeighReweighOfShipment',
    WILL_CALL: 'WillCall',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateQuoteTypeCd = {
    CUSTOMER_SPECIFIC: 'CustomerSpecific',
    GENERIC: 'Generic',
    SHIPMENT: 'Shipment',
    SPOT_QUOTE: 'SpotQuote',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateRequestSubTypeCd = {
    GUAR_FAIL: 'GuarFail',
    GUAR_NOSA: 'GuarNosa',
    WRNT_FAIL: 'WrntFail',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateRequestTypeCd = {
    INVOICE: 'Invoice',
    MANUAL: 'Manual',
    PREVIEW: 'Preview',
    RATE_PASS: 'RatePass',
    RATE_QUOTE: 'RateQuote',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RateStatusCd = {
    N: 'N',
    P: 'P',
    Y: 'Y',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingCurrencyCd = {
    CANADIAN_DOLLAR: 'CanadianDollar',
    US_DOLLAR: 'UsDollar',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingPartyLocationTypeCd = {
    CONSTRUCTION_UTILITY_SITES: 'Construction/UtilitySites',
    EXHIBITION: 'Exhibition',
    GOVERNMENT: 'Government',
    PIERS: 'Piers',
    RESIDENTIAL: 'Residential',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingQueueClassTypeCd = {
    AUDIT: 'Audit',
    ENTRY: 'Entry',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingShipmentFileTypeCd = {
    CUSTOMER_SHIPMENT: 'CustomerShipment',
    XPO_SHIPMENT: 'XpoShipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingStatusCd = {
    FAILED: 'Failed',
    SUCCESSFUL: 'Successful',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RatingWhatIfRequestStatusCd = {
    COMPLETED: 'Completed',
    ERROR: 'Error',
    IN_PROGRESS: 'InProgress',
    OPEN: 'Open',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RebuttalExternalStatusCd = {
    APPROVED: 'Approved',
    CUSTOMER_CANCELLED: 'CustomerCancelled',
    DECLINED: 'Declined',
    REBUTTAL_RECEIVED: 'RebuttalReceived',
    UNDER_REVIEW: 'UnderReview',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RebuttalInternalStatusCd = {
    APPROVED: 'Approved',
    CEO_PENDING_APPROVAL: 'CeoPendingApproval',
    CUSTOMER_CANCELLED: 'CustomerCancelled',
    DECLINED: 'Declined',
    DIRECTOR_PENDING_APPROVAL: 'DirectorPendingApproval',
    EXAMINER_PENDING_APPROVAL: 'ExaminerPendingApproval',
    MANAGER_PENDING_APPROVAL: 'ManagerPendingApproval',
    PRESIDENT_PENDING_APPROVAL: 'PresidentPendingApproval',
    REBUTTAL_RECEIVED: 'RebuttalReceived',
    RVP_PENDING_APPROVAL: 'RVPPendingApproval',
    RVP_SALES_PENDING_APPROVAL: 'RVPSalesPendingApproval',
    SVP_OF_OPS_PENDING_APPROVAL: 'SVPOfOpsPendingApproval',
    SVP_SALES_PENDING_APPROVAL: 'SVPSalesPendingApproval',
    UNDER_REVIEW: 'UnderReview',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RebuttalReasonCd = {
    ADD_DOCUMENTS: 'AddDocuments',
    AMENDING_CLAIM_AMOUNT: 'AmendingClaimAmount',
    CONCEALED_DAMAGE: 'ConcealedDamage',
    CONTRACT_DISCREPANCY: 'ContractDiscrepancy',
    FREIGHT_CHARGES: 'FreightCharges',
    OTHER: 'Other',
    POLICY_PAY: 'PolicyPay',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ReducedServiceSatelliteTypeCd = {
    INTERLINE: 'INTERLINE',
    NON_INTERLINE: 'NON_INTERLINE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RefusedReasonCd = {
    ARRIVED_TOO_EARLY: 'ArrivedTooEarly',
    ARRIVED_TOO_LATE: 'ArrivedTooLate',
    CONSIGNEE_REFUSED_COLLED: 'ConsigneeRefusedColled',
    CUSTOMER_WANTED_EARLIER: 'CustomerWantedEarlier',
    DID_NOT_ORDER: 'DidNotOrder',
    DUPLICATE_ORDER: 'DuplicateOrder',
    INSUFFICIENT_DELIVERY_TIME: 'InsufficientDeliveryTime',
    MANUFACTURERS_DEFECT: 'ManufacturersDefect',
    ORDER_CANCELLED: 'OrderCancelled',
    OTHER: 'Other',
    SENT_TO_WRONG_LOCATION: 'SentToWrongLocation',
    UNAUTHORIZED_RETURN: 'UnauthorizedReturn',
    WRONG_ORDER: 'WrongOrder',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ReportsCd = {
    D: 'D',
    S: 'S',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RequestedChangeCd = {
    BUSINESS_NAME_ALIAS: 'BusinessNameAlias',
    CONTACT: 'Contact',
    INVOICING: 'Invoicing',
    LOCATION: 'Location',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RequestedChangeItemActionCd = {
    ADD: 'Add',
    DELETE: 'Delete',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RequestedChangeTypeCd = {
    BUSINESS_NAME_ALIAS: 'BusinessNameAlias',
    CONTACT: 'Contact',
    FINANCIAL: 'Financial',
    INVOICE_INSTRUCTION: 'InvoiceInstruction',
    NAME_AND_ADDRESS: 'NameAndAddress',
    SERVICE_RECIPIENT: 'ServiceRecipient',
    TRUE_DEBTOR: 'True Debtor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RerateTypeCd = {
    BATCH_RERATE: 'BatchRerate',
    MASS_RERATE: 'MassRerate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ReturnInstrRetainCheckCd = {
    DEPARTMENT_OF_CLAIMS: 'DepartmentOfClaims',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ReturnReasonCd = {
    DRIVER_RELATED: 'DriverRelated',
    INSUFFICIENT_DELIVERY_TIME: 'InsufficientDeliveryTime',
    MECHANICAL_BREAKDOWN: 'MechanicalBreakdown',
    MISSED_DELIVERY: 'MissedDelivery',
    OTHER_CARRIER: 'OtherCarrier',
    PACKAGE_MISSORTED: 'PackageMissorted',
    PREVIOUS_STOP_DELIVERY: 'PreviousStopDelivery',
    SHIPPER_RELATED: 'ShipperRelated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RevenueDayCd = {
    HOLIDAY: 'Holiday',
    REVENUE_DAY: 'RevenueDay',
    WEEKEND_DAY: 'WeekendDay',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ReweighStatusCd = {
    APPROVED: 'Approved',
    DECLINED: 'Declined',
    ERROR: 'Error',
    NEW: 'New',
    PENDING: 'Pending',
    REPLACED: 'Replaced',
    RESUBMIT: 'Resubmit',
    WITHIN_TOLERANCE: 'WithinTolerance',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteActionCd = {
    RELEASE: 'Release',
    RENAME: 'Rename',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteAutoSequenceTypeCd = {
    DOMICILE: 'Domicile',
    GO_FAR: 'GoFar',
    PICKUP_POINT: 'PickupPoint',
    PINNED: 'Pinned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteBalancingTypeCd = {
    AUTOSEQUENCE: 'Autosequence',
    MANUAL_SEQUENCE: 'ManualSequence',
    NO_ACTION: 'NoAction',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteCategoryCd = {
    DELIVERY: 'Delivery',
    DOCK: 'Dock',
    PLANNING: 'Planning',
    UNDEFINED: 'Undefined',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteDetailCd = {
    ROUTE_HIST: 'RouteHist',
    SHIPMENTS: 'Shipments',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteEquipmentTypeCd = {
    DOLLY: 'Dolly',
    OTHER: 'Other',
    POWER_TRACTOR: 'PowerTractor',
    STRAIGHT_TRUCK: 'StraightTruck',
    TRAILER: 'Trailer',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteStatusCd = {
    CANCELLED: 'Cancelled',
    CLOSED: 'Closed',
    COMPLETE: 'Complete',
    DISPATCHED: 'Dispatched',
    DOCK: 'Dock',
    DROPPED: 'Dropped',
    LOADING: 'Loading',
    NEW: 'New',
    RELEASED: 'Released',
    RETURNING: 'Returning',
    UNRELEASED: 'Unreleased',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RouteTypeCd = {
    NOT_ROUTED: 'NotRouted',
    ROUTED: 'Routed',
    STAGED: 'Staged',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RschCnclReasonCd = {
    CUSTOMER_REQUEST: 'Customer Request',
    EQUIPMENT_FAILURE: 'Equipment Failure',
    MISSED_PICKUP_BY_XPO: 'Missed Pickup by XPO',
    OTHER: 'Other',
    UNDEFINED: 'Undefined',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleActiveTypeCd = {
    INACTIVE: 'Inactive',
    PRODUCTION: 'Production',
    TEST: 'Test',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleExpressionValueTypeCd = {
    BETWEEN: 'Between',
    BOOLEAN: 'Boolean',
    DATE_TIME: 'DateTime',
    LIST: 'List',
    NUMBER: 'Number',
    NUMBER_LIST: 'NumberList',
    TEXT: 'Text',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleFailureReasonCd = {
    SRN_NOT_ENTERED: 'SrnNotEntered',
    SRN_NOT_VALID: 'SrnNotValid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleLogicalOperatorCd = {
    AND: 'And',
    OR: 'Or',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleOperatorCd = {
    ANY_BETWEEN: 'AnyBetween',
    ANY_EQUAL: 'AnyEqual',
    ANY_GREATER_THAN: 'AnyGreaterThan',
    ANY_GREATER_THAN_OR_EQUAL: 'AnyGreaterThanOrEqual',
    ANY_IN: 'AnyIn',
    ANY_LESS_THAN: 'AnyLessThan',
    ANY_LESS_THAN_OR_EQUAL: 'AnyLessThanOrEqual',
    ANY_MATCHES: 'AnyMatches',
    ANY_NOT_BETWEEN: 'AnyNotBetween',
    ANY_NOT_EQUAL: 'AnyNotEqual',
    ANY_NOT_IN: 'AnyNotIn',
    ANY_NOT_MATCHES: 'AnyNotMatches',
    BETWEEN: 'Between',
    EQUAL_TO: 'EqualTo',
    GREATER_THAN: 'GreaterThan',
    GREATER_THAN_OR_EQUAL: 'GreaterThanOrEqual',
    IN: 'In',
    LESS_THAN: 'LessThan',
    LESS_THAN_OR_EQUAL: 'LessThanOrEqual',
    MATCHES: 'Matches',
    NOT_BETWEEN: 'NotBetween',
    NOT_EQUAL_TO: 'NotEqualTo',
    NOT_IN: 'NotIn',
    NOT_MATCHES: 'NotMatches',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleOverrideReasonCd = {
    SRN_AVAILABLE_NOT_VALID: 'SrnAvailableNotValid',
    SRN_NOT_AVAILABLE: 'SrnNotAvailable',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RuleShmEntityTypeCd = {
    ACCESSORIAL: 'Accessorial',
    COMMODITY: 'Commodity',
    SUPP_REF_NBR: 'SuppRefNbr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RunShiftCd = {
    BYPASS: 'Bypass',
    EXEC: 'Exec',
    FAC: 'FAC',
    OUTBOUND: 'Outbound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const RwgLogHeaderMoreInfoCd = {
    PSR_BC_RECOVERY: 'PsrBcRecovery',
    UP_COR_ST_FR_ERR_NO_SHM: 'UpCorStFrErrNoShm',
    UP_COR_ST_FR_ERR_SUCC: 'UpCorStFrErrSucc',
    UP_COR_ST_FR_PEND_SUCC: 'UpCorStFrPendSucc',
    UP_COR_ST_NO_BC_FOUND: 'UpCorStNoBcFound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SalvageRequestStatusCd = {
    APPROVED_FOR_CMK: 'ApprovedForCMK',
    APPROVED_FOR_COMMON_DISPOSAL: 'ApprovedForCommonDisposal',
    APPROVED_FOR_COMPANY_USE: 'ApprovedForCompanyUse',
    APPROVED_FOR_CSV: 'ApprovedForCSV',
    APPROVED_FOR_REGULATED_DISPOSAL: 'ApprovedForRegulatedDisposal',
    CLOSED: 'Closed',
    CLOSED_NOT_APPROVED: 'ClosedNotApproved',
    CLOSED_RETURN_TO_CUSTOMER: 'ClosedReturnToCustomer',
    FEEDBACK_SUBMITTED: 'FeedbackSubmitted',
    INSPECTION_REPORT_NEEDED: 'InspectionReportNeeded',
    OPEN: 'Open',
    REQUEST_FOR_FEEDBACK: 'RequestForFeedback',
    REQUEST_FOR_PHOTOS: 'RequestForPhotos',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SalvageRequestTypeCd = {
    COMMON_DISPOSAL: 'CommonDisposal',
    COMPANY_USE: 'CompanyUse',
    HAZ_MAT_REGULATED_DISPOSAL: 'HazMatRegulatedDisposal',
    MOVE_TO_CMK: 'MoveToCMK',
    MOVE_TO_CSV: 'MoveToCSV',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SatelliteTypeCd = {
    CUSTOMER: 'CUSTOMER',
    INTERMODAL: 'INTERMODAL',
    REDUCED_SERVICE: 'REDUCED_SERVICE',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ScheduleStatusCd = {
    ARRIVED: 'Arrived',
    COMPLETED: 'Completed',
    DELAYED: 'Delayed',
    DISPATCHED: 'Dispatched',
    ENROUTE: 'Enroute',
    HELD: 'Held',
    NOT_APPLICABLE: 'NotApplicable',
    PLAN: 'Plan',
    TERMINATED: 'Terminated',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ScoEventStatusCd = {
    DELIVERED: 'Delivered',
    FAILED: 'Failed',
    QUEUED: 'Queued',
    REVIEWED: 'Reviewed',
    SUCCESSFUL: 'Successful',
    TEXT_FROM_DEVICE: 'TextFromDevice',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ScoEventSubTypeCd = {
    BREAK: 'Break',
    DELIVERY: 'Delivery',
    DRIVER: 'Driver',
    DROP: 'Drop',
    EXCLUDE_TRAILER: 'ExcludeTrailer',
    FORCED: 'Forced',
    GATE: 'Gate',
    HOOK: 'Hook',
    HOOK_EMPTY: 'HookEmpty',
    HOOK_LOADED: 'HookLoaded',
    INVALID: 'Invalid',
    MSG_FROM_DSR: 'MsgFromDsr',
    MSG_TO_DSR: 'MsgToDsr',
    NORMAL_PICKUP: 'NormalPickup',
    OTHER: 'Other',
    PLAN_TRLR_ACTN: 'PlanTrlrActn',
    REUSE_TIMEOUT: 'ReuseTimeout',
    ROUTE: 'Route',
    ROUTE_SHIPMENT: 'RouteShipment',
    SPOT_EMPTY: 'SpotEmpty',
    SPOT_LOADED: 'SpotLoaded',
    STOP: 'Stop',
    TRIP: 'Trip',
    TRLR_CON: 'TrlrCon',
    VALID: 'Valid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ScoEventTypeCd = {
    ARRIVE: 'Arrive',
    ASSIGN: 'Assign',
    COMPLETE: 'Complete',
    CONVERT: 'Convert',
    DEPART: 'Depart',
    DISPATCH: 'Dispatch',
    ENTER: 'Enter',
    LEAVE: 'Leave',
    LOGIN: 'Login',
    LOGOFF: 'Logoff',
    RELEASE: 'Release',
    RETURN: 'Return',
    START: 'Start',
    STOP: 'Stop',
    UNASSIGN: 'Unassign',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SeaNotifyEventCd = {
    ALL_SHORT: 'AllShort',
    APPT_REQUIRED_AT_DEST: 'ApptRequiredAtDest',
    ARRIVED_AT_DEST: 'ArrivedAtDest',
    ARRIVED_AT_INTERIM: 'ArrivedAtInterim',
    ATTEMPTED_DLVRY: 'AttemptedDlvry',
    AT_DEST: 'AtDest',
    AT_INTERIM: 'AtInterim',
    AT_ORIGIN: 'AtOrigin',
    AWAITING_UNLOAD_AT_CONSIGNEE: 'AwaitingUnloadAtConsignee',
    BOL_IMAGE_AVAILABLE: 'BolImageAvailable',
    CONSOLIDATING_PER_CONSIGNEE: 'ConsolidatingPerConsignee',
    DELAYED_EN_ROUTE_TO_DEST: 'DelayedEnRouteToDest',
    DELAYED_EN_ROUTE_TO_INTERIM: 'DelayedEnRouteToInterim',
    DELIVERED: 'Delivered',
    DLRY_NOT_ATTEMPTED: 'DlryNotAttempted',
    DLVRD_PART_SHORT: 'DlvrdPartShort',
    DLVRY_ATTEMPTED: 'DlvryAttempted',
    DLVRY_RECEIPT_IMAGE_AVAILABLE: 'DlvryReceiptImageAvailable',
    ENROUTE_FROM_SEATTLE_TO_ALASKA: 'EnrouteFromSeattleToAlaska',
    ENROUTE_TO_HAWAII: 'EnrouteToHawaii',
    ENROUTE_TO_PUERTO_RICO: 'EnrouteToPuertoRico',
    EN_ROUTE_TO_DEST: 'EnRouteToDest',
    EN_ROUTE_TO_INTERIM: 'EnRouteToInterim',
    FINAL_DLVRY_PENDING_REVIEW: 'FinalDlvryPendingReview',
    FOLLOW_UP_DELAYED: 'FollowUpDelayed',
    FOLLOW_UP_ON_TIME: 'FollowUpOnTime',
    HOLD_FOR_CARTAGE_AT_DEST: 'HoldForCartageAtDest',
    HOLD_FOR_CUSTOMS_AT_DEST: 'HoldForCustomsAtDest',
    INTL_SHIPMEN_FROM_MX: 'IntlShipmenFromMX',
    INTL_SHIPMEN_TO_MX: 'IntlShipmenToMX',
    LATE: 'Late',
    LATE_NO_DELAY_NOTIFICATION_SENT: 'LateNoDelayNotificationSent',
    NON_MVMT_PRO: 'NonMvmtPro',
    OUT_FOR_DLVRY: 'OutForDlvry',
    OVERAGE: 'Overage',
    PICKUP_UP: 'PickupUp',
    POSSIBLE_DELAY_NOTIFICATION: 'PossibleDelayNotification',
    RECORDED_IN_SYSTEM: 'RecordedInSystem',
    REFUSED_DLVRY: 'RefusedDlvry',
    REFUSED_FOR_DAMAGE: 'RefusedForDamage',
    RETURNED_NO_ATTEMPT_TO_DLVRY: 'ReturnedNoAttemptToDlvry',
    SHIPMENT_CANCELLED: 'ShipmentCancelled',
    TRANSFER: 'Transfer',
    UNDELIVERABLE: 'Undeliverable',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceCalculationStatusCd = {
    ALL_SHORT: 'AllShort',
    APPT: 'Appt',
    ATTEMPTED: 'Attempted',
    CALCULATED_FROM: 'CalculatedFrom',
    CANNOT_CALCULATE: 'CannotCalculate',
    CARTAGE: 'Cartage',
    DAMAGED: 'Damaged',
    FINAL: 'Final',
    HOLD_FOR_CUSTOMS: 'HoldForCustoms',
    NOT_CALC: 'NotCalc',
    OVER_SHPMT: 'OverShpmt',
    PARTIAL_SHORT: 'PartialShort',
    PRG_BLOCKED: 'PrgBlocked',
    REFUSED: 'Refused',
    RETURNED: 'Returned',
    SPOTTED: 'Spotted',
    SUSPENSE: 'Suspense',
    TRANSFER: 'Transfer',
    TRAPPED: 'Trapped',
    UNDELIVERED: 'Undelivered',
    WAIT: 'Wait',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceCd = {
    DEFERRED: 'Deferred',
    NORMAL_LTL: 'NormalLtl',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceLevelCd = {
    APPT_STORAGE: 'ApptStorage',
    BRONZE: 'Bronze',
    CUST_DIGEST: 'CustDigest',
    GOLD: 'Gold',
    SILVER: 'Silver',
    WHITE_GLOVE: 'WhiteGlove',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceLevelPartyTypeCd = {
    BILL_TO: 'Bill-To',
    CONSIGNEE: 'Consignee',
    DEBTOR: 'Debtor',
    SHIPPER: 'Shipper',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceStatusCd = {
    EXEMPT: 'Exempt',
    FAIL: 'Fail',
    SUCCESS: 'Success',
    UNKNOWN: 'Unknown',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ServiceTypeCd = {
    GUARANTEED_BY_12_NOON: 'GuaranteedBy12Noon',
    NORMAL: 'Normal',
    RAPID_REMOTE_SERVICE: 'RapidRemoteService',
    XPO_DEFERRED_EXPRESS: 'XPODeferredExpress',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShiftCd = {
    DAY_RESHIP: 'DayReship',
    INBOUND: 'Inbound',
    NIGHT_FAC: 'NightFAC',
    OUTBOUND: 'Outbound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentAcquiredTypeCd = {
    DOCK_DROP: 'DockDrop',
    HOOK_LD: 'HookLd',
    REGULAR_PKUP: 'RegularPkup',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentActionCd = {
    APPLY: 'Apply',
    RESET: 'Reset',
    SAVE: 'Save',
    SUBMIT: 'Submit',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentAgendaItemActionCd = {
    APPOINTMENT_SET: 'AppointmentSet',
    FINAL_DELIVERY: 'FinalDelivery',
    LOAD: 'Load',
    UNLOAD: 'Unload',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentAuditStatusCd = {
    CONFLICT: 'Conflict',
    DR_CORRECTION_DONE: 'DRCorrectionDone',
    DR_CORRECTION_DONE_OTHER: 'DRCorrectionDoneOther',
    DR_CORRECTION_FAILED: 'DRCorrectionFailed',
    DR_CORRECTION_READY: 'DRCorrectionReady',
    EXPIRED: 'Expired',
    IGNORED: 'Ignored',
    PENDING: 'Pending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentCreditStatusCd = {
    BAD_DEBT: 'BadDebt',
    CASH_ONLY: 'CashOnly',
    CREDIT: 'Credit',
    NON_CREDIT: 'NonCredit',
    PCO_CNTRL: 'PcoCntrl',
    POST_PETITION: 'PostPetition',
    VOLUNTARY: 'Voluntary',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentDetailCd = {
    ACCESSORIAL: 'Accessorial',
    ADVANCE_BEYOND: 'AdvanceBeyond',
    APPOINTMENT_REQUIRED: 'AppointmentRequired',
    BILL_ENTRY_STATS: 'BillEntryStats',
    CHILD_SHIPMENT: 'ChildShipment',
    COMMODITY: 'Commodity',
    COMMODITY_DIMENSIONS: 'CommodityDimensions',
    COUNTRY_CODES: 'CountryCodes',
    CUSTOMS_BOND: 'CustomsBond',
    EVENT_LOG: 'EventLog',
    HANDLING_UNIT: 'HandlingUnit',
    HANDLING_UNIT_MOVEMENT: 'HandlingUnitMovement',
    LINEHAUL_DIMENSIONS: 'LinehaulDimensions',
    MANAGEMENT_REMARK: 'ManagementRemark',
    MISC_LINE_ITEM: 'MiscLineItem',
    MOVEMENT_EXCEPTION: 'MovementException',
    NOTIFICATION: 'Notification',
    NO_SHIPMENT: 'NoShipment',
    OPERATIONS_SHIPMENT: 'OperationsShipment',
    RATING_INFO: 'RatingInfo',
    REMARKS: 'Remarks',
    RULE_OVERRIDE: 'RuleOverride',
    SHIPMENT_BILL_OF_LADING: 'ShipmentBillOfLading',
    SHIPMENT_HIST: 'ShipmentHist',
    SHIPMENT_ONLY: 'ShipmentOnly',
    SHIPMENT_PARTIES: 'ShipmentParties',
    SIBLING_SHIPMENT: 'SiblingShipment',
    SPECIAL_SERVICES: 'SpecialServices',
    SUPP_REF_NBR: 'SuppRefNbr',
    TIME_DATE_CRITICAL: 'TimeDateCritical',
    XDOCK_EXCEPTION: 'XdockException',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentDirectionCd = {
    NORTHBOUND: 'Northbound',
    SOUTHBOUND: 'Southbound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentEventsCd = {
    ALL_STATUSES: 'AllStatuses',
    DELAYS: 'Delays',
    MOVEMENT: 'Movement',
    PICKUP_OR_DELIVERY: 'PickupOrDelivery',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentHistoryDetailCd = {
    ADMIN: 'Admin',
    EXTERNAL: 'External',
    MOVEMENT: 'Movement',
    TRACE: 'Trace',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentItemTypeCd = {
    CUSTOMER: 'Customer',
    SHIPMENT: 'Shipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentManagementRemarkTypeCd = {
    CUSTOMER_SERVICE_REMARKS: 'CustomerServiceRemarks',
    EXCEPTION_REMARKS: 'ExceptionRemarks',
    INBOND_REMARKS: 'InbondRemarks',
    OSD_REMARKS: 'OsdRemarks',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentMovementTypeCd = {
    CLOSE: 'Close',
    DELIVERY: 'Delivery',
    FORCED_TO_LOCATION: 'ForcedToLocation',
    LOAD: 'Load',
    OUT_FOR_DELIVERY: 'OutForDelivery',
    PICKUP: 'Pickup',
    UNLOAD: 'Unload',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentOnTimeStatusCd = {
    EARLY: 'Early',
    LATE: 'Late',
    ON_TIME: 'OnTime',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentPnDStatusCd = {
    ASSIGNED: 'Assigned',
    COMPLETE: 'Complete',
    DISPATCHED: 'Dispatched',
    EXCEPTION: 'Exception',
    LOADED: 'Loaded',
    NOT_APPLICABLE: 'NotApplicable',
    RETURNING: 'Returning',
    UNASSIGNED: 'Unassigned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentRemarkTypeCd = {
    ADHOC_HZ_MATL_RMK: 'AdhocHzMatlRmk',
    AUTHORITY_LN_TXT_RMK: 'AuthorityLnTxtRmk',
    DLVRY_ATTM_RMK: 'DlvryAttmRmk',
    OPRATNL_FRT_HDLNG_RMK: 'OpratnlFrtHdlngRmk',
    OSD_CNTCT: 'OsdCntct',
    PIECE_CNT_RMK: 'PieceCntRmk',
    SHIPPING_RMK: 'ShippingRmk',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentServiceTypeCd = {
    CON_WAY_DEFERRED_EXPRESS: 'ConWayDeferredExpress',
    GUARANTEED_BY_12_NOON: 'GuaranteedBy12Noon',
    LTL_EXPEDITE_SERVICE: 'LtlExpediteService',
    NORMAL_LTL: 'NormalLtl',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentSourceCd = {
    EDI: 'Edi',
    FTP: 'FTP',
    MANL_BILL_ENTRY: 'ManlBillEntry',
    OCR: 'OCR',
    PKUP_REQUEST: 'PkupRequest',
    TCON_OR_LOAD: 'TconOrLoad',
    WEB: 'Web',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentSpecialServiceCd = {
    AFTER_HOURS_PICKUP: 'AfterHoursPickup',
    APPOINTMENT: 'Appointment',
    BULK_LIQUID: 'BulkLiquid',
    BYPASS: 'Bypass',
    CASH_ON_DELIVERY: 'CashOnDelivery',
    CONSTRUCTION_AND_UTILITY_SITES_DELIVERY: 'ConstructionAndUtilitySitesDelivery',
    CUSTOMS_IN_BOND: 'CustomsInBond',
    DESTINATION_APPOINTMENT: 'DestinationAppointment',
    DRIVER_COLLECT: 'DriverCollect',
    EXCESSIVE_LENGTH: 'ExcessiveLength',
    EXPEDITE: 'Expedite',
    FOOD: 'Food',
    FORK_LIFT: 'ForkLift',
    FREEZABLE: 'Freezable',
    GUARANTEED: 'Guaranteed',
    GUARANTEED_BY_NOON: 'GuaranteedByNoon',
    HAZMAT: 'Hazmat',
    HEADLOAD: 'Headload',
    HIGHWAY_SUB_SERVICE: 'HighwaySubService',
    INSIDE_PICKUP: 'InsidePickup',
    LIFT_GATE: 'LiftGate',
    LINEHAUL: 'Linehaul',
    MISLOAD: 'Misload',
    NOTIFY_ON_ARRIVAL: 'NotifyOnArrival',
    PALLET_JACK: 'PalletJack',
    PARTIAL_BYPASS: 'PartialBypass',
    PREMIUM_SUPPORT_SERVICE: 'PremiumSupportService',
    PUP_ONLY: 'PupOnly',
    RAPID_REMOTE_SERVICE: 'RapidRemoteService',
    RESIDENTIAL_DELIVERY: 'ResidentialDelivery',
    STRAND: 'Strand',
    SUPPLEMENTAL: 'Supplemental',
    TIME_DATE_CRITICAL: 'TimeDateCritical',
    TRAP_SERVICE: 'TrapService',
    UNMAPPED: 'Unmapped',
    VOLUME_PICKUP: 'VolumePickup',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentUpdateActionCd = {
    AUTO_RATE: 'AutoRate',
    CORRECTION: 'Correction',
    MANUAL_RATE: 'ManualRate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentVolumeMethodCd = {
    ACTL_DIM: 'ActlDim',
    DFLT_SHPR_PRFL: 'DfltShprPrfl',
    SHPR_PRFL_FOR_DEST_ZIP: 'ShprPrflForDestZip',
    SVC_CENTER_PRFL: 'SvcCenterPrfl',
    SYSTEM_PRFL: 'SystemPrfl',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipmentVolumeTypeCd = {
    DENSITY_SHPMT: 'DensityShpmt',
    FOOTPRINT_PIECE_PRFL: 'FootprintPiecePrfl',
    HGHT_PIECE: 'HghtPiece',
    VOL_PIECE: 'VolPiece',
    VOL_SHPMT: 'VolShpmt',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipperCountryCd = {
    CANADA: 'Canada',
    MEXICO: 'Mexico',
    UNITED_STATES: 'United States',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipperCreditStatusCd = {
    BANKRUPT: 'Bankrupt',
    CASH: 'Cash',
    CREDIT: 'Credit',
    NO_CREDIT: 'No Credit',
    PAY_PLAN: 'Pay Plan',
    VOLUNTARY: 'Voluntary',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipperCustomerTypeCd = {
    CUSTOMER: 'Customer',
    FUTURE: 'Future',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipperLoadedTrailerCd = {
    DOCK_DROP: 'DockDrop',
    HOOK_LD: 'HookLd',
    LD_BY_SHPR: 'LdByShpr',
    NOT_LD_BY_SHPR: 'NotLdByShpr',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShipperPhoneCountryCd = {
    CANADA: 'Canada',
    MEXICO: 'Mexico',
    UNDEFINED: 'Undefined',
    UNITED_STATES: 'United States',
    US: 'US',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ShortageTypeCd = {
    ALL_SHORT: 'AllShort',
    PART_SHORT: 'PartShort',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SnapshotDataTypeCd = {
    JSON: 'JSON',
    XML: 'XML',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SortOrderCd = {
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SpecialEquipmentCd = {
    FORKLIFT: 'Forklift',
    LIFTGATE: 'Liftgate',
    PALLET_JACK: 'PalletJack',
    UNDEFINED: 'Undefined',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const StopDetailCd = {
    ACTIVITIES: 'Activities',
    CUSTOMERS: 'Customers',
    ROUTE: 'Route',
    SHIPMENTS: 'Shipments',
    SPECIAL_SERVICES: 'SpecialServices',
    STOP_WINDOWS: 'StopWindows',
    TRIP_NODES: 'TripNodes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const StopSequenceModelConflictCd = {
    CAPACITY: 'Capacity',
    FIRST_LAST_PIN: 'FirstLastPin',
    OTHER: 'Other',
    SERVICE_TIME: 'ServiceTime',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const StopWindowCd = {
    APPOINTMENT: 'Appointment',
    CONFLICT: 'Conflict',
    CUSTOMER_OPERATIONAL_HOURS: 'CustomerOperationalHours',
    CUSTOMER_PROFILE_TIME: 'CustomerProfileTime',
    GUARANTEED_BY_NOON: 'GuaranteedByNoon',
    MIXED_SOURCE: 'MixedSource',
    TIME_DATE_CRITICAL: 'TimeDateCritical',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const StopWindowNoteTypeCd = {
    FBDS: 'FBDS',
    INTERNAL: 'Internal',
    TIME_DATE_CRITICAL: 'TimeDateCritical',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const StrandReasonCd = {
    LATE_TENDER: 'Late Tender',
    NOT_STRANDED: 'Not Stranded',
    UNDEFINED: 'Undefined',
    XPO_CAUSED: 'XPO Caused',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const SymphonyPubDeliverToCd = {
    EMS: 'EMS',
    ENSEMBLE: 'Ensemble',
    KAFKA: 'Kafka',
    PUB_SUB: 'PubSub',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TariffOperatorCd = {
    ANY_BETWEEN: 'AnyBetween',
    ANY_EQUAL: 'AnyEqual',
    ANY_GREATER_THAN: 'AnyGreaterThan',
    ANY_GREATER_THAN_OR_EQUAL: 'AnyGreaterThanOrEqual',
    ANY_IN: 'AnyIn',
    ANY_LESS_THAN: 'AnyLessThan',
    ANY_LESS_THAN_OR_EQUAL: 'AnyLessThanOrEqual',
    ANY_MATCHES: 'AnyMatches',
    ANY_NOT_BETWEEN: 'AnyNotBetween',
    ANY_NOT_EQUAL: 'AnyNotEqual',
    ANY_NOT_IN: 'AnyNotIn',
    ANY_NOT_MATCHES: 'AnyNotMatches',
    BETWEEN: 'Between',
    EQUAL_TO: 'EqualTo',
    GREATER_THAN: 'GreaterThan',
    GREATER_THAN_OR_EQUAL: 'GreaterThanOrEqual',
    IN: 'In',
    LESS_THAN: 'LessThan',
    LESS_THAN_OR_EQUAL: 'LessThanOrEqual',
    MATCHES: 'Matches',
    NOT_BETWEEN: 'NotBetween',
    NOT_EQUAL_TO: 'NotEqualTo',
    NOT_IN: 'NotIn',
    NOT_MATCHES: 'NotMatches',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TariffTypeCd = {
    CORPORATE: 'Corporate',
    CURRENT: 'Current',
    FOREIGN: 'Foreign',
    FROZEN: 'Frozen',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TrailerAgendaItemActionCd = {
    CITY_ARRIVE: 'CityArrive',
    CLOSE_FOR_DELIVERY: 'CloseForDelivery',
    LINEHAUL_ARRIVE: 'LinehaulArrive',
    LINEHAUL_CLOSE: 'LinehaulClose',
    LINEHAUL_DISPATCH: 'LinehaulDispatch',
    LINEHAUL_LOADING_AT_DOCK: 'LinehaulLoadingAtDock',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TrailerLoadedUnitDetailCd = {
    CONSIGNEE: 'Consignee',
    DELIVERY_TIME: 'DeliveryTime',
    ROUTE: 'Route',
    SHIPPER: 'Shipper',
    STATISTICS: 'Statistics',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TrailerRoutingEventCd = {
    ARIV: 'ARIV',
    CLOS: 'CLOS',
    DISP: 'DISP',
    ENDC: 'ENDC',
    TERM: 'TERM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TrailerStatusCd = {
    APPOINTMENT: 'Appointment',
    ARRIVE: 'Arrive',
    CITY_ARRIVE: 'CityArrive',
    CITY_LOADING_AT_DOCK: 'CityLoadingAtDock',
    CLOSE_FOR_DELIVERY: 'CloseForDelivery',
    CLOSE_FOR_LINEHAUL: 'CloseForLinehaul',
    DROP: 'Drop',
    EMPTY: 'Empty',
    LOADING_AT_CUSTOMER: 'LoadingAtCustomer',
    LOADING_AT_DOCK: 'LoadingAtDock',
    OVERHEAD: 'Overhead',
    PICKUP_AND_DELIVERY: 'PickupAndDelivery',
    TRAP: 'Trap',
    UNLOAD_AT_CUSTOMER: 'UnloadAtCustomer',
    UNLOAD_AT_DOCK: 'UnloadAtDock',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TransactionEventDetailTypeCd = {
    DELETE: 'Delete',
    INSERT: 'Insert',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TransitTimeDirectionTypeCd = {
    BOTH: 'Both',
    INBOUND: 'Inbound',
    OUTBOUND: 'Outbound',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TrapReasonCd = {
    CLOSED_FOR_HOLIDAY: 'ClosedForHoliday',
    CUSTOMER_REQUEST_CONSOLIDATE: 'CustomerRequestConsolidate',
    HELD_PROTECTIVE_SERVICE: 'HeldProtectiveService',
    RECEIVE_TIME_RESTRICTED: 'ReceiveTimeRestricted',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripActivityTypeCd = {
    END_LUNCH: 'EndLunch',
    ENTER_GATE: 'EnterGate',
    LEAVE_GATE: 'LeaveGate',
    OTHER_ACTIVITY_END: 'OtherActivityEnd',
    OTHER_ACTIVITY_START: 'OtherActivityStart',
    START_LUNCH: 'StartLunch',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripCategoryCd = {
    OPERATIONAL: 'Operational',
    THIRD_PARTY_AD_HOC: 'ThirdPartyAdHoc',
    THIRD_PARTY_SCHEDULED: 'ThirdPartyScheduled',
    TRIP_EQUIPMENT_DROP: 'TripEquipmentDrop',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripDetailCd = {
    ACTIVITIES: 'Activities',
    CUSTOMER: 'Customer',
    DISPATCH_GROUPS: 'DispatchGroups',
    DRIVER: 'Driver',
    DROP_LOCATIONS: 'DropLocations',
    EQUIPMENT: 'Equipment',
    HANDHELD_USE: 'HandheldUse',
    METRICS: 'Metrics',
    NOTES: 'Notes',
    ROUTES: 'Routes',
    SINGLE_STOP_WITH_EDT: 'SingleStopWithEDT',
    SPECIAL_SERVICES: 'SpecialServices',
    STOPS: 'Stops',
    TRIP: 'Trip',
    TRIP_HIST: 'TripHist',
    WINDOWS: 'Windows',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripEquipmentStatusCd = {
    ATTACHED: 'Attached',
    DROPPED: 'Dropped',
    PLANNED: 'Planned',
    PLANNED_FOR_HOOK: 'PlannedForHook',
    RETURNED: 'Returned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripNodeActivityCd = {
    ARRIVE: 'Arrive',
    DELIVER_SHIPMENT: 'DeliverShipment',
    DEPART_DISPATCH: 'Depart/Dispatch',
    DROP_EQUIPMENT: 'DropEquipment',
    HOOK_EMPTY: 'HookEmpty',
    HOOK_EQUIPMENT: 'HookEquipment',
    HOOK_LOADED: 'HookLoaded',
    PICKUP_SHIPMENTS: 'PickupShipments',
    SPOT_EMPTY: 'SpotEmpty',
    SPOT_LOADED: 'SpotLoaded',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripNodeStatusCd = {
    ASSIGNED: 'Assigned',
    COMPLETED: 'Completed',
    PENDING: 'Pending',
    PRE_ASSIGNED: 'PreAssigned',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripNodeTypeCd = {
    DESTINATION: 'Destination',
    ORIGIN: 'Origin',
    STOP: 'Stop',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripStatusCd = {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    DISPATCHED: 'Dispatched',
    NEW_TRIP: 'NewTrip',
    RETURNING: 'Returning',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const TripStopActionCd = {
    COMPLETE: 'Complete',
    UPDATE: 'Update',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UnassignPickupsSourceCd = {
    PAST_DUE: 'PastDue',
    UNASSIGNED: 'Unassigned',
    UNMAPPED: 'Unmapped',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UnassignReasonCd = {
    CANCEL: 'Cancel',
    RESCHEDULE: 'Reschedule',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UndeliveredReasonCd = {
    CONSTRUCTION_SITE: 'ConstructionSite',
    CONS_IN_LABOR_DISPUTE: 'ConsInLaborDispute',
    CONS_MOVED: 'ConsMoved',
    CONS_NOT_FOUND_AT_ADDR_OR_PHON: 'ConsNotFoundAtAddrOrPhon',
    CREDIT_HOLD: 'CreditHold',
    INSUFFICIENT_DLVRY_TM: 'InsufficientDlvryTm',
    NO_RSPNS_TO_ARRIVAL_NTFICTN: 'NoRspnsToArrivalNtfictn',
    OTHER: 'Other',
    SUSPENDED_AT_CUST_RQST: 'SuspendedAtCustRqst',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UploadDynamicPricingFileOperationCd = {
    DP_RULE_DISCOUNTS_UPDATE: 'DPRuleDiscountsUpdate',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UserRoleCd = {
    CDS: 'CDS',
    DNM: 'DNM',
    FAC: 'FAC',
    FOM: 'FOM',
    FOS: 'FOS',
    MANAGER_SUPERVISOR_LINEHAUL: 'ManagerSupervisorLinehaul',
    RM: 'RM',
    SCM: 'SCM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const UserRoleTypeCd = {
    FINANCIAL_ACCESS: 'FinancialAccess',
    FINANCIAL_ACCESS_ADMIN: 'FinancialAccessAdmin',
    NAVIGATOR_TABS: 'NavigatorTabs',
    NAVIGATOR_TABS_ADMIN: 'NavigatorTabsAdmin',
    VIEW_AR: 'ViewAR',
    VIEW_AR_ADMIN: 'ViewARAdmin',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WarrantyStatusCd = {
    APPROVED: 'Approved',
    DENIED: 'Denied',
    FILED: 'Filed',
    NONE: 'None',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WeekDayCd = {
    FRIDAY: 'Friday',
    MONDAY: 'Monday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
    THURSDAY: 'Thursday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WeightUomCd = {
    KILOGRAMS: 'Kilograms',
    POUNDS: 'Pounds',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WhatIfDownloadFileTypeCd = {
    SHIPMENT_FILE: 'ShipmentFile',
    WHAT_IF_RATING_RESULT_FILE: 'WhatIfRatingResultFile',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WhatIfShipmentSelectionTypeCd = {
    ACCOUNT: 'Account',
    AGREEMENT_ID: 'AgreementId',
    BATCH_RERATE: 'BatchRerate',
    CUSTOMER_SHIPMENT: 'CustomerShipment',
    MASS_RERATE: 'MassRerate',
    XPO_SHIPMENT: 'XpoShipment',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WorkerStatusCd = {
    ASSIGNED: 'Assigned',
    AVAILABLE: 'Available',
    RETURNING: 'Returning',
    SICK: 'Sick',
    TRAINING: 'Training',
    UNAVAILABLE: 'Unavailable',
    VACATION: 'Vacation',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const WorkflowSelectionModeCd = {
    LIST: 'List',
    TOP_OF_STACK: 'TopOfStack',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const XFlowFrequencyCd = {
    DAILY: 'Daily',
    HOURLY: 'Hourly',
    IMMEDIATELY: 'Immediately',
    ONCE: 'Once',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const XFlowNotificationTypeCd = {
    CHANGE_FEED: 'ChangeFeed',
    EMAIL: 'Email',
    PUB_SUB: 'PubSub',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const XdockExceptionTypeCd = {
    DAMAGED: 'Damaged',
    OVER: 'Over',
    SHORT: 'Short',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ZoneIndicatorCd = {
    INCLUDE_ZONES: 'IncludeZones',
    NO_ZONES: 'NoZones',
    ZONES_ONLY: 'ZonesOnly',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Helper for enums
 * @abstract
 */
class EnumHelper {
    constructor() {
        this._values = [];
        this._keys = [];
    }
    /**
     * @return {?}
     */
    values() {
        return this._values;
    }
    /**
     * @return {?}
     */
    keys() {
        return this._keys;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ARDebtorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ARDebtorCd) {
            this._values.push(ARDebtorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ARDebtorCd) {
            if (ARDebtorCd[obj] === value) {
                return /** @type {?} */ (ARDebtorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ARDebtorCdHelper = new ARDebtorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AccessorialCheckCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AccessorialCheckCd) {
            this._values.push(AccessorialCheckCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AccessorialCheckCd) {
            if (AccessorialCheckCd[obj] === value) {
                return /** @type {?} */ (AccessorialCheckCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AccessorialCheckCdHelper = new AccessorialCheckCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AccessorialUnitOfMeasureCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AccessorialUnitOfMeasureCd) {
            this._values.push(AccessorialUnitOfMeasureCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AccessorialUnitOfMeasureCd) {
            if (AccessorialUnitOfMeasureCd[obj] === value) {
                return /** @type {?} */ (AccessorialUnitOfMeasureCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AccessorialUnitOfMeasureCdHelper = new AccessorialUnitOfMeasureCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ActionCd) {
            this._values.push(ActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ActionCd) {
            if (ActionCd[obj] === value) {
                return /** @type {?} */ (ActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ActionCdHelper = new ActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ActivityStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ActivityStatusCd) {
            this._values.push(ActivityStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ActivityStatusCd) {
            if (ActivityStatusCd[obj] === value) {
                return /** @type {?} */ (ActivityStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ActivityStatusCdHelper = new ActivityStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AddressTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AddressTypeCd) {
            this._values.push(AddressTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AddressTypeCd) {
            if (AddressTypeCd[obj] === value) {
                return /** @type {?} */ (AddressTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AddressTypeCdHelper = new AddressTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AdvanceBeyondTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AdvanceBeyondTypeCd) {
            this._values.push(AdvanceBeyondTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AdvanceBeyondTypeCd) {
            if (AdvanceBeyondTypeCd[obj] === value) {
                return /** @type {?} */ (AdvanceBeyondTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AdvanceBeyondTypeCdHelper = new AdvanceBeyondTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AgendaItemStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AgendaItemStatusCd) {
            this._values.push(AgendaItemStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AgendaItemStatusCd) {
            if (AgendaItemStatusCd[obj] === value) {
                return /** @type {?} */ (AgendaItemStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AgendaItemStatusCdHelper = new AgendaItemStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AgendaOwnerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AgendaOwnerTypeCd) {
            this._values.push(AgendaOwnerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AgendaOwnerTypeCd) {
            if (AgendaOwnerTypeCd[obj] === value) {
                return /** @type {?} */ (AgendaOwnerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AgendaOwnerTypeCdHelper = new AgendaOwnerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiAuthTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiAuthTypeCd) {
            this._values.push(ApiAuthTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiAuthTypeCd) {
            if (ApiAuthTypeCd[obj] === value) {
                return /** @type {?} */ (ApiAuthTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiAuthTypeCdHelper = new ApiAuthTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractExceptionSeverityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractExceptionSeverityCd) {
            this._values.push(ApiContractExceptionSeverityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractExceptionSeverityCd) {
            if (ApiContractExceptionSeverityCd[obj] === value) {
                return /** @type {?} */ (ApiContractExceptionSeverityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractExceptionSeverityCdHelper = new ApiContractExceptionSeverityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractImplApiMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractImplApiMethodCd) {
            this._values.push(ApiContractImplApiMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractImplApiMethodCd) {
            if (ApiContractImplApiMethodCd[obj] === value) {
                return /** @type {?} */ (ApiContractImplApiMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractImplApiMethodCdHelper = new ApiContractImplApiMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractImplProtocolCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractImplProtocolCd) {
            this._values.push(ApiContractImplProtocolCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractImplProtocolCd) {
            if (ApiContractImplProtocolCd[obj] === value) {
                return /** @type {?} */ (ApiContractImplProtocolCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractImplProtocolCdHelper = new ApiContractImplProtocolCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractImplTechnologyHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractImplTechnology) {
            this._values.push(ApiContractImplTechnology[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractImplTechnology) {
            if (ApiContractImplTechnology[obj] === value) {
                return /** @type {?} */ (ApiContractImplTechnology[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractImplTechnologyHelper = new ApiContractImplTechnologyHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractStatusCd) {
            this._values.push(ApiContractStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractStatusCd) {
            if (ApiContractStatusCd[obj] === value) {
                return /** @type {?} */ (ApiContractStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractStatusCdHelper = new ApiContractStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiContractTypeCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiContractTypeCategoryCd) {
            this._values.push(ApiContractTypeCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiContractTypeCategoryCd) {
            if (ApiContractTypeCategoryCd[obj] === value) {
                return /** @type {?} */ (ApiContractTypeCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiContractTypeCategoryCdHelper = new ApiContractTypeCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiFeatureStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiFeatureStatusCd) {
            this._values.push(ApiFeatureStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiFeatureStatusCd) {
            if (ApiFeatureStatusCd[obj] === value) {
                return /** @type {?} */ (ApiFeatureStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiFeatureStatusCdHelper = new ApiFeatureStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiThrottlingTierCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiThrottlingTierCd) {
            this._values.push(ApiThrottlingTierCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiThrottlingTierCd) {
            if (ApiThrottlingTierCd[obj] === value) {
                return /** @type {?} */ (ApiThrottlingTierCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiThrottlingTierCdHelper = new ApiThrottlingTierCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiTypeAttributeDataTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiTypeAttributeDataTypeCd) {
            this._values.push(ApiTypeAttributeDataTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiTypeAttributeDataTypeCd) {
            if (ApiTypeAttributeDataTypeCd[obj] === value) {
                return /** @type {?} */ (ApiTypeAttributeDataTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiTypeAttributeDataTypeCdHelper = new ApiTypeAttributeDataTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiTypeCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiTypeCategoryCd) {
            this._values.push(ApiTypeCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiTypeCategoryCd) {
            if (ApiTypeCategoryCd[obj] === value) {
                return /** @type {?} */ (ApiTypeCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiTypeCategoryCdHelper = new ApiTypeCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApiTypeStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApiTypeStatusCd) {
            this._values.push(ApiTypeStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApiTypeStatusCd) {
            if (ApiTypeStatusCd[obj] === value) {
                return /** @type {?} */ (ApiTypeStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApiTypeStatusCdHelper = new ApiTypeStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApplicationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApplicationCd) {
            this._values.push(ApplicationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApplicationCd) {
            if (ApplicationCd[obj] === value) {
                return /** @type {?} */ (ApplicationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApplicationCdHelper = new ApplicationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AppointmentNotificationStatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AppointmentNotificationStatCd) {
            this._values.push(AppointmentNotificationStatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AppointmentNotificationStatCd) {
            if (AppointmentNotificationStatCd[obj] === value) {
                return /** @type {?} */ (AppointmentNotificationStatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AppointmentNotificationStatCdHelper = new AppointmentNotificationStatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AppointmentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AppointmentStatusCd) {
            this._values.push(AppointmentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AppointmentStatusCd) {
            if (AppointmentStatusCd[obj] === value) {
                return /** @type {?} */ (AppointmentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AppointmentStatusCdHelper = new AppointmentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ApprovalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ApprovalStatusCd) {
            this._values.push(ApprovalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ApprovalStatusCd) {
            if (ApprovalStatusCd[obj] === value) {
                return /** @type {?} */ (ApprovalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ApprovalStatusCdHelper = new ApprovalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ArchiveControlCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ArchiveControlCd) {
            this._values.push(ArchiveControlCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ArchiveControlCd) {
            if (ArchiveControlCd[obj] === value) {
                return /** @type {?} */ (ArchiveControlCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ArchiveControlCdHelper = new ArchiveControlCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AttemptReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AttemptReasonCd) {
            this._values.push(AttemptReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AttemptReasonCd) {
            if (AttemptReasonCd[obj] === value) {
                return /** @type {?} */ (AttemptReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AttemptReasonCdHelper = new AttemptReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AvailableStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in AvailableStatusCd) {
            this._values.push(AvailableStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in AvailableStatusCd) {
            if (AvailableStatusCd[obj] === value) {
                return /** @type {?} */ (AvailableStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ AvailableStatusCdHelper = new AvailableStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BatchFrameworkArgumentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BatchFrameworkArgumentTypeCd) {
            this._values.push(BatchFrameworkArgumentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BatchFrameworkArgumentTypeCd) {
            if (BatchFrameworkArgumentTypeCd[obj] === value) {
                return /** @type {?} */ (BatchFrameworkArgumentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BatchFrameworkArgumentTypeCdHelper = new BatchFrameworkArgumentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconItemStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconItemStatusCd) {
            this._values.push(BeaconItemStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconItemStatusCd) {
            if (BeaconItemStatusCd[obj] === value) {
                return /** @type {?} */ (BeaconItemStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconItemStatusCdHelper = new BeaconItemStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconOwnerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconOwnerTypeCd) {
            this._values.push(BeaconOwnerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconOwnerTypeCd) {
            if (BeaconOwnerTypeCd[obj] === value) {
                return /** @type {?} */ (BeaconOwnerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconOwnerTypeCdHelper = new BeaconOwnerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconPriorityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconPriorityCd) {
            this._values.push(BeaconPriorityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconPriorityCd) {
            if (BeaconPriorityCd[obj] === value) {
                return /** @type {?} */ (BeaconPriorityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconPriorityCdHelper = new BeaconPriorityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconSourceCd) {
            this._values.push(BeaconSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconSourceCd) {
            if (BeaconSourceCd[obj] === value) {
                return /** @type {?} */ (BeaconSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconSourceCdHelper = new BeaconSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconStatusCd) {
            this._values.push(BeaconStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconStatusCd) {
            if (BeaconStatusCd[obj] === value) {
                return /** @type {?} */ (BeaconStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconStatusCdHelper = new BeaconStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BeaconTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BeaconTypeCd) {
            this._values.push(BeaconTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BeaconTypeCd) {
            if (BeaconTypeCd[obj] === value) {
                return /** @type {?} */ (BeaconTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BeaconTypeCdHelper = new BeaconTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillClassCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillClassCd) {
            this._values.push(BillClassCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillClassCd) {
            if (BillClassCd[obj] === value) {
                return /** @type {?} */ (BillClassCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillClassCdHelper = new BillClassCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillCorrectionStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillCorrectionStatusCd) {
            this._values.push(BillCorrectionStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillCorrectionStatusCd) {
            if (BillCorrectionStatusCd[obj] === value) {
                return /** @type {?} */ (BillCorrectionStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillCorrectionStatusCdHelper = new BillCorrectionStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillStatusCd) {
            this._values.push(BillStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillStatusCd) {
            if (BillStatusCd[obj] === value) {
                return /** @type {?} */ (BillStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillStatusCdHelper = new BillStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillToRelationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillToRelationCd) {
            this._values.push(BillToRelationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillToRelationCd) {
            if (BillToRelationCd[obj] === value) {
                return /** @type {?} */ (BillToRelationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillToRelationCdHelper = new BillToRelationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillTypeCd) {
            this._values.push(BillTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillTypeCd) {
            if (BillTypeCd[obj] === value) {
                return /** @type {?} */ (BillTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillTypeCdHelper = new BillTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BillingRemarkTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BillingRemarkTypeCd) {
            this._values.push(BillingRemarkTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BillingRemarkTypeCd) {
            if (BillingRemarkTypeCd[obj] === value) {
                return /** @type {?} */ (BillingRemarkTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BillingRemarkTypeCdHelper = new BillingRemarkTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BolPartyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BolPartyTypeCd) {
            this._values.push(BolPartyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BolPartyTypeCd) {
            if (BolPartyTypeCd[obj] === value) {
                return /** @type {?} */ (BolPartyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BolPartyTypeCdHelper = new BolPartyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BolUsageTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BolUsageTypeCd) {
            this._values.push(BolUsageTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BolUsageTypeCd) {
            if (BolUsageTypeCd[obj] === value) {
                return /** @type {?} */ (BolUsageTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BolUsageTypeCdHelper = new BolUsageTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BondReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BondReasonCd) {
            this._values.push(BondReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BondReasonCd) {
            if (BondReasonCd[obj] === value) {
                return /** @type {?} */ (BondReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BondReasonCdHelper = new BondReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BondStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BondStatusCd) {
            this._values.push(BondStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BondStatusCd) {
            if (BondStatusCd[obj] === value) {
                return /** @type {?} */ (BondStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BondStatusCdHelper = new BondStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BondTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BondTypeCd) {
            this._values.push(BondTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BondTypeCd) {
            if (BondTypeCd[obj] === value) {
                return /** @type {?} */ (BondTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BondTypeCdHelper = new BondTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class BusinessMetricCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in BusinessMetricCd) {
            this._values.push(BusinessMetricCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in BusinessMetricCd) {
            if (BusinessMetricCd[obj] === value) {
                return /** @type {?} */ (BusinessMetricCd[obj]);
            }
        }
    }
}
const /** @type {?} */ BusinessMetricCdHelper = new BusinessMetricCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CarrierDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CarrierDetailCd) {
            this._values.push(CarrierDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CarrierDetailCd) {
            if (CarrierDetailCd[obj] === value) {
                return /** @type {?} */ (CarrierDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CarrierDetailCdHelper = new CarrierDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CarrierLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CarrierLocationTypeCd) {
            this._values.push(CarrierLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CarrierLocationTypeCd) {
            if (CarrierLocationTypeCd[obj] === value) {
                return /** @type {?} */ (CarrierLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CarrierLocationTypeCdHelper = new CarrierLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CarrierTenderGroupStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CarrierTenderGroupStatusCd) {
            this._values.push(CarrierTenderGroupStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CarrierTenderGroupStatusCd) {
            if (CarrierTenderGroupStatusCd[obj] === value) {
                return /** @type {?} */ (CarrierTenderGroupStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CarrierTenderGroupStatusCdHelper = new CarrierTenderGroupStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CarrierTenderStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CarrierTenderStatusCd) {
            this._values.push(CarrierTenderStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CarrierTenderStatusCd) {
            if (CarrierTenderStatusCd[obj] === value) {
                return /** @type {?} */ (CarrierTenderStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CarrierTenderStatusCdHelper = new CarrierTenderStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CbolRespMessageStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CbolRespMessageStatusCd) {
            this._values.push(CbolRespMessageStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CbolRespMessageStatusCd) {
            if (CbolRespMessageStatusCd[obj] === value) {
                return /** @type {?} */ (CbolRespMessageStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CbolRespMessageStatusCdHelper = new CbolRespMessageStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ChangeRsnCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ChangeRsnCd) {
            this._values.push(ChangeRsnCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ChangeRsnCd) {
            if (ChangeRsnCd[obj] === value) {
                return /** @type {?} */ (ChangeRsnCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ChangeRsnCdHelper = new ChangeRsnCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ChargeToCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ChargeToCd) {
            this._values.push(ChargeToCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ChargeToCd) {
            if (ChargeToCd[obj] === value) {
                return /** @type {?} */ (ChargeToCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ChargeToCdHelper = new ChargeToCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CheckpointEventStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CheckpointEventStatusCd) {
            this._values.push(CheckpointEventStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CheckpointEventStatusCd) {
            if (CheckpointEventStatusCd[obj] === value) {
                return /** @type {?} */ (CheckpointEventStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CheckpointEventStatusCdHelper = new CheckpointEventStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CheckpointMasterActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CheckpointMasterActionCd) {
            this._values.push(CheckpointMasterActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CheckpointMasterActionCd) {
            if (CheckpointMasterActionCd[obj] === value) {
                return /** @type {?} */ (CheckpointMasterActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CheckpointMasterActionCdHelper = new CheckpointMasterActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CisRequestApprovalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CisRequestApprovalStatusCd) {
            this._values.push(CisRequestApprovalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CisRequestApprovalStatusCd) {
            if (CisRequestApprovalStatusCd[obj] === value) {
                return /** @type {?} */ (CisRequestApprovalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CisRequestApprovalStatusCdHelper = new CisRequestApprovalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CisRequestPriorityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CisRequestPriorityCd) {
            this._values.push(CisRequestPriorityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CisRequestPriorityCd) {
            if (CisRequestPriorityCd[obj] === value) {
                return /** @type {?} */ (CisRequestPriorityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CisRequestPriorityCdHelper = new CisRequestPriorityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CisRequestStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CisRequestStatusCd) {
            this._values.push(CisRequestStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CisRequestStatusCd) {
            if (CisRequestStatusCd[obj] === value) {
                return /** @type {?} */ (CisRequestStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CisRequestStatusCdHelper = new CisRequestStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimAdditionalPaymentReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimAdditionalPaymentReasonCd) {
            this._values.push(ClaimAdditionalPaymentReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimAdditionalPaymentReasonCd) {
            if (ClaimAdditionalPaymentReasonCd[obj] === value) {
                return /** @type {?} */ (ClaimAdditionalPaymentReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimAdditionalPaymentReasonCdHelper = new ClaimAdditionalPaymentReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimChargeabilityReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimChargeabilityReasonCd) {
            this._values.push(ClaimChargeabilityReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimChargeabilityReasonCd) {
            if (ClaimChargeabilityReasonCd[obj] === value) {
                return /** @type {?} */ (ClaimChargeabilityReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimChargeabilityReasonCdHelper = new ClaimChargeabilityReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimCurrencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimCurrencyCd) {
            this._values.push(ClaimCurrencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimCurrencyCd) {
            if (ClaimCurrencyCd[obj] === value) {
                return /** @type {?} */ (ClaimCurrencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimCurrencyCdHelper = new ClaimCurrencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimDecisionCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimDecisionCategoryCd) {
            this._values.push(ClaimDecisionCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimDecisionCategoryCd) {
            if (ClaimDecisionCategoryCd[obj] === value) {
                return /** @type {?} */ (ClaimDecisionCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimDecisionCategoryCdHelper = new ClaimDecisionCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimDecisionSubCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimDecisionSubCategoryCd) {
            this._values.push(ClaimDecisionSubCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimDecisionSubCategoryCd) {
            if (ClaimDecisionSubCategoryCd[obj] === value) {
                return /** @type {?} */ (ClaimDecisionSubCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimDecisionSubCategoryCdHelper = new ClaimDecisionSubCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimEmailTemplateFieldCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimEmailTemplateFieldCd) {
            this._values.push(ClaimEmailTemplateFieldCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimEmailTemplateFieldCd) {
            if (ClaimEmailTemplateFieldCd[obj] === value) {
                return /** @type {?} */ (ClaimEmailTemplateFieldCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimEmailTemplateFieldCdHelper = new ClaimEmailTemplateFieldCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimEmailTemplateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimEmailTemplateTypeCd) {
            this._values.push(ClaimEmailTemplateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimEmailTemplateTypeCd) {
            if (ClaimEmailTemplateTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimEmailTemplateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimEmailTemplateTypeCdHelper = new ClaimEmailTemplateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimEventTypeCd) {
            this._values.push(ClaimEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimEventTypeCd) {
            if (ClaimEventTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimEventTypeCdHelper = new ClaimEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimExternalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimExternalStatusCd) {
            this._values.push(ClaimExternalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimExternalStatusCd) {
            if (ClaimExternalStatusCd[obj] === value) {
                return /** @type {?} */ (ClaimExternalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimExternalStatusCdHelper = new ClaimExternalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimExternalVisibilityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimExternalVisibilityCd) {
            this._values.push(ClaimExternalVisibilityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimExternalVisibilityCd) {
            if (ClaimExternalVisibilityCd[obj] === value) {
                return /** @type {?} */ (ClaimExternalVisibilityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimExternalVisibilityCdHelper = new ClaimExternalVisibilityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimFieldNameHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimFieldName) {
            this._values.push(ClaimFieldName[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimFieldName) {
            if (ClaimFieldName[obj] === value) {
                return /** @type {?} */ (ClaimFieldName[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimFieldNameHelper = new ClaimFieldNameHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimFilingMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimFilingMethodCd) {
            this._values.push(ClaimFilingMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimFilingMethodCd) {
            if (ClaimFilingMethodCd[obj] === value) {
                return /** @type {?} */ (ClaimFilingMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimFilingMethodCdHelper = new ClaimFilingMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimInternalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimInternalStatusCd) {
            this._values.push(ClaimInternalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimInternalStatusCd) {
            if (ClaimInternalStatusCd[obj] === value) {
                return /** @type {?} */ (ClaimInternalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimInternalStatusCdHelper = new ClaimInternalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimNoteTypeCd) {
            this._values.push(ClaimNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimNoteTypeCd) {
            if (ClaimNoteTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimNoteTypeCdHelper = new ClaimNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimNoteVisibilityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimNoteVisibilityCd) {
            this._values.push(ClaimNoteVisibilityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimNoteVisibilityCd) {
            if (ClaimNoteVisibilityCd[obj] === value) {
                return /** @type {?} */ (ClaimNoteVisibilityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimNoteVisibilityCdHelper = new ClaimNoteVisibilityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimPartyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimPartyTypeCd) {
            this._values.push(ClaimPartyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimPartyTypeCd) {
            if (ClaimPartyTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimPartyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimPartyTypeCdHelper = new ClaimPartyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimPaymentMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimPaymentMethodCd) {
            this._values.push(ClaimPaymentMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimPaymentMethodCd) {
            if (ClaimPaymentMethodCd[obj] === value) {
                return /** @type {?} */ (ClaimPaymentMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimPaymentMethodCdHelper = new ClaimPaymentMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimRelatedShipmentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimRelatedShipmentTypeCd) {
            this._values.push(ClaimRelatedShipmentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimRelatedShipmentTypeCd) {
            if (ClaimRelatedShipmentTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimRelatedShipmentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimRelatedShipmentTypeCdHelper = new ClaimRelatedShipmentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimTypeCd) {
            this._values.push(ClaimTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimTypeCd) {
            if (ClaimTypeCd[obj] === value) {
                return /** @type {?} */ (ClaimTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimTypeCdHelper = new ClaimTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ClaimantSameAsCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ClaimantSameAsCd) {
            this._values.push(ClaimantSameAsCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ClaimantSameAsCd) {
            if (ClaimantSameAsCd[obj] === value) {
                return /** @type {?} */ (ClaimantSameAsCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ClaimantSameAsCdHelper = new ClaimantSameAsCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CloseReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CloseReasonCd) {
            this._values.push(CloseReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CloseReasonCd) {
            if (CloseReasonCd[obj] === value) {
                return /** @type {?} */ (CloseReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CloseReasonCdHelper = new CloseReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CmsTripTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CmsTripTypeCd) {
            this._values.push(CmsTripTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CmsTripTypeCd) {
            if (CmsTripTypeCd[obj] === value) {
                return /** @type {?} */ (CmsTripTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CmsTripTypeCdHelper = new CmsTripTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CollectMoneyAtDeliveryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CollectMoneyAtDeliveryCd) {
            this._values.push(CollectMoneyAtDeliveryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CollectMoneyAtDeliveryCd) {
            if (CollectMoneyAtDeliveryCd[obj] === value) {
                return /** @type {?} */ (CollectMoneyAtDeliveryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CollectMoneyAtDeliveryCdHelper = new CollectMoneyAtDeliveryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CommodityClaimTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CommodityClaimTypeCd) {
            this._values.push(CommodityClaimTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CommodityClaimTypeCd) {
            if (CommodityClaimTypeCd[obj] === value) {
                return /** @type {?} */ (CommodityClaimTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CommodityClaimTypeCdHelper = new CommodityClaimTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CommodityClassCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CommodityClassCd) {
            this._values.push(CommodityClassCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CommodityClassCd) {
            if (CommodityClassCd[obj] === value) {
                return /** @type {?} */ (CommodityClassCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CommodityClassCdHelper = new CommodityClassCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CommodityConditionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CommodityConditionTypeCd) {
            this._values.push(CommodityConditionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CommodityConditionTypeCd) {
            if (CommodityConditionTypeCd[obj] === value) {
                return /** @type {?} */ (CommodityConditionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CommodityConditionTypeCdHelper = new CommodityConditionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CommodityPackageCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CommodityPackageCd) {
            this._values.push(CommodityPackageCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CommodityPackageCd) {
            if (CommodityPackageCd[obj] === value) {
                return /** @type {?} */ (CommodityPackageCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CommodityPackageCdHelper = new CommodityPackageCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConeColorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ConeColorCd) {
            this._values.push(ConeColorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ConeColorCd) {
            if (ConeColorCd[obj] === value) {
                return /** @type {?} */ (ConeColorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ConeColorCdHelper = new ConeColorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConfigurationValueTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ConfigurationValueTypeCd) {
            this._values.push(ConfigurationValueTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ConfigurationValueTypeCd) {
            if (ConfigurationValueTypeCd[obj] === value) {
                return /** @type {?} */ (ConfigurationValueTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ConfigurationValueTypeCdHelper = new ConfigurationValueTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConsigneeUnloadedTrailerCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ConsigneeUnloadedTrailerCd) {
            this._values.push(ConsigneeUnloadedTrailerCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ConsigneeUnloadedTrailerCd) {
            if (ConsigneeUnloadedTrailerCd[obj] === value) {
                return /** @type {?} */ (ConsigneeUnloadedTrailerCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ConsigneeUnloadedTrailerCdHelper = new ConsigneeUnloadedTrailerCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ContactRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ContactRoleCd) {
            this._values.push(ContactRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ContactRoleCd) {
            if (ContactRoleCd[obj] === value) {
                return /** @type {?} */ (ContactRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ContactRoleCdHelper = new ContactRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConversationActionItemStatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ConversationActionItemStatCd) {
            this._values.push(ConversationActionItemStatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ConversationActionItemStatCd) {
            if (ConversationActionItemStatCd[obj] === value) {
                return /** @type {?} */ (ConversationActionItemStatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ConversationActionItemStatCdHelper = new ConversationActionItemStatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConversationSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ConversationSourceCd) {
            this._values.push(ConversationSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ConversationSourceCd) {
            if (ConversationSourceCd[obj] === value) {
                return /** @type {?} */ (ConversationSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ConversationSourceCdHelper = new ConversationSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CorrectionQueueNameCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CorrectionQueueNameCd) {
            this._values.push(CorrectionQueueNameCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CorrectionQueueNameCd) {
            if (CorrectionQueueNameCd[obj] === value) {
                return /** @type {?} */ (CorrectionQueueNameCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CorrectionQueueNameCdHelper = new CorrectionQueueNameCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CorrectionReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CorrectionReasonCd) {
            this._values.push(CorrectionReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CorrectionReasonCd) {
            if (CorrectionReasonCd[obj] === value) {
                return /** @type {?} */ (CorrectionReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CorrectionReasonCdHelper = new CorrectionReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CorrectionStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CorrectionStatusCd) {
            this._values.push(CorrectionStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CorrectionStatusCd) {
            if (CorrectionStatusCd[obj] === value) {
                return /** @type {?} */ (CorrectionStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CorrectionStatusCdHelper = new CorrectionStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CorrectionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CorrectionTypeCd) {
            this._values.push(CorrectionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CorrectionTypeCd) {
            if (CorrectionTypeCd[obj] === value) {
                return /** @type {?} */ (CorrectionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CorrectionTypeCdHelper = new CorrectionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CostCardTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CostCardTypeCd) {
            this._values.push(CostCardTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CostCardTypeCd) {
            if (CostCardTypeCd[obj] === value) {
                return /** @type {?} */ (CostCardTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CostCardTypeCdHelper = new CostCardTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CountryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CountryCd) {
            this._values.push(CountryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CountryCd) {
            if (CountryCd[obj] === value) {
                return /** @type {?} */ (CountryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CountryCdHelper = new CountryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CouponCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CouponCd) {
            this._values.push(CouponCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CouponCd) {
            if (CouponCd[obj] === value) {
                return /** @type {?} */ (CouponCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CouponCdHelper = new CouponCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CrcAuditCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CrcAuditCd) {
            this._values.push(CrcAuditCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CrcAuditCd) {
            if (CrcAuditCd[obj] === value) {
                return /** @type {?} */ (CrcAuditCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CrcAuditCdHelper = new CrcAuditCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CredStatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CredStatCd) {
            this._values.push(CredStatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CredStatCd) {
            if (CredStatCd[obj] === value) {
                return /** @type {?} */ (CredStatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CredStatCdHelper = new CredStatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CssClassCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CssClassCd) {
            this._values.push(CssClassCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CssClassCd) {
            if (CssClassCd[obj] === value) {
                return /** @type {?} */ (CssClassCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CssClassCdHelper = new CssClassCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CubicFeetProfileMthdCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CubicFeetProfileMthdCd) {
            this._values.push(CubicFeetProfileMthdCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CubicFeetProfileMthdCd) {
            if (CubicFeetProfileMthdCd[obj] === value) {
                return /** @type {?} */ (CubicFeetProfileMthdCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CubicFeetProfileMthdCdHelper = new CubicFeetProfileMthdCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CubicFeetProfileTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CubicFeetProfileTypeCd) {
            this._values.push(CubicFeetProfileTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CubicFeetProfileTypeCd) {
            if (CubicFeetProfileTypeCd[obj] === value) {
                return /** @type {?} */ (CubicFeetProfileTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CubicFeetProfileTypeCdHelper = new CubicFeetProfileTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CurrencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CurrencyCd) {
            this._values.push(CurrencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CurrencyCd) {
            if (CurrencyCd[obj] === value) {
                return /** @type {?} */ (CurrencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CurrencyCdHelper = new CurrencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustOperationHoursTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustOperationHoursTypeCd) {
            this._values.push(CustOperationHoursTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustOperationHoursTypeCd) {
            if (CustOperationHoursTypeCd[obj] === value) {
                return /** @type {?} */ (CustOperationHoursTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustOperationHoursTypeCdHelper = new CustOperationHoursTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustOperationNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustOperationNoteTypeCd) {
            this._values.push(CustOperationNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustOperationNoteTypeCd) {
            if (CustOperationNoteTypeCd[obj] === value) {
                return /** @type {?} */ (CustOperationNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustOperationNoteTypeCdHelper = new CustOperationNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustOperationsPickupTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustOperationsPickupTypeCd) {
            this._values.push(CustOperationsPickupTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustOperationsPickupTypeCd) {
            if (CustOperationsPickupTypeCd[obj] === value) {
                return /** @type {?} */ (CustOperationsPickupTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustOperationsPickupTypeCdHelper = new CustOperationsPickupTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerAccountTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerAccountTypeCd) {
            this._values.push(CustomerAccountTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerAccountTypeCd) {
            if (CustomerAccountTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerAccountTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerAccountTypeCdHelper = new CustomerAccountTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerAddressValidationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerAddressValidationCd) {
            this._values.push(CustomerAddressValidationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerAddressValidationCd) {
            if (CustomerAddressValidationCd[obj] === value) {
                return /** @type {?} */ (CustomerAddressValidationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerAddressValidationCdHelper = new CustomerAddressValidationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerContactRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerContactRoleCd) {
            this._values.push(CustomerContactRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerContactRoleCd) {
            if (CustomerContactRoleCd[obj] === value) {
                return /** @type {?} */ (CustomerContactRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerContactRoleCdHelper = new CustomerContactRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerCreditStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerCreditStatusCd) {
            this._values.push(CustomerCreditStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerCreditStatusCd) {
            if (CustomerCreditStatusCd[obj] === value) {
                return /** @type {?} */ (CustomerCreditStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerCreditStatusCdHelper = new CustomerCreditStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerDetailCd) {
            this._values.push(CustomerDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerDetailCd) {
            if (CustomerDetailCd[obj] === value) {
                return /** @type {?} */ (CustomerDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerDetailCdHelper = new CustomerDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerExpiryReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerExpiryReasonCd) {
            this._values.push(CustomerExpiryReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerExpiryReasonCd) {
            if (CustomerExpiryReasonCd[obj] === value) {
                return /** @type {?} */ (CustomerExpiryReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerExpiryReasonCdHelper = new CustomerExpiryReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerFunctionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerFunctionCd) {
            this._values.push(CustomerFunctionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerFunctionCd) {
            if (CustomerFunctionCd[obj] === value) {
                return /** @type {?} */ (CustomerFunctionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerFunctionCdHelper = new CustomerFunctionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerHoldCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerHoldCategoryCd) {
            this._values.push(CustomerHoldCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerHoldCategoryCd) {
            if (CustomerHoldCategoryCd[obj] === value) {
                return /** @type {?} */ (CustomerHoldCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerHoldCategoryCdHelper = new CustomerHoldCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerIdTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerIdTypeCd) {
            this._values.push(CustomerIdTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerIdTypeCd) {
            if (CustomerIdTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerIdTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerIdTypeCdHelper = new CustomerIdTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerInvoiceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerInvoiceCd) {
            this._values.push(CustomerInvoiceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerInvoiceCd) {
            if (CustomerInvoiceCd[obj] === value) {
                return /** @type {?} */ (CustomerInvoiceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerInvoiceCdHelper = new CustomerInvoiceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerLineStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerLineStatusCd) {
            this._values.push(CustomerLineStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerLineStatusCd) {
            if (CustomerLineStatusCd[obj] === value) {
                return /** @type {?} */ (CustomerLineStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerLineStatusCdHelper = new CustomerLineStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerMatchRequestTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerMatchRequestTypeCd) {
            this._values.push(CustomerMatchRequestTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerMatchRequestTypeCd) {
            if (CustomerMatchRequestTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerMatchRequestTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerMatchRequestTypeCdHelper = new CustomerMatchRequestTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerMatchResultTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerMatchResultTypeCd) {
            this._values.push(CustomerMatchResultTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerMatchResultTypeCd) {
            if (CustomerMatchResultTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerMatchResultTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerMatchResultTypeCdHelper = new CustomerMatchResultTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNoteForCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNoteForCd) {
            this._values.push(CustomerNoteForCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNoteForCd) {
            if (CustomerNoteForCd[obj] === value) {
                return /** @type {?} */ (CustomerNoteForCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNoteForCdHelper = new CustomerNoteForCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNoteTypeCd) {
            this._values.push(CustomerNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNoteTypeCd) {
            if (CustomerNoteTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNoteTypeCdHelper = new CustomerNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationActionFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationActionFormatCd) {
            this._values.push(CustomerNotificationActionFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationActionFormatCd) {
            if (CustomerNotificationActionFormatCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationActionFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationActionFormatCdHelper = new CustomerNotificationActionFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationBroadcastCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationBroadcastCd) {
            this._values.push(CustomerNotificationBroadcastCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationBroadcastCd) {
            if (CustomerNotificationBroadcastCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationBroadcastCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationBroadcastCdHelper = new CustomerNotificationBroadcastCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationLevelCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationLevelCd) {
            this._values.push(CustomerNotificationLevelCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationLevelCd) {
            if (CustomerNotificationLevelCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationLevelCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationLevelCdHelper = new CustomerNotificationLevelCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationPayloadFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationPayloadFormatCd) {
            this._values.push(CustomerNotificationPayloadFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationPayloadFormatCd) {
            if (CustomerNotificationPayloadFormatCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationPayloadFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationPayloadFormatCdHelper = new CustomerNotificationPayloadFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationPriorityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationPriorityCd) {
            this._values.push(CustomerNotificationPriorityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationPriorityCd) {
            if (CustomerNotificationPriorityCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationPriorityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationPriorityCdHelper = new CustomerNotificationPriorityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerNotificationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerNotificationTypeCd) {
            this._values.push(CustomerNotificationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerNotificationTypeCd) {
            if (CustomerNotificationTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerNotificationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerNotificationTypeCdHelper = new CustomerNotificationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerPaymentTermsCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerPaymentTermsCd) {
            this._values.push(CustomerPaymentTermsCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerPaymentTermsCd) {
            if (CustomerPaymentTermsCd[obj] === value) {
                return /** @type {?} */ (CustomerPaymentTermsCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerPaymentTermsCdHelper = new CustomerPaymentTermsCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerProfileDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerProfileDetailCd) {
            this._values.push(CustomerProfileDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerProfileDetailCd) {
            if (CustomerProfileDetailCd[obj] === value) {
                return /** @type {?} */ (CustomerProfileDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerProfileDetailCdHelper = new CustomerProfileDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerRequestPriorityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerRequestPriorityCd) {
            this._values.push(CustomerRequestPriorityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerRequestPriorityCd) {
            if (CustomerRequestPriorityCd[obj] === value) {
                return /** @type {?} */ (CustomerRequestPriorityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerRequestPriorityCdHelper = new CustomerRequestPriorityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerRequestQueueNameCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerRequestQueueNameCd) {
            this._values.push(CustomerRequestQueueNameCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerRequestQueueNameCd) {
            if (CustomerRequestQueueNameCd[obj] === value) {
                return /** @type {?} */ (CustomerRequestQueueNameCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerRequestQueueNameCdHelper = new CustomerRequestQueueNameCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerRequestStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerRequestStatusCd) {
            this._values.push(CustomerRequestStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerRequestStatusCd) {
            if (CustomerRequestStatusCd[obj] === value) {
                return /** @type {?} */ (CustomerRequestStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerRequestStatusCdHelper = new CustomerRequestStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerStatusCd) {
            this._values.push(CustomerStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerStatusCd) {
            if (CustomerStatusCd[obj] === value) {
                return /** @type {?} */ (CustomerStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerStatusCdHelper = new CustomerStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerTypeCd) {
            this._values.push(CustomerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerTypeCd) {
            if (CustomerTypeCd[obj] === value) {
                return /** @type {?} */ (CustomerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerTypeCdHelper = new CustomerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomerTypeOfSvcIndicatorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomerTypeOfSvcIndicatorCd) {
            this._values.push(CustomerTypeOfSvcIndicatorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomerTypeOfSvcIndicatorCd) {
            if (CustomerTypeOfSvcIndicatorCd[obj] === value) {
                return /** @type {?} */ (CustomerTypeOfSvcIndicatorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomerTypeOfSvcIndicatorCdHelper = new CustomerTypeOfSvcIndicatorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomsControlTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomsControlTypeCd) {
            this._values.push(CustomsControlTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomsControlTypeCd) {
            if (CustomsControlTypeCd[obj] === value) {
                return /** @type {?} */ (CustomsControlTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomsControlTypeCdHelper = new CustomsControlTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomsPortCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomsPortCd) {
            this._values.push(CustomsPortCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomsPortCd) {
            if (CustomsPortCd[obj] === value) {
                return /** @type {?} */ (CustomsPortCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomsPortCdHelper = new CustomsPortCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CustomsReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in CustomsReasonCd) {
            this._values.push(CustomsReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in CustomsReasonCd) {
            if (CustomsReasonCd[obj] === value) {
                return /** @type {?} */ (CustomsReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ CustomsReasonCdHelper = new CustomsReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DamageTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DamageTypeCd) {
            this._values.push(DamageTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DamageTypeCd) {
            if (DamageTypeCd[obj] === value) {
                return /** @type {?} */ (DamageTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DamageTypeCdHelper = new DamageTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DebtorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DebtorCd) {
            this._values.push(DebtorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DebtorCd) {
            if (DebtorCd[obj] === value) {
                return /** @type {?} */ (DebtorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DebtorCdHelper = new DebtorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeliveryDateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeliveryDateTypeCd) {
            this._values.push(DeliveryDateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeliveryDateTypeCd) {
            if (DeliveryDateTypeCd[obj] === value) {
                return /** @type {?} */ (DeliveryDateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeliveryDateTypeCdHelper = new DeliveryDateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeliveryInfoRequiredCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeliveryInfoRequiredCd) {
            this._values.push(DeliveryInfoRequiredCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeliveryInfoRequiredCd) {
            if (DeliveryInfoRequiredCd[obj] === value) {
                return /** @type {?} */ (DeliveryInfoRequiredCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeliveryInfoRequiredCdHelper = new DeliveryInfoRequiredCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeliveryQualifierCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeliveryQualifierCd) {
            this._values.push(DeliveryQualifierCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeliveryQualifierCd) {
            if (DeliveryQualifierCd[obj] === value) {
                return /** @type {?} */ (DeliveryQualifierCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeliveryQualifierCdHelper = new DeliveryQualifierCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeliveryQualifierReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeliveryQualifierReasonCd) {
            this._values.push(DeliveryQualifierReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeliveryQualifierReasonCd) {
            if (DeliveryQualifierReasonCd[obj] === value) {
                return /** @type {?} */ (DeliveryQualifierReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeliveryQualifierReasonCdHelper = new DeliveryQualifierReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeliveryShipmentIndexCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeliveryShipmentIndexCd) {
            this._values.push(DeliveryShipmentIndexCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeliveryShipmentIndexCd) {
            if (DeliveryShipmentIndexCd[obj] === value) {
                return /** @type {?} */ (DeliveryShipmentIndexCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeliveryShipmentIndexCdHelper = new DeliveryShipmentIndexCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeltaSignCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeltaSignCd) {
            this._values.push(DeltaSignCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeltaSignCd) {
            if (DeltaSignCd[obj] === value) {
                return /** @type {?} */ (DeltaSignCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeltaSignCdHelper = new DeltaSignCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeltaVarianceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeltaVarianceTypeCd) {
            this._values.push(DeltaVarianceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeltaVarianceTypeCd) {
            if (DeltaVarianceTypeCd[obj] === value) {
                return /** @type {?} */ (DeltaVarianceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeltaVarianceTypeCdHelper = new DeltaVarianceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DensitySourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DensitySourceCd) {
            this._values.push(DensitySourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DensitySourceCd) {
            if (DensitySourceCd[obj] === value) {
                return /** @type {?} */ (DensitySourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DensitySourceCdHelper = new DensitySourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DependentFreightTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DependentFreightTypeCd) {
            this._values.push(DependentFreightTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DependentFreightTypeCd) {
            if (DependentFreightTypeCd[obj] === value) {
                return /** @type {?} */ (DependentFreightTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DependentFreightTypeCdHelper = new DependentFreightTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeviceApplicationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeviceApplicationCd) {
            this._values.push(DeviceApplicationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeviceApplicationCd) {
            if (DeviceApplicationCd[obj] === value) {
                return /** @type {?} */ (DeviceApplicationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeviceApplicationCdHelper = new DeviceApplicationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeviceShiftCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeviceShiftCd) {
            this._values.push(DeviceShiftCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeviceShiftCd) {
            if (DeviceShiftCd[obj] === value) {
                return /** @type {?} */ (DeviceShiftCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeviceShiftCdHelper = new DeviceShiftCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DeviceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DeviceTypeCd) {
            this._values.push(DeviceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DeviceTypeCd) {
            if (DeviceTypeCd[obj] === value) {
                return /** @type {?} */ (DeviceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DeviceTypeCdHelper = new DeviceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DimensionSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DimensionSourceCd) {
            this._values.push(DimensionSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DimensionSourceCd) {
            if (DimensionSourceCd[obj] === value) {
                return /** @type {?} */ (DimensionSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DimensionSourceCdHelper = new DimensionSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DimensionUomCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DimensionUomCd) {
            this._values.push(DimensionUomCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DimensionUomCd) {
            if (DimensionUomCd[obj] === value) {
                return /** @type {?} */ (DimensionUomCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DimensionUomCdHelper = new DimensionUomCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DirectedLoadingExceptionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DirectedLoadingExceptionTypeCd) {
            this._values.push(DirectedLoadingExceptionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DirectedLoadingExceptionTypeCd) {
            if (DirectedLoadingExceptionTypeCd[obj] === value) {
                return /** @type {?} */ (DirectedLoadingExceptionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DirectedLoadingExceptionTypeCdHelper = new DirectedLoadingExceptionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DirectedLoadingLaneTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DirectedLoadingLaneTypeCd) {
            this._values.push(DirectedLoadingLaneTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DirectedLoadingLaneTypeCd) {
            if (DirectedLoadingLaneTypeCd[obj] === value) {
                return /** @type {?} */ (DirectedLoadingLaneTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DirectedLoadingLaneTypeCdHelper = new DirectedLoadingLaneTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeAreaCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeAreaCd) {
            this._values.push(DisputeAreaCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeAreaCd) {
            if (DisputeAreaCd[obj] === value) {
                return /** @type {?} */ (DisputeAreaCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeAreaCdHelper = new DisputeAreaCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeCsvFileStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeCsvFileStatusCd) {
            this._values.push(DisputeCsvFileStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeCsvFileStatusCd) {
            if (DisputeCsvFileStatusCd[obj] === value) {
                return /** @type {?} */ (DisputeCsvFileStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeCsvFileStatusCdHelper = new DisputeCsvFileStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeCsvFileUploadStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeCsvFileUploadStatusCd) {
            this._values.push(DisputeCsvFileUploadStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeCsvFileUploadStatusCd) {
            if (DisputeCsvFileUploadStatusCd[obj] === value) {
                return /** @type {?} */ (DisputeCsvFileUploadStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeCsvFileUploadStatusCdHelper = new DisputeCsvFileUploadStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeDecisionReasonSubTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeDecisionReasonSubTypeCd) {
            this._values.push(DisputeDecisionReasonSubTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeDecisionReasonSubTypeCd) {
            if (DisputeDecisionReasonSubTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeDecisionReasonSubTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeDecisionReasonSubTypeCdHelper = new DisputeDecisionReasonSubTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeDecisionReasonTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeDecisionReasonTypeCd) {
            this._values.push(DisputeDecisionReasonTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeDecisionReasonTypeCd) {
            if (DisputeDecisionReasonTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeDecisionReasonTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeDecisionReasonTypeCdHelper = new DisputeDecisionReasonTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeDrpCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeDrpCategoryCd) {
            this._values.push(DisputeDrpCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeDrpCategoryCd) {
            if (DisputeDrpCategoryCd[obj] === value) {
                return /** @type {?} */ (DisputeDrpCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeDrpCategoryCdHelper = new DisputeDrpCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeEmailTemplateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeEmailTemplateTypeCd) {
            this._values.push(DisputeEmailTemplateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeEmailTemplateTypeCd) {
            if (DisputeEmailTemplateTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeEmailTemplateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeEmailTemplateTypeCdHelper = new DisputeEmailTemplateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeEventTypeCd) {
            this._values.push(DisputeEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeEventTypeCd) {
            if (DisputeEventTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeEventTypeCdHelper = new DisputeEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeFilingMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeFilingMethodCd) {
            this._values.push(DisputeFilingMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeFilingMethodCd) {
            if (DisputeFilingMethodCd[obj] === value) {
                return /** @type {?} */ (DisputeFilingMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeFilingMethodCdHelper = new DisputeFilingMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeNoteTypeCd) {
            this._values.push(DisputeNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeNoteTypeCd) {
            if (DisputeNoteTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeNoteTypeCdHelper = new DisputeNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputePartyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputePartyTypeCd) {
            this._values.push(DisputePartyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputePartyTypeCd) {
            if (DisputePartyTypeCd[obj] === value) {
                return /** @type {?} */ (DisputePartyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputePartyTypeCdHelper = new DisputePartyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeProValidationStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeProValidationStatusCd) {
            this._values.push(DisputeProValidationStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeProValidationStatusCd) {
            if (DisputeProValidationStatusCd[obj] === value) {
                return /** @type {?} */ (DisputeProValidationStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeProValidationStatusCdHelper = new DisputeProValidationStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeReassignReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeReassignReasonCd) {
            this._values.push(DisputeReassignReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeReassignReasonCd) {
            if (DisputeReassignReasonCd[obj] === value) {
                return /** @type {?} */ (DisputeReassignReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeReassignReasonCdHelper = new DisputeReassignReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeRequestReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeRequestReasonCd) {
            this._values.push(DisputeRequestReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeRequestReasonCd) {
            if (DisputeRequestReasonCd[obj] === value) {
                return /** @type {?} */ (DisputeRequestReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeRequestReasonCdHelper = new DisputeRequestReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeShipmentCurrencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeShipmentCurrencyCd) {
            this._values.push(DisputeShipmentCurrencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeShipmentCurrencyCd) {
            if (DisputeShipmentCurrencyCd[obj] === value) {
                return /** @type {?} */ (DisputeShipmentCurrencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeShipmentCurrencyCdHelper = new DisputeShipmentCurrencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeShipmentPaymentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeShipmentPaymentStatusCd) {
            this._values.push(DisputeShipmentPaymentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeShipmentPaymentStatusCd) {
            if (DisputeShipmentPaymentStatusCd[obj] === value) {
                return /** @type {?} */ (DisputeShipmentPaymentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeShipmentPaymentStatusCdHelper = new DisputeShipmentPaymentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeShpIneligibilityRsnCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeShpIneligibilityRsnCd) {
            this._values.push(DisputeShpIneligibilityRsnCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeShpIneligibilityRsnCd) {
            if (DisputeShpIneligibilityRsnCd[obj] === value) {
                return /** @type {?} */ (DisputeShpIneligibilityRsnCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeShpIneligibilityRsnCdHelper = new DisputeShpIneligibilityRsnCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeStatusCd) {
            this._values.push(DisputeStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeStatusCd) {
            if (DisputeStatusCd[obj] === value) {
                return /** @type {?} */ (DisputeStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeStatusCdHelper = new DisputeStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DisputeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DisputeTypeCd) {
            this._values.push(DisputeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DisputeTypeCd) {
            if (DisputeTypeCd[obj] === value) {
                return /** @type {?} */ (DisputeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DisputeTypeCdHelper = new DisputeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DmsDocTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DmsDocTypeCd) {
            this._values.push(DmsDocTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DmsDocTypeCd) {
            if (DmsDocTypeCd[obj] === value) {
                return /** @type {?} */ (DmsDocTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DmsDocTypeCdHelper = new DmsDocTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockActivityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockActivityCd) {
            this._values.push(DockActivityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockActivityCd) {
            if (DockActivityCd[obj] === value) {
                return /** @type {?} */ (DockActivityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockActivityCdHelper = new DockActivityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockManifestReportTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockManifestReportTypeCd) {
            this._values.push(DockManifestReportTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockManifestReportTypeCd) {
            if (DockManifestReportTypeCd[obj] === value) {
                return /** @type {?} */ (DockManifestReportTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockManifestReportTypeCdHelper = new DockManifestReportTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockOperationsReportTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockOperationsReportTypeCd) {
            this._values.push(DockOperationsReportTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockOperationsReportTypeCd) {
            if (DockOperationsReportTypeCd[obj] === value) {
                return /** @type {?} */ (DockOperationsReportTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockOperationsReportTypeCdHelper = new DockOperationsReportTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockShipmentListTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockShipmentListTypeCd) {
            this._values.push(DockShipmentListTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockShipmentListTypeCd) {
            if (DockShipmentListTypeCd[obj] === value) {
                return /** @type {?} */ (DockShipmentListTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockShipmentListTypeCdHelper = new DockShipmentListTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockShipmentProgressCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockShipmentProgressCd) {
            this._values.push(DockShipmentProgressCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockShipmentProgressCd) {
            if (DockShipmentProgressCd[obj] === value) {
                return /** @type {?} */ (DockShipmentProgressCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockShipmentProgressCdHelper = new DockShipmentProgressCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DockShipmentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DockShipmentTypeCd) {
            this._values.push(DockShipmentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DockShipmentTypeCd) {
            if (DockShipmentTypeCd[obj] === value) {
                return /** @type {?} */ (DockShipmentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DockShipmentTypeCdHelper = new DockShipmentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DocumentFormTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DocumentFormTypeCd) {
            this._values.push(DocumentFormTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DocumentFormTypeCd) {
            if (DocumentFormTypeCd[obj] === value) {
                return /** @type {?} */ (DocumentFormTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DocumentFormTypeCdHelper = new DocumentFormTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DoorMatchCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DoorMatchCd) {
            this._values.push(DoorMatchCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DoorMatchCd) {
            if (DoorMatchCd[obj] === value) {
                return /** @type {?} */ (DoorMatchCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DoorMatchCdHelper = new DoorMatchCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DoorPlanActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DoorPlanActionCd) {
            this._values.push(DoorPlanActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DoorPlanActionCd) {
            if (DoorPlanActionCd[obj] === value) {
                return /** @type {?} */ (DoorPlanActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DoorPlanActionCdHelper = new DoorPlanActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DoorPlanProfileTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DoorPlanProfileTypeCd) {
            this._values.push(DoorPlanProfileTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DoorPlanProfileTypeCd) {
            if (DoorPlanProfileTypeCd[obj] === value) {
                return /** @type {?} */ (DoorPlanProfileTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DoorPlanProfileTypeCdHelper = new DoorPlanProfileTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DoorPreferenceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DoorPreferenceTypeCd) {
            this._values.push(DoorPreferenceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DoorPreferenceTypeCd) {
            if (DoorPreferenceTypeCd[obj] === value) {
                return /** @type {?} */ (DoorPreferenceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DoorPreferenceTypeCdHelper = new DoorPreferenceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DriverJobTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DriverJobTypeCd) {
            this._values.push(DriverJobTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DriverJobTypeCd) {
            if (DriverJobTypeCd[obj] === value) {
                return /** @type {?} */ (DriverJobTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DriverJobTypeCdHelper = new DriverJobTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DriverMessageOperationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DriverMessageOperationCd) {
            this._values.push(DriverMessageOperationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DriverMessageOperationCd) {
            if (DriverMessageOperationCd[obj] === value) {
                return /** @type {?} */ (DriverMessageOperationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DriverMessageOperationCdHelper = new DriverMessageOperationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DriverSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DriverSourceCd) {
            this._values.push(DriverSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DriverSourceCd) {
            if (DriverSourceCd[obj] === value) {
                return /** @type {?} */ (DriverSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DriverSourceCdHelper = new DriverSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DriverTurnTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DriverTurnTypeCd) {
            this._values.push(DriverTurnTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DriverTurnTypeCd) {
            if (DriverTurnTypeCd[obj] === value) {
                return /** @type {?} */ (DriverTurnTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DriverTurnTypeCdHelper = new DriverTurnTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DsrLicenseCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DsrLicenseCd) {
            this._values.push(DsrLicenseCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DsrLicenseCd) {
            if (DsrLicenseCd[obj] === value) {
                return /** @type {?} */ (DsrLicenseCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DsrLicenseCdHelper = new DsrLicenseCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DsrSelectionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DsrSelectionTypeCd) {
            this._values.push(DsrSelectionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DsrSelectionTypeCd) {
            if (DsrSelectionTypeCd[obj] === value) {
                return /** @type {?} */ (DsrSelectionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DsrSelectionTypeCdHelper = new DsrSelectionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DwellPeriodTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DwellPeriodTypeCd) {
            this._values.push(DwellPeriodTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DwellPeriodTypeCd) {
            if (DwellPeriodTypeCd[obj] === value) {
                return /** @type {?} */ (DwellPeriodTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DwellPeriodTypeCdHelper = new DwellPeriodTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DwellReasonTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DwellReasonTypeCd) {
            this._values.push(DwellReasonTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DwellReasonTypeCd) {
            if (DwellReasonTypeCd[obj] === value) {
                return /** @type {?} */ (DwellReasonTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DwellReasonTypeCdHelper = new DwellReasonTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DwellSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DwellSourceCd) {
            this._values.push(DwellSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DwellSourceCd) {
            if (DwellSourceCd[obj] === value) {
                return /** @type {?} */ (DwellSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DwellSourceCdHelper = new DwellSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceApiNameCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceApiNameCd) {
            this._values.push(DynamicPriceApiNameCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceApiNameCd) {
            if (DynamicPriceApiNameCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceApiNameCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceApiNameCdHelper = new DynamicPriceApiNameCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceApplicationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceApplicationTypeCd) {
            this._values.push(DynamicPriceApplicationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceApplicationTypeCd) {
            if (DynamicPriceApplicationTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceApplicationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceApplicationTypeCdHelper = new DynamicPriceApplicationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceEventTypeCd) {
            this._values.push(DynamicPriceEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceEventTypeCd) {
            if (DynamicPriceEventTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceEventTypeCdHelper = new DynamicPriceEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceLTLBillStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceLTLBillStatusCd) {
            this._values.push(DynamicPriceLTLBillStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceLTLBillStatusCd) {
            if (DynamicPriceLTLBillStatusCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceLTLBillStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceLTLBillStatusCdHelper = new DynamicPriceLTLBillStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceLaneTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceLaneTypeCd) {
            this._values.push(DynamicPriceLaneTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceLaneTypeCd) {
            if (DynamicPriceLaneTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceLaneTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceLaneTypeCdHelper = new DynamicPriceLaneTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceLocationTypeCd) {
            this._values.push(DynamicPriceLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceLocationTypeCd) {
            if (DynamicPriceLocationTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceLocationTypeCdHelper = new DynamicPriceLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceQualifierTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceQualifierTypeCd) {
            this._values.push(DynamicPriceQualifierTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceQualifierTypeCd) {
            if (DynamicPriceQualifierTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceQualifierTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceQualifierTypeCdHelper = new DynamicPriceQualifierTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceRateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceRateTypeCd) {
            this._values.push(DynamicPriceRateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceRateTypeCd) {
            if (DynamicPriceRateTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceRateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceRateTypeCdHelper = new DynamicPriceRateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceRestrictionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceRestrictionTypeCd) {
            this._values.push(DynamicPriceRestrictionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceRestrictionTypeCd) {
            if (DynamicPriceRestrictionTypeCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceRestrictionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceRestrictionTypeCdHelper = new DynamicPriceRestrictionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DynamicPriceStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in DynamicPriceStatusCd) {
            this._values.push(DynamicPriceStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DynamicPriceStatusCd) {
            if (DynamicPriceStatusCd[obj] === value) {
                return /** @type {?} */ (DynamicPriceStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ DynamicPriceStatusCdHelper = new DynamicPriceStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EarlyCutoffCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EarlyCutoffCd) {
            this._values.push(EarlyCutoffCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EarlyCutoffCd) {
            if (EarlyCutoffCd[obj] === value) {
                return /** @type {?} */ (EarlyCutoffCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EarlyCutoffCdHelper = new EarlyCutoffCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EcmGoalTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EcmGoalTypeCd) {
            this._values.push(EcmGoalTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EcmGoalTypeCd) {
            if (EcmGoalTypeCd[obj] === value) {
                return /** @type {?} */ (EcmGoalTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EcmGoalTypeCdHelper = new EcmGoalTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EcmSummaryCountTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EcmSummaryCountTypeCd) {
            this._values.push(EcmSummaryCountTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EcmSummaryCountTypeCd) {
            if (EcmSummaryCountTypeCd[obj] === value) {
                return /** @type {?} */ (EcmSummaryCountTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EcmSummaryCountTypeCdHelper = new EcmSummaryCountTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EdiSlashPoundCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EdiSlashPoundCd) {
            this._values.push(EdiSlashPoundCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EdiSlashPoundCd) {
            if (EdiSlashPoundCd[obj] === value) {
                return /** @type {?} */ (EdiSlashPoundCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EdiSlashPoundCdHelper = new EdiSlashPoundCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EmailDirectionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EmailDirectionTypeCd) {
            this._values.push(EmailDirectionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EmailDirectionTypeCd) {
            if (EmailDirectionTypeCd[obj] === value) {
                return /** @type {?} */ (EmailDirectionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EmailDirectionTypeCdHelper = new EmailDirectionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EmailFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EmailFormatCd) {
            this._values.push(EmailFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EmailFormatCd) {
            if (EmailFormatCd[obj] === value) {
                return /** @type {?} */ (EmailFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EmailFormatCdHelper = new EmailFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EmployeeIdTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EmployeeIdTypeCd) {
            this._values.push(EmployeeIdTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EmployeeIdTypeCd) {
            if (EmployeeIdTypeCd[obj] === value) {
                return /** @type {?} */ (EmployeeIdTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EmployeeIdTypeCdHelper = new EmployeeIdTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EmployeeRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EmployeeRoleCd) {
            this._values.push(EmployeeRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EmployeeRoleCd) {
            if (EmployeeRoleCd[obj] === value) {
                return /** @type {?} */ (EmployeeRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EmployeeRoleCdHelper = new EmployeeRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EnsembleExecutionStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EnsembleExecutionStatusCd) {
            this._values.push(EnsembleExecutionStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EnsembleExecutionStatusCd) {
            if (EnsembleExecutionStatusCd[obj] === value) {
                return /** @type {?} */ (EnsembleExecutionStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EnsembleExecutionStatusCdHelper = new EnsembleExecutionStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EnsembleListenerModeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EnsembleListenerModeCd) {
            this._values.push(EnsembleListenerModeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EnsembleListenerModeCd) {
            if (EnsembleListenerModeCd[obj] === value) {
                return /** @type {?} */ (EnsembleListenerModeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EnsembleListenerModeCdHelper = new EnsembleListenerModeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EnvironmentCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EnvironmentCd) {
            this._values.push(EnvironmentCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EnvironmentCd) {
            if (EnvironmentCd[obj] === value) {
                return /** @type {?} */ (EnvironmentCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EnvironmentCdHelper = new EnvironmentCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentEventReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentEventReasonCd) {
            this._values.push(EquipmentEventReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentEventReasonCd) {
            if (EquipmentEventReasonCd[obj] === value) {
                return /** @type {?} */ (EquipmentEventReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentEventReasonCdHelper = new EquipmentEventReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentEventSubTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentEventSubTypeCd) {
            this._values.push(EquipmentEventSubTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentEventSubTypeCd) {
            if (EquipmentEventSubTypeCd[obj] === value) {
                return /** @type {?} */ (EquipmentEventSubTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentEventSubTypeCdHelper = new EquipmentEventSubTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentEventTypeCd) {
            this._values.push(EquipmentEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentEventTypeCd) {
            if (EquipmentEventTypeCd[obj] === value) {
                return /** @type {?} */ (EquipmentEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentEventTypeCdHelper = new EquipmentEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentQualifierCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentQualifierCd) {
            this._values.push(EquipmentQualifierCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentQualifierCd) {
            if (EquipmentQualifierCd[obj] === value) {
                return /** @type {?} */ (EquipmentQualifierCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentQualifierCdHelper = new EquipmentQualifierCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentSizeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentSizeCd) {
            this._values.push(EquipmentSizeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentSizeCd) {
            if (EquipmentSizeCd[obj] === value) {
                return /** @type {?} */ (EquipmentSizeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentSizeCdHelper = new EquipmentSizeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentStatusCd) {
            this._values.push(EquipmentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentStatusCd) {
            if (EquipmentStatusCd[obj] === value) {
                return /** @type {?} */ (EquipmentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentStatusCdHelper = new EquipmentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentStatusQualifierCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentStatusQualifierCd) {
            this._values.push(EquipmentStatusQualifierCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentStatusQualifierCd) {
            if (EquipmentStatusQualifierCd[obj] === value) {
                return /** @type {?} */ (EquipmentStatusQualifierCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentStatusQualifierCdHelper = new EquipmentStatusQualifierCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentTypeCd) {
            this._values.push(EquipmentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentTypeCd) {
            if (EquipmentTypeCd[obj] === value) {
                return /** @type {?} */ (EquipmentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentTypeCdHelper = new EquipmentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EquipmentTypeDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EquipmentTypeDetailCd) {
            this._values.push(EquipmentTypeDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EquipmentTypeDetailCd) {
            if (EquipmentTypeDetailCd[obj] === value) {
                return /** @type {?} */ (EquipmentTypeDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EquipmentTypeDetailCdHelper = new EquipmentTypeDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EslCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EslCd) {
            this._values.push(EslCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EslCd) {
            if (EslCd[obj] === value) {
                return /** @type {?} */ (EslCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EslCdHelper = new EslCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EventLogSubTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EventLogSubTypeCd) {
            this._values.push(EventLogSubTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EventLogSubTypeCd) {
            if (EventLogSubTypeCd[obj] === value) {
                return /** @type {?} */ (EventLogSubTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EventLogSubTypeCdHelper = new EventLogSubTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EventLogTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EventLogTypeCd) {
            this._values.push(EventLogTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EventLogTypeCd) {
            if (EventLogTypeCd[obj] === value) {
                return /** @type {?} */ (EventLogTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EventLogTypeCdHelper = new EventLogTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EventSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EventSourceCd) {
            this._values.push(EventSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EventSourceCd) {
            if (EventSourceCd[obj] === value) {
                return /** @type {?} */ (EventSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EventSourceCdHelper = new EventSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in EventTypeCd) {
            this._values.push(EventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in EventTypeCd) {
            if (EventTypeCd[obj] === value) {
                return /** @type {?} */ (EventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ EventTypeCdHelper = new EventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExadataDatabaseCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExadataDatabaseCd) {
            this._values.push(ExadataDatabaseCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExadataDatabaseCd) {
            if (ExadataDatabaseCd[obj] === value) {
                return /** @type {?} */ (ExadataDatabaseCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExadataDatabaseCdHelper = new ExadataDatabaseCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionCategoryCd) {
            this._values.push(ExceptionCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionCategoryCd) {
            if (ExceptionCategoryCd[obj] === value) {
                return /** @type {?} */ (ExceptionCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionCategoryCdHelper = new ExceptionCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionLocationTypeCd) {
            this._values.push(ExceptionLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionLocationTypeCd) {
            if (ExceptionLocationTypeCd[obj] === value) {
                return /** @type {?} */ (ExceptionLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionLocationTypeCdHelper = new ExceptionLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionStatusCd) {
            this._values.push(ExceptionStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionStatusCd) {
            if (ExceptionStatusCd[obj] === value) {
                return /** @type {?} */ (ExceptionStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionStatusCdHelper = new ExceptionStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionSummaryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionSummaryCd) {
            this._values.push(ExceptionSummaryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionSummaryCd) {
            if (ExceptionSummaryCd[obj] === value) {
                return /** @type {?} */ (ExceptionSummaryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionSummaryCdHelper = new ExceptionSummaryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionSummaryTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionSummaryTypeCd) {
            this._values.push(ExceptionSummaryTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionSummaryTypeCd) {
            if (ExceptionSummaryTypeCd[obj] === value) {
                return /** @type {?} */ (ExceptionSummaryTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionSummaryTypeCdHelper = new ExceptionSummaryTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExceptionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExceptionTypeCd) {
            this._values.push(ExceptionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExceptionTypeCd) {
            if (ExceptionTypeCd[obj] === value) {
                return /** @type {?} */ (ExceptionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExceptionTypeCdHelper = new ExceptionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExemptReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExemptReasonCd) {
            this._values.push(ExemptReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExemptReasonCd) {
            if (ExemptReasonCd[obj] === value) {
                return /** @type {?} */ (ExemptReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExemptReasonCdHelper = new ExemptReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExpectationOwnerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExpectationOwnerTypeCd) {
            this._values.push(ExpectationOwnerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExpectationOwnerTypeCd) {
            if (ExpectationOwnerTypeCd[obj] === value) {
                return /** @type {?} */ (ExpectationOwnerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExpectationOwnerTypeCdHelper = new ExpectationOwnerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExpectationStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExpectationStatusCd) {
            this._values.push(ExpectationStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExpectationStatusCd) {
            if (ExpectationStatusCd[obj] === value) {
                return /** @type {?} */ (ExpectationStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExpectationStatusCdHelper = new ExpectationStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExpireReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExpireReasonCd) {
            this._values.push(ExpireReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExpireReasonCd) {
            if (ExpireReasonCd[obj] === value) {
                return /** @type {?} */ (ExpireReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExpireReasonCdHelper = new ExpireReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExtendedServiceLaneTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExtendedServiceLaneTypeCd) {
            this._values.push(ExtendedServiceLaneTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExtendedServiceLaneTypeCd) {
            if (ExtendedServiceLaneTypeCd[obj] === value) {
                return /** @type {?} */ (ExtendedServiceLaneTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExtendedServiceLaneTypeCdHelper = new ExtendedServiceLaneTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ExternalShipmentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ExternalShipmentStatusCd) {
            this._values.push(ExternalShipmentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ExternalShipmentStatusCd) {
            if (ExternalShipmentStatusCd[obj] === value) {
                return /** @type {?} */ (ExternalShipmentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ExternalShipmentStatusCdHelper = new ExternalShipmentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FbdsPrintCountCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FbdsPrintCountCd) {
            this._values.push(FbdsPrintCountCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FbdsPrintCountCd) {
            if (FbdsPrintCountCd[obj] === value) {
                return /** @type {?} */ (FbdsPrintCountCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FbdsPrintCountCdHelper = new FbdsPrintCountCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FbdsVersionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FbdsVersionCd) {
            this._values.push(FbdsVersionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FbdsVersionCd) {
            if (FbdsVersionCd[obj] === value) {
                return /** @type {?} */ (FbdsVersionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FbdsVersionCdHelper = new FbdsVersionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FieldDisplayTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FieldDisplayTypeCd) {
            this._values.push(FieldDisplayTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FieldDisplayTypeCd) {
            if (FieldDisplayTypeCd[obj] === value) {
                return /** @type {?} */ (FieldDisplayTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FieldDisplayTypeCdHelper = new FieldDisplayTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FinalStandardAddressSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FinalStandardAddressSourceCd) {
            this._values.push(FinalStandardAddressSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FinalStandardAddressSourceCd) {
            if (FinalStandardAddressSourceCd[obj] === value) {
                return /** @type {?} */ (FinalStandardAddressSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FinalStandardAddressSourceCdHelper = new FinalStandardAddressSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FinancialFunctionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FinancialFunctionCd) {
            this._values.push(FinancialFunctionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FinancialFunctionCd) {
            if (FinancialFunctionCd[obj] === value) {
                return /** @type {?} */ (FinancialFunctionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FinancialFunctionCdHelper = new FinancialFunctionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FoodPoisonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FoodPoisonCd) {
            this._values.push(FoodPoisonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FoodPoisonCd) {
            if (FoodPoisonCd[obj] === value) {
                return /** @type {?} */ (FoodPoisonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FoodPoisonCdHelper = new FoodPoisonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FreightMaintenanceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FreightMaintenanceTypeCd) {
            this._values.push(FreightMaintenanceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FreightMaintenanceTypeCd) {
            if (FreightMaintenanceTypeCd[obj] === value) {
                return /** @type {?} */ (FreightMaintenanceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FreightMaintenanceTypeCdHelper = new FreightMaintenanceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FreightOperationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FreightOperationTypeCd) {
            this._values.push(FreightOperationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FreightOperationTypeCd) {
            if (FreightOperationTypeCd[obj] === value) {
                return /** @type {?} */ (FreightOperationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FreightOperationTypeCdHelper = new FreightOperationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FreightServiceAreaTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FreightServiceAreaTypeCd) {
            this._values.push(FreightServiceAreaTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FreightServiceAreaTypeCd) {
            if (FreightServiceAreaTypeCd[obj] === value) {
                return /** @type {?} */ (FreightServiceAreaTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FreightServiceAreaTypeCdHelper = new FreightServiceAreaTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FreightStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in FreightStatusCd) {
            this._values.push(FreightStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in FreightStatusCd) {
            if (FreightStatusCd[obj] === value) {
                return /** @type {?} */ (FreightStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ FreightStatusCdHelper = new FreightStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class GeoLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in GeoLocationTypeCd) {
            this._values.push(GeoLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in GeoLocationTypeCd) {
            if (GeoLocationTypeCd[obj] === value) {
                return /** @type {?} */ (GeoLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ GeoLocationTypeCdHelper = new GeoLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class GlobalSearchDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in GlobalSearchDetailCd) {
            this._values.push(GlobalSearchDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in GlobalSearchDetailCd) {
            if (GlobalSearchDetailCd[obj] === value) {
                return /** @type {?} */ (GlobalSearchDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ GlobalSearchDetailCdHelper = new GlobalSearchDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class GoalLevelCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in GoalLevelCd) {
            this._values.push(GoalLevelCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in GoalLevelCd) {
            if (GoalLevelCd[obj] === value) {
                return /** @type {?} */ (GoalLevelCd[obj]);
            }
        }
    }
}
const /** @type {?} */ GoalLevelCdHelper = new GoalLevelCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class GoalTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in GoalTypeCd) {
            this._values.push(GoalTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in GoalTypeCd) {
            if (GoalTypeCd[obj] === value) {
                return /** @type {?} */ (GoalTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ GoalTypeCdHelper = new GoalTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HandlingUnitDimensionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HandlingUnitDimensionTypeCd) {
            this._values.push(HandlingUnitDimensionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HandlingUnitDimensionTypeCd) {
            if (HandlingUnitDimensionTypeCd[obj] === value) {
                return /** @type {?} */ (HandlingUnitDimensionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HandlingUnitDimensionTypeCdHelper = new HandlingUnitDimensionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HandlingUnitMovementTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HandlingUnitMovementTypeCd) {
            this._values.push(HandlingUnitMovementTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HandlingUnitMovementTypeCd) {
            if (HandlingUnitMovementTypeCd[obj] === value) {
                return /** @type {?} */ (HandlingUnitMovementTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HandlingUnitMovementTypeCdHelper = new HandlingUnitMovementTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HandlingUnitTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HandlingUnitTypeCd) {
            this._values.push(HandlingUnitTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HandlingUnitTypeCd) {
            if (HandlingUnitTypeCd[obj] === value) {
                return /** @type {?} */ (HandlingUnitTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HandlingUnitTypeCdHelper = new HandlingUnitTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HazmatBulkQuantityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HazmatBulkQuantityCd) {
            this._values.push(HazmatBulkQuantityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HazmatBulkQuantityCd) {
            if (HazmatBulkQuantityCd[obj] === value) {
                return /** @type {?} */ (HazmatBulkQuantityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HazmatBulkQuantityCdHelper = new HazmatBulkQuantityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HazmatSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HazmatSourceCd) {
            this._values.push(HazmatSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HazmatSourceCd) {
            if (HazmatSourceCd[obj] === value) {
                return /** @type {?} */ (HazmatSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HazmatSourceCdHelper = new HazmatSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HierarchyGroupCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HierarchyGroupCategoryCd) {
            this._values.push(HierarchyGroupCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HierarchyGroupCategoryCd) {
            if (HierarchyGroupCategoryCd[obj] === value) {
                return /** @type {?} */ (HierarchyGroupCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HierarchyGroupCategoryCdHelper = new HierarchyGroupCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HookCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HookCategoryCd) {
            this._values.push(HookCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HookCategoryCd) {
            if (HookCategoryCd[obj] === value) {
                return /** @type {?} */ (HookCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HookCategoryCdHelper = new HookCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HookStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HookStatusCd) {
            this._values.push(HookStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HookStatusCd) {
            if (HookStatusCd[obj] === value) {
                return /** @type {?} */ (HookStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HookStatusCdHelper = new HookStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HostlerInstructionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HostlerInstructionCd) {
            this._values.push(HostlerInstructionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HostlerInstructionCd) {
            if (HostlerInstructionCd[obj] === value) {
                return /** @type {?} */ (HostlerInstructionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HostlerInstructionCdHelper = new HostlerInstructionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HssRegionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HssRegionCd) {
            this._values.push(HssRegionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HssRegionCd) {
            if (HssRegionCd[obj] === value) {
                return /** @type {?} */ (HssRegionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ HssRegionCdHelper = new HssRegionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class HttpMethodHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in HttpMethod) {
            this._values.push(HttpMethod[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in HttpMethod) {
            if (HttpMethod[obj] === value) {
                return /** @type {?} */ (HttpMethod[obj]);
            }
        }
    }
}
const /** @type {?} */ HttpMethodHelper = new HttpMethodHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class IdentifiedLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in IdentifiedLocationTypeCd) {
            this._values.push(IdentifiedLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in IdentifiedLocationTypeCd) {
            if (IdentifiedLocationTypeCd[obj] === value) {
                return /** @type {?} */ (IdentifiedLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ IdentifiedLocationTypeCdHelper = new IdentifiedLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InstructionStatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InstructionStatCd) {
            this._values.push(InstructionStatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InstructionStatCd) {
            if (InstructionStatCd[obj] === value) {
                return /** @type {?} */ (InstructionStatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InstructionStatCdHelper = new InstructionStatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class IntermodalSatelliteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in IntermodalSatelliteTypeCd) {
            this._values.push(IntermodalSatelliteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in IntermodalSatelliteTypeCd) {
            if (IntermodalSatelliteTypeCd[obj] === value) {
                return /** @type {?} */ (IntermodalSatelliteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ IntermodalSatelliteTypeCdHelper = new IntermodalSatelliteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvPaymentChrgToCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvPaymentChrgToCd) {
            this._values.push(InvPaymentChrgToCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvPaymentChrgToCd) {
            if (InvPaymentChrgToCd[obj] === value) {
                return /** @type {?} */ (InvPaymentChrgToCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvPaymentChrgToCdHelper = new InvPaymentChrgToCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceAccuracyConstraintCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceAccuracyConstraintCd) {
            this._values.push(InvoiceAccuracyConstraintCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceAccuracyConstraintCd) {
            if (InvoiceAccuracyConstraintCd[obj] === value) {
                return /** @type {?} */ (InvoiceAccuracyConstraintCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceAccuracyConstraintCdHelper = new InvoiceAccuracyConstraintCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceAddressCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceAddressCd) {
            this._values.push(InvoiceAddressCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceAddressCd) {
            if (InvoiceAddressCd[obj] === value) {
                return /** @type {?} */ (InvoiceAddressCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceAddressCdHelper = new InvoiceAddressCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceAttachmentCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceAttachmentCd) {
            this._values.push(InvoiceAttachmentCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceAttachmentCd) {
            if (InvoiceAttachmentCd[obj] === value) {
                return /** @type {?} */ (InvoiceAttachmentCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceAttachmentCdHelper = new InvoiceAttachmentCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceCurrencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceCurrencyCd) {
            this._values.push(InvoiceCurrencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceCurrencyCd) {
            if (InvoiceCurrencyCd[obj] === value) {
                return /** @type {?} */ (InvoiceCurrencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceCurrencyCdHelper = new InvoiceCurrencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceDetailDataTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceDetailDataTypeCd) {
            this._values.push(InvoiceDetailDataTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceDetailDataTypeCd) {
            if (InvoiceDetailDataTypeCd[obj] === value) {
                return /** @type {?} */ (InvoiceDetailDataTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceDetailDataTypeCdHelper = new InvoiceDetailDataTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceDocumentCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceDocumentCd) {
            this._values.push(InvoiceDocumentCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceDocumentCd) {
            if (InvoiceDocumentCd[obj] === value) {
                return /** @type {?} */ (InvoiceDocumentCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceDocumentCdHelper = new InvoiceDocumentCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceEvalOperCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceEvalOperCd) {
            this._values.push(InvoiceEvalOperCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceEvalOperCd) {
            if (InvoiceEvalOperCd[obj] === value) {
                return /** @type {?} */ (InvoiceEvalOperCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceEvalOperCdHelper = new InvoiceEvalOperCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceHoldReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceHoldReasonCd) {
            this._values.push(InvoiceHoldReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceHoldReasonCd) {
            if (InvoiceHoldReasonCd[obj] === value) {
                return /** @type {?} */ (InvoiceHoldReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceHoldReasonCdHelper = new InvoiceHoldReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceModeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceModeCd) {
            this._values.push(InvoiceModeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceModeCd) {
            if (InvoiceModeCd[obj] === value) {
                return /** @type {?} */ (InvoiceModeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceModeCdHelper = new InvoiceModeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoicePostDeliveryStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoicePostDeliveryStatusCd) {
            this._values.push(InvoicePostDeliveryStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoicePostDeliveryStatusCd) {
            if (InvoicePostDeliveryStatusCd[obj] === value) {
                return /** @type {?} */ (InvoicePostDeliveryStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoicePostDeliveryStatusCdHelper = new InvoicePostDeliveryStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoicePreferenceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoicePreferenceCd) {
            this._values.push(InvoicePreferenceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoicePreferenceCd) {
            if (InvoicePreferenceCd[obj] === value) {
                return /** @type {?} */ (InvoicePreferenceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoicePreferenceCdHelper = new InvoicePreferenceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoicePreferenceConstraintCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoicePreferenceConstraintCd) {
            this._values.push(InvoicePreferenceConstraintCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoicePreferenceConstraintCd) {
            if (InvoicePreferenceConstraintCd[obj] === value) {
                return /** @type {?} */ (InvoicePreferenceConstraintCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoicePreferenceConstraintCdHelper = new InvoicePreferenceConstraintCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoicePresentationFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoicePresentationFormatCd) {
            this._values.push(InvoicePresentationFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoicePresentationFormatCd) {
            if (InvoicePresentationFormatCd[obj] === value) {
                return /** @type {?} */ (InvoicePresentationFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoicePresentationFormatCdHelper = new InvoicePresentationFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceRequirementCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceRequirementCategoryCd) {
            this._values.push(InvoiceRequirementCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceRequirementCategoryCd) {
            if (InvoiceRequirementCategoryCd[obj] === value) {
                return /** @type {?} */ (InvoiceRequirementCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceRequirementCategoryCdHelper = new InvoiceRequirementCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceRequirementTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceRequirementTypeCd) {
            this._values.push(InvoiceRequirementTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceRequirementTypeCd) {
            if (InvoiceRequirementTypeCd[obj] === value) {
                return /** @type {?} */ (InvoiceRequirementTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceRequirementTypeCdHelper = new InvoiceRequirementTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceSendStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceSendStatusCd) {
            this._values.push(InvoiceSendStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceSendStatusCd) {
            if (InvoiceSendStatusCd[obj] === value) {
                return /** @type {?} */ (InvoiceSendStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceSendStatusCdHelper = new InvoiceSendStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceTransmissionFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceTransmissionFormatCd) {
            this._values.push(InvoiceTransmissionFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceTransmissionFormatCd) {
            if (InvoiceTransmissionFormatCd[obj] === value) {
                return /** @type {?} */ (InvoiceTransmissionFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceTransmissionFormatCdHelper = new InvoiceTransmissionFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceTransmitStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceTransmitStatusCd) {
            this._values.push(InvoiceTransmitStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceTransmitStatusCd) {
            if (InvoiceTransmitStatusCd[obj] === value) {
                return /** @type {?} */ (InvoiceTransmitStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceTransmitStatusCdHelper = new InvoiceTransmitStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class InvoiceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in InvoiceTypeCd) {
            this._values.push(InvoiceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in InvoiceTypeCd) {
            if (InvoiceTypeCd[obj] === value) {
                return /** @type {?} */ (InvoiceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ InvoiceTypeCdHelper = new InvoiceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JSPLaborRollupTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JSPLaborRollupTypeCd) {
            this._values.push(JSPLaborRollupTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JSPLaborRollupTypeCd) {
            if (JSPLaborRollupTypeCd[obj] === value) {
                return /** @type {?} */ (JSPLaborRollupTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JSPLaborRollupTypeCdHelper = new JSPLaborRollupTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JSPShiftTimeNameTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JSPShiftTimeNameTypeCd) {
            this._values.push(JSPShiftTimeNameTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JSPShiftTimeNameTypeCd) {
            if (JSPShiftTimeNameTypeCd[obj] === value) {
                return /** @type {?} */ (JSPShiftTimeNameTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JSPShiftTimeNameTypeCdHelper = new JSPShiftTimeNameTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JSPShiftTimeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JSPShiftTimeTypeCd) {
            this._values.push(JSPShiftTimeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JSPShiftTimeTypeCd) {
            if (JSPShiftTimeTypeCd[obj] === value) {
                return /** @type {?} */ (JSPShiftTimeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JSPShiftTimeTypeCdHelper = new JSPShiftTimeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JSPWorkerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JSPWorkerTypeCd) {
            this._values.push(JSPWorkerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JSPWorkerTypeCd) {
            if (JSPWorkerTypeCd[obj] === value) {
                return /** @type {?} */ (JSPWorkerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JSPWorkerTypeCdHelper = new JSPWorkerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JobSelectionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JobSelectionCd) {
            this._values.push(JobSelectionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JobSelectionCd) {
            if (JobSelectionCd[obj] === value) {
                return /** @type {?} */ (JobSelectionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JobSelectionCdHelper = new JobSelectionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class JobStateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in JobStateTypeCd) {
            this._values.push(JobStateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in JobStateTypeCd) {
            if (JobStateTypeCd[obj] === value) {
                return /** @type {?} */ (JobStateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ JobStateTypeCdHelper = new JobStateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LabelShippingStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LabelShippingStatusCd) {
            this._values.push(LabelShippingStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LabelShippingStatusCd) {
            if (LabelShippingStatusCd[obj] === value) {
                return /** @type {?} */ (LabelShippingStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LabelShippingStatusCdHelper = new LabelShippingStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LateTenderCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LateTenderCd) {
            this._values.push(LateTenderCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LateTenderCd) {
            if (LateTenderCd[obj] === value) {
                return /** @type {?} */ (LateTenderCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LateTenderCdHelper = new LateTenderCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LegalTermsTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LegalTermsTypeCd) {
            this._values.push(LegalTermsTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LegalTermsTypeCd) {
            if (LegalTermsTypeCd[obj] === value) {
                return /** @type {?} */ (LegalTermsTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LegalTermsTypeCdHelper = new LegalTermsTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LengthUomCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LengthUomCd) {
            this._values.push(LengthUomCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LengthUomCd) {
            if (LengthUomCd[obj] === value) {
                return /** @type {?} */ (LengthUomCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LengthUomCdHelper = new LengthUomCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LhoEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LhoEventTypeCd) {
            this._values.push(LhoEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LhoEventTypeCd) {
            if (LhoEventTypeCd[obj] === value) {
                return /** @type {?} */ (LhoEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LhoEventTypeCdHelper = new LhoEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LicenseEquipmentBodyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LicenseEquipmentBodyCd) {
            this._values.push(LicenseEquipmentBodyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LicenseEquipmentBodyCd) {
            if (LicenseEquipmentBodyCd[obj] === value) {
                return /** @type {?} */ (LicenseEquipmentBodyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LicenseEquipmentBodyCdHelper = new LicenseEquipmentBodyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LicenseEquipmentFuelTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LicenseEquipmentFuelTypeCd) {
            this._values.push(LicenseEquipmentFuelTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LicenseEquipmentFuelTypeCd) {
            if (LicenseEquipmentFuelTypeCd[obj] === value) {
                return /** @type {?} */ (LicenseEquipmentFuelTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LicenseEquipmentFuelTypeCdHelper = new LicenseEquipmentFuelTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LicenseEquipmentOwnedLeaseCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LicenseEquipmentOwnedLeaseCd) {
            this._values.push(LicenseEquipmentOwnedLeaseCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LicenseEquipmentOwnedLeaseCd) {
            if (LicenseEquipmentOwnedLeaseCd[obj] === value) {
                return /** @type {?} */ (LicenseEquipmentOwnedLeaseCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LicenseEquipmentOwnedLeaseCdHelper = new LicenseEquipmentOwnedLeaseCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LicenseEquipmentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LicenseEquipmentTypeCd) {
            this._values.push(LicenseEquipmentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LicenseEquipmentTypeCd) {
            if (LicenseEquipmentTypeCd[obj] === value) {
                return /** @type {?} */ (LicenseEquipmentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LicenseEquipmentTypeCdHelper = new LicenseEquipmentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LicenseValidityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LicenseValidityCd) {
            this._values.push(LicenseValidityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LicenseValidityCd) {
            if (LicenseValidityCd[obj] === value) {
                return /** @type {?} */ (LicenseValidityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LicenseValidityCdHelper = new LicenseValidityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LineItemChargeToCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LineItemChargeToCd) {
            this._values.push(LineItemChargeToCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LineItemChargeToCd) {
            if (LineItemChargeToCd[obj] === value) {
                return /** @type {?} */ (LineItemChargeToCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LineItemChargeToCdHelper = new LineItemChargeToCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoadGroupTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LoadGroupTypeCd) {
            this._values.push(LoadGroupTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LoadGroupTypeCd) {
            if (LoadGroupTypeCd[obj] === value) {
                return /** @type {?} */ (LoadGroupTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LoadGroupTypeCdHelper = new LoadGroupTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LoadUnloadIdentifierCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LoadUnloadIdentifierCd) {
            this._values.push(LoadUnloadIdentifierCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LoadUnloadIdentifierCd) {
            if (LoadUnloadIdentifierCd[obj] === value) {
                return /** @type {?} */ (LoadUnloadIdentifierCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LoadUnloadIdentifierCdHelper = new LoadUnloadIdentifierCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationAddressTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationAddressTypeCd) {
            this._values.push(LocationAddressTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationAddressTypeCd) {
            if (LocationAddressTypeCd[obj] === value) {
                return /** @type {?} */ (LocationAddressTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationAddressTypeCdHelper = new LocationAddressTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationDetailCd) {
            this._values.push(LocationDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationDetailCd) {
            if (LocationDetailCd[obj] === value) {
                return /** @type {?} */ (LocationDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationDetailCdHelper = new LocationDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationHierarchyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationHierarchyTypeCd) {
            this._values.push(LocationHierarchyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationHierarchyTypeCd) {
            if (LocationHierarchyTypeCd[obj] === value) {
                return /** @type {?} */ (LocationHierarchyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationHierarchyTypeCdHelper = new LocationHierarchyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationOperationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationOperationTypeCd) {
            this._values.push(LocationOperationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationOperationTypeCd) {
            if (LocationOperationTypeCd[obj] === value) {
                return /** @type {?} */ (LocationOperationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationOperationTypeCdHelper = new LocationOperationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationPhoneTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationPhoneTypeCd) {
            this._values.push(LocationPhoneTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationPhoneTypeCd) {
            if (LocationPhoneTypeCd[obj] === value) {
                return /** @type {?} */ (LocationPhoneTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationPhoneTypeCdHelper = new LocationPhoneTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LocationTypeCd) {
            this._values.push(LocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LocationTypeCd) {
            if (LocationTypeCd[obj] === value) {
                return /** @type {?} */ (LocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LocationTypeCdHelper = new LocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LogLevelHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LogLevel) {
            this._values.push(LogLevel[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LogLevel) {
            if (LogLevel[obj] === value) {
                return /** @type {?} */ (LogLevel[obj]);
            }
        }
    }
}
const /** @type {?} */ LogLevelHelper = new LogLevelHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class LookerResultFormatCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in LookerResultFormatCd) {
            this._values.push(LookerResultFormatCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in LookerResultFormatCd) {
            if (LookerResultFormatCd[obj] === value) {
                return /** @type {?} */ (LookerResultFormatCd[obj]);
            }
        }
    }
}
const /** @type {?} */ LookerResultFormatCdHelper = new LookerResultFormatCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ManifestReportTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ManifestReportTypeCd) {
            this._values.push(ManifestReportTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ManifestReportTypeCd) {
            if (ManifestReportTypeCd[obj] === value) {
                return /** @type {?} */ (ManifestReportTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ManifestReportTypeCdHelper = new ManifestReportTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MatchedPartySourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MatchedPartySourceCd) {
            this._values.push(MatchedPartySourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MatchedPartySourceCd) {
            if (MatchedPartySourceCd[obj] === value) {
                return /** @type {?} */ (MatchedPartySourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MatchedPartySourceCdHelper = new MatchedPartySourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MatchedPartyStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MatchedPartyStatusCd) {
            this._values.push(MatchedPartyStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MatchedPartyStatusCd) {
            if (MatchedPartyStatusCd[obj] === value) {
                return /** @type {?} */ (MatchedPartyStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MatchedPartyStatusCdHelper = new MatchedPartyStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MatchedPartyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MatchedPartyTypeCd) {
            this._values.push(MatchedPartyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MatchedPartyTypeCd) {
            if (MatchedPartyTypeCd[obj] === value) {
                return /** @type {?} */ (MatchedPartyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MatchedPartyTypeCdHelper = new MatchedPartyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MessageLogStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MessageLogStatusCd) {
            this._values.push(MessageLogStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MessageLogStatusCd) {
            if (MessageLogStatusCd[obj] === value) {
                return /** @type {?} */ (MessageLogStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MessageLogStatusCdHelper = new MessageLogStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MessagePriorityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MessagePriorityCd) {
            this._values.push(MessagePriorityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MessagePriorityCd) {
            if (MessagePriorityCd[obj] === value) {
                return /** @type {?} */ (MessagePriorityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MessagePriorityCdHelper = new MessagePriorityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricPredictionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricPredictionTypeCd) {
            this._values.push(MetricPredictionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricPredictionTypeCd) {
            if (MetricPredictionTypeCd[obj] === value) {
                return /** @type {?} */ (MetricPredictionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricPredictionTypeCdHelper = new MetricPredictionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricStageCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricStageCd) {
            this._values.push(MetricStageCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricStageCd) {
            if (MetricStageCd[obj] === value) {
                return /** @type {?} */ (MetricStageCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricStageCdHelper = new MetricStageCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricStageSubCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricStageSubCd) {
            this._values.push(MetricStageSubCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricStageSubCd) {
            if (MetricStageSubCd[obj] === value) {
                return /** @type {?} */ (MetricStageSubCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricStageSubCdHelper = new MetricStageSubCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricThresholdContextCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricThresholdContextCd) {
            this._values.push(MetricThresholdContextCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricThresholdContextCd) {
            if (MetricThresholdContextCd[obj] === value) {
                return /** @type {?} */ (MetricThresholdContextCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricThresholdContextCdHelper = new MetricThresholdContextCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricThresholdValueTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricThresholdValueTypeCd) {
            this._values.push(MetricThresholdValueTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricThresholdValueTypeCd) {
            if (MetricThresholdValueTypeCd[obj] === value) {
                return /** @type {?} */ (MetricThresholdValueTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricThresholdValueTypeCdHelper = new MetricThresholdValueTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricTypeCd) {
            this._values.push(MetricTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricTypeCd) {
            if (MetricTypeCd[obj] === value) {
                return /** @type {?} */ (MetricTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricTypeCdHelper = new MetricTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricValueKeyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricValueKeyCd) {
            this._values.push(MetricValueKeyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricValueKeyCd) {
            if (MetricValueKeyCd[obj] === value) {
                return /** @type {?} */ (MetricValueKeyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricValueKeyCdHelper = new MetricValueKeyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MetricVarianceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MetricVarianceCd) {
            this._values.push(MetricVarianceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MetricVarianceCd) {
            if (MetricVarianceCd[obj] === value) {
                return /** @type {?} */ (MetricVarianceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MetricVarianceCdHelper = new MetricVarianceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MinuetExecutionStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MinuetExecutionStatusCd) {
            this._values.push(MinuetExecutionStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MinuetExecutionStatusCd) {
            if (MinuetExecutionStatusCd[obj] === value) {
                return /** @type {?} */ (MinuetExecutionStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MinuetExecutionStatusCdHelper = new MinuetExecutionStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MiscLineItemCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MiscLineItemCd) {
            this._values.push(MiscLineItemCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MiscLineItemCd) {
            if (MiscLineItemCd[obj] === value) {
                return /** @type {?} */ (MiscLineItemCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MiscLineItemCdHelper = new MiscLineItemCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MiscLineItemPaymentMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MiscLineItemPaymentMethodCd) {
            this._values.push(MiscLineItemPaymentMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MiscLineItemPaymentMethodCd) {
            if (MiscLineItemPaymentMethodCd[obj] === value) {
                return /** @type {?} */ (MiscLineItemPaymentMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MiscLineItemPaymentMethodCdHelper = new MiscLineItemPaymentMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModelGroupCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ModelGroupCd) {
            this._values.push(ModelGroupCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ModelGroupCd) {
            if (ModelGroupCd[obj] === value) {
                return /** @type {?} */ (ModelGroupCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ModelGroupCdHelper = new ModelGroupCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModuleExecutorDataExtractTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ModuleExecutorDataExtractTypeCd) {
            this._values.push(ModuleExecutorDataExtractTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ModuleExecutorDataExtractTypeCd) {
            if (ModuleExecutorDataExtractTypeCd[obj] === value) {
                return /** @type {?} */ (ModuleExecutorDataExtractTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ModuleExecutorDataExtractTypeCdHelper = new ModuleExecutorDataExtractTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModuleExecutorDatasetTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ModuleExecutorDatasetTypeCd) {
            this._values.push(ModuleExecutorDatasetTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ModuleExecutorDatasetTypeCd) {
            if (ModuleExecutorDatasetTypeCd[obj] === value) {
                return /** @type {?} */ (ModuleExecutorDatasetTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ModuleExecutorDatasetTypeCdHelper = new ModuleExecutorDatasetTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModuleExecutorParmsArgTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ModuleExecutorParmsArgTypeCd) {
            this._values.push(ModuleExecutorParmsArgTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ModuleExecutorParmsArgTypeCd) {
            if (ModuleExecutorParmsArgTypeCd[obj] === value) {
                return /** @type {?} */ (ModuleExecutorParmsArgTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ModuleExecutorParmsArgTypeCdHelper = new ModuleExecutorParmsArgTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModuleExecutorSuccessfulCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ModuleExecutorSuccessfulCd) {
            this._values.push(ModuleExecutorSuccessfulCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ModuleExecutorSuccessfulCd) {
            if (ModuleExecutorSuccessfulCd[obj] === value) {
                return /** @type {?} */ (ModuleExecutorSuccessfulCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ModuleExecutorSuccessfulCdHelper = new ModuleExecutorSuccessfulCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MoveModeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MoveModeCd) {
            this._values.push(MoveModeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MoveModeCd) {
            if (MoveModeCd[obj] === value) {
                return /** @type {?} */ (MoveModeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MoveModeCdHelper = new MoveModeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MovementExceptionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MovementExceptionTypeCd) {
            this._values.push(MovementExceptionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MovementExceptionTypeCd) {
            if (MovementExceptionTypeCd[obj] === value) {
                return /** @type {?} */ (MovementExceptionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MovementExceptionTypeCdHelper = new MovementExceptionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class MovementStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in MovementStatusCd) {
            this._values.push(MovementStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in MovementStatusCd) {
            if (MovementStatusCd[obj] === value) {
                return /** @type {?} */ (MovementStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ MovementStatusCdHelper = new MovementStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NetExplosiveMassUomCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NetExplosiveMassUomCd) {
            this._values.push(NetExplosiveMassUomCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NetExplosiveMassUomCd) {
            if (NetExplosiveMassUomCd[obj] === value) {
                return /** @type {?} */ (NetExplosiveMassUomCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NetExplosiveMassUomCdHelper = new NetExplosiveMassUomCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NextBestActionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NextBestActionTypeCd) {
            this._values.push(NextBestActionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NextBestActionTypeCd) {
            if (NextBestActionTypeCd[obj] === value) {
                return /** @type {?} */ (NextBestActionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NextBestActionTypeCdHelper = new NextBestActionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NextBusinessDayOperationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NextBusinessDayOperationCd) {
            this._values.push(NextBusinessDayOperationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NextBusinessDayOperationCd) {
            if (NextBusinessDayOperationCd[obj] === value) {
                return /** @type {?} */ (NextBusinessDayOperationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NextBusinessDayOperationCdHelper = new NextBusinessDayOperationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NodeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NodeTypeCd) {
            this._values.push(NodeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NodeTypeCd) {
            if (NodeTypeCd[obj] === value) {
                return /** @type {?} */ (NodeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NodeTypeCdHelper = new NodeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NonDriveTimeLocationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NonDriveTimeLocationCd) {
            this._values.push(NonDriveTimeLocationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NonDriveTimeLocationCd) {
            if (NonDriveTimeLocationCd[obj] === value) {
                return /** @type {?} */ (NonDriveTimeLocationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NonDriveTimeLocationCdHelper = new NonDriveTimeLocationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NonDriveTimePaidCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NonDriveTimePaidCd) {
            this._values.push(NonDriveTimePaidCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NonDriveTimePaidCd) {
            if (NonDriveTimePaidCd[obj] === value) {
                return /** @type {?} */ (NonDriveTimePaidCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NonDriveTimePaidCdHelper = new NonDriveTimePaidCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NonWorkDayTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NonWorkDayTypeCd) {
            this._values.push(NonWorkDayTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NonWorkDayTypeCd) {
            if (NonWorkDayTypeCd[obj] === value) {
                return /** @type {?} */ (NonWorkDayTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NonWorkDayTypeCdHelper = new NonWorkDayTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NoteTypeCd) {
            this._values.push(NoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NoteTypeCd) {
            if (NoteTypeCd[obj] === value) {
                return /** @type {?} */ (NoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NoteTypeCdHelper = new NoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NotificationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in NotificationCd) {
            this._values.push(NotificationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in NotificationCd) {
            if (NotificationCd[obj] === value) {
                return /** @type {?} */ (NotificationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ NotificationCdHelper = new NotificationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OptimizerParameterCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OptimizerParameterCd) {
            this._values.push(OptimizerParameterCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OptimizerParameterCd) {
            if (OptimizerParameterCd[obj] === value) {
                return /** @type {?} */ (OptimizerParameterCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OptimizerParameterCdHelper = new OptimizerParameterCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OptimizerParameterTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OptimizerParameterTypeCd) {
            this._values.push(OptimizerParameterTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OptimizerParameterTypeCd) {
            if (OptimizerParameterTypeCd[obj] === value) {
                return /** @type {?} */ (OptimizerParameterTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OptimizerParameterTypeCdHelper = new OptimizerParameterTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OptimizerResultReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OptimizerResultReasonCd) {
            this._values.push(OptimizerResultReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OptimizerResultReasonCd) {
            if (OptimizerResultReasonCd[obj] === value) {
                return /** @type {?} */ (OptimizerResultReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OptimizerResultReasonCdHelper = new OptimizerResultReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OptimizerResultStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OptimizerResultStatusCd) {
            this._values.push(OptimizerResultStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OptimizerResultStatusCd) {
            if (OptimizerResultStatusCd[obj] === value) {
                return /** @type {?} */ (OptimizerResultStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OptimizerResultStatusCdHelper = new OptimizerResultStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OptimizerStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OptimizerStatusCd) {
            this._values.push(OptimizerStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OptimizerStatusCd) {
            if (OptimizerStatusCd[obj] === value) {
                return /** @type {?} */ (OptimizerStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OptimizerStatusCdHelper = new OptimizerStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OriginalSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OriginalSourceCd) {
            this._values.push(OriginalSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OriginalSourceCd) {
            if (OriginalSourceCd[obj] === value) {
                return /** @type {?} */ (OriginalSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OriginalSourceCdHelper = new OriginalSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OsdCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OsdCategoryCd) {
            this._values.push(OsdCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OsdCategoryCd) {
            if (OsdCategoryCd[obj] === value) {
                return /** @type {?} */ (OsdCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OsdCategoryCdHelper = new OsdCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OsdPayloadTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OsdPayloadTypeCd) {
            this._values.push(OsdPayloadTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OsdPayloadTypeCd) {
            if (OsdPayloadTypeCd[obj] === value) {
                return /** @type {?} */ (OsdPayloadTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OsdPayloadTypeCdHelper = new OsdPayloadTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class OsdStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in OsdStatusCd) {
            this._values.push(OsdStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in OsdStatusCd) {
            if (OsdStatusCd[obj] === value) {
                return /** @type {?} */ (OsdStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ OsdStatusCdHelper = new OsdStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ParentActivityTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ParentActivityTypeCd) {
            this._values.push(ParentActivityTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ParentActivityTypeCd) {
            if (ParentActivityTypeCd[obj] === value) {
                return /** @type {?} */ (ParentActivityTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ParentActivityTypeCdHelper = new ParentActivityTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ParkingLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ParkingLocationTypeCd) {
            this._values.push(ParkingLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ParkingLocationTypeCd) {
            if (ParkingLocationTypeCd[obj] === value) {
                return /** @type {?} */ (ParkingLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ParkingLocationTypeCdHelper = new ParkingLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PartyRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PartyRoleCd) {
            this._values.push(PartyRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PartyRoleCd) {
            if (PartyRoleCd[obj] === value) {
                return /** @type {?} */ (PartyRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PartyRoleCdHelper = new PartyRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PartyShipmentRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PartyShipmentRoleCd) {
            this._values.push(PartyShipmentRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PartyShipmentRoleCd) {
            if (PartyShipmentRoleCd[obj] === value) {
                return /** @type {?} */ (PartyShipmentRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PartyShipmentRoleCdHelper = new PartyShipmentRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PayformActivityLocCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PayformActivityLocCd) {
            this._values.push(PayformActivityLocCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PayformActivityLocCd) {
            if (PayformActivityLocCd[obj] === value) {
                return /** @type {?} */ (PayformActivityLocCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PayformActivityLocCdHelper = new PayformActivityLocCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PayformDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PayformDetailCd) {
            this._values.push(PayformDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PayformDetailCd) {
            if (PayformDetailCd[obj] === value) {
                return /** @type {?} */ (PayformDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PayformDetailCdHelper = new PayformDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PayformNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PayformNoteTypeCd) {
            this._values.push(PayformNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PayformNoteTypeCd) {
            if (PayformNoteTypeCd[obj] === value) {
                return /** @type {?} */ (PayformNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PayformNoteTypeCdHelper = new PayformNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PayformPaidTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PayformPaidTypeCd) {
            this._values.push(PayformPaidTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PayformPaidTypeCd) {
            if (PayformPaidTypeCd[obj] === value) {
                return /** @type {?} */ (PayformPaidTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PayformPaidTypeCdHelper = new PayformPaidTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PayformStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PayformStatusCd) {
            this._values.push(PayformStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PayformStatusCd) {
            if (PayformStatusCd[obj] === value) {
                return /** @type {?} */ (PayformStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PayformStatusCdHelper = new PayformStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PaymentMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PaymentMethodCd) {
            this._values.push(PaymentMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PaymentMethodCd) {
            if (PaymentMethodCd[obj] === value) {
                return /** @type {?} */ (PaymentMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PaymentMethodCdHelper = new PaymentMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PaymentStatusExternalCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PaymentStatusExternalCd) {
            this._values.push(PaymentStatusExternalCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PaymentStatusExternalCd) {
            if (PaymentStatusExternalCd[obj] === value) {
                return /** @type {?} */ (PaymentStatusExternalCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PaymentStatusExternalCdHelper = new PaymentStatusExternalCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PaymentStatusInternalCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PaymentStatusInternalCd) {
            this._values.push(PaymentStatusInternalCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PaymentStatusInternalCd) {
            if (PaymentStatusInternalCd[obj] === value) {
                return /** @type {?} */ (PaymentStatusInternalCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PaymentStatusInternalCdHelper = new PaymentStatusInternalCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PaymentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PaymentTypeCd) {
            this._values.push(PaymentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PaymentTypeCd) {
            if (PaymentTypeCd[obj] === value) {
                return /** @type {?} */ (PaymentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PaymentTypeCdHelper = new PaymentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PhotoTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PhotoTypeCd) {
            this._values.push(PhotoTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PhotoTypeCd) {
            if (PhotoTypeCd[obj] === value) {
                return /** @type {?} */ (PhotoTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PhotoTypeCdHelper = new PhotoTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestHoldTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestHoldTypeCd) {
            this._values.push(PickupRequestHoldTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestHoldTypeCd) {
            if (PickupRequestHoldTypeCd[obj] === value) {
                return /** @type {?} */ (PickupRequestHoldTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestHoldTypeCdHelper = new PickupRequestHoldTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestReasonCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestReasonCategoryCd) {
            this._values.push(PickupRequestReasonCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestReasonCategoryCd) {
            if (PickupRequestReasonCategoryCd[obj] === value) {
                return /** @type {?} */ (PickupRequestReasonCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestReasonCategoryCdHelper = new PickupRequestReasonCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestReasonCategoryRefCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestReasonCategoryRefCd) {
            this._values.push(PickupRequestReasonCategoryRefCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestReasonCategoryRefCd) {
            if (PickupRequestReasonCategoryRefCd[obj] === value) {
                return /** @type {?} */ (PickupRequestReasonCategoryRefCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestReasonCategoryRefCdHelper = new PickupRequestReasonCategoryRefCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestReasonSubCategoryRefCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestReasonSubCategoryRefCd) {
            this._values.push(PickupRequestReasonSubCategoryRefCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestReasonSubCategoryRefCd) {
            if (PickupRequestReasonSubCategoryRefCd[obj] === value) {
                return /** @type {?} */ (PickupRequestReasonSubCategoryRefCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestReasonSubCategoryRefCdHelper = new PickupRequestReasonSubCategoryRefCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestReasonTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestReasonTypeCd) {
            this._values.push(PickupRequestReasonTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestReasonTypeCd) {
            if (PickupRequestReasonTypeCd[obj] === value) {
                return /** @type {?} */ (PickupRequestReasonTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestReasonTypeCdHelper = new PickupRequestReasonTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequestReinstateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequestReinstateTypeCd) {
            this._values.push(PickupRequestReinstateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequestReinstateTypeCd) {
            if (PickupRequestReinstateTypeCd[obj] === value) {
                return /** @type {?} */ (PickupRequestReinstateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequestReinstateTypeCdHelper = new PickupRequestReinstateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupRequesterRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupRequesterRoleCd) {
            this._values.push(PickupRequesterRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupRequesterRoleCd) {
            if (PickupRequesterRoleCd[obj] === value) {
                return /** @type {?} */ (PickupRequesterRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupRequesterRoleCdHelper = new PickupRequesterRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupShipmentSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupShipmentSourceCd) {
            this._values.push(PickupShipmentSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupShipmentSourceCd) {
            if (PickupShipmentSourceCd[obj] === value) {
                return /** @type {?} */ (PickupShipmentSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupShipmentSourceCdHelper = new PickupShipmentSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupShipmentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupShipmentStatusCd) {
            this._values.push(PickupShipmentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupShipmentStatusCd) {
            if (PickupShipmentStatusCd[obj] === value) {
                return /** @type {?} */ (PickupShipmentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupShipmentStatusCdHelper = new PickupShipmentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupShipmetActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupShipmetActionCd) {
            this._values.push(PickupShipmetActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupShipmetActionCd) {
            if (PickupShipmetActionCd[obj] === value) {
                return /** @type {?} */ (PickupShipmetActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupShipmetActionCdHelper = new PickupShipmetActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupSourceCd) {
            this._values.push(PickupSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupSourceCd) {
            if (PickupSourceCd[obj] === value) {
                return /** @type {?} */ (PickupSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupSourceCdHelper = new PickupSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupStatusCd) {
            this._values.push(PickupStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupStatusCd) {
            if (PickupStatusCd[obj] === value) {
                return /** @type {?} */ (PickupStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupStatusCdHelper = new PickupStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PickupTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PickupTypeCd) {
            this._values.push(PickupTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PickupTypeCd) {
            if (PickupTypeCd[obj] === value) {
                return /** @type {?} */ (PickupTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PickupTypeCdHelper = new PickupTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PnDAutoPrintOptionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PnDAutoPrintOptionCd) {
            this._values.push(PnDAutoPrintOptionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PnDAutoPrintOptionCd) {
            if (PnDAutoPrintOptionCd[obj] === value) {
                return /** @type {?} */ (PnDAutoPrintOptionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PnDAutoPrintOptionCdHelper = new PnDAutoPrintOptionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PnDReportTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PnDReportTypeCd) {
            this._values.push(PnDReportTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PnDReportTypeCd) {
            if (PnDReportTypeCd[obj] === value) {
                return /** @type {?} */ (PnDReportTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PnDReportTypeCdHelper = new PnDReportTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PnDRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PnDRoleCd) {
            this._values.push(PnDRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PnDRoleCd) {
            if (PnDRoleCd[obj] === value) {
                return /** @type {?} */ (PnDRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PnDRoleCdHelper = new PnDRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PolygonTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PolygonTypeCd) {
            this._values.push(PolygonTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PolygonTypeCd) {
            if (PolygonTypeCd[obj] === value) {
                return /** @type {?} */ (PolygonTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PolygonTypeCdHelper = new PolygonTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PricingAnalysisRunTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PricingAnalysisRunTypeCd) {
            this._values.push(PricingAnalysisRunTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PricingAnalysisRunTypeCd) {
            if (PricingAnalysisRunTypeCd[obj] === value) {
                return /** @type {?} */ (PricingAnalysisRunTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PricingAnalysisRunTypeCdHelper = new PricingAnalysisRunTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PricingRulesetOwnerCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PricingRulesetOwnerCd) {
            this._values.push(PricingRulesetOwnerCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PricingRulesetOwnerCd) {
            if (PricingRulesetOwnerCd[obj] === value) {
                return /** @type {?} */ (PricingRulesetOwnerCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PricingRulesetOwnerCdHelper = new PricingRulesetOwnerCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PricingTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PricingTypeCd) {
            this._values.push(PricingTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PricingTypeCd) {
            if (PricingTypeCd[obj] === value) {
                return /** @type {?} */ (PricingTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PricingTypeCdHelper = new PricingTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class PrintFBDSDocumentsTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in PrintFBDSDocumentsTypeCd) {
            this._values.push(PrintFBDSDocumentsTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in PrintFBDSDocumentsTypeCd) {
            if (PrintFBDSDocumentsTypeCd[obj] === value) {
                return /** @type {?} */ (PrintFBDSDocumentsTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ PrintFBDSDocumentsTypeCdHelper = new PrintFBDSDocumentsTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProBolUsageStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProBolUsageStatusCd) {
            this._values.push(ProBolUsageStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProBolUsageStatusCd) {
            if (ProBolUsageStatusCd[obj] === value) {
                return /** @type {?} */ (ProBolUsageStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProBolUsageStatusCdHelper = new ProBolUsageStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProCheckoutTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProCheckoutTypeCd) {
            this._values.push(ProCheckoutTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProCheckoutTypeCd) {
            if (ProCheckoutTypeCd[obj] === value) {
                return /** @type {?} */ (ProCheckoutTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProCheckoutTypeCdHelper = new ProCheckoutTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProInUseCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProInUseCd) {
            this._values.push(ProInUseCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProInUseCd) {
            if (ProInUseCd[obj] === value) {
                return /** @type {?} */ (ProInUseCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProInUseCdHelper = new ProInUseCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProNbrTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProNbrTypeCd) {
            this._values.push(ProNbrTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProNbrTypeCd) {
            if (ProNbrTypeCd[obj] === value) {
                return /** @type {?} */ (ProNbrTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProNbrTypeCdHelper = new ProNbrTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProPadTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProPadTypeCd) {
            this._values.push(ProPadTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProPadTypeCd) {
            if (ProPadTypeCd[obj] === value) {
                return /** @type {?} */ (ProPadTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProPadTypeCdHelper = new ProPadTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProPrintedLabelStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProPrintedLabelStatusCd) {
            this._values.push(ProPrintedLabelStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProPrintedLabelStatusCd) {
            if (ProPrintedLabelStatusCd[obj] === value) {
                return /** @type {?} */ (ProPrintedLabelStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProPrintedLabelStatusCdHelper = new ProPrintedLabelStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProRequestDetailStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProRequestDetailStatusCd) {
            this._values.push(ProRequestDetailStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProRequestDetailStatusCd) {
            if (ProRequestDetailStatusCd[obj] === value) {
                return /** @type {?} */ (ProRequestDetailStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProRequestDetailStatusCdHelper = new ProRequestDetailStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProRequestStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProRequestStatusCd) {
            this._values.push(ProRequestStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProRequestStatusCd) {
            if (ProRequestStatusCd[obj] === value) {
                return /** @type {?} */ (ProRequestStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProRequestStatusCdHelper = new ProRequestStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProStatusCd) {
            this._values.push(ProStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProStatusCd) {
            if (ProStatusCd[obj] === value) {
                return /** @type {?} */ (ProStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProStatusCdHelper = new ProStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProSummaryTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProSummaryTypeCd) {
            this._values.push(ProSummaryTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProSummaryTypeCd) {
            if (ProSummaryTypeCd[obj] === value) {
                return /** @type {?} */ (ProSummaryTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProSummaryTypeCdHelper = new ProSummaryTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProTrackingLabelStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProTrackingLabelStatusCd) {
            this._values.push(ProTrackingLabelStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProTrackingLabelStatusCd) {
            if (ProTrackingLabelStatusCd[obj] === value) {
                return /** @type {?} */ (ProTrackingLabelStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProTrackingLabelStatusCdHelper = new ProTrackingLabelStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ProcessStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ProcessStatusCd) {
            this._values.push(ProcessStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ProcessStatusCd) {
            if (ProcessStatusCd[obj] === value) {
                return /** @type {?} */ (ProcessStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ProcessStatusCdHelper = new ProcessStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class QueueNameCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in QueueNameCd) {
            this._values.push(QueueNameCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in QueueNameCd) {
            if (QueueNameCd[obj] === value) {
                return /** @type {?} */ (QueueNameCd[obj]);
            }
        }
    }
}
const /** @type {?} */ QueueNameCdHelper = new QueueNameCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RadioactivityUomCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RadioactivityUomCd) {
            this._values.push(RadioactivityUomCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RadioactivityUomCd) {
            if (RadioactivityUomCd[obj] === value) {
                return /** @type {?} */ (RadioactivityUomCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RadioactivityUomCdHelper = new RadioactivityUomCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateDiscountSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateDiscountSourceCd) {
            this._values.push(RateDiscountSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateDiscountSourceCd) {
            if (RateDiscountSourceCd[obj] === value) {
                return /** @type {?} */ (RateDiscountSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateDiscountSourceCdHelper = new RateDiscountSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateQuoteAccessorialCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateQuoteAccessorialCd) {
            this._values.push(RateQuoteAccessorialCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateQuoteAccessorialCd) {
            if (RateQuoteAccessorialCd[obj] === value) {
                return /** @type {?} */ (RateQuoteAccessorialCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateQuoteAccessorialCdHelper = new RateQuoteAccessorialCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateQuoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateQuoteTypeCd) {
            this._values.push(RateQuoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateQuoteTypeCd) {
            if (RateQuoteTypeCd[obj] === value) {
                return /** @type {?} */ (RateQuoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateQuoteTypeCdHelper = new RateQuoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateRequestSubTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateRequestSubTypeCd) {
            this._values.push(RateRequestSubTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateRequestSubTypeCd) {
            if (RateRequestSubTypeCd[obj] === value) {
                return /** @type {?} */ (RateRequestSubTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateRequestSubTypeCdHelper = new RateRequestSubTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateRequestTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateRequestTypeCd) {
            this._values.push(RateRequestTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateRequestTypeCd) {
            if (RateRequestTypeCd[obj] === value) {
                return /** @type {?} */ (RateRequestTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateRequestTypeCdHelper = new RateRequestTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RateStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RateStatusCd) {
            this._values.push(RateStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RateStatusCd) {
            if (RateStatusCd[obj] === value) {
                return /** @type {?} */ (RateStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RateStatusCdHelper = new RateStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingCurrencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingCurrencyCd) {
            this._values.push(RatingCurrencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingCurrencyCd) {
            if (RatingCurrencyCd[obj] === value) {
                return /** @type {?} */ (RatingCurrencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingCurrencyCdHelper = new RatingCurrencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingPartyLocationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingPartyLocationTypeCd) {
            this._values.push(RatingPartyLocationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingPartyLocationTypeCd) {
            if (RatingPartyLocationTypeCd[obj] === value) {
                return /** @type {?} */ (RatingPartyLocationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingPartyLocationTypeCdHelper = new RatingPartyLocationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingQueueClassTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingQueueClassTypeCd) {
            this._values.push(RatingQueueClassTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingQueueClassTypeCd) {
            if (RatingQueueClassTypeCd[obj] === value) {
                return /** @type {?} */ (RatingQueueClassTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingQueueClassTypeCdHelper = new RatingQueueClassTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingShipmentFileTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingShipmentFileTypeCd) {
            this._values.push(RatingShipmentFileTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingShipmentFileTypeCd) {
            if (RatingShipmentFileTypeCd[obj] === value) {
                return /** @type {?} */ (RatingShipmentFileTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingShipmentFileTypeCdHelper = new RatingShipmentFileTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingStatusCd) {
            this._values.push(RatingStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingStatusCd) {
            if (RatingStatusCd[obj] === value) {
                return /** @type {?} */ (RatingStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingStatusCdHelper = new RatingStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RatingWhatIfRequestStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RatingWhatIfRequestStatusCd) {
            this._values.push(RatingWhatIfRequestStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RatingWhatIfRequestStatusCd) {
            if (RatingWhatIfRequestStatusCd[obj] === value) {
                return /** @type {?} */ (RatingWhatIfRequestStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RatingWhatIfRequestStatusCdHelper = new RatingWhatIfRequestStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RebuttalExternalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RebuttalExternalStatusCd) {
            this._values.push(RebuttalExternalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RebuttalExternalStatusCd) {
            if (RebuttalExternalStatusCd[obj] === value) {
                return /** @type {?} */ (RebuttalExternalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RebuttalExternalStatusCdHelper = new RebuttalExternalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RebuttalInternalStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RebuttalInternalStatusCd) {
            this._values.push(RebuttalInternalStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RebuttalInternalStatusCd) {
            if (RebuttalInternalStatusCd[obj] === value) {
                return /** @type {?} */ (RebuttalInternalStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RebuttalInternalStatusCdHelper = new RebuttalInternalStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RebuttalReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RebuttalReasonCd) {
            this._values.push(RebuttalReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RebuttalReasonCd) {
            if (RebuttalReasonCd[obj] === value) {
                return /** @type {?} */ (RebuttalReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RebuttalReasonCdHelper = new RebuttalReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ReducedServiceSatelliteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ReducedServiceSatelliteTypeCd) {
            this._values.push(ReducedServiceSatelliteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ReducedServiceSatelliteTypeCd) {
            if (ReducedServiceSatelliteTypeCd[obj] === value) {
                return /** @type {?} */ (ReducedServiceSatelliteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ReducedServiceSatelliteTypeCdHelper = new ReducedServiceSatelliteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RefusedReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RefusedReasonCd) {
            this._values.push(RefusedReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RefusedReasonCd) {
            if (RefusedReasonCd[obj] === value) {
                return /** @type {?} */ (RefusedReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RefusedReasonCdHelper = new RefusedReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ReportsCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ReportsCd) {
            this._values.push(ReportsCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ReportsCd) {
            if (ReportsCd[obj] === value) {
                return /** @type {?} */ (ReportsCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ReportsCdHelper = new ReportsCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RequestedChangeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RequestedChangeCd) {
            this._values.push(RequestedChangeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RequestedChangeCd) {
            if (RequestedChangeCd[obj] === value) {
                return /** @type {?} */ (RequestedChangeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RequestedChangeCdHelper = new RequestedChangeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RequestedChangeItemActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RequestedChangeItemActionCd) {
            this._values.push(RequestedChangeItemActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RequestedChangeItemActionCd) {
            if (RequestedChangeItemActionCd[obj] === value) {
                return /** @type {?} */ (RequestedChangeItemActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RequestedChangeItemActionCdHelper = new RequestedChangeItemActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RequestedChangeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RequestedChangeTypeCd) {
            this._values.push(RequestedChangeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RequestedChangeTypeCd) {
            if (RequestedChangeTypeCd[obj] === value) {
                return /** @type {?} */ (RequestedChangeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RequestedChangeTypeCdHelper = new RequestedChangeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RerateTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RerateTypeCd) {
            this._values.push(RerateTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RerateTypeCd) {
            if (RerateTypeCd[obj] === value) {
                return /** @type {?} */ (RerateTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RerateTypeCdHelper = new RerateTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ReturnInstrRetainCheckCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ReturnInstrRetainCheckCd) {
            this._values.push(ReturnInstrRetainCheckCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ReturnInstrRetainCheckCd) {
            if (ReturnInstrRetainCheckCd[obj] === value) {
                return /** @type {?} */ (ReturnInstrRetainCheckCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ReturnInstrRetainCheckCdHelper = new ReturnInstrRetainCheckCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ReturnReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ReturnReasonCd) {
            this._values.push(ReturnReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ReturnReasonCd) {
            if (ReturnReasonCd[obj] === value) {
                return /** @type {?} */ (ReturnReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ReturnReasonCdHelper = new ReturnReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RevenueDayCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RevenueDayCd) {
            this._values.push(RevenueDayCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RevenueDayCd) {
            if (RevenueDayCd[obj] === value) {
                return /** @type {?} */ (RevenueDayCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RevenueDayCdHelper = new RevenueDayCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ReweighStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ReweighStatusCd) {
            this._values.push(ReweighStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ReweighStatusCd) {
            if (ReweighStatusCd[obj] === value) {
                return /** @type {?} */ (ReweighStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ReweighStatusCdHelper = new ReweighStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteActionCd) {
            this._values.push(RouteActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteActionCd) {
            if (RouteActionCd[obj] === value) {
                return /** @type {?} */ (RouteActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteActionCdHelper = new RouteActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteAutoSequenceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteAutoSequenceTypeCd) {
            this._values.push(RouteAutoSequenceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteAutoSequenceTypeCd) {
            if (RouteAutoSequenceTypeCd[obj] === value) {
                return /** @type {?} */ (RouteAutoSequenceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteAutoSequenceTypeCdHelper = new RouteAutoSequenceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteBalancingTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteBalancingTypeCd) {
            this._values.push(RouteBalancingTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteBalancingTypeCd) {
            if (RouteBalancingTypeCd[obj] === value) {
                return /** @type {?} */ (RouteBalancingTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteBalancingTypeCdHelper = new RouteBalancingTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteCategoryCd) {
            this._values.push(RouteCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteCategoryCd) {
            if (RouteCategoryCd[obj] === value) {
                return /** @type {?} */ (RouteCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteCategoryCdHelper = new RouteCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteDetailCd) {
            this._values.push(RouteDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteDetailCd) {
            if (RouteDetailCd[obj] === value) {
                return /** @type {?} */ (RouteDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteDetailCdHelper = new RouteDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteEquipmentTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteEquipmentTypeCd) {
            this._values.push(RouteEquipmentTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteEquipmentTypeCd) {
            if (RouteEquipmentTypeCd[obj] === value) {
                return /** @type {?} */ (RouteEquipmentTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteEquipmentTypeCdHelper = new RouteEquipmentTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteStatusCd) {
            this._values.push(RouteStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteStatusCd) {
            if (RouteStatusCd[obj] === value) {
                return /** @type {?} */ (RouteStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteStatusCdHelper = new RouteStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RouteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RouteTypeCd) {
            this._values.push(RouteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RouteTypeCd) {
            if (RouteTypeCd[obj] === value) {
                return /** @type {?} */ (RouteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RouteTypeCdHelper = new RouteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RschCnclReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RschCnclReasonCd) {
            this._values.push(RschCnclReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RschCnclReasonCd) {
            if (RschCnclReasonCd[obj] === value) {
                return /** @type {?} */ (RschCnclReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RschCnclReasonCdHelper = new RschCnclReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleActiveTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleActiveTypeCd) {
            this._values.push(RuleActiveTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleActiveTypeCd) {
            if (RuleActiveTypeCd[obj] === value) {
                return /** @type {?} */ (RuleActiveTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleActiveTypeCdHelper = new RuleActiveTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleExpressionValueTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleExpressionValueTypeCd) {
            this._values.push(RuleExpressionValueTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleExpressionValueTypeCd) {
            if (RuleExpressionValueTypeCd[obj] === value) {
                return /** @type {?} */ (RuleExpressionValueTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleExpressionValueTypeCdHelper = new RuleExpressionValueTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleFailureReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleFailureReasonCd) {
            this._values.push(RuleFailureReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleFailureReasonCd) {
            if (RuleFailureReasonCd[obj] === value) {
                return /** @type {?} */ (RuleFailureReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleFailureReasonCdHelper = new RuleFailureReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleLogicalOperatorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleLogicalOperatorCd) {
            this._values.push(RuleLogicalOperatorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleLogicalOperatorCd) {
            if (RuleLogicalOperatorCd[obj] === value) {
                return /** @type {?} */ (RuleLogicalOperatorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleLogicalOperatorCdHelper = new RuleLogicalOperatorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleOperatorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleOperatorCd) {
            this._values.push(RuleOperatorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleOperatorCd) {
            if (RuleOperatorCd[obj] === value) {
                return /** @type {?} */ (RuleOperatorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleOperatorCdHelper = new RuleOperatorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleOverrideReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleOverrideReasonCd) {
            this._values.push(RuleOverrideReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleOverrideReasonCd) {
            if (RuleOverrideReasonCd[obj] === value) {
                return /** @type {?} */ (RuleOverrideReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleOverrideReasonCdHelper = new RuleOverrideReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RuleShmEntityTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RuleShmEntityTypeCd) {
            this._values.push(RuleShmEntityTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RuleShmEntityTypeCd) {
            if (RuleShmEntityTypeCd[obj] === value) {
                return /** @type {?} */ (RuleShmEntityTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RuleShmEntityTypeCdHelper = new RuleShmEntityTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RunShiftCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RunShiftCd) {
            this._values.push(RunShiftCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RunShiftCd) {
            if (RunShiftCd[obj] === value) {
                return /** @type {?} */ (RunShiftCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RunShiftCdHelper = new RunShiftCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class RwgLogHeaderMoreInfoCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in RwgLogHeaderMoreInfoCd) {
            this._values.push(RwgLogHeaderMoreInfoCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in RwgLogHeaderMoreInfoCd) {
            if (RwgLogHeaderMoreInfoCd[obj] === value) {
                return /** @type {?} */ (RwgLogHeaderMoreInfoCd[obj]);
            }
        }
    }
}
const /** @type {?} */ RwgLogHeaderMoreInfoCdHelper = new RwgLogHeaderMoreInfoCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SalvageRequestStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SalvageRequestStatusCd) {
            this._values.push(SalvageRequestStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SalvageRequestStatusCd) {
            if (SalvageRequestStatusCd[obj] === value) {
                return /** @type {?} */ (SalvageRequestStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SalvageRequestStatusCdHelper = new SalvageRequestStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SalvageRequestTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SalvageRequestTypeCd) {
            this._values.push(SalvageRequestTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SalvageRequestTypeCd) {
            if (SalvageRequestTypeCd[obj] === value) {
                return /** @type {?} */ (SalvageRequestTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SalvageRequestTypeCdHelper = new SalvageRequestTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SatelliteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SatelliteTypeCd) {
            this._values.push(SatelliteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SatelliteTypeCd) {
            if (SatelliteTypeCd[obj] === value) {
                return /** @type {?} */ (SatelliteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SatelliteTypeCdHelper = new SatelliteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ScheduleStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ScheduleStatusCd) {
            this._values.push(ScheduleStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ScheduleStatusCd) {
            if (ScheduleStatusCd[obj] === value) {
                return /** @type {?} */ (ScheduleStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ScheduleStatusCdHelper = new ScheduleStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ScoEventStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ScoEventStatusCd) {
            this._values.push(ScoEventStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ScoEventStatusCd) {
            if (ScoEventStatusCd[obj] === value) {
                return /** @type {?} */ (ScoEventStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ScoEventStatusCdHelper = new ScoEventStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ScoEventSubTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ScoEventSubTypeCd) {
            this._values.push(ScoEventSubTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ScoEventSubTypeCd) {
            if (ScoEventSubTypeCd[obj] === value) {
                return /** @type {?} */ (ScoEventSubTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ScoEventSubTypeCdHelper = new ScoEventSubTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ScoEventTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ScoEventTypeCd) {
            this._values.push(ScoEventTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ScoEventTypeCd) {
            if (ScoEventTypeCd[obj] === value) {
                return /** @type {?} */ (ScoEventTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ScoEventTypeCdHelper = new ScoEventTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SeaNotifyEventCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SeaNotifyEventCd) {
            this._values.push(SeaNotifyEventCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SeaNotifyEventCd) {
            if (SeaNotifyEventCd[obj] === value) {
                return /** @type {?} */ (SeaNotifyEventCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SeaNotifyEventCdHelper = new SeaNotifyEventCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceCalculationStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceCalculationStatusCd) {
            this._values.push(ServiceCalculationStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceCalculationStatusCd) {
            if (ServiceCalculationStatusCd[obj] === value) {
                return /** @type {?} */ (ServiceCalculationStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceCalculationStatusCdHelper = new ServiceCalculationStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceCd) {
            this._values.push(ServiceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceCd) {
            if (ServiceCd[obj] === value) {
                return /** @type {?} */ (ServiceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceCdHelper = new ServiceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceLevelCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceLevelCd) {
            this._values.push(ServiceLevelCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceLevelCd) {
            if (ServiceLevelCd[obj] === value) {
                return /** @type {?} */ (ServiceLevelCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceLevelCdHelper = new ServiceLevelCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceLevelPartyTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceLevelPartyTypeCd) {
            this._values.push(ServiceLevelPartyTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceLevelPartyTypeCd) {
            if (ServiceLevelPartyTypeCd[obj] === value) {
                return /** @type {?} */ (ServiceLevelPartyTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceLevelPartyTypeCdHelper = new ServiceLevelPartyTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceStatusCd) {
            this._values.push(ServiceStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceStatusCd) {
            if (ServiceStatusCd[obj] === value) {
                return /** @type {?} */ (ServiceStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceStatusCdHelper = new ServiceStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServiceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ServiceTypeCd) {
            this._values.push(ServiceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ServiceTypeCd) {
            if (ServiceTypeCd[obj] === value) {
                return /** @type {?} */ (ServiceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ServiceTypeCdHelper = new ServiceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShiftCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShiftCd) {
            this._values.push(ShiftCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShiftCd) {
            if (ShiftCd[obj] === value) {
                return /** @type {?} */ (ShiftCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShiftCdHelper = new ShiftCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentAcquiredTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentAcquiredTypeCd) {
            this._values.push(ShipmentAcquiredTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentAcquiredTypeCd) {
            if (ShipmentAcquiredTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentAcquiredTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentAcquiredTypeCdHelper = new ShipmentAcquiredTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentActionCd) {
            this._values.push(ShipmentActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentActionCd) {
            if (ShipmentActionCd[obj] === value) {
                return /** @type {?} */ (ShipmentActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentActionCdHelper = new ShipmentActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentAgendaItemActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentAgendaItemActionCd) {
            this._values.push(ShipmentAgendaItemActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentAgendaItemActionCd) {
            if (ShipmentAgendaItemActionCd[obj] === value) {
                return /** @type {?} */ (ShipmentAgendaItemActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentAgendaItemActionCdHelper = new ShipmentAgendaItemActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentAuditStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentAuditStatusCd) {
            this._values.push(ShipmentAuditStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentAuditStatusCd) {
            if (ShipmentAuditStatusCd[obj] === value) {
                return /** @type {?} */ (ShipmentAuditStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentAuditStatusCdHelper = new ShipmentAuditStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentCreditStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentCreditStatusCd) {
            this._values.push(ShipmentCreditStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentCreditStatusCd) {
            if (ShipmentCreditStatusCd[obj] === value) {
                return /** @type {?} */ (ShipmentCreditStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentCreditStatusCdHelper = new ShipmentCreditStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentDetailCd) {
            this._values.push(ShipmentDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentDetailCd) {
            if (ShipmentDetailCd[obj] === value) {
                return /** @type {?} */ (ShipmentDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentDetailCdHelper = new ShipmentDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentDirectionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentDirectionCd) {
            this._values.push(ShipmentDirectionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentDirectionCd) {
            if (ShipmentDirectionCd[obj] === value) {
                return /** @type {?} */ (ShipmentDirectionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentDirectionCdHelper = new ShipmentDirectionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentEventsCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentEventsCd) {
            this._values.push(ShipmentEventsCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentEventsCd) {
            if (ShipmentEventsCd[obj] === value) {
                return /** @type {?} */ (ShipmentEventsCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentEventsCdHelper = new ShipmentEventsCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentHistoryDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentHistoryDetailCd) {
            this._values.push(ShipmentHistoryDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentHistoryDetailCd) {
            if (ShipmentHistoryDetailCd[obj] === value) {
                return /** @type {?} */ (ShipmentHistoryDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentHistoryDetailCdHelper = new ShipmentHistoryDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentItemTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentItemTypeCd) {
            this._values.push(ShipmentItemTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentItemTypeCd) {
            if (ShipmentItemTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentItemTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentItemTypeCdHelper = new ShipmentItemTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentManagementRemarkTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentManagementRemarkTypeCd) {
            this._values.push(ShipmentManagementRemarkTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentManagementRemarkTypeCd) {
            if (ShipmentManagementRemarkTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentManagementRemarkTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentManagementRemarkTypeCdHelper = new ShipmentManagementRemarkTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentMovementTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentMovementTypeCd) {
            this._values.push(ShipmentMovementTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentMovementTypeCd) {
            if (ShipmentMovementTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentMovementTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentMovementTypeCdHelper = new ShipmentMovementTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentOnTimeStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentOnTimeStatusCd) {
            this._values.push(ShipmentOnTimeStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentOnTimeStatusCd) {
            if (ShipmentOnTimeStatusCd[obj] === value) {
                return /** @type {?} */ (ShipmentOnTimeStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentOnTimeStatusCdHelper = new ShipmentOnTimeStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentPnDStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentPnDStatusCd) {
            this._values.push(ShipmentPnDStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentPnDStatusCd) {
            if (ShipmentPnDStatusCd[obj] === value) {
                return /** @type {?} */ (ShipmentPnDStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentPnDStatusCdHelper = new ShipmentPnDStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentRemarkTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentRemarkTypeCd) {
            this._values.push(ShipmentRemarkTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentRemarkTypeCd) {
            if (ShipmentRemarkTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentRemarkTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentRemarkTypeCdHelper = new ShipmentRemarkTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentServiceTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentServiceTypeCd) {
            this._values.push(ShipmentServiceTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentServiceTypeCd) {
            if (ShipmentServiceTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentServiceTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentServiceTypeCdHelper = new ShipmentServiceTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentSourceCd) {
            this._values.push(ShipmentSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentSourceCd) {
            if (ShipmentSourceCd[obj] === value) {
                return /** @type {?} */ (ShipmentSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentSourceCdHelper = new ShipmentSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentSpecialServiceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentSpecialServiceCd) {
            this._values.push(ShipmentSpecialServiceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentSpecialServiceCd) {
            if (ShipmentSpecialServiceCd[obj] === value) {
                return /** @type {?} */ (ShipmentSpecialServiceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentSpecialServiceCdHelper = new ShipmentSpecialServiceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentUpdateActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentUpdateActionCd) {
            this._values.push(ShipmentUpdateActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentUpdateActionCd) {
            if (ShipmentUpdateActionCd[obj] === value) {
                return /** @type {?} */ (ShipmentUpdateActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentUpdateActionCdHelper = new ShipmentUpdateActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentVolumeMethodCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentVolumeMethodCd) {
            this._values.push(ShipmentVolumeMethodCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentVolumeMethodCd) {
            if (ShipmentVolumeMethodCd[obj] === value) {
                return /** @type {?} */ (ShipmentVolumeMethodCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentVolumeMethodCdHelper = new ShipmentVolumeMethodCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipmentVolumeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipmentVolumeTypeCd) {
            this._values.push(ShipmentVolumeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipmentVolumeTypeCd) {
            if (ShipmentVolumeTypeCd[obj] === value) {
                return /** @type {?} */ (ShipmentVolumeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipmentVolumeTypeCdHelper = new ShipmentVolumeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipperCountryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipperCountryCd) {
            this._values.push(ShipperCountryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipperCountryCd) {
            if (ShipperCountryCd[obj] === value) {
                return /** @type {?} */ (ShipperCountryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipperCountryCdHelper = new ShipperCountryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipperCreditStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipperCreditStatusCd) {
            this._values.push(ShipperCreditStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipperCreditStatusCd) {
            if (ShipperCreditStatusCd[obj] === value) {
                return /** @type {?} */ (ShipperCreditStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipperCreditStatusCdHelper = new ShipperCreditStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipperCustomerTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipperCustomerTypeCd) {
            this._values.push(ShipperCustomerTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipperCustomerTypeCd) {
            if (ShipperCustomerTypeCd[obj] === value) {
                return /** @type {?} */ (ShipperCustomerTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipperCustomerTypeCdHelper = new ShipperCustomerTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipperLoadedTrailerCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipperLoadedTrailerCd) {
            this._values.push(ShipperLoadedTrailerCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipperLoadedTrailerCd) {
            if (ShipperLoadedTrailerCd[obj] === value) {
                return /** @type {?} */ (ShipperLoadedTrailerCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipperLoadedTrailerCdHelper = new ShipperLoadedTrailerCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShipperPhoneCountryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShipperPhoneCountryCd) {
            this._values.push(ShipperPhoneCountryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShipperPhoneCountryCd) {
            if (ShipperPhoneCountryCd[obj] === value) {
                return /** @type {?} */ (ShipperPhoneCountryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShipperPhoneCountryCdHelper = new ShipperPhoneCountryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ShortageTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ShortageTypeCd) {
            this._values.push(ShortageTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ShortageTypeCd) {
            if (ShortageTypeCd[obj] === value) {
                return /** @type {?} */ (ShortageTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ShortageTypeCdHelper = new ShortageTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SnapshotDataTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SnapshotDataTypeCd) {
            this._values.push(SnapshotDataTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SnapshotDataTypeCd) {
            if (SnapshotDataTypeCd[obj] === value) {
                return /** @type {?} */ (SnapshotDataTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SnapshotDataTypeCdHelper = new SnapshotDataTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SortOrderCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SortOrderCd) {
            this._values.push(SortOrderCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SortOrderCd) {
            if (SortOrderCd[obj] === value) {
                return /** @type {?} */ (SortOrderCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SortOrderCdHelper = new SortOrderCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SpecialEquipmentCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SpecialEquipmentCd) {
            this._values.push(SpecialEquipmentCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SpecialEquipmentCd) {
            if (SpecialEquipmentCd[obj] === value) {
                return /** @type {?} */ (SpecialEquipmentCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SpecialEquipmentCdHelper = new SpecialEquipmentCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class StopDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in StopDetailCd) {
            this._values.push(StopDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in StopDetailCd) {
            if (StopDetailCd[obj] === value) {
                return /** @type {?} */ (StopDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ StopDetailCdHelper = new StopDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class StopSequenceModelConflictCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in StopSequenceModelConflictCd) {
            this._values.push(StopSequenceModelConflictCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in StopSequenceModelConflictCd) {
            if (StopSequenceModelConflictCd[obj] === value) {
                return /** @type {?} */ (StopSequenceModelConflictCd[obj]);
            }
        }
    }
}
const /** @type {?} */ StopSequenceModelConflictCdHelper = new StopSequenceModelConflictCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class StopWindowCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in StopWindowCd) {
            this._values.push(StopWindowCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in StopWindowCd) {
            if (StopWindowCd[obj] === value) {
                return /** @type {?} */ (StopWindowCd[obj]);
            }
        }
    }
}
const /** @type {?} */ StopWindowCdHelper = new StopWindowCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class StopWindowNoteTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in StopWindowNoteTypeCd) {
            this._values.push(StopWindowNoteTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in StopWindowNoteTypeCd) {
            if (StopWindowNoteTypeCd[obj] === value) {
                return /** @type {?} */ (StopWindowNoteTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ StopWindowNoteTypeCdHelper = new StopWindowNoteTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class StrandReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in StrandReasonCd) {
            this._values.push(StrandReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in StrandReasonCd) {
            if (StrandReasonCd[obj] === value) {
                return /** @type {?} */ (StrandReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ StrandReasonCdHelper = new StrandReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class SymphonyPubDeliverToCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in SymphonyPubDeliverToCd) {
            this._values.push(SymphonyPubDeliverToCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in SymphonyPubDeliverToCd) {
            if (SymphonyPubDeliverToCd[obj] === value) {
                return /** @type {?} */ (SymphonyPubDeliverToCd[obj]);
            }
        }
    }
}
const /** @type {?} */ SymphonyPubDeliverToCdHelper = new SymphonyPubDeliverToCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TariffOperatorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TariffOperatorCd) {
            this._values.push(TariffOperatorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TariffOperatorCd) {
            if (TariffOperatorCd[obj] === value) {
                return /** @type {?} */ (TariffOperatorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TariffOperatorCdHelper = new TariffOperatorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TariffTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TariffTypeCd) {
            this._values.push(TariffTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TariffTypeCd) {
            if (TariffTypeCd[obj] === value) {
                return /** @type {?} */ (TariffTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TariffTypeCdHelper = new TariffTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrailerAgendaItemActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TrailerAgendaItemActionCd) {
            this._values.push(TrailerAgendaItemActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TrailerAgendaItemActionCd) {
            if (TrailerAgendaItemActionCd[obj] === value) {
                return /** @type {?} */ (TrailerAgendaItemActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TrailerAgendaItemActionCdHelper = new TrailerAgendaItemActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrailerLoadedUnitDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TrailerLoadedUnitDetailCd) {
            this._values.push(TrailerLoadedUnitDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TrailerLoadedUnitDetailCd) {
            if (TrailerLoadedUnitDetailCd[obj] === value) {
                return /** @type {?} */ (TrailerLoadedUnitDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TrailerLoadedUnitDetailCdHelper = new TrailerLoadedUnitDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrailerRoutingEventCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TrailerRoutingEventCd) {
            this._values.push(TrailerRoutingEventCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TrailerRoutingEventCd) {
            if (TrailerRoutingEventCd[obj] === value) {
                return /** @type {?} */ (TrailerRoutingEventCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TrailerRoutingEventCdHelper = new TrailerRoutingEventCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrailerStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TrailerStatusCd) {
            this._values.push(TrailerStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TrailerStatusCd) {
            if (TrailerStatusCd[obj] === value) {
                return /** @type {?} */ (TrailerStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TrailerStatusCdHelper = new TrailerStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TransactionEventDetailTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TransactionEventDetailTypeCd) {
            this._values.push(TransactionEventDetailTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TransactionEventDetailTypeCd) {
            if (TransactionEventDetailTypeCd[obj] === value) {
                return /** @type {?} */ (TransactionEventDetailTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TransactionEventDetailTypeCdHelper = new TransactionEventDetailTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TransitTimeDirectionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TransitTimeDirectionTypeCd) {
            this._values.push(TransitTimeDirectionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TransitTimeDirectionTypeCd) {
            if (TransitTimeDirectionTypeCd[obj] === value) {
                return /** @type {?} */ (TransitTimeDirectionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TransitTimeDirectionTypeCdHelper = new TransitTimeDirectionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrapReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TrapReasonCd) {
            this._values.push(TrapReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TrapReasonCd) {
            if (TrapReasonCd[obj] === value) {
                return /** @type {?} */ (TrapReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TrapReasonCdHelper = new TrapReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripActivityTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripActivityTypeCd) {
            this._values.push(TripActivityTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripActivityTypeCd) {
            if (TripActivityTypeCd[obj] === value) {
                return /** @type {?} */ (TripActivityTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripActivityTypeCdHelper = new TripActivityTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripCategoryCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripCategoryCd) {
            this._values.push(TripCategoryCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripCategoryCd) {
            if (TripCategoryCd[obj] === value) {
                return /** @type {?} */ (TripCategoryCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripCategoryCdHelper = new TripCategoryCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripDetailCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripDetailCd) {
            this._values.push(TripDetailCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripDetailCd) {
            if (TripDetailCd[obj] === value) {
                return /** @type {?} */ (TripDetailCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripDetailCdHelper = new TripDetailCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripEquipmentStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripEquipmentStatusCd) {
            this._values.push(TripEquipmentStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripEquipmentStatusCd) {
            if (TripEquipmentStatusCd[obj] === value) {
                return /** @type {?} */ (TripEquipmentStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripEquipmentStatusCdHelper = new TripEquipmentStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripNodeActivityCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripNodeActivityCd) {
            this._values.push(TripNodeActivityCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripNodeActivityCd) {
            if (TripNodeActivityCd[obj] === value) {
                return /** @type {?} */ (TripNodeActivityCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripNodeActivityCdHelper = new TripNodeActivityCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripNodeStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripNodeStatusCd) {
            this._values.push(TripNodeStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripNodeStatusCd) {
            if (TripNodeStatusCd[obj] === value) {
                return /** @type {?} */ (TripNodeStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripNodeStatusCdHelper = new TripNodeStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripNodeTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripNodeTypeCd) {
            this._values.push(TripNodeTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripNodeTypeCd) {
            if (TripNodeTypeCd[obj] === value) {
                return /** @type {?} */ (TripNodeTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripNodeTypeCdHelper = new TripNodeTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripStatusCd) {
            this._values.push(TripStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripStatusCd) {
            if (TripStatusCd[obj] === value) {
                return /** @type {?} */ (TripStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripStatusCdHelper = new TripStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TripStopActionCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in TripStopActionCd) {
            this._values.push(TripStopActionCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in TripStopActionCd) {
            if (TripStopActionCd[obj] === value) {
                return /** @type {?} */ (TripStopActionCd[obj]);
            }
        }
    }
}
const /** @type {?} */ TripStopActionCdHelper = new TripStopActionCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UnassignPickupsSourceCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UnassignPickupsSourceCd) {
            this._values.push(UnassignPickupsSourceCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UnassignPickupsSourceCd) {
            if (UnassignPickupsSourceCd[obj] === value) {
                return /** @type {?} */ (UnassignPickupsSourceCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UnassignPickupsSourceCdHelper = new UnassignPickupsSourceCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UnassignReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UnassignReasonCd) {
            this._values.push(UnassignReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UnassignReasonCd) {
            if (UnassignReasonCd[obj] === value) {
                return /** @type {?} */ (UnassignReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UnassignReasonCdHelper = new UnassignReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UndeliveredReasonCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UndeliveredReasonCd) {
            this._values.push(UndeliveredReasonCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UndeliveredReasonCd) {
            if (UndeliveredReasonCd[obj] === value) {
                return /** @type {?} */ (UndeliveredReasonCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UndeliveredReasonCdHelper = new UndeliveredReasonCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UploadDynamicPricingFileOperationCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UploadDynamicPricingFileOperationCd) {
            this._values.push(UploadDynamicPricingFileOperationCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UploadDynamicPricingFileOperationCd) {
            if (UploadDynamicPricingFileOperationCd[obj] === value) {
                return /** @type {?} */ (UploadDynamicPricingFileOperationCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UploadDynamicPricingFileOperationCdHelper = new UploadDynamicPricingFileOperationCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UserRoleCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UserRoleCd) {
            this._values.push(UserRoleCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UserRoleCd) {
            if (UserRoleCd[obj] === value) {
                return /** @type {?} */ (UserRoleCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UserRoleCdHelper = new UserRoleCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class UserRoleTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in UserRoleTypeCd) {
            this._values.push(UserRoleTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in UserRoleTypeCd) {
            if (UserRoleTypeCd[obj] === value) {
                return /** @type {?} */ (UserRoleTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ UserRoleTypeCdHelper = new UserRoleTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WarrantyStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WarrantyStatusCd) {
            this._values.push(WarrantyStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WarrantyStatusCd) {
            if (WarrantyStatusCd[obj] === value) {
                return /** @type {?} */ (WarrantyStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WarrantyStatusCdHelper = new WarrantyStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WeekDayCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WeekDayCd) {
            this._values.push(WeekDayCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WeekDayCd) {
            if (WeekDayCd[obj] === value) {
                return /** @type {?} */ (WeekDayCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WeekDayCdHelper = new WeekDayCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WeightUomCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WeightUomCd) {
            this._values.push(WeightUomCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WeightUomCd) {
            if (WeightUomCd[obj] === value) {
                return /** @type {?} */ (WeightUomCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WeightUomCdHelper = new WeightUomCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WhatIfDownloadFileTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WhatIfDownloadFileTypeCd) {
            this._values.push(WhatIfDownloadFileTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WhatIfDownloadFileTypeCd) {
            if (WhatIfDownloadFileTypeCd[obj] === value) {
                return /** @type {?} */ (WhatIfDownloadFileTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WhatIfDownloadFileTypeCdHelper = new WhatIfDownloadFileTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WhatIfShipmentSelectionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WhatIfShipmentSelectionTypeCd) {
            this._values.push(WhatIfShipmentSelectionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WhatIfShipmentSelectionTypeCd) {
            if (WhatIfShipmentSelectionTypeCd[obj] === value) {
                return /** @type {?} */ (WhatIfShipmentSelectionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WhatIfShipmentSelectionTypeCdHelper = new WhatIfShipmentSelectionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WorkerStatusCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WorkerStatusCd) {
            this._values.push(WorkerStatusCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WorkerStatusCd) {
            if (WorkerStatusCd[obj] === value) {
                return /** @type {?} */ (WorkerStatusCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WorkerStatusCdHelper = new WorkerStatusCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class WorkflowSelectionModeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in WorkflowSelectionModeCd) {
            this._values.push(WorkflowSelectionModeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in WorkflowSelectionModeCd) {
            if (WorkflowSelectionModeCd[obj] === value) {
                return /** @type {?} */ (WorkflowSelectionModeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ WorkflowSelectionModeCdHelper = new WorkflowSelectionModeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class XFlowFrequencyCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in XFlowFrequencyCd) {
            this._values.push(XFlowFrequencyCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in XFlowFrequencyCd) {
            if (XFlowFrequencyCd[obj] === value) {
                return /** @type {?} */ (XFlowFrequencyCd[obj]);
            }
        }
    }
}
const /** @type {?} */ XFlowFrequencyCdHelper = new XFlowFrequencyCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class XFlowNotificationTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in XFlowNotificationTypeCd) {
            this._values.push(XFlowNotificationTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in XFlowNotificationTypeCd) {
            if (XFlowNotificationTypeCd[obj] === value) {
                return /** @type {?} */ (XFlowNotificationTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ XFlowNotificationTypeCdHelper = new XFlowNotificationTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class XdockExceptionTypeCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in XdockExceptionTypeCd) {
            this._values.push(XdockExceptionTypeCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in XdockExceptionTypeCd) {
            if (XdockExceptionTypeCd[obj] === value) {
                return /** @type {?} */ (XdockExceptionTypeCd[obj]);
            }
        }
    }
}
const /** @type {?} */ XdockExceptionTypeCdHelper = new XdockExceptionTypeCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ZoneIndicatorCdHelperEnumHelperClass extends EnumHelper {
    constructor() {
        super();
        for (const /** @type {?} */ obj in ZoneIndicatorCd) {
            this._values.push(ZoneIndicatorCd[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in ZoneIndicatorCd) {
            if (ZoneIndicatorCd[obj] === value) {
                return /** @type {?} */ (ZoneIndicatorCd[obj]);
            }
        }
    }
}
const /** @type {?} */ ZoneIndicatorCdHelper = new ZoneIndicatorCdHelperEnumHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { Utils, FileContents, Envelope, CarrierMaster, TenderDetail, AcctId, AcctIdBasic, Address, Area, Attachment, AuditInfo, Charge, ChildProNbrReplacement, ChildShipmentId, Code, Comment, CompanyLocation, ContactInfo, ContactInfoBasic, CountInfo, DataValidationError, Density, TransitTime, DimensionMeasurement, Dimensions, Distance, Document, ElectronicMessage, Email, EquipmentId, EventHdr, ExchangeRateInfo, Fault, FieldInfo, FieldValueChange, File, FilterCriteria, FilterString, FilterStringBetween, FilterDate, FilterDateBetween, FilterNumber, FilterNumberBetween, LatLong, GeoCoordinates, HyperMedia, ListInfo, Location, GeoLocation, MappingInfo, MonetaryAmount, MoreInfo, NameValue, PaymentCalcMethod, ParentProNbrReplacement, Person, Phone, PickupRequestId, PostalAssignment, ReferenceNumber, ServiceCenterLocation, ShipmentId, ShipmentImagedDocument, ShipmentImagedDocument_File, SortField, Status, StatusException, SupplementalReference, EmployeeId, User, Volume, Weight, GetHealthCheckResp, Instruction, CustomerHrchy, CustomerSchedule, ConfigParm, PartyBasic, PartyAccountBasic, PartyContactBasic, InvoicingInstruction, CrmAccount, CrmAccountOwner, AccountDetail, Equipment, EquipmentBase, EquipmentInfo, EquipmentProperty, EquipmentSeal, Speed, TransactionEvent, TransactionEventBusiness, TransactionEventDetail, FaultResponse, JobStatus, JobRetryConfig, Attribute, PubsubTarget, AppEngineRouting, AppEngineHttpTarget, HttpTarget, Job, Locations, LocationAddress, KafkaMessageHeader, SearchRecordMessageHeader, LTLMessageHdr, Body, PayloadType, TranCntxt, LTLEvent, CBOHeaderType, TrackingInfoType, AppInfoType, InfoType, CBOType, LinehaulSchedule, LinehaulScheduleLeg, StopWindow, StopWindowNote, CancelledPickupRequest, CancelledPickupRequestShipment, CompletePickupRequest, PickupRequest, PickupRequestShipment, PickupRequestStatus, PickupShipment, PickupRequestor, PickupLineItemSearchFilter, PickupLineItemSearchRecord, RescheduledPickupRequest, PkrPickupRequest, PkrShipment, PkrShipmentDimension, PkrShipmentHandlingUnit, PkrShipmentHazMat, Accessorial, Appointment, Bond, CashOnDelivery, ChemicalCharacteristics, CommodityLine, CommodityInfo, DoNotHoldDeliveryLine, FBDSDocument, FreightExceptions, HazardousCharacteristics, Packaging, RateAndCharge, RatedAsWeight, ReducedCharge, ShipmentCharge, ShipmentDimension, ShipmentNotification, ShipmentParty, ShipmentPartyBasic, ShipmentSpecialServiceSummary, AccessorialService, AdvanceBeyondCarrier, AsMatchedParty, Commodity, CommodityDimension, CommodityDimensionSnapshot, CustomsBond, CustomsBondSnapshot, HandlingUnit, HandlingUnitSnapshot, HandlingUnitMovement, HandlingUnitMovementSnapshot, HazMat, LnhDimension, LnhDimensionSnapshot, MiscLineItem, Movement, MovementException, MovementExceptionAction, Remark, Shipment, TimeDateCritical, XrtAttributeFilter, XrtDistanceFeature, XrtGeoPoint, XrtSortExpression, XrtSearchQueryHeader, XrtSearchRespHeader, XrtExportQueryHeader, AccessorialChargePricing, AccessorialOverride, AgreementContractTerm, ClassOverrideBasic, ClassOverridexx, ClassRate, CommodityPricing, DiscountPgm, DiscountTier, FuelSurcharge, LinealFeetRate, MiscSvcOverride, NmfcClassOverride, NmfcItemOverride, PricingAgreementId, RulesetId, WeightRestriction, PalletCommodity, PricingAgreement, Rating, RatingAccessorial, RatingCommodityLine, RatingParty, RatingRequest, RatingResponse, RatingRule, RatingShipmentRequest, RatingShipmentResponse, RatingTotal, TransactionContext, XFlowConversation, XFlowConversationGroup, XFlowItem, XFlowItemCount, XFlowMessage, ARDebtorCd, AccessorialCheckCd, AccessorialUnitOfMeasureCd, ActionCd, ActivityStatusCd, AddressTypeCd, AdvanceBeyondTypeCd, AgendaItemStatusCd, AgendaOwnerTypeCd, ApiAuthTypeCd, ApiContractExceptionSeverityCd, ApiContractImplApiMethodCd, ApiContractImplProtocolCd, ApiContractImplTechnology, ApiContractStatusCd, ApiContractTypeCategoryCd, ApiFeatureStatusCd, ApiThrottlingTierCd, ApiTypeAttributeDataTypeCd, ApiTypeCategoryCd, ApiTypeStatusCd, ApplicationCd, AppointmentNotificationStatCd, AppointmentStatusCd, ApprovalStatusCd, ArchiveControlCd, AttemptReasonCd, AvailableStatusCd, BatchFrameworkArgumentTypeCd, BeaconItemStatusCd, BeaconOwnerTypeCd, BeaconPriorityCd, BeaconSourceCd, BeaconStatusCd, BeaconTypeCd, BillClassCd, BillCorrectionStatusCd, BillStatusCd, BillToRelationCd, BillTypeCd, BillingRemarkTypeCd, BolPartyTypeCd, BolUsageTypeCd, BondReasonCd, BondStatusCd, BondTypeCd, BusinessMetricCd, CarrierDetailCd, CarrierLocationTypeCd, CarrierTenderGroupStatusCd, CarrierTenderStatusCd, CbolRespMessageStatusCd, ChangeRsnCd, ChargeToCd, CheckpointEventStatusCd, CheckpointMasterActionCd, CisRequestApprovalStatusCd, CisRequestPriorityCd, CisRequestStatusCd, ClaimAdditionalPaymentReasonCd, ClaimChargeabilityReasonCd, ClaimCurrencyCd, ClaimDecisionCategoryCd, ClaimDecisionSubCategoryCd, ClaimEmailTemplateFieldCd, ClaimEmailTemplateTypeCd, ClaimEventTypeCd, ClaimExternalStatusCd, ClaimExternalVisibilityCd, ClaimFieldName, ClaimFilingMethodCd, ClaimInternalStatusCd, ClaimNoteTypeCd, ClaimNoteVisibilityCd, ClaimPartyTypeCd, ClaimPaymentMethodCd, ClaimRelatedShipmentTypeCd, ClaimTypeCd, ClaimantSameAsCd, CloseReasonCd, CmsTripTypeCd, CollectMoneyAtDeliveryCd, CommodityClaimTypeCd, CommodityClassCd, CommodityConditionTypeCd, CommodityPackageCd, ConeColorCd, ConfigurationValueTypeCd, ConsigneeUnloadedTrailerCd, ContactRoleCd, ConversationActionItemStatCd, ConversationSourceCd, CorrectionQueueNameCd, CorrectionReasonCd, CorrectionStatusCd, CorrectionTypeCd, CostCardTypeCd, CountryCd, CouponCd, CrcAuditCd, CredStatCd, CssClassCd, CubicFeetProfileMthdCd, CubicFeetProfileTypeCd, CurrencyCd, CustOperationHoursTypeCd, CustOperationNoteTypeCd, CustOperationsPickupTypeCd, CustomerAccountTypeCd, CustomerAddressValidationCd, CustomerContactRoleCd, CustomerCreditStatusCd, CustomerDetailCd, CustomerExpiryReasonCd, CustomerFunctionCd, CustomerHoldCategoryCd, CustomerIdTypeCd, CustomerInvoiceCd, CustomerLineStatusCd, CustomerMatchRequestTypeCd, CustomerMatchResultTypeCd, CustomerNoteForCd, CustomerNoteTypeCd, CustomerNotificationActionFormatCd, CustomerNotificationBroadcastCd, CustomerNotificationLevelCd, CustomerNotificationPayloadFormatCd, CustomerNotificationPriorityCd, CustomerNotificationTypeCd, CustomerPaymentTermsCd, CustomerProfileDetailCd, CustomerRequestPriorityCd, CustomerRequestQueueNameCd, CustomerRequestStatusCd, CustomerStatusCd, CustomerTypeCd, CustomerTypeOfSvcIndicatorCd, CustomsControlTypeCd, CustomsPortCd, CustomsReasonCd, DamageTypeCd, DebtorCd, DeliveryDateTypeCd, DeliveryInfoRequiredCd, DeliveryQualifierCd, DeliveryQualifierReasonCd, DeliveryShipmentIndexCd, DeltaSignCd, DeltaVarianceTypeCd, DensitySourceCd, DependentFreightTypeCd, DeviceApplicationCd, DeviceShiftCd, DeviceTypeCd, DimensionSourceCd, DimensionUomCd, DirectedLoadingExceptionTypeCd, DirectedLoadingLaneTypeCd, DisputeAreaCd, DisputeCsvFileStatusCd, DisputeCsvFileUploadStatusCd, DisputeDecisionReasonSubTypeCd, DisputeDecisionReasonTypeCd, DisputeDrpCategoryCd, DisputeEmailTemplateTypeCd, DisputeEventTypeCd, DisputeFilingMethodCd, DisputeNoteTypeCd, DisputePartyTypeCd, DisputeProValidationStatusCd, DisputeReassignReasonCd, DisputeRequestReasonCd, DisputeShipmentCurrencyCd, DisputeShipmentPaymentStatusCd, DisputeShpIneligibilityRsnCd, DisputeStatusCd, DisputeTypeCd, DmsDocTypeCd, DockActivityCd, DockManifestReportTypeCd, DockOperationsReportTypeCd, DockShipmentListTypeCd, DockShipmentProgressCd, DockShipmentTypeCd, DocumentFormTypeCd, DoorMatchCd, DoorPlanActionCd, DoorPlanProfileTypeCd, DoorPreferenceTypeCd, DriverJobTypeCd, DriverMessageOperationCd, DriverSourceCd, DriverTurnTypeCd, DsrLicenseCd, DsrSelectionTypeCd, DwellPeriodTypeCd, DwellReasonTypeCd, DwellSourceCd, DynamicPriceApiNameCd, DynamicPriceApplicationTypeCd, DynamicPriceEventTypeCd, DynamicPriceLTLBillStatusCd, DynamicPriceLaneTypeCd, DynamicPriceLocationTypeCd, DynamicPriceQualifierTypeCd, DynamicPriceRateTypeCd, DynamicPriceRestrictionTypeCd, DynamicPriceStatusCd, EarlyCutoffCd, EcmGoalTypeCd, EcmSummaryCountTypeCd, EdiSlashPoundCd, EmailDirectionTypeCd, EmailFormatCd, EmployeeIdTypeCd, EmployeeRoleCd, EnsembleExecutionStatusCd, EnsembleListenerModeCd, EnvironmentCd, EquipmentEventReasonCd, EquipmentEventSubTypeCd, EquipmentEventTypeCd, EquipmentQualifierCd, EquipmentSizeCd, EquipmentStatusCd, EquipmentStatusQualifierCd, EquipmentTypeCd, EquipmentTypeDetailCd, EslCd, EventLogSubTypeCd, EventLogTypeCd, EventSourceCd, EventTypeCd, ExadataDatabaseCd, ExceptionCategoryCd, ExceptionLocationTypeCd, ExceptionStatusCd, ExceptionSummaryCd, ExceptionSummaryTypeCd, ExceptionTypeCd, ExemptReasonCd, ExpectationOwnerTypeCd, ExpectationStatusCd, ExpireReasonCd, ExtendedServiceLaneTypeCd, ExternalShipmentStatusCd, FbdsPrintCountCd, FbdsVersionCd, FieldDisplayTypeCd, FinalStandardAddressSourceCd, FinancialFunctionCd, FoodPoisonCd, FreightMaintenanceTypeCd, FreightOperationTypeCd, FreightServiceAreaTypeCd, FreightStatusCd, GeoLocationTypeCd, GlobalSearchDetailCd, GoalLevelCd, GoalTypeCd, HandlingUnitDimensionTypeCd, HandlingUnitMovementTypeCd, HandlingUnitTypeCd, HazmatBulkQuantityCd, HazmatSourceCd, HierarchyGroupCategoryCd, HookCategoryCd, HookStatusCd, HostlerInstructionCd, HssRegionCd, HttpMethod, IdentifiedLocationTypeCd, InstructionStatCd, IntermodalSatelliteTypeCd, InvPaymentChrgToCd, InvoiceAccuracyConstraintCd, InvoiceAddressCd, InvoiceAttachmentCd, InvoiceCurrencyCd, InvoiceDetailDataTypeCd, InvoiceDocumentCd, InvoiceEvalOperCd, InvoiceHoldReasonCd, InvoiceModeCd, InvoicePostDeliveryStatusCd, InvoicePreferenceCd, InvoicePreferenceConstraintCd, InvoicePresentationFormatCd, InvoiceRequirementCategoryCd, InvoiceRequirementTypeCd, InvoiceSendStatusCd, InvoiceTransmissionFormatCd, InvoiceTransmitStatusCd, InvoiceTypeCd, JSPLaborRollupTypeCd, JSPShiftTimeNameTypeCd, JSPShiftTimeTypeCd, JSPWorkerTypeCd, JobSelectionCd, JobStateTypeCd, LabelShippingStatusCd, LateTenderCd, LegalTermsTypeCd, LengthUomCd, LhoEventTypeCd, LicenseEquipmentBodyCd, LicenseEquipmentFuelTypeCd, LicenseEquipmentOwnedLeaseCd, LicenseEquipmentTypeCd, LicenseValidityCd, LineItemChargeToCd, LoadGroupTypeCd, LoadUnloadIdentifierCd, LocationAddressTypeCd, LocationDetailCd, LocationHierarchyTypeCd, LocationOperationTypeCd, LocationPhoneTypeCd, LocationTypeCd, LogLevel, LookerResultFormatCd, ManifestReportTypeCd, MatchedPartySourceCd, MatchedPartyStatusCd, MatchedPartyTypeCd, MessageLogStatusCd, MessagePriorityCd, MetricPredictionTypeCd, MetricStageCd, MetricStageSubCd, MetricThresholdContextCd, MetricThresholdValueTypeCd, MetricTypeCd, MetricValueKeyCd, MetricVarianceCd, MinuetExecutionStatusCd, MiscLineItemCd, MiscLineItemPaymentMethodCd, ModelGroupCd, ModuleExecutorDataExtractTypeCd, ModuleExecutorDatasetTypeCd, ModuleExecutorParmsArgTypeCd, ModuleExecutorSuccessfulCd, MoveModeCd, MovementExceptionTypeCd, MovementStatusCd, NetExplosiveMassUomCd, NextBestActionTypeCd, NextBusinessDayOperationCd, NodeTypeCd, NonDriveTimeLocationCd, NonDriveTimePaidCd, NonWorkDayTypeCd, NoteTypeCd, NotificationCd, OptimizerParameterCd, OptimizerParameterTypeCd, OptimizerResultReasonCd, OptimizerResultStatusCd, OptimizerStatusCd, OriginalSourceCd, OsdCategoryCd, OsdPayloadTypeCd, OsdStatusCd, ParentActivityTypeCd, ParkingLocationTypeCd, PartyRoleCd, PartyShipmentRoleCd, PayformActivityLocCd, PayformDetailCd, PayformNoteTypeCd, PayformPaidTypeCd, PayformStatusCd, PaymentMethodCd, PaymentStatusExternalCd, PaymentStatusInternalCd, PaymentTypeCd, PhotoTypeCd, PickupRequestHoldTypeCd, PickupRequestReasonCategoryCd, PickupRequestReasonCategoryRefCd, PickupRequestReasonSubCategoryRefCd, PickupRequestReasonTypeCd, PickupRequestReinstateTypeCd, PickupRequesterRoleCd, PickupShipmentSourceCd, PickupShipmentStatusCd, PickupShipmetActionCd, PickupSourceCd, PickupStatusCd, PickupTypeCd, PnDAutoPrintOptionCd, PnDReportTypeCd, PnDRoleCd, PolygonTypeCd, PricingAnalysisRunTypeCd, PricingRulesetOwnerCd, PricingTypeCd, PrintFBDSDocumentsTypeCd, ProBolUsageStatusCd, ProCheckoutTypeCd, ProInUseCd, ProNbrTypeCd, ProPadTypeCd, ProPrintedLabelStatusCd, ProRequestDetailStatusCd, ProRequestStatusCd, ProStatusCd, ProSummaryTypeCd, ProTrackingLabelStatusCd, ProcessStatusCd, QueueNameCd, RadioactivityUomCd, RateDiscountSourceCd, RateQuoteAccessorialCd, RateQuoteTypeCd, RateRequestSubTypeCd, RateRequestTypeCd, RateStatusCd, RatingCurrencyCd, RatingPartyLocationTypeCd, RatingQueueClassTypeCd, RatingShipmentFileTypeCd, RatingStatusCd, RatingWhatIfRequestStatusCd, RebuttalExternalStatusCd, RebuttalInternalStatusCd, RebuttalReasonCd, ReducedServiceSatelliteTypeCd, RefusedReasonCd, ReportsCd, RequestedChangeCd, RequestedChangeItemActionCd, RequestedChangeTypeCd, RerateTypeCd, ReturnInstrRetainCheckCd, ReturnReasonCd, RevenueDayCd, ReweighStatusCd, RouteActionCd, RouteAutoSequenceTypeCd, RouteBalancingTypeCd, RouteCategoryCd, RouteDetailCd, RouteEquipmentTypeCd, RouteStatusCd, RouteTypeCd, RschCnclReasonCd, RuleActiveTypeCd, RuleExpressionValueTypeCd, RuleFailureReasonCd, RuleLogicalOperatorCd, RuleOperatorCd, RuleOverrideReasonCd, RuleShmEntityTypeCd, RunShiftCd, RwgLogHeaderMoreInfoCd, SalvageRequestStatusCd, SalvageRequestTypeCd, SatelliteTypeCd, ScheduleStatusCd, ScoEventStatusCd, ScoEventSubTypeCd, ScoEventTypeCd, SeaNotifyEventCd, ServiceCalculationStatusCd, ServiceCd, ServiceLevelCd, ServiceLevelPartyTypeCd, ServiceStatusCd, ServiceTypeCd, ShiftCd, ShipmentAcquiredTypeCd, ShipmentActionCd, ShipmentAgendaItemActionCd, ShipmentAuditStatusCd, ShipmentCreditStatusCd, ShipmentDetailCd, ShipmentDirectionCd, ShipmentEventsCd, ShipmentHistoryDetailCd, ShipmentItemTypeCd, ShipmentManagementRemarkTypeCd, ShipmentMovementTypeCd, ShipmentOnTimeStatusCd, ShipmentPnDStatusCd, ShipmentRemarkTypeCd, ShipmentServiceTypeCd, ShipmentSourceCd, ShipmentSpecialServiceCd, ShipmentUpdateActionCd, ShipmentVolumeMethodCd, ShipmentVolumeTypeCd, ShipperCountryCd, ShipperCreditStatusCd, ShipperCustomerTypeCd, ShipperLoadedTrailerCd, ShipperPhoneCountryCd, ShortageTypeCd, SnapshotDataTypeCd, SortOrderCd, SpecialEquipmentCd, StopDetailCd, StopSequenceModelConflictCd, StopWindowCd, StopWindowNoteTypeCd, StrandReasonCd, SymphonyPubDeliverToCd, TariffOperatorCd, TariffTypeCd, TrailerAgendaItemActionCd, TrailerLoadedUnitDetailCd, TrailerRoutingEventCd, TrailerStatusCd, TransactionEventDetailTypeCd, TransitTimeDirectionTypeCd, TrapReasonCd, TripActivityTypeCd, TripCategoryCd, TripDetailCd, TripEquipmentStatusCd, TripNodeActivityCd, TripNodeStatusCd, TripNodeTypeCd, TripStatusCd, TripStopActionCd, UnassignPickupsSourceCd, UnassignReasonCd, UndeliveredReasonCd, UploadDynamicPricingFileOperationCd, UserRoleCd, UserRoleTypeCd, WarrantyStatusCd, WeekDayCd, WeightUomCd, WhatIfDownloadFileTypeCd, WhatIfShipmentSelectionTypeCd, WorkerStatusCd, WorkflowSelectionModeCd, XFlowFrequencyCd, XFlowNotificationTypeCd, XdockExceptionTypeCd, ZoneIndicatorCd, ARDebtorCdHelper, AccessorialCheckCdHelper, AccessorialUnitOfMeasureCdHelper, ActionCdHelper, ActivityStatusCdHelper, AddressTypeCdHelper, AdvanceBeyondTypeCdHelper, AgendaItemStatusCdHelper, AgendaOwnerTypeCdHelper, ApiAuthTypeCdHelper, ApiContractExceptionSeverityCdHelper, ApiContractImplApiMethodCdHelper, ApiContractImplProtocolCdHelper, ApiContractImplTechnologyHelper, ApiContractStatusCdHelper, ApiContractTypeCategoryCdHelper, ApiFeatureStatusCdHelper, ApiThrottlingTierCdHelper, ApiTypeAttributeDataTypeCdHelper, ApiTypeCategoryCdHelper, ApiTypeStatusCdHelper, ApplicationCdHelper, AppointmentNotificationStatCdHelper, AppointmentStatusCdHelper, ApprovalStatusCdHelper, ArchiveControlCdHelper, AttemptReasonCdHelper, AvailableStatusCdHelper, BatchFrameworkArgumentTypeCdHelper, BeaconItemStatusCdHelper, BeaconOwnerTypeCdHelper, BeaconPriorityCdHelper, BeaconSourceCdHelper, BeaconStatusCdHelper, BeaconTypeCdHelper, BillClassCdHelper, BillCorrectionStatusCdHelper, BillStatusCdHelper, BillToRelationCdHelper, BillTypeCdHelper, BillingRemarkTypeCdHelper, BolPartyTypeCdHelper, BolUsageTypeCdHelper, BondReasonCdHelper, BondStatusCdHelper, BondTypeCdHelper, BusinessMetricCdHelper, CarrierDetailCdHelper, CarrierLocationTypeCdHelper, CarrierTenderGroupStatusCdHelper, CarrierTenderStatusCdHelper, CbolRespMessageStatusCdHelper, ChangeRsnCdHelper, ChargeToCdHelper, CheckpointEventStatusCdHelper, CheckpointMasterActionCdHelper, CisRequestApprovalStatusCdHelper, CisRequestPriorityCdHelper, CisRequestStatusCdHelper, ClaimAdditionalPaymentReasonCdHelper, ClaimChargeabilityReasonCdHelper, ClaimCurrencyCdHelper, ClaimDecisionCategoryCdHelper, ClaimDecisionSubCategoryCdHelper, ClaimEmailTemplateFieldCdHelper, ClaimEmailTemplateTypeCdHelper, ClaimEventTypeCdHelper, ClaimExternalStatusCdHelper, ClaimExternalVisibilityCdHelper, ClaimFieldNameHelper, ClaimFilingMethodCdHelper, ClaimInternalStatusCdHelper, ClaimNoteTypeCdHelper, ClaimNoteVisibilityCdHelper, ClaimPartyTypeCdHelper, ClaimPaymentMethodCdHelper, ClaimRelatedShipmentTypeCdHelper, ClaimTypeCdHelper, ClaimantSameAsCdHelper, CloseReasonCdHelper, CmsTripTypeCdHelper, CollectMoneyAtDeliveryCdHelper, CommodityClaimTypeCdHelper, CommodityClassCdHelper, CommodityConditionTypeCdHelper, CommodityPackageCdHelper, ConeColorCdHelper, ConfigurationValueTypeCdHelper, ConsigneeUnloadedTrailerCdHelper, ContactRoleCdHelper, ConversationActionItemStatCdHelper, ConversationSourceCdHelper, CorrectionQueueNameCdHelper, CorrectionReasonCdHelper, CorrectionStatusCdHelper, CorrectionTypeCdHelper, CostCardTypeCdHelper, CountryCdHelper, CouponCdHelper, CrcAuditCdHelper, CredStatCdHelper, CssClassCdHelper, CubicFeetProfileMthdCdHelper, CubicFeetProfileTypeCdHelper, CurrencyCdHelper, CustOperationHoursTypeCdHelper, CustOperationNoteTypeCdHelper, CustOperationsPickupTypeCdHelper, CustomerAccountTypeCdHelper, CustomerAddressValidationCdHelper, CustomerContactRoleCdHelper, CustomerCreditStatusCdHelper, CustomerDetailCdHelper, CustomerExpiryReasonCdHelper, CustomerFunctionCdHelper, CustomerHoldCategoryCdHelper, CustomerIdTypeCdHelper, CustomerInvoiceCdHelper, CustomerLineStatusCdHelper, CustomerMatchRequestTypeCdHelper, CustomerMatchResultTypeCdHelper, CustomerNoteForCdHelper, CustomerNoteTypeCdHelper, CustomerNotificationActionFormatCdHelper, CustomerNotificationBroadcastCdHelper, CustomerNotificationLevelCdHelper, CustomerNotificationPayloadFormatCdHelper, CustomerNotificationPriorityCdHelper, CustomerNotificationTypeCdHelper, CustomerPaymentTermsCdHelper, CustomerProfileDetailCdHelper, CustomerRequestPriorityCdHelper, CustomerRequestQueueNameCdHelper, CustomerRequestStatusCdHelper, CustomerStatusCdHelper, CustomerTypeCdHelper, CustomerTypeOfSvcIndicatorCdHelper, CustomsControlTypeCdHelper, CustomsPortCdHelper, CustomsReasonCdHelper, DamageTypeCdHelper, DebtorCdHelper, DeliveryDateTypeCdHelper, DeliveryInfoRequiredCdHelper, DeliveryQualifierCdHelper, DeliveryQualifierReasonCdHelper, DeliveryShipmentIndexCdHelper, DeltaSignCdHelper, DeltaVarianceTypeCdHelper, DensitySourceCdHelper, DependentFreightTypeCdHelper, DeviceApplicationCdHelper, DeviceShiftCdHelper, DeviceTypeCdHelper, DimensionSourceCdHelper, DimensionUomCdHelper, DirectedLoadingExceptionTypeCdHelper, DirectedLoadingLaneTypeCdHelper, DisputeAreaCdHelper, DisputeCsvFileStatusCdHelper, DisputeCsvFileUploadStatusCdHelper, DisputeDecisionReasonSubTypeCdHelper, DisputeDecisionReasonTypeCdHelper, DisputeDrpCategoryCdHelper, DisputeEmailTemplateTypeCdHelper, DisputeEventTypeCdHelper, DisputeFilingMethodCdHelper, DisputeNoteTypeCdHelper, DisputePartyTypeCdHelper, DisputeProValidationStatusCdHelper, DisputeReassignReasonCdHelper, DisputeRequestReasonCdHelper, DisputeShipmentCurrencyCdHelper, DisputeShipmentPaymentStatusCdHelper, DisputeShpIneligibilityRsnCdHelper, DisputeStatusCdHelper, DisputeTypeCdHelper, DmsDocTypeCdHelper, DockActivityCdHelper, DockManifestReportTypeCdHelper, DockOperationsReportTypeCdHelper, DockShipmentListTypeCdHelper, DockShipmentProgressCdHelper, DockShipmentTypeCdHelper, DocumentFormTypeCdHelper, DoorMatchCdHelper, DoorPlanActionCdHelper, DoorPlanProfileTypeCdHelper, DoorPreferenceTypeCdHelper, DriverJobTypeCdHelper, DriverMessageOperationCdHelper, DriverSourceCdHelper, DriverTurnTypeCdHelper, DsrLicenseCdHelper, DsrSelectionTypeCdHelper, DwellPeriodTypeCdHelper, DwellReasonTypeCdHelper, DwellSourceCdHelper, DynamicPriceApiNameCdHelper, DynamicPriceApplicationTypeCdHelper, DynamicPriceEventTypeCdHelper, DynamicPriceLTLBillStatusCdHelper, DynamicPriceLaneTypeCdHelper, DynamicPriceLocationTypeCdHelper, DynamicPriceQualifierTypeCdHelper, DynamicPriceRateTypeCdHelper, DynamicPriceRestrictionTypeCdHelper, DynamicPriceStatusCdHelper, EarlyCutoffCdHelper, EcmGoalTypeCdHelper, EcmSummaryCountTypeCdHelper, EdiSlashPoundCdHelper, EmailDirectionTypeCdHelper, EmailFormatCdHelper, EmployeeIdTypeCdHelper, EmployeeRoleCdHelper, EnsembleExecutionStatusCdHelper, EnsembleListenerModeCdHelper, EnvironmentCdHelper, EquipmentEventReasonCdHelper, EquipmentEventSubTypeCdHelper, EquipmentEventTypeCdHelper, EquipmentQualifierCdHelper, EquipmentSizeCdHelper, EquipmentStatusCdHelper, EquipmentStatusQualifierCdHelper, EquipmentTypeCdHelper, EquipmentTypeDetailCdHelper, EslCdHelper, EventLogSubTypeCdHelper, EventLogTypeCdHelper, EventSourceCdHelper, EventTypeCdHelper, ExadataDatabaseCdHelper, ExceptionCategoryCdHelper, ExceptionLocationTypeCdHelper, ExceptionStatusCdHelper, ExceptionSummaryCdHelper, ExceptionSummaryTypeCdHelper, ExceptionTypeCdHelper, ExemptReasonCdHelper, ExpectationOwnerTypeCdHelper, ExpectationStatusCdHelper, ExpireReasonCdHelper, ExtendedServiceLaneTypeCdHelper, ExternalShipmentStatusCdHelper, FbdsPrintCountCdHelper, FbdsVersionCdHelper, FieldDisplayTypeCdHelper, FinalStandardAddressSourceCdHelper, FinancialFunctionCdHelper, FoodPoisonCdHelper, FreightMaintenanceTypeCdHelper, FreightOperationTypeCdHelper, FreightServiceAreaTypeCdHelper, FreightStatusCdHelper, GeoLocationTypeCdHelper, GlobalSearchDetailCdHelper, GoalLevelCdHelper, GoalTypeCdHelper, HandlingUnitDimensionTypeCdHelper, HandlingUnitMovementTypeCdHelper, HandlingUnitTypeCdHelper, HazmatBulkQuantityCdHelper, HazmatSourceCdHelper, HierarchyGroupCategoryCdHelper, HookCategoryCdHelper, HookStatusCdHelper, HostlerInstructionCdHelper, HssRegionCdHelper, HttpMethodHelper, IdentifiedLocationTypeCdHelper, InstructionStatCdHelper, IntermodalSatelliteTypeCdHelper, InvPaymentChrgToCdHelper, InvoiceAccuracyConstraintCdHelper, InvoiceAddressCdHelper, InvoiceAttachmentCdHelper, InvoiceCurrencyCdHelper, InvoiceDetailDataTypeCdHelper, InvoiceDocumentCdHelper, InvoiceEvalOperCdHelper, InvoiceHoldReasonCdHelper, InvoiceModeCdHelper, InvoicePostDeliveryStatusCdHelper, InvoicePreferenceCdHelper, InvoicePreferenceConstraintCdHelper, InvoicePresentationFormatCdHelper, InvoiceRequirementCategoryCdHelper, InvoiceRequirementTypeCdHelper, InvoiceSendStatusCdHelper, InvoiceTransmissionFormatCdHelper, InvoiceTransmitStatusCdHelper, InvoiceTypeCdHelper, JSPLaborRollupTypeCdHelper, JSPShiftTimeNameTypeCdHelper, JSPShiftTimeTypeCdHelper, JSPWorkerTypeCdHelper, JobSelectionCdHelper, JobStateTypeCdHelper, LabelShippingStatusCdHelper, LateTenderCdHelper, LegalTermsTypeCdHelper, LengthUomCdHelper, LhoEventTypeCdHelper, LicenseEquipmentBodyCdHelper, LicenseEquipmentFuelTypeCdHelper, LicenseEquipmentOwnedLeaseCdHelper, LicenseEquipmentTypeCdHelper, LicenseValidityCdHelper, LineItemChargeToCdHelper, LoadGroupTypeCdHelper, LoadUnloadIdentifierCdHelper, LocationAddressTypeCdHelper, LocationDetailCdHelper, LocationHierarchyTypeCdHelper, LocationOperationTypeCdHelper, LocationPhoneTypeCdHelper, LocationTypeCdHelper, LogLevelHelper, LookerResultFormatCdHelper, ManifestReportTypeCdHelper, MatchedPartySourceCdHelper, MatchedPartyStatusCdHelper, MatchedPartyTypeCdHelper, MessageLogStatusCdHelper, MessagePriorityCdHelper, MetricPredictionTypeCdHelper, MetricStageCdHelper, MetricStageSubCdHelper, MetricThresholdContextCdHelper, MetricThresholdValueTypeCdHelper, MetricTypeCdHelper, MetricValueKeyCdHelper, MetricVarianceCdHelper, MinuetExecutionStatusCdHelper, MiscLineItemCdHelper, MiscLineItemPaymentMethodCdHelper, ModelGroupCdHelper, ModuleExecutorDataExtractTypeCdHelper, ModuleExecutorDatasetTypeCdHelper, ModuleExecutorParmsArgTypeCdHelper, ModuleExecutorSuccessfulCdHelper, MoveModeCdHelper, MovementExceptionTypeCdHelper, MovementStatusCdHelper, NetExplosiveMassUomCdHelper, NextBestActionTypeCdHelper, NextBusinessDayOperationCdHelper, NodeTypeCdHelper, NonDriveTimeLocationCdHelper, NonDriveTimePaidCdHelper, NonWorkDayTypeCdHelper, NoteTypeCdHelper, NotificationCdHelper, OptimizerParameterCdHelper, OptimizerParameterTypeCdHelper, OptimizerResultReasonCdHelper, OptimizerResultStatusCdHelper, OptimizerStatusCdHelper, OriginalSourceCdHelper, OsdCategoryCdHelper, OsdPayloadTypeCdHelper, OsdStatusCdHelper, ParentActivityTypeCdHelper, ParkingLocationTypeCdHelper, PartyRoleCdHelper, PartyShipmentRoleCdHelper, PayformActivityLocCdHelper, PayformDetailCdHelper, PayformNoteTypeCdHelper, PayformPaidTypeCdHelper, PayformStatusCdHelper, PaymentMethodCdHelper, PaymentStatusExternalCdHelper, PaymentStatusInternalCdHelper, PaymentTypeCdHelper, PhotoTypeCdHelper, PickupRequestHoldTypeCdHelper, PickupRequestReasonCategoryCdHelper, PickupRequestReasonCategoryRefCdHelper, PickupRequestReasonSubCategoryRefCdHelper, PickupRequestReasonTypeCdHelper, PickupRequestReinstateTypeCdHelper, PickupRequesterRoleCdHelper, PickupShipmentSourceCdHelper, PickupShipmentStatusCdHelper, PickupShipmetActionCdHelper, PickupSourceCdHelper, PickupStatusCdHelper, PickupTypeCdHelper, PnDAutoPrintOptionCdHelper, PnDReportTypeCdHelper, PnDRoleCdHelper, PolygonTypeCdHelper, PricingAnalysisRunTypeCdHelper, PricingRulesetOwnerCdHelper, PricingTypeCdHelper, PrintFBDSDocumentsTypeCdHelper, ProBolUsageStatusCdHelper, ProCheckoutTypeCdHelper, ProInUseCdHelper, ProNbrTypeCdHelper, ProPadTypeCdHelper, ProPrintedLabelStatusCdHelper, ProRequestDetailStatusCdHelper, ProRequestStatusCdHelper, ProStatusCdHelper, ProSummaryTypeCdHelper, ProTrackingLabelStatusCdHelper, ProcessStatusCdHelper, QueueNameCdHelper, RadioactivityUomCdHelper, RateDiscountSourceCdHelper, RateQuoteAccessorialCdHelper, RateQuoteTypeCdHelper, RateRequestSubTypeCdHelper, RateRequestTypeCdHelper, RateStatusCdHelper, RatingCurrencyCdHelper, RatingPartyLocationTypeCdHelper, RatingQueueClassTypeCdHelper, RatingShipmentFileTypeCdHelper, RatingStatusCdHelper, RatingWhatIfRequestStatusCdHelper, RebuttalExternalStatusCdHelper, RebuttalInternalStatusCdHelper, RebuttalReasonCdHelper, ReducedServiceSatelliteTypeCdHelper, RefusedReasonCdHelper, ReportsCdHelper, RequestedChangeCdHelper, RequestedChangeItemActionCdHelper, RequestedChangeTypeCdHelper, RerateTypeCdHelper, ReturnInstrRetainCheckCdHelper, ReturnReasonCdHelper, RevenueDayCdHelper, ReweighStatusCdHelper, RouteActionCdHelper, RouteAutoSequenceTypeCdHelper, RouteBalancingTypeCdHelper, RouteCategoryCdHelper, RouteDetailCdHelper, RouteEquipmentTypeCdHelper, RouteStatusCdHelper, RouteTypeCdHelper, RschCnclReasonCdHelper, RuleActiveTypeCdHelper, RuleExpressionValueTypeCdHelper, RuleFailureReasonCdHelper, RuleLogicalOperatorCdHelper, RuleOperatorCdHelper, RuleOverrideReasonCdHelper, RuleShmEntityTypeCdHelper, RunShiftCdHelper, RwgLogHeaderMoreInfoCdHelper, SalvageRequestStatusCdHelper, SalvageRequestTypeCdHelper, SatelliteTypeCdHelper, ScheduleStatusCdHelper, ScoEventStatusCdHelper, ScoEventSubTypeCdHelper, ScoEventTypeCdHelper, SeaNotifyEventCdHelper, ServiceCalculationStatusCdHelper, ServiceCdHelper, ServiceLevelCdHelper, ServiceLevelPartyTypeCdHelper, ServiceStatusCdHelper, ServiceTypeCdHelper, ShiftCdHelper, ShipmentAcquiredTypeCdHelper, ShipmentActionCdHelper, ShipmentAgendaItemActionCdHelper, ShipmentAuditStatusCdHelper, ShipmentCreditStatusCdHelper, ShipmentDetailCdHelper, ShipmentDirectionCdHelper, ShipmentEventsCdHelper, ShipmentHistoryDetailCdHelper, ShipmentItemTypeCdHelper, ShipmentManagementRemarkTypeCdHelper, ShipmentMovementTypeCdHelper, ShipmentOnTimeStatusCdHelper, ShipmentPnDStatusCdHelper, ShipmentRemarkTypeCdHelper, ShipmentServiceTypeCdHelper, ShipmentSourceCdHelper, ShipmentSpecialServiceCdHelper, ShipmentUpdateActionCdHelper, ShipmentVolumeMethodCdHelper, ShipmentVolumeTypeCdHelper, ShipperCountryCdHelper, ShipperCreditStatusCdHelper, ShipperCustomerTypeCdHelper, ShipperLoadedTrailerCdHelper, ShipperPhoneCountryCdHelper, ShortageTypeCdHelper, SnapshotDataTypeCdHelper, SortOrderCdHelper, SpecialEquipmentCdHelper, StopDetailCdHelper, StopSequenceModelConflictCdHelper, StopWindowCdHelper, StopWindowNoteTypeCdHelper, StrandReasonCdHelper, SymphonyPubDeliverToCdHelper, TariffOperatorCdHelper, TariffTypeCdHelper, TrailerAgendaItemActionCdHelper, TrailerLoadedUnitDetailCdHelper, TrailerRoutingEventCdHelper, TrailerStatusCdHelper, TransactionEventDetailTypeCdHelper, TransitTimeDirectionTypeCdHelper, TrapReasonCdHelper, TripActivityTypeCdHelper, TripCategoryCdHelper, TripDetailCdHelper, TripEquipmentStatusCdHelper, TripNodeActivityCdHelper, TripNodeStatusCdHelper, TripNodeTypeCdHelper, TripStatusCdHelper, TripStopActionCdHelper, UnassignPickupsSourceCdHelper, UnassignReasonCdHelper, UndeliveredReasonCdHelper, UploadDynamicPricingFileOperationCdHelper, UserRoleCdHelper, UserRoleTypeCdHelper, WarrantyStatusCdHelper, WeekDayCdHelper, WeightUomCdHelper, WhatIfDownloadFileTypeCdHelper, WhatIfShipmentSelectionTypeCdHelper, WorkerStatusCdHelper, WorkflowSelectionModeCdHelper, XFlowFrequencyCdHelper, XFlowNotificationTypeCdHelper, XdockExceptionTypeCdHelper, ZoneIndicatorCdHelper };

